import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  Unit_instance104q5opgivhr8 as Unit_instance,
  toSet2orjxp16sotqu as toSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll21mdhg523wnoa as addAll_0,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toString1pkumu07cwy4m as toString,
  sorted354mfsiv4s7x5 as sorted,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  isInterface3d6p8outrmvmk as isInterface,
  fill2542d4m9l93pn as fill,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  createThis2j2avj17cvnv2 as createThis,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  arrayCopytctsywo3h7gj as arrayCopy,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  protoOf180f3jzyo7rfj as protoOf,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  Long2qws0ah9gnpki as Long,
  numberToLong1a4cndvg6c52s as numberToLong,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  Key_instance2d3ch37kcwr5h as Key_instance,
  getxe4seun860fg as get_0,
  minusKey2uxs00uz5ceqp as minusKey_0,
  releaseInterceptedContinuation17jnf0xkuoovi as releaseInterceptedContinuation,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  Result__exceptionOrNull_impl_p6xea91phgcskd46fkx as Result__exceptionOrNull_impl_p6xea9,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg1uwg4i093qaqh as _Result___get_value__impl__bjfvqg,
  printStackTrace18lnx7a39cni as printStackTrace,
  println2shhhgwwt4c61 as println,
  Collection1k04j3hzsbod0 as Collection,
  HashMap1a0ld5kgwhmhv as HashMap,
  toMutableList20rdgwi7d3cwi as toMutableList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  KtMap140uvy3s5zad8 as KtMap,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  KtMutableList1beimitadwkna as KtMutableList,
  AbstractList3ck35puwbp1e9 as AbstractList,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  AbstractMutableList192xfq8ycgofs as AbstractMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  joinToStringxqcavsxcmh4q as joinToString,
  RandomAccess1jbw8sdogqb8x as RandomAccess,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  reverse2o3etdk6ug8y7 as reverse,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf,
  take8rd02inxauy8 as take,
  KtList3hktaavzmj137 as KtList,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  copyOfgossjg6lh6js as copyOf_0,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_0,
  asList2ho2pewtsfvv as asList,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  toList3jhuyej2anx2q as toList,
  to2cs3ny02qtbcb as to,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  joinToString1cxrrlmo0chqs as joinToString_0,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_1,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  contentEqualsaf55p28mnw74 as contentEquals_0,
  contentHashCode2i020q5tbeh2s as contentHashCode_0,
  toList383f556t1dixk as toList_0,
  isComparableviyv6ctzm76u as isComparable,
  isNumberiramasdbon0i as isNumber,
  numberToDouble210hrknaofnhf as numberToDouble,
  compareTo3ankvs086tmwq as compareTo,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  NullPointerException3mu0rhxjjitqq as NullPointerException,
  listOfvhqybd2zx248 as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  Comparable198qfk8pnblz0 as Comparable,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull_0,
  toLongOrNull12l1gfztrukv1 as toLongOrNull,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd1g1ubcha2b2yr as Char__toInt_impl_vasixd,
  copyOfwy6h3t5vzqpl as copyOf_2,
  replace3le3ie7l9k8aq as replace,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  Char__plus_impl_qi7pgjue8oeapgr66d as Char__plus_impl_qi7pgj,
  last1vo29oleiqj36 as last,
  dropLast1vpiyky649o34 as dropLast,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  Companion_getInstance1pxg306pnafvz as Companion_getInstance,
  toLongw1zpgk99d84b as toLong,
  KProperty1ca4yb4wlo496 as KProperty1,
  substringBeforeLastqh7oeuvefdek as substringBeforeLast,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  decodeToString1x4faah2liw2p as decodeToString,
  lines3g90sq0zeq43v as lines,
  substringBefore3n7kj60w69hju as substringBefore,
  removePrefix279df90bhrqqg as removePrefix,
  Regexxgw0gjiagf4z as Regex,
  startsWith26w8qjqapeeq6 as startsWith,
  listOf1jh22dvmctj1r as listOf_0,
  endsWith3cq61xxngobwh as endsWith,
  asSequence2phdjljfh9jhx as asSequence,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  plus2l6bq32n2wlna as plus_0,
  contains3ue2qo8xhmpf1 as contains,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  plus310ted5e4i90h as plus_1,
  getKClass1s3j9wy1cofik as getKClass,
  PrimitiveClasses_getInstance28ukyr6i8fs0q as PrimitiveClasses_getInstance,
  first58ocm7j58k3q as first,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  RuntimeException1r3t0zl97011n as RuntimeException,
  iterator3f5i676wpaa3g as iterator,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  mapOf1xd03cq9cnmy8 as mapOf,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  numberToChar93r9buh19yek as numberToChar,
  toString26mv3gzfo7fn as toString_1,
  roundToInt1ue8x8yshtznx as roundToInt,
  Enum3alwj03lh1n41 as Enum,
  compareValues1n2ayl87ihzfk as compareValues,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_2,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b1f2vqqjkgwgjr as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap,
  toIntArray2d4xwvtjb01mq as toIntArray,
  abs1kdzbjes1idip as abs,
  Monotonic_instance19wu6xfdyzm85 as Monotonic_instance,
  ValueTimeMark__minus_impl_f87sko1pcxed03k2z1m as ValueTimeMark__minus_impl_f87sko,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance_0,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  Duration__compareTo_impl_pchp0f1z7ae3ty3s6c1 as Duration__compareTo_impl_pchp0f,
  intercepted2ogpsikxxj4u0 as intercepted,
  captureStack1fzi4aczwc4hg as captureStack,
  equals2v6cggk171b6e as equals_0,
  toDuration7gy6v749ektt as toDuration_0,
  indexOfj0u699sj4o53 as indexOf,
  coerceIn302bduskdb54x as coerceIn,
  Paire9pteg33gng7 as Pair,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains_0,
  replaceqbix900hl8kl as replace_0,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  trim6jpmwojjgb3l as trim_0,
  indexOfwa4w6635jewi as indexOf_0,
  contains2el4s70rdq4ld as contains_1,
  get_lastIndexld83bqhfgcdd as get_lastIndex_0,
  lastIndexOfpmd3ei5son2n as lastIndexOf,
  boxApply1qmzdb3dh90hg as boxApply,
  startCoroutine1brije5juseye as startCoroutine,
  _Result___get_isFailure__impl__jpiriv1ffgeoyqwuzmr as _Result___get_isFailure__impl__jpiriv,
  removeAll3o43e67jmwdpc as removeAll,
  sortWith4fnm6b3vw03s as sortWith,
  until32cjhie5unyfs as until_0,
  toLongOrNullutqivezb0wx1 as toLongOrNull_0,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  dropLastlqc2oyv04br0 as dropLast_0,
  substringAfter1hku067gwr5ve as substringAfter,
  substringBeforekje8w2lxhyb6 as substringBefore_0,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart1mkod6gyztuyy as trimStart,
  Char19o2r8palgjof as Char,
  split3d3yeauc4rm2n as split_0,
  toMap1vec9topfei08 as toMap_0,
  linkedMapOf1is69t4zkcfr3 as linkedMapOf,
  charArray2ujmm1qusno00 as charArray,
  StringCompanionObject_instance2odz3s3zbrixa as StringCompanionObject_instance,
  EmptyCoroutineContext_getInstance2bxophqwsfm9n as EmptyCoroutineContext_getInstance,
  newThrowablezl37abp36p5f as newThrowable,
  isByteArray4nnzfn1x4o3w as isByteArray,
  drop258un2a8hqa2a as drop,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  trimEnd17pt8cbotbalj as trimEnd_0,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  joinTo3533moo9lcgda as joinTo,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  indexOf1xbs558u7wr52 as indexOf_1,
  toInt2q8uldh7sc951 as toInt_0,
  repeat2w4c6j8zoq09o as repeat,
  isNaNymqb93xtq8w8 as isNaN_0,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  round2mrvepag8eey0 as round,
  Char__minus_impl_a2frrhp8twy13wqz9c as Char__minus_impl_a2frrh,
  Char__compareTo_impl_ypi4mb25zzl63tc6wpg as Char__compareTo_impl_ypi4mb,
  coerceInlzh524ulyz3c as coerceIn_0,
  contentEquals379bkuxwxaiqz as contentEquals_1,
  contentHashCode2dpr73siofp13 as contentHashCode_1,
  coerceIn10f36k81le1mm as coerceIn_1,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  enumEntries20mr21zbe3az4 as enumEntries,
  LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
  fill3lmv1pckd4inv as fill_0,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2enan2cfix0ie as toList_1,
  concatToString2syawgu50khxi as concatToString,
  maxOrNull2lr3mpfpypi46 as maxOrNull,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3idov4hy0gkwd as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  DurationUnit_NANOSECONDS_getInstancexzp0zqz7eqak as DurationUnit_NANOSECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_1,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Job13y4jkazwjho0 as Job,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Deferred6wjx2us769ee as Deferred,
  invokeOnTimeout3llts2igdsa63 as invokeOnTimeout,
  Delay9umexudtwyie as Delay,
  asDeferredzhtizu7g12ut as asDeferred,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  Dispatchers_getInstance1nk2l7rcqz5wi as Dispatchers_getInstance,
  await2pwm8za8tntlx as await_0,
  Channel3r72atmcithql as Channel,
  delay1a7xkalnslpld as delay,
  withContext2i47m7ae4v1sd as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
  Mutex16li1l0asjv17 as Mutex,
  asyncz02dsa2nb2zt as async,
  CoroutineStart_UNDISPATCHED_getInstance1s89xhsoy2cne as CoroutineStart_UNDISPATCHED_getInstance,
  completeWith2hvdlbg1q1mlx as completeWith,
  delayop3h8lf643wg as delay_0,
} from './kotlinx-coroutines-core.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
var clz32 = Math.clz32;
var log2 = Math.log2;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  u18(formats) {
    return (new AudioFormats()).y18(formats.slice());
  }
}
class AudioFormat {
  constructor(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.AudioFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.g(tmp$ret$3);
    }
    tmp.a19_1 = toSet(destination);
  }
  z18() {
    return this.a19_1;
  }
  k3() {
    return 'AudioFormat';
  }
  toString() {
    return this.k3() + '(' + toString(sorted(this.z18())) + ')';
  }
}
class AudioFormats extends AudioFormat {
  constructor() {
    super([]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.w18_1 = ArrayList.j1();
    this.x18_1 = null;
  }
  z18() {
    if (this.x18_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.w18_1;
      var destination = ArrayList.j1();
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.audio.format.AudioFormats.<get-extensions>.<anonymous>' call
        var list = element.z18();
        addAll(destination, list);
      }
      tmp.x18_1 = toSet(destination);
    }
    return ensureNotNull(this.x18_1);
  }
  y18(formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.AudioFormats.register.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.w18_1;
    addAll_0(this_1, formats);
    return this_0;
  }
}
class MP3Decoder extends AudioFormat {
  constructor() {
    Companion_getInstance_2();
    super(['mp3']);
    this.c19_1 = Minimp3AudioFormat_getInstance();
  }
  toString() {
    return 'NativeMp3DecoderFormat';
  }
}
class Companion_0 extends MP3Decoder {
  constructor() {
    Companion_instance_1 = null;
    super();
    Companion_instance_1 = this;
  }
}
class BaseMinimp3AudioFormat extends AudioFormat {
  constructor() {
    Companion_getInstance_3();
    super(['mp3']);
  }
}
class Minimp3AudioFormat extends BaseMinimp3AudioFormat {
  constructor() {
    Minimp3AudioFormat_instance = null;
    super();
    Minimp3AudioFormat_instance = this;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.d19_1 = new Int8Array([88, 105, 110, 103]);
    var tmp_0 = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0.e19_1 = new Int8Array([73, 110, 102, 111]);
  }
}
class WAV extends AudioFormat {
  constructor() {
    Companion_getInstance_4();
    super(['wav']);
  }
}
class Companion_2 extends WAV {
  constructor() {
    Companion_instance_3 = null;
    super();
    Companion_instance_3 = this;
  }
}
class NativeSoundProvider {
  constructor() {
    this.f19_1 = 'unknown';
    this.g19_1 = false;
    this.h19_1 = Companion_getInstance_83().n19_1;
    this.i19_1 = Companion_getInstance_83().p19_1;
    this.j19_1 = Companion_getInstance_83().t19_1;
    this.k19_1 = Companion_getInstance_83().n19_1;
    var tmp = this;
    tmp.l19_1 = lazy(NativeSoundProvider$audioFormats$delegate$lambda);
  }
  v19(_set____db54di) {
    this.g19_1 = _set____db54di;
  }
  p5() {
  }
}
class NativeSoundProviderNew extends NativeSoundProvider {}
class DummyNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    Companion_getInstance_5();
    super();
  }
}
class Companion_3 extends DummyNativeSoundProvider {
  constructor() {
    Companion_instance_4 = null;
    super();
    Companion_instance_4 = this;
  }
}
class HtmlNativeSoundProvider extends NativeSoundProviderNew {
  constructor() {
    super();
    HtmlSimpleSound_getInstance().b1a();
  }
}
class HtmlSimpleSound {
  constructor() {
    HtmlSimpleSound_instance = this;
    this.w19_1 = Companion_getInstance_65().p1a('HtmlSimpleSound');
    var tmp = this;
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (!(typeof window.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        if (!(typeof window.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          tmp_1 = null;
        }
      }
      var this_0 = tmp_1;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
      // Inline function 'kotlin.js.asDynamic' call
      window.globalAudioContext = this_0;
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = this.w19_1;
        var level = Level_ERROR_getInstance();
        var tmp_3;
        if (this_1.k1a(level)) {
          // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
          this_1.j1a(level, e);
          tmp_3 = Unit_instance;
        }
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp.x19_1 = tmp_0;
    this.y19_1 = false;
    this.z19_1 = CompletableDeferred(Job());
    var tmp_4 = this;
    var tmp_5 = this.z19_1;
    tmp_4.a1a_1 = isInterface(tmp_5, Deferred) ? tmp_5 : THROW_CCE();
    var tmp47_safe_receiver = this.x19_1;
    var _scratchBuffer = tmp47_safe_receiver == null ? null : tmp47_safe_receiver.createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    unlock._v = HtmlSimpleSound$lambda(unlock, this, _scratchBuffer);
    var tmp_6 = document;
    var tmp_7;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_7 = unlock._v;
    }
    tmp_6.addEventListener('keydown', tmp_7, true);
    var tmp_8 = document;
    var tmp_9;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_9 = unlock._v;
    }
    tmp_8.addEventListener('touchstart', tmp_9, true);
    var tmp_10 = document;
    var tmp_11;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_11 = unlock._v;
    }
    tmp_10.addEventListener('touchend', tmp_11, true);
    var tmp_12 = document;
    var tmp_13;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_13 = unlock._v;
    }
    tmp_12.addEventListener('mousedown', tmp_13, true);
  }
  b1a() {
  }
}
class Adler32 {
  constructor() {
    this.q1a_1 = 65521;
    this.r1a_1 = 1;
  }
  s1a(old, data, offset, len) {
    var s1 = (old >>> 0 | 0) & 65535;
    var s2 = (old >>> 16 | 0) & 65535;
    var inductionVariable = offset;
    var last = offset + len | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        s1 = (s1 + (data[n] & 255) | 0) % 65521 | 0;
        s2 = (s2 + s1 | 0) % 65521 | 0;
      }
       while (inductionVariable < last);
    return s2 << 16 | s1;
  }
}
class CRC32 {
  constructor() {
    CRC32_instance = this;
    this.t1a_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(256);
    while (tmp_0 < 256) {
      var tmp_2 = tmp_0;
      var c = tmp_2;
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var k = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          c = !((c & 1) === 0) ? -306674912 ^ (c >>> 1 | 0) : c >>> 1 | 0;
        }
         while (inductionVariable < 8);
      tmp_1[tmp_2] = c;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.u1a_1 = tmp_1;
  }
  s1a(old, data, offset, len) {
    var c = ~old;
    var table = this.u1a_1;
    var inductionVariable = offset;
    var last = offset + len | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        c = table[(c ^ data[n] & 255) & 255] ^ (c >>> 8 | 0);
      }
       while (inductionVariable < last);
    return ~c;
  }
}
class Companion_4 {
  constructor() {
    this.v1a_1 = 8388608;
    this.w1a_1 = 131072;
  }
}
class Companion_5 {
  constructor() {
    this.x1a_1 = -1;
    this.y1a_1 = -2;
    this.z1a_1 = 1023;
    this.a1b_1 = 16;
    this.b1b_1 = 288;
    this.c1b_1 = true;
    this.d1b_1 = true;
    this.e1b_1 = 10;
  }
}
class SlidingWindowWithOutput {
  constructor(sliding, out, flushSize, extraSize) {
    flushSize = flushSize === VOID ? 8388608 : flushSize;
    extraSize = extraSize === VOID ? 131072 : extraSize;
    this.u1b_1 = sliding;
    this.v1b_1 = out;
    this.w1b_1 = flushSize;
    this.x1b_1 = extraSize;
    this.y1b_1 = FixedSizeByteArrayBuilder.w1c(this.w1b_1 + this.x1b_1 | 0);
  }
  c1c() {
    return this.y1b_1.a1c_1 >= this.w1b_1;
  }
  r1c(distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this.u1b_1.b1d(distance);
        this.y1b_1.c1d(toByte(v));
      }
       while (inductionVariable < length);
  }
  v1c(bytes, offset, len) {
    this.y1b_1.d1d(bytes, offset, len);
    this.u1b_1.e1d(bytes, offset, len);
  }
  s1c(byte) {
    this.y1b_1.c1d(byte);
    this.u1b_1.f1d(get_unsigned(byte));
  }
}
class DeflaterPortable {
  constructor(windowBits) {
    Companion_getInstance_8();
    this.r1b_1 = windowBits;
  }
  h1d(reader, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp(this, reader, out, $completion), $completion);
  }
}
class Companion_6 extends DeflaterPortable {
  constructor() {
    Companion_instance_7 = null;
    super(15);
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(288);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.compression.deflate.Companion.FIXED_TREE.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0[n] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0[n_0] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this_0[n_1] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        this_0[n_2] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp.h1c_1 = tmp_0.g1d(this_0);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(32);
    while (tmp_3 < 32) {
      tmp_4[tmp_3] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1.i1c_1 = tmp_2.g1d(tmp_4);
    var tmp_5 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_5.j1c_1 = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    var tmp_6 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_6.k1c_1 = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    var tmp_7 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_7.l1c_1 = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var tmp_8 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_8.m1c_1 = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    var tmp_9 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_9.n1c_1 = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  }
}
class HuffmanTree {
  constructor() {
    this.f1b_1 = new Int32Array(1024);
    this.g1b_1 = new Int32Array(1024);
    this.h1b_1 = new Int32Array(1024);
    this.i1b_1 = 0;
    this.j1b_1 = 1023;
    this.k1b_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(1024);
    while (tmp_0 < 1024) {
      tmp_1[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.l1b_1 = tmp_1;
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(1024);
    while (tmp_3 < 1024) {
      tmp_4[tmp_3] = 0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2.m1b_1 = tmp_4;
    this.n1b_1 = new Int32Array(17);
    this.o1b_1 = new Int32Array(17);
    this.p1b_1 = new Int32Array(17);
    this.q1b_1 = new Int32Array(288);
  }
  p1c(reader) {
    reader.i1d(10);
    var node = this.j1b_1;
    if (true && reader.l1d() >= 10) {
      var bits = reader.j1d(10);
      var raw = this.l1b_1[bits];
      var value = toShort(raw);
      var len = raw >> 16;
      if (len > 0) {
        reader.k1d(len);
        if (value === -2) {
          node = this.m1b_1[bits];
        } else {
          return value;
        }
      }
    }
    $l$1: do {
      $l$0: do {
        var tmp;
        if (reader.e1c()) {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
          var this_0 = node;
          tmp = this.h1b_1[this_0];
        } else {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
          var this_1 = node;
          tmp = this.g1b_1[this_1];
        }
        node = tmp;
      }
       while (false);
      var tmp_0;
      if (!(node === 1023)) {
        // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
        var this_2 = node;
        tmp_0 = this.f1b_1[this_2] === -1;
      } else {
        tmp_0 = false;
      }
    }
     while (tmp_0);
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var this_3 = node;
    return this.f1b_1[this_3];
  }
  m1d(codeLengths, start, end) {
    this.q1c(codeLengths, start, end);
    return this;
  }
  g1d(codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    return $super === VOID ? this.m1d(codeLengths, start, end) : $super.m1d.call(this, codeLengths, start, end);
  }
  q1c(codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    fill(this.n1b_1, 0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        if (!(0 <= codeLen ? codeLen <= 16 : false)) {
          // Inline function 'kotlin.error' call
          var message = 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException.n4(toString(message));
        }
        var _array__4zh2yp = this.n1b_1;
        _array__4zh2yp[codeLen] = _array__4zh2yp[codeLen] + 1 | 0;
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 16)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count = this.n1b_1[n_0];
        this.o1b_1[n_0] = currentOffset;
        this.p1b_1[n_0] = currentOffset;
        currentOffset = currentOffset + count | 0;
      }
       while (inductionVariable_0 < 16);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var _array__4zh2yp_0 = this.p1b_1;
        var _unary__edvuaz = _array__4zh2yp_0[codeLen_0];
        _array__4zh2yp_0[codeLen_0] = _unary__edvuaz + 1 | 0;
        this.q1b_1[_unary__edvuaz] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this.i1b_1;
        var OFFSET = this.o1b_1[i];
        var SIZE = this.n1b_1[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this.q1b_1[OFFSET + j | 0]);
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression.u1_1;
        var last = progression.v1_1;
        var step_0 = progression.w1_1;
        if (step_0 > 0 && inductionVariable_4 <= last || (step_0 < 0 && last <= inductionVariable_4))
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
          }
           while (!(j_0 === last));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 && !((oldCount % 2 | 0) === 0)) {
          // Inline function 'kotlin.error' call
          var message_0 = 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException.n4(toString(message_0));
        }
      }
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      // Inline function 'kotlin.error' call
      var message_1 = 'This canonical code does not represent a Huffman code tree';
      throw IllegalStateException.n4(toString(message_1));
    }
    this.j1b_1 = allocNode(this, this.i1b_1 - 2 | 0, this.i1b_1 - 1 | 0);
    this.k1b_1 = ncodes;
    computeFastLookup(this);
  }
  o1c(codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    var tmp;
    if ($super === VOID) {
      this.q1c(codeLengths, start, end);
      tmp = Unit_instance;
    } else {
      tmp = $super.q1c.call(this, codeLengths, start, end);
    }
    return tmp;
  }
}
class SlidingWindow {
  constructor(nbits) {
    this.x1c_1 = nbits;
    this.y1c_1 = new Int8Array(1 << this.x1c_1);
    this.z1c_1 = this.y1c_1.length - 1 | 0;
    this.a1d_1 = 0;
  }
  f1(offset) {
    return this.y1c_1[(this.a1d_1 - offset | 0) & this.z1c_1] & 255;
  }
  b1d(offset) {
    return this.f1d(this.f1(offset));
  }
  f1d(value) {
    this.y1c_1[this.a1d_1] = toByte(value);
    this.a1d_1 = (this.a1d_1 + 1 | 0) & this.z1c_1;
    return value;
  }
  e1d(bytes, offset, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.f1d(get_unsigned(bytes[offset + n | 0]));
      }
       while (inductionVariable < len);
  }
}
class FixedSizeByteArrayBuilder {
  static n1d(data) {
    var $this = createThis(this);
    $this.z1b_1 = data;
    $this.a1c_1 = 0;
    return $this;
  }
  static w1c(size) {
    return this.n1d(new Int8Array(size));
  }
  z2() {
    this.a1c_1 = 0;
  }
  d1d(array, offset, len) {
    arraycopy(array, offset, this.z1b_1, this.a1c_1, len);
    this.a1c_1 = this.a1c_1 + len | 0;
  }
  c1d(v) {
    var _unary__edvuaz = this.a1c_1;
    this.a1c_1 = _unary__edvuaz + 1 | 0;
    this.z1b_1[_unary__edvuaz] = v;
  }
}
class CompressionMethod {}
function uncompress(reader, out, $completion) {
  unsupported_0();
}
class uncompressStream$slambda {
  constructor($this_uncompressStream, $input) {
    this.x1d_1 = $this_uncompressStream;
    this.y1d_1 = $input;
  }
  z1d(output, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, output, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.z1d((!(p1 == null) ? isInterface(p1, AsyncOutputStream) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class uncompress$slambda {
  constructor($this_uncompress, $i, $o) {
    this.a1e_1 = $this_uncompress;
    this.b1e_1 = $i;
    this.c1e_1 = $o;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0(this, $completion), $completion);
  }
}
class Deflate$4 {
  constructor($windowBits) {
    this.d1e_1 = DeflaterNative($windowBits);
  }
  o1d(reader, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_1(this, reader, out, $completion), $completion);
  }
}
class toDeflater$1 {
  constructor($this_toDeflater) {
    this.e1e_1 = $this_toDeflater;
  }
  s1b() {
    return this.e1e_1.g1e_1;
  }
  t1b() {
    return this.e1e_1.h1e_1;
  }
  l1d() {
    return this.e1e_1.j1e_1;
  }
  i1d(bits) {
    return this.e1e_1.i1d(bits);
  }
  u1c(count, $completion) {
    return this.e1e_1.q1e(count, VOID, $completion);
  }
  t1c() {
    return this.e1e_1.t1c();
  }
  e1c() {
    return this.e1e_1.e1c();
  }
  k1d(bits) {
    return this.e1e_1.k1d(bits);
  }
  j1d(count) {
    return this.e1e_1.j1d(count);
  }
  f1c(count) {
    return this.e1e_1.f1c(count);
  }
  d1c($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBigChunkIfRequired__yhuuys(this, $completion), $completion);
  }
}
class toDeflater$2 {
  constructor($this_toDeflater) {
    this.r1e_1 = $this_toDeflater;
  }
  b1c(bytes, offset, size, $completion) {
    return this.r1e_1.b1c(bytes, offset, size, $completion);
  }
}
class GZIPBase {
  constructor(checkCrc, deflater) {
    this.s1e_1 = checkCrc;
    this.t1e_1 = deflater;
  }
  toString() {
    return 'GZIPBase(' + this.s1e_1 + ', ' + toString(this.t1e_1) + ')';
  }
  o1d(reader, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_2(this, reader, out, $completion), $completion);
  }
}
class GZIP extends GZIPBase {
  constructor(deflater) {
    Companion_getInstance_9();
    super(true, deflater);
  }
}
class Companion_7 extends GZIP {
  constructor() {
    Companion_instance_8 = null;
    super(GZIP$Companion$_init_$lambda_4zsoc7);
    Companion_instance_8 = this;
  }
  toString() {
    return 'GZIP';
  }
}
class AsyncOutputStream {}
function write$default(buffer, offset, len, $completion, $super) {
  offset = offset === VOID ? 0 : offset;
  len = len === VOID ? buffer.length - offset | 0 : len;
  return $super === VOID ? this.b1c(buffer, offset, len, $completion) : $super.b1c.call(this, buffer, offset, len, $completion);
}
class GZIPBase$uncompress$2 {
  constructor($out, $ccrc32, $csize) {
    this.v1e_1 = $out;
    this.w1e_1 = $ccrc32;
    this.x1e_1 = $csize;
    this.u1e_1 = $out;
  }
  y1e($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0(this, $completion), $completion);
  }
  b1c(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l(this, buffer, offset, len, $completion), $completion);
  }
}
class ZLib {
  constructor(deflater) {
    Companion_getInstance_10();
    this.f1f_1 = deflater;
  }
  o1d(reader, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_3(this, reader, out, $completion), $completion);
  }
}
class Companion_8 extends ZLib {
  constructor() {
    Companion_instance_9 = null;
    super(ZLib$Companion$_init_$lambda_nrgg4o);
    Companion_instance_9 = this;
  }
}
class ZLib$uncompress$2 {
  constructor($o, $chash) {
    this.d1f_1 = $o;
    this.e1f_1 = $chash;
  }
  y1e($completion) {
    return this.d1f_1.y1e($completion);
  }
  b1c(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_0(this, buffer, offset, len, $completion), $completion);
  }
}
class Companion_9 {
  constructor() {
    this.u1d_1 = 8388608;
    this.v1d_1 = 32768;
  }
  w1d(s, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forInput__mjt6c9(this, s, $completion), $completion);
  }
}
class AsyncGetLengthStream {}
function hasLength($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_hasLength__5f5ox8_0(this, $completion), $completion);
}
function getLength($completion) {
  throw UnsupportedOperationException.m7();
}
class AsyncGetPositionStream {}
function getPosition($completion) {
  throw UnsupportedOperationException.m7();
}
class BitReader {
  constructor(s, bigChunkSize, readWithSize) {
    bigChunkSize = bigChunkSize === VOID ? 8388608 : bigChunkSize;
    readWithSize = readWithSize === VOID ? 32768 : readWithSize;
    this.f1e_1 = s;
    this.g1e_1 = bigChunkSize;
    this.h1e_1 = readWithSize;
    this.i1e_1 = 0;
    this.j1e_1 = 0;
    this.k1e_1 = new SimpleRingBuffer(ilog2(get_nextPowerOfTwo(this.g1e_1)));
    this.l1e_1 = 0.0;
    this.m1e_1 = 0.0;
    this.n1e_1 = new Int8Array(4);
  }
  toString() {
    return 'BitReader(' + toString(this.f1e_1) + ', bigChunkSize=' + this.g1e_1 + ', readWithSize=' + this.h1e_1 + ')';
  }
  p1e() {
    return this.k1e_1.q1f_1 < this.h1e_1;
  }
  o1e(expectedBytes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBytesUpTo__5zpo26(this, expectedBytes, $completion), $completion);
  }
  i1d(bitcount) {
    while (this.j1e_1 < bitcount) {
      var tmp = this;
      var tmp_0 = this.i1e_1;
      // Inline function 'korlibs.io.compression.util.BitReader._su8' call
      this.l1e_1 = this.l1e_1 + 1;
      tmp.i1e_1 = tmp_0 | this.k1e_1.y1f() << this.j1e_1;
      this.j1e_1 = this.j1e_1 + 8 | 0;
    }
  }
  j1d(bitcount) {
    return this.i1e_1 & ((1 << bitcount) - 1 | 0);
  }
  k1d(bitcount) {
    this.i1e_1 = this.i1e_1 >>> bitcount | 0;
    this.j1e_1 = this.j1e_1 - bitcount | 0;
  }
  f1c(bitcount) {
    this.i1d(bitcount);
    var readed = this.j1d(bitcount);
    this.k1d(bitcount);
    return readed;
  }
  e1c() {
    return !(this.f1c(1) === 0);
  }
  z1f(count, out) {
    var offset = 0;
    var count_0 = count;
    if (this.j1e_1 >= 8) {
      if (!((this.j1e_1 % 8 | 0) === 0)) {
        var bits = this.j1e_1 % 8 | 0;
        this.k1d(bits);
      }
      while (this.j1e_1 >= 8) {
        var byte = toByte(this.f1c(8));
        var _unary__edvuaz = offset;
        offset = _unary__edvuaz + 1 | 0;
        out[_unary__edvuaz] = byte;
        count_0 = count_0 - 1 | 0;
      }
    }
    // Inline function 'korlibs.io.compression.util.BitReader.discardBits' call
    this.i1e_1 = 0;
    this.j1e_1 = 0;
    var readCount = this.k1e_1.x1f(out, offset, count_0);
    if (readCount > 0)
      this.l1e_1 = this.l1e_1 + readCount;
  }
  w1f(count, out) {
    this.z1f(count, out);
    return out;
  }
  z1e() {
    // Inline function 'korlibs.io.compression.util.BitReader._su8' call
    // Inline function 'korlibs.io.compression.util.BitReader.discardBits' call
    this.i1e_1 = 0;
    this.j1e_1 = 0;
    this.l1e_1 = this.l1e_1 + 1;
    return this.k1e_1.y1f();
  }
  t1c() {
    this.z1f(2, this.n1e_1);
    return getU16LE_0(this.n1e_1, 0);
  }
  a1f() {
    this.z1f(4, this.n1e_1);
    return getS32LE(this.n1e_1, 0);
  }
  g1f() {
    this.z1f(4, this.n1e_1);
    return getS32BE(this.n1e_1, 0);
  }
  a1g(count, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_abytes__gje57m(this, count, out, $completion), $completion);
  }
  q1e(count, out, $completion, $super) {
    out = out === VOID ? new Int8Array(count) : out;
    return $super === VOID ? this.a1g(count, out, $completion) : $super.a1g.call(this, count, out, $completion);
  }
  u1f(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe(this, buffer, offset, len, $completion), $completion);
  }
  y1e($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_0(this, $completion), $completion);
  }
  b1f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_strz__qhnc5d(this, $completion), $completion);
  }
  b1g($completion) {
    return numberToLong(this.l1e_1);
  }
  h1f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_hasLength__5f5ox8(this, $completion), $completion);
  }
  i1f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94(this, $completion), $completion);
  }
}
class BaseLock {}
class NonRecursiveLock extends BaseLock {
  constructor() {
    super();
    this.c1g_1 = atomic$int$1(0);
  }
  d1g() {
    if (Companion_getInstance_14().f1g()) {
      // Inline function 'korlibs.concurrent.thread.Companion.spinWhile' call
      Companion_getInstance_14();
      $l$loop: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.lock.<anonymous>' call
        if (!!this.c1g_1.atomicfu$compareAndSet(0, 1)) {
          break $l$loop;
        }
      }
    }
  }
  g1g() {
    if (Companion_getInstance_14().f1g()) {
      // Inline function 'korlibs.concurrent.thread.Companion.spinWhile' call
      Companion_getInstance_14();
      $l$loop: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.unlock.<anonymous>' call
        if (!!this.c1g_1.atomicfu$compareAndSet(1, 0)) {
          break $l$loop;
        }
      }
    }
  }
}
class Companion_10 {
  f1g() {
    return Companion_getInstance_14().f1g();
  }
}
class Lock extends BaseLock {
  constructor() {
    super();
    this.h1g_1 = atomic$boolean$1(false);
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.i1g_1 = get_atomicfu$reentrantLock();
    this.j1g_1 = atomic$long$1(new Long(0, 0));
    this.k1g_1 = atomic$int$1(0);
  }
  d1g() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.lock' call
    this.i1g_1;
    this.k1g_1.atomicfu$incrementAndGet();
    this.j1g_1.kotlinx$atomicfu$value = Companion_getInstance_14().l1g();
  }
  g1g() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.unlock' call
    this.i1g_1;
    this.k1g_1.atomicfu$decrementAndGet();
  }
  m1g(unit) {
    if (!Companion_instance_11.f1g())
      throw UnsupportedOperationException.m7();
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.k1g_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.Lock.notify.<anonymous>' call
      var message = 'Must wait inside a synchronization block';
      throw IllegalStateException.n4(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.j1g_1.kotlinx$atomicfu$value.equals(Companion_getInstance_14().l1g())) {
      // Inline function 'korlibs.concurrent.lock.Lock.notify.<anonymous>' call
      var message_0 = 'Must lock the notify thread';
      throw IllegalStateException.n4(toString(message_0));
    }
    this.h1g_1.kotlinx$atomicfu$value = true;
  }
  n1g(unit, $super) {
    unit = unit === VOID ? Unit_instance : unit;
    var tmp;
    if ($super === VOID) {
      this.m1g(unit);
      tmp = Unit_instance;
    } else {
      var tmp_0 = $super.m1g;
      tmp = tmp_0.call(this, Unit_instance);
    }
    return tmp;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_12 = this;
    this.o1g_1 = new PreferSyncIo(true);
    this.p1g_1 = new PreferSyncIo(false);
  }
  q1g(preferSyncIo) {
    return preferSyncIo === true ? this.o1g_1 : this.p1g_1;
  }
}
class PreferSyncIo {
  constructor(preferSyncIo) {
    Companion_getInstance_13();
    this.r1g_1 = preferSyncIo;
  }
  g3() {
    return Companion_getInstance_13();
  }
  toString() {
    return 'PreferSyncIo(preferSyncIo=' + this.r1g_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.r1g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferSyncIo))
      return false;
    var tmp0_other_with_cast = other instanceof PreferSyncIo ? other : THROW_CCE();
    if (!(this.r1g_1 === tmp0_other_with_cast.r1g_1))
      return false;
    return true;
  }
}
class BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = BaseSignal$_init_$lambda_tuu04y;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    this.x1g_1 = onRegister;
    this.y1g_1 = FastArrayList.j1h();
    this.z1g_1 = FastArrayList.j1h();
    this.a1h_1 = 0;
  }
  b1h(once, handler) {
    this.x1g_1();
    var node = new Node(this, once, handler);
    this.y1g_1.g(node);
    return node;
  }
}
class Signal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = Signal$_init_$lambda_6vimhp;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  w1g(handler) {
    return this.b1h(false, handler);
  }
  c1h(handler) {
    return this.w1g(handler);
  }
  d1h(value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.y1g_1.g1()) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      try {
        this.a1h_1 = this.a1h_1 + 1 | 0;
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_0 = this.y1g_1;
        var n = 0;
        var m = 0;
        while (n < this_0.d1()) {
          if (m >= 0 && !(m === n)) {
            this_0.v2(m, this_0.f1(n));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var node = this_0.f1(n);
          var remove = node.e1h_1;
          // Inline function 'korlibs.io.async.Signal.invoke.<anonymous>' call
          node.f1h_1(value);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.d1() > m) {
          this_0.w2(this_0.d1() - 1 | 0);
        }
      }finally {
        this.a1h_1 = this.a1h_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.z1g_1.g1()) {
          // Inline function 'korlibs.io.async.fastIterateRemove' call
          var this_1 = this.z1g_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.d1()) {
            if (m_0 >= 0 && !(m_0 === n_0)) {
              this_1.v2(m_0, this_1.f1(n_0));
            }
            // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
            var it = this_1.f1(n_0);
            this.y1g_1.u2(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.d1() > m_0) {
            this_1.w2(this_1.d1() - 1 | 0);
          }
        }
      }
    }
    return tmp$ret$0;
  }
}
class Node {
  constructor($outer, once, item) {
    this.g1h_1 = $outer;
    this.e1h_1 = once;
    this.f1h_1 = item;
  }
  p5() {
    if (this.g1h_1.a1h_1 > 0) {
      this.g1h_1.z1g_1.g(this);
    } else {
      this.g1h_1.y1g_1.u2(this);
    }
  }
}
class AsyncSignal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = AsyncSignal$_init_$lambda_rsv6fb;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  o1h(value, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1(this, value, $completion), $completion);
  }
}
class runBlockingNoSuspensions$1$context$1 extends AbstractCoroutineContextElement {
  static s1h($suspendCount, $box) {
    if ($box === VOID)
      $box = {};
    $box.r1h_1 = $suspendCount;
    var $this = this.em(Key_instance, $box);
    $this.q1h_1 = Key_instance;
    return $this;
  }
  g3() {
    return this.q1h_1;
  }
  nc(continuation) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.async.<no name provided>.interceptContinuation.<anonymous>' call
    var _unary__edvuaz = this.r1h_1._v;
    this.r1h_1._v = _unary__edvuaz + 1 | 0;
    return continuation;
  }
  pv(timeMillis, continuation) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    continuation.bc(tmp$ret$0);
    return Unit_instance;
  }
}
class runBlockingNoSuspensions$1 {
  constructor($suspendCount, $resultEx, $completed, $rresult) {
    this.u1h_1 = $resultEx;
    this.v1h_1 = $completed;
    this.w1h_1 = $rresult;
    var tmp = this;
    tmp.t1h_1 = runBlockingNoSuspensions$1$context$1.s1h($suspendCount);
  }
  zb() {
    return this.t1h_1;
  }
  x1h(result) {
    var exception = Result__exceptionOrNull_impl_p6xea9(result);
    if (!(exception == null)) {
      this.u1h_1._v = exception;
      this.v1h_1._v = true;
      printStackTrace(exception);
    } else {
      // Inline function 'kotlin.getOrThrow' call
      throwOnFailure(result);
      var tmp = _Result___get_value__impl__bjfvqg(result);
      var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        _get_unitInstance__yoa8mq(this);
        var tmp_1 = Unit_instance;
        var tmp_2;
        if (!(Unit_instance == null)) {
          tmp_2 = Unit_instance;
        } else {
          tmp_2 = THROW_CCE();
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this.w1h_1._v = rvalue;
      this.v1h_1._v = true;
    }
  }
  bc(result) {
    return this.x1h(result);
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    tmp.e1g_1 = lazy(NativeThread$Companion$warnSleep$delegate$lambda);
  }
  f1g() {
    return false;
  }
  l1g() {
    return new Long(1, 0);
  }
}
class DoubleList {}
function getAt(index) {
  return this.f1(index);
}
function listIterator() {
  return this.s2(0);
}
function listIterator_0(index) {
  return this.t2(index, this.d1()).r2();
}
function subList(fromIndex, toIndex) {
  return SimpleSubList(fromIndex, toIndex, DoubleList$subList$lambda(this));
}
function containsAll(elements) {
  return containsAllCheck(this, elements);
}
function isEmpty() {
  return this.d1() === 0;
}
function iterator_0() {
  return this.r2();
}
class Mixin {
  constructor(extra) {
    extra = extra === VOID ? null : extra;
    this.a1i_1 = extra;
  }
  b1i(_set____db54di) {
    this.a1i_1 = _set____db54di;
  }
  c1i() {
    return this.a1i_1;
  }
}
class Property {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.d1i_1 = name;
    this.e1i_1 = defaultGen;
  }
}
class PropertyThis {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.f1i_1 = name;
    this.g1i_1 = defaultGen;
    var tmp = this;
    tmp.h1i_1 = Extra$PropertyThis$transform$lambda;
  }
}
class ExtraObject {
  constructor() {
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.i1i_1 = get_atomicfu$reentrantLock();
    this.j1i_1 = HashMap.u7();
    var tmp_0 = this;
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    // Inline function 'korlibs.datastructure.ExtraObject.values.<anonymous>' call
    tmp_0.k1i_1 = toMutableList(this.j1i_1.b3());
  }
  d1() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-size>.<anonymous>' call
    return this.j1i_1.d1();
  }
  c3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>' call
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = this.j1i_1.a3();
    var result = LinkedHashMap.pb(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = this.j1i_1.f3(element);
      result.x2(element, tmp$ret$0);
    }
    return toMutableSet(toMutableMap(result).c3());
  }
  a3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-keys>.<anonymous>' call
    return toMutableSet(this.j1i_1.a3());
  }
  l1i(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    // Inline function 'korlibs.datastructure.ExtraObject.get.<anonymous>' call
    return this.j1i_1.f3(key);
  }
  f3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.l1i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  m1i(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    this.j1i_1.x2(key, value);
    return Unit_instance;
  }
  n1i(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    // Inline function 'korlibs.datastructure.ExtraObject.contains.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.j1i_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).d3(key);
  }
  g1() {
    return this.d1() === 0;
  }
  z2() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    this.j1i_1.z2();
    return Unit_instance;
  }
  o1i(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    this.j1i_1.x2(key, value);
    return Unit_instance;
  }
  x2(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.o1i(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  p1i(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.i1i_1;
    // Inline function 'korlibs.datastructure.ExtraObject.containsKey.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.j1i_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).d3(key);
  }
  d3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.p1i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
}
class MutableListEx {}
function setAddAll(index, elements, offset, size) {
  // Inline function 'kotlin.math.min' call
  var b = this.d1() - index | 0;
  var setCount = Math.min(size, b);
  this.t1i(index, elements, offset, setCount);
  this.u1i(elements, offset + setCount | 0, size - setCount | 0);
}
function setAddAll$default(index, elements, offset, size, $super) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? elements.d1() - offset | 0 : size;
  var tmp;
  if ($super === VOID) {
    this.s1i(index, elements, offset, size);
    tmp = Unit_instance;
  } else {
    setAddAll(index, elements, offset, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setAll(index, elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.v2(index + n | 0, elements.f1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function addAll_1(elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.g(elements.f1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function removeToSize(size) {
  this.r1i(size, this.d1());
}
class SimpleSubList$1 extends AbstractList {
  static a1j($toIndex, $fromIndex, $get, $box) {
    if ($box === VOID)
      $box = {};
    $box.x1i_1 = $toIndex;
    $box.y1i_1 = $fromIndex;
    $box.z1i_1 = $get;
    return this.vh($box);
  }
  d1() {
    return this.x1i_1 - this.y1i_1 | 0;
  }
  f1(index) {
    if (!(0 <= index ? index < this.d1() : false))
      throw IndexOutOfBoundsException.nd();
    return this.z1i_1(index + this.y1i_1 | 0);
  }
}
class Fixed {
  constructor(value) {
    this.b1j_1 = value;
  }
  c1j() {
    return this.b1j_1;
  }
  toString() {
    return 'Fixed(value=' + toString(this.b1j_1) + ')';
  }
  hashCode() {
    return hashCode(this.b1j_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fixed))
      return false;
    var tmp0_other_with_cast = other instanceof Fixed ? other : THROW_CCE();
    if (!equals(this.b1j_1, tmp0_other_with_cast.b1j_1))
      return false;
    return true;
  }
}
class FastArrayList extends AbstractMutableList {
  static d1j(__array) {
    var $this = this.j6();
    $this.i1h_1 = __array;
    return $this;
  }
  static j1h() {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.d1j(tmp$ret$0);
  }
  static q1i(initialCapacity) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.d1j(tmp$ret$0);
  }
  d1() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.i1h_1.length;
  }
  f1(index) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.i1h_1[rangeCheck(this, index)];
  }
  v2(index, element) {
    rangeCheck(this, index);
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = this.i1h_1[index];
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FastArrayList.set.<anonymous>' call
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    this.i1h_1[index] = element;
    return this_0;
  }
  g(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.i1h_1.push(element);
    this.y5_1 = this.y5_1 + 1 | 0;
    return true;
  }
  k6(index, element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.i1h_1.splice(insertionRangeCheck(this, index), 0, element);
    this.y5_1 = this.y5_1 + 1 | 0;
  }
  e1(elements) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  }
  w2(index) {
    rangeCheck(this, index);
    this.y5_1 = this.y5_1 + 1 | 0;
    var tmp;
    if (index === 0) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.i1h_1.shift();
    } else if (index === get_lastIndex(this)) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.i1h_1.pop();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.i1h_1.splice(index, 1)[0];
    }
    return tmp;
  }
  u2(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.i1h_1;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = array[index];
        if (equals(tmp$ret$4, element)) {
          array.splice(index, 1);
          this.y5_1 = this.y5_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  r1i(fromIndex, toIndex) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.i1h_1.splice(fromIndex, toIndex - fromIndex | 0);
    this.y5_1 = this.y5_1 + 1 | 0;
  }
  z2() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.i1h_1.length = 0;
    this.y5_1 = this.y5_1 + 1 | 0;
  }
  m6(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.i1h_1.indexOf(element);
  }
  toString() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = this.i1h_1;
    return '[' + joinToString(tmp$ret$4, ', ') + ']';
  }
  i7() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.i1h_1.concat();
  }
  toArray() {
    return this.i7();
  }
}
class Companion_13 {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.h1j() && y < this.i1j();
}
function getAt_0(x, y) {
  return this.q1j(x, y) ? this.y1h(indexOr(this, x, y)) : this.y1h(0);
}
function asString() {
  var tmp = until(0, this.i1j());
  return joinToString_0(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get_1(x, y) {
  return this.k1j(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.l1j(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.k1j(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.e1j_1 = width;
    this.f1j_1 = height;
    this.g1j_1 = data;
    Companion_instance_17.j1j(this.h1j(), this.i1j(), this.g1j_1.length);
  }
  h1j() {
    return this.e1j_1;
  }
  i1j() {
    return this.f1j_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.h1j() === other.h1j();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i1j() === other.i1j();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.g1j_1, other.g1j_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  k1j(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.g1j_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.IntArray2.getFast.<anonymous>' call
      tmp = this.g1j_1[0];
    }
    return tmp;
  }
  l1j(idx, value) {
    if (0 <= idx ? idx <= (this.g1j_1.length - 1 | 0) : false) {
      this.g1j_1[idx] = value;
    }
  }
  hashCode() {
    return (this.h1j() + this.i1j() | 0) + contentHashCode(this.g1j_1) | 0;
  }
  a1() {
    return intArrayIterator(this.g1j_1);
  }
  toString() {
    return this.m1j();
  }
}
class Companion_14 {}
class IntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Int32Array(capacity);
    tmp.r1j_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.s1j_1 = 0;
  }
  d1() {
    return this.s1j_1;
  }
  t1j(count) {
    if ((this.s1j_1 + count | 0) > this.r1j_1.length) {
      var tmp = this;
      var tmp_0 = this.r1j_1;
      // Inline function 'kotlin.math.max' call
      var a = this.s1j_1 + count | 0;
      var b = imul(this.r1j_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf(tmp_0, tmp$ret$0);
      tmp.r1j_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  z2() {
    this.s1j_1 = 0;
  }
  u1j(v0) {
    this.t1j(1);
    var tmp = this.r1j_1;
    var _unary__edvuaz = this.s1j_1;
    this.s1j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  f1(index) {
    return this.r1j_1[index];
  }
  y1h(index) {
    return this.r1j_1[index];
  }
  a1() {
    return this.s2(0);
  }
  pm(element) {
    var inductionVariable = 0;
    var last = this.s1j_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.r1j_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  v1j(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.pm(e))
        return false;
    }
    return true;
  }
  q2(elements) {
    return this.v1j(elements);
  }
  g1() {
    return this.d1() === 0;
  }
  w1j() {
    return !(this.d1() === 0);
  }
  x1j() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.nd();
    } else {
      tmp = this.r1j_1[this.s1j_1 - 1 | 0];
    }
    return tmp;
  }
  s2(index) {
    return take(this.r1j_1, this.s1j_1).s2(index);
  }
  hashCode() {
    return contentHashCode_2(this.r1j_1, 0, this.d1());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.d1() === other.d1() && contentEquals_2(this.r1j_1, other.r1j_1, 0, this.d1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.gb(2 + imul(5, this.d1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.bb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ab(', ');
        }
        this_0.eg(this.y1h(n));
      }
       while (inductionVariable < last);
    this_0.bb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_15 {}
class DoubleArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Float64Array(capacity);
    tmp.y1j_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.z1j_1 = 0;
  }
  d1() {
    return this.z1j_1;
  }
  a1k(v0, v1) {
    ensure(this, 2);
    var tmp = this.y1j_1;
    var _unary__edvuaz = this.z1j_1;
    this.z1j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.y1j_1;
    var _unary__edvuaz_0 = this.z1j_1;
    this.z1j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  b1k(v0, v1, v2, v3, v4, v5) {
    ensure(this, 6);
    var tmp = this.y1j_1;
    var _unary__edvuaz = this.z1j_1;
    this.z1j_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.y1j_1;
    var _unary__edvuaz_0 = this.z1j_1;
    this.z1j_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.y1j_1;
    var _unary__edvuaz_1 = this.z1j_1;
    this.z1j_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.y1j_1;
    var _unary__edvuaz_2 = this.z1j_1;
    this.z1j_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.y1j_1;
    var _unary__edvuaz_3 = this.z1j_1;
    this.z1j_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.y1j_1;
    var _unary__edvuaz_4 = this.z1j_1;
    this.z1j_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  f1(index) {
    return this.y1j_1[index];
  }
  y1h(index) {
    return this.y1j_1[index];
  }
  a1() {
    return this.s2(0);
  }
  c1k(element) {
    var inductionVariable = 0;
    var last = this.z1j_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.y1j_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  z1h(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.c1k(e))
        return false;
    }
    return true;
  }
  q2(elements) {
    return this.z1h(elements);
  }
  g1() {
    return this.d1() === 0;
  }
  s2(index) {
    return take_0(this.y1j_1, this.z1j_1).s2(index);
  }
  t2(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.y1j_1;
    return asList(tmp$ret$1).t2(fromIndex, toIndex);
  }
  hashCode() {
    return contentHashCode_3(this.y1j_1, 0, this.d1());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.d1() === other.d1() && contentEquals_3(this.y1j_1, other.y1j_1, 0, this.d1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.gb(2 + imul(5, this.d1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.bb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ab(', ');
        }
        this_0.hg(this.y1h(n));
      }
       while (inductionVariable < last);
    this_0.bb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.i1k_1 = $that;
    this.j1k_1 = this$0;
    this.h1k_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.h1k_1;
    this.h1k_1 = _unary__edvuaz + 1 | 0;
    return this.i1k_1.f1(_unary__edvuaz);
  }
  b1() {
    return this.h1k_1 < this.j1k_1.d1();
  }
  t5() {
    this.h1k_1 = this.h1k_1 - 1 | 0;
    this.j1k_1.w2(this.h1k_1);
  }
}
class TGenDeque {
  static k1k(initialCapacity) {
    var $this = createThis(this);
    $this.d1k_1 = 0;
    $this.e1k_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.f1k_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static l1k() {
    return this.k1k(16);
  }
  d1() {
    return this.e1k_1;
  }
  g1() {
    return this.d1() === 0;
  }
  m1k(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  n1k(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.d1();
    resizeIfRequiredFor(this, count);
    var base = this.d1k_1 + this.e1k_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.f1k_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.f1(n);
      }
       while (inductionVariable < count);
    this.e1k_1 = this.e1k_1 + count | 0;
    return true;
  }
  o1k(elements) {
    return this.n1k(toList(elements));
  }
  e1(elements) {
    return this.o1k(elements);
  }
  sj() {
    if (this.e1k_1 <= 0)
      throw IndexOutOfBoundsException.nd();
    var out = this.p1k();
    nullify(this, this.d1k_1);
    this.d1k_1 = (this.d1k_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.e1k_1 = this.e1k_1 - 1 | 0;
    return out;
  }
  uj() {
    if (this.e1k_1 <= 0)
      throw IndexOutOfBoundsException.nd();
    var out = this.q1k();
    nullify(this, internalIndex(this, this.d1() - 1 | 0));
    this.e1k_1 = this.e1k_1 - 1 | 0;
    return out;
  }
  w2(index) {
    if (index < 0 || index >= this.d1())
      throw IndexOutOfBoundsException.nd();
    if (index === 0)
      return this.sj();
    if (index === (this.d1() - 1 | 0))
      return this.uj();
    var old = this.f1(index);
    if (index < (this.d1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.r1k(n, this.f1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.d1k_1 = umod(this.d1k_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.d1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.r1k(n_0, this.f1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.e1k_1 = this.e1k_1 - 1 | 0;
    return old;
  }
  s1k(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.m1k(element);
    return true;
  }
  g(element) {
    return this.s1k((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  p1k() {
    return this.f1k_1[this.d1k_1];
  }
  q1k() {
    return this.f1k_1[internalIndex(this, this.d1() - 1 | 0)];
  }
  r1k(index, value) {
    this.f1k_1[internalIndex(this, index)] = value;
  }
  f1(index) {
    return this.f1k_1[internalIndex(this, index)];
  }
  t1k(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.g(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.f1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).d3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.x2(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.b3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  q2(elements) {
    return this.t1k(elements);
  }
  a1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.d1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.f1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.d1() === this.d1()))
      return false;
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.f1(n), other.f1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.i();
    sb.bb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.za(this.f1(n));
        if (!(n === (this.d1() - 1 | 0))) {
          sb.ab(', ');
        }
      }
       while (inductionVariable < last);
    sb.bb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.z1k_1 = $that;
    this.a1l_1 = this$0;
    this.y1k_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.y1k_1;
    this.y1k_1 = _unary__edvuaz + 1 | 0;
    return this.z1k_1.f1(_unary__edvuaz);
  }
  b1() {
    return this.y1k_1 < this.a1l_1.d1();
  }
  t5() {
    this.y1k_1 = this.y1k_1 - 1 | 0;
    this.a1l_1.w2(this.y1k_1);
  }
}
class IntDeque {
  static b1l(initialCapacity) {
    var $this = createThis(this);
    $this.u1k_1 = 0;
    $this.v1k_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.w1k_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static c1l() {
    return this.b1l(16);
  }
  d1() {
    return this.v1k_1;
  }
  g1() {
    return this.d1() === 0;
  }
  d1l(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  e1l(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.d1();
    resizeIfRequiredFor_0(this, count);
    var base = this.u1k_1 + this.v1k_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.w1k_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.f1(n);
      }
       while (inductionVariable < count);
    this.v1k_1 = this.v1k_1 + count | 0;
    return true;
  }
  f1l(elements) {
    return this.e1l(toList(elements));
  }
  e1(elements) {
    return this.f1l(elements);
  }
  sj() {
    if (this.v1k_1 <= 0)
      throw IndexOutOfBoundsException.nd();
    var out = this.p1k();
    nullify_0(this, this.u1k_1);
    this.u1k_1 = (this.u1k_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.v1k_1 = this.v1k_1 - 1 | 0;
    return out;
  }
  uj() {
    if (this.v1k_1 <= 0)
      throw IndexOutOfBoundsException.nd();
    var out = this.q1k();
    nullify_0(this, internalIndex_0(this, this.d1() - 1 | 0));
    this.v1k_1 = this.v1k_1 - 1 | 0;
    return out;
  }
  w2(index) {
    if (index < 0 || index >= this.d1())
      throw IndexOutOfBoundsException.nd();
    if (index === 0)
      return this.sj();
    if (index === (this.d1() - 1 | 0))
      return this.uj();
    var old = this.f1(index);
    if (index < (this.d1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.g1l(n, this.f1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.u1k_1 = umod(this.u1k_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.d1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.g1l(n_0, this.f1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.v1k_1 = this.v1k_1 - 1 | 0;
    return old;
  }
  h1l(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.d1l(element);
    return true;
  }
  g(element) {
    return this.h1l((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  p1k() {
    return this.w1k_1[this.u1k_1];
  }
  q1k() {
    return this.w1k_1[internalIndex_0(this, this.d1() - 1 | 0)];
  }
  g1l(index, value) {
    this.w1k_1[internalIndex_0(this, index)] = value;
  }
  f1(index) {
    return this.w1k_1[internalIndex_0(this, index)];
  }
  v1j(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.g(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.f1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).d3(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.x2(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.b3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  q2(elements) {
    return this.v1j(elements);
  }
  a1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.d1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.f1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.d1() === this.d1()))
      return false;
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.f1(n) === other.f1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.i();
    sb.bb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.eg(this.f1(n));
        if (!(n === (this.d1() - 1 | 0))) {
          sb.ab(', ');
        }
      }
       while (inductionVariable < last);
    sb.bb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastSmallSet extends AbstractMutableSet {
  static m1l() {
    var $this = this.e7();
    $this.i1l_1 = LinkedHashSet.h1();
    $this.j1l_1 = null;
    $this.k1l_1 = null;
    $this.l1l_1 = null;
    return $this;
  }
  d1() {
    return this.i1l_1.d1();
  }
  a1() {
    return this.i1l_1.a1();
  }
  n1l(element) {
    if (this.ak(element))
      return false;
    this.i1l_1.g(element);
    return true;
  }
  g(element) {
    return this.n1l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  o1l(element) {
    this.j1l_1 = null;
    this.k1l_1 = null;
    this.l1l_1 = null;
    this.i1l_1.u2(element);
    return true;
  }
  u2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.o1l((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  ak(element) {
    if (element === this.j1l_1 || element === this.k1l_1 || element === this.j1l_1)
      return true;
    var result = this.i1l_1.p2(element);
    if (result) {
      this.k1l_1 = this.j1l_1;
      this.l1l_1 = this.k1l_1;
      this.j1l_1 = element;
    }
    return result;
  }
  p2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.ak((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  z2() {
    this.i1l_1.z2();
    this.j1l_1 = null;
    this.k1l_1 = null;
    this.l1l_1 = null;
  }
}
class Companion_16 {
  j1j(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.n4(toString(message));
    }
  }
}
class Companion_17 {
  constructor() {
    this.f1m_1 = 2147483646;
    this.g1m_1 = 2147483647;
    this.h1m_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.l1m_1 = key;
    this.m1m_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.l1m_1 + ', value=' + toString_0(this.m1m_1) + ')';
  }
  hashCode() {
    var result = this.l1m_1;
    result = imul(result, 31) + (this.m1m_1 == null ? 0 : hashCode(this.m1m_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.l1m_1 === tmp0_other_with_cast.l1m_1))
      return false;
    if (!equals(this.m1m_1, tmp0_other_with_cast.m1m_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.p1l_1 = map;
    this.q1l_1 = this.p1l_1.v1l_1 ? 2147483647 : nextNonEmptyIndex(this, this.p1l_1.z1l_1, 0);
    this.r1l_1 = new Entry(0, null);
  }
  b1() {
    return !(this.q1l_1 === 2147483646);
  }
  d1m() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  }
  e1m() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0) {
    this.n1m_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.n1m_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.o1m_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.o1m_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  static i1m(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.s1l_1 = nbits;
    $this.t1l_1 = loadFactor;
    $this.u1l_1 = 1 << $this.s1l_1;
    $this.v1l_1 = false;
    $this.w1l_1 = null;
    $this.x1l_1 = $this.u1l_1 - 1 | 0;
    $this.y1l_1 = 1 + imul($this.s1l_1, $this.s1l_1) | 0;
    $this.z1l_1 = new Int32Array($this.k1m());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.k1m();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.a1m_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.b1m_1 = numberToInt($this.u1l_1 * $this.t1l_1);
    $this.c1m_1 = 0;
    return $this;
  }
  static p1m(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.i1m(tmp$ret$0, loadFactor, true);
  }
  k1m() {
    return this.u1l_1 + this.y1l_1 | 0;
  }
  f1(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.w1l_1;
    return this.a1m_1[index];
  }
  j1m(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.v1l_1 = true;
          this.w1l_1 = value;
          this.c1m_1 = this.c1m_1 + 1 | 0;
          return null;
        }
        if (this.c1m_1 >= this.b1m_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.z1l_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.z1l_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.z1l_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.z1l_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.z1l_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.y1l_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.w1l_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.w1l_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.a1m_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.a1m_1[index] = value;
        return this_1;
      }
    }
  }
  a3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  }
  b3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  }
  q1m(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.v1l_1 ? 2147483647 : this.q1m(this.z1l_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.z1l_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.f1(it);
      if (!equals(other.f1(key), value))
        return false;
      index = this.q1m(this.z1l_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.v1l_1 ? 2147483647 : this.q1m(this.z1l_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.z1l_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.f1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.q1m(this.z1l_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.r1m_1 = $hasNext;
    this.s1m_1 = $next;
  }
  b1() {
    return this.r1m_1();
  }
  c1() {
    return this.s1m_1();
  }
}
class Companion_18 {}
class Pool {
  static x1m(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.t1m_1 = reset;
    $this.u1m_1 = gen;
    $this.v1m_1 = _TGenStack___init__impl__yynjgt();
    $this.w1m_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.w1m_1;
        $this.w1m_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.v1m_1, $this.u1m_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static y1m(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.x1m(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  z1m() {
    return _TGenStack___get_size__impl__cvg66t(this.v1m_1);
  }
  a1n() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.v1m_1)).g1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.v1m_1);
    } else {
      var _unary__edvuaz = this.w1m_1;
      this.w1m_1 = _unary__edvuaz + 1 | 0;
      tmp = this.u1m_1(_unary__edvuaz);
    }
    return tmp;
  }
  z2() {
    TGenStack__clear_impl_pali4s(this.v1m_1);
    this.w1m_1 = 0;
  }
  b1n(element) {
    this.t1m_1(element);
    TGenStack__push_impl_9yh33t(this.v1m_1, element);
  }
  c1n(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.b1n(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.v1m_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.v1m_1, other.v1m_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.z1m() === other.z1m();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ConcurrentPool extends Pool {
  static k1n(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.x1m(reset, preallocate, gen);
    $this.h1n_1 = reset;
    $this.i1n_1 = gen;
    $this.j1n_1 = new NonRecursiveLock();
    return $this;
  }
  a1n() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.j1n_1;
      this_0.d1g();
      try {
        // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
        tmp$ret$1 = super.a1n();
        break $l$block;
      }finally {
        this_0.g1g();
      }
    }
    return tmp$ret$1;
  }
  z2() {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.j1n_1;
      this_0.d1g();
      try {
        super.z2();
        break $l$block;
      }finally {
        this_0.g1g();
      }
    }
  }
  b1n(element) {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.j1n_1;
      this_0.d1g();
      try {
        super.b1n(element);
        break $l$block;
      }finally {
        this_0.g1g();
      }
    }
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.l1n_1 = _reset;
    this.m1n_1 = gen;
    this.n1n_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.o1n_1 = Pool.x1m(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.p1n_1 = this.o1n_1.a1n();
  }
  c1() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.n1n_1;
    var element = this.p1n_1;
    this_0.g(element);
    this.p1n_1 = this.o1n_1.a1n();
    return this.p1n_1;
  }
  q1n() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.n1n_1.i1h_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.o1n_1.b1n(it);
    }
    this.n1n_1.z2();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.r1n_1 = function_0;
  }
  zh(a, b) {
    return this.r1n_1(a, b);
  }
  compare(a, b) {
    return this.zh(a, b);
  }
}
class Companion_19 {
  s1n(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  t1n(reversed, comparator) {
    return Companion_instance_20.s1n(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  u1n(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.t1n(reversed, comparator) : $super.t1n.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.y1n_1 = $index;
    this.z1n_1 = this$0;
  }
  b1() {
    return this.y1n_1._v < this.z1n_1.x1n_1;
  }
  c1() {
    var _unary__edvuaz = this.y1n_1._v;
    this.y1n_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz), this.z1n_1);
  }
  vu() {
    throw NotImplementedError.cd();
  }
  t5() {
    return this.vu();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.v1n_1 = data;
    this.w1n_1 = comparator;
    this.x1n_1 = 0;
  }
  d1() {
    return this.x1n_1;
  }
  a1o() {
    if (this.x1n_1 <= 0)
      throw IndexOutOfBoundsException.nd();
    return this.v1n_1[0];
  }
  s1k(element) {
    this.x1n_1 = this.x1n_1 + 1 | 0;
    ensure_0(this, this.x1n_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.x1n_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) && gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this))) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  }
  g(element) {
    return this.s1k((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  b1o() {
    if (this.x1n_1 <= 0)
      throw IndexOutOfBoundsException.nd();
    if (this.x1n_1 === 1) {
      this.x1n_1 = this.x1n_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.x1n_1 - 1 | 0), this));
    this.x1n_1 = this.x1n_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  c1o(element) {
    var inductionVariable = 0;
    var last = this.x1n_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.v1n_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  d1o(element) {
    var index = this.c1o(element);
    if (index >= 0) {
      this.e1o(index);
    }
    return index >= 0;
  }
  e1o(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.b1o();
  }
  t1k(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.p2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  q2(elements) {
    return this.t1k(elements);
  }
  g1() {
    return this.x1n_1 === 0;
  }
  o1k(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      this.s1k(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.g1();
  }
  e1(elements) {
    return this.o1k(elements);
  }
  a1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_0(this.v1n_1, other.v1n_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.w1n_1, other.w1n_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_0(this.v1n_1);
  }
}
class TGenQueue {
  constructor() {
    this.f1o_1 = TGenDeque.l1k();
  }
  d1() {
    return this.f1o_1.d1();
  }
  g1() {
    return this.d1() === 0;
  }
  g1o(v) {
    this.f1o_1.m1k(v);
  }
  h1o() {
    return this.f1o_1.sj();
  }
  t1k(elements) {
    return this.f1o_1.t1k(elements);
  }
  q2(elements) {
    return this.t1k(elements);
  }
  a1() {
    return this.f1o_1.a1();
  }
  hashCode() {
    return this.f1o_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.f1o_1.equals(other.f1o_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$2 {
  i1o(_set____db54di) {
    this.j1o_1 = _set____db54di;
  }
  h3() {
    var tmp = this.j1o_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$3 {
  constructor($prop) {
    this.k1o_1 = $prop;
  }
  i1o(value) {
    this.k1o_1.set(value);
  }
  h3() {
    return this.k1o_1.get();
  }
}
class Companion_20 {}
class TGenStack {
  constructor(items) {
    this.l1o_1 = items;
  }
  d1() {
    return _TGenStack___get_size__impl__cvg66t(this.l1o_1);
  }
  g1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.l1o_1);
  }
  t1k(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.l1o_1, elements);
  }
  q2(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  a1() {
    return TGenStack__iterator_impl_2pdia5(this.l1o_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.l1o_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.l1o_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.l1o_1, other);
  }
}
class SyncPauseable {
  constructor() {
    this.m1o_1 = new Lock();
    this.n1o_1 = false;
  }
  v19(value) {
    if (!(this.n1o_1 === value)) {
      this.n1o_1 = value;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
        var this_0 = this.m1o_1;
        this_0.d1g();
        try {
          this.m1o_1.n1g();
          break $l$block;
        }finally {
          this_0.g1g();
        }
      }
    }
  }
}
class Memory {
  g1k(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  }
  x1k(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class Companion_21 {
  p1o() {
    return get_dyn(get_dynApi().q1o());
  }
}
class Dyn {
  constructor(value) {
    this.o1o_1 = value;
  }
  u1o(other) {
    return Dyn__compareTo_impl_7znl52(this.o1o_1, other);
  }
  d(other) {
    return Dyn__compareTo_impl_7znl52_0(this, other);
  }
  toString() {
    return Dyn__toString_impl_9l0v3s(this.o1o_1);
  }
  hashCode() {
    return Dyn__hashCode_impl_vc6rwn(this.o1o_1);
  }
  equals(other) {
    return Dyn__equals_impl_sp125n(this.o1o_1, other);
  }
}
class DynApi {}
function get_global() {
  return Unit_instance;
}
class DynamicInternal {
  q1o() {
    return globalThis;
  }
  s1o(instance, key) {
    // Inline function 'kotlin.js.asDynamic' call
    return instance[key];
  }
  r1o(instance, key, value) {
    // Inline function 'kotlin.js.asDynamic' call
    instance[key] = value;
  }
}
class Base64 {
  constructor() {
    Base64_instance = this;
    this.v1o_1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    this.w1o_1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=';
    this.x1o_1 = toDecodeArray(this.v1o_1);
    this.y1o_1 = toDecodeArray(this.w1o_1);
  }
  a1p(str, url) {
    var tmp = 0;
    var tmp_0 = str.length;
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(str, tmp_2);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp_1[tmp_2] = toByte(tmp$ret$0);
      tmp = tmp + 1 | 0;
    }
    var src = tmp_1;
    var dst = new Int8Array(src.length);
    return copyOf_2(dst, this.b1p(src, dst, url));
  }
  z1o(ignoreSpaces, str, url) {
    return ignoreSpaces ? Base64_getInstance().c1p(str, url) : Base64_getInstance().a1p(str, url);
  }
  c1p(str, url) {
    return this.a1p(replace(replace(replace(replace(str, ' ', ''), '\n', ''), '\r', ''), '\t', ''), url);
  }
  b1p(src, dst, url) {
    var tmp;
    if (url) {
      tmp = this.y1o_1;
    } else {
      tmp = this.x1o_1;
    }
    var decodeArray = tmp;
    var m = 0;
    var n = 0;
    $l$loop: while (n < src.length) {
      var d = decodeArray[readU8(src, this, n)];
      if (d < 0) {
        n = n + 1 | 0;
        continue $l$loop;
      }
      var tmp_0;
      if (n < src.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp_0 = decodeArray[readU8(src, this, _unary__edvuaz)];
      } else {
        tmp_0 = 64;
      }
      var b0 = tmp_0;
      var tmp_1;
      if (n < src.length) {
        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        tmp_1 = decodeArray[readU8(src, this, _unary__edvuaz_0)];
      } else {
        tmp_1 = 64;
      }
      var b1 = tmp_1;
      var tmp_2;
      if (n < src.length) {
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        tmp_2 = decodeArray[readU8(src, this, _unary__edvuaz_1)];
      } else {
        tmp_2 = 64;
      }
      var b2 = tmp_2;
      var tmp_3;
      if (n < src.length) {
        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        tmp_3 = decodeArray[readU8(src, this, _unary__edvuaz_2)];
      } else {
        tmp_3 = 64;
      }
      var b3 = tmp_3;
      var _unary__edvuaz_3 = m;
      m = _unary__edvuaz_3 + 1 | 0;
      dst[_unary__edvuaz_3] = toByte(b0 << 2 | b1 >> 4);
      if (b2 < 64) {
        var _unary__edvuaz_4 = m;
        m = _unary__edvuaz_4 + 1 | 0;
        dst[_unary__edvuaz_4] = toByte(b1 << 4 | b2 >> 2);
        if (b3 < 64) {
          var _unary__edvuaz_5 = m;
          m = _unary__edvuaz_5 + 1 | 0;
          dst[_unary__edvuaz_5] = toByte(b2 << 6 | b3);
        }
      }
    }
    return m;
  }
}
class Hex {
  f1p(v) {
    return v >= 10 ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(97), v - 10 | 0) : Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), v);
  }
  g1p(v) {
    return v >= 10 ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), v - 10 | 0) : Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), v);
  }
  e1p(appender, value) {
    appender.bb(this.f1p((value >>> 4 | 0) & 15));
    appender.bb(this.f1p((value >>> 0 | 0) & 15));
  }
  h1p(src) {
    // Inline function 'korlibs.encoding.Hex.encodeBase' call
    // Inline function 'kotlin.text.buildString' call
    var capacity = imul(src.length, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.gb(capacity);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.encoding.Hex.encodeBase.<anonymous>' call
    // Inline function 'korlibs.encoding.Hex.encode' call
    var inductionVariable = 0;
    var last = src.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = src[n] & 255;
        // Inline function 'korlibs.encoding.Hex.encodeLower.<anonymous>' call
        var it = (v >>> 4 | 0) & 15;
        var tmp$ret$0 = Hex_instance.f1p(it);
        this_0.bb(tmp$ret$0);
        // Inline function 'korlibs.encoding.Hex.encodeLower.<anonymous>' call
        var it_0 = (v >>> 0 | 0) & 15;
        var tmp$ret$1 = Hex_instance.f1p(it_0);
        this_0.bb(tmp$ret$1);
      }
       while (inductionVariable <= last);
    return this_0.toString();
  }
  i1p(v) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.gb(2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.encoding.Hex.shex.<anonymous>' call
    this_0.bb(Hex_instance.g1p((v >>> 4 | 0) & 15));
    this_0.bb(Hex_instance.g1p((v >>> 0 | 0) & 15));
    return this_0.toString();
  }
  d1p(v) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.gb(8);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.encoding.Hex.shex.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable < 8)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v_0 = (v >>> imul(7 - n | 0, 4) | 0) & 15;
        this_0.bb(Hex_instance.g1p(v_0));
      }
       while (inductionVariable < 8);
    return this_0.toString();
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_23 = this;
    this.j1p_1 = get_FFI_SUPPORTED();
  }
  k1p(type) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.cf();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.Companion.extractTypeFunc.<anonymous>' call
      var tmp$ret$0 = item.gn_1;
      destination.g(tmp$ret$0);
    }
    var generics = destination;
    var ret = last(generics);
    var params = dropLast(generics, 1);
    return new FuncType(params, ret);
  }
}
class FuncDelegate {
  constructor(base, bname, name, type, config, required) {
    this.l1p_1 = base;
    this.m1p_1 = bname;
    this.n1p_1 = name;
    this.o1p_1 = type;
    this.p1p_1 = config;
    this.q1p_1 = required;
    this.r1p_1 = Companion_getInstance_24().k1p(this.o1p_1);
    this.s1p_1 = this.r1p_1.x1p_1;
    this.t1p_1 = this.r1p_1.y1p_1;
    this.u1p_1 = null;
  }
  z1p(thisRef, property) {
    if (this.u1p_1 == null)
      this.u1p_1 = this.l1p_1.f1q().g1q(this.m1p_1, this.o1p_1);
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.u1p_1;
  }
  mm(thisRef, property) {
    return this.z1p(thisRef instanceof FFILib ? thisRef : THROW_CCE(), property);
  }
}
class FuncInfo {
  constructor(type, extraName, config, required) {
    required = required === VOID ? true : required;
    this.h1q_1 = type;
    this.i1q_1 = extraName;
    this.j1q_1 = config;
    this.k1q_1 = required;
  }
  l1q(thisRef, prop) {
    // Inline function 'kotlin.also' call
    var tmp = prop.callableName;
    var tmp0_elvis_lhs = this.i1q_1;
    var this_0 = new FuncDelegate(thisRef, tmp, tmp0_elvis_lhs == null ? prop.callableName : tmp0_elvis_lhs, this.h1q_1, this.j1q_1, this.k1q_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.ffi.FuncInfo.provideDelegate.<anonymous>' call
    thisRef.d1q_1.g(this_0);
    if (!thisRef.b1q_1) {
      this_0.z1p(thisRef, prop);
    }
    return this_0;
  }
}
class FFILib {
  static q1q(paths, lazyCreate) {
    Companion_getInstance_24();
    lazyCreate = lazyCreate === VOID ? true : lazyCreate;
    var $this = createThis(this);
    $this.a1q_1 = paths;
    $this.b1q_1 = lazyCreate;
    var tmp = $this;
    tmp.c1q_1 = lazy(FFILib$resolvedPath$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.d1q_1 = ArrayList.j1();
    $this.e1q_1 = null;
    return $this;
  }
  r1q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c1q_1;
    resolvedPath$factory();
    return this_0.h3();
  }
  static s1q(paths, lazyCreate) {
    Companion_getInstance_24();
    lazyCreate = lazyCreate === VOID ? true : lazyCreate;
    return this.q1q(filterNotNull(toList_0(paths)), lazyCreate);
  }
  t1q() {
    return FFILibSym_0(this);
  }
  f1q() {
    if (this.e1q_1 == null)
      this.e1q_1 = this.t1q();
    return ensureNotNull(this.e1q_1);
  }
  p5() {
    this.f1q().p5();
  }
}
class FFILibSym {}
function get_2(name, type) {
  throw NotImplementedError.cd();
}
function close() {
}
class FuncType {
  constructor(params, ret) {
    this.v1p_1 = params;
    this.w1p_1 = ret;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.v1p_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.FuncType.paramsClass.<anonymous>' call
      var tmp$ret$0 = item == null ? null : item.bf();
      destination.g(tmp$ret$0);
    }
    tmp.x1p_1 = destination;
    var tmp_0 = this;
    var tmp189_safe_receiver = this.w1p_1;
    tmp_0.y1p_1 = tmp189_safe_receiver == null ? null : tmp189_safe_receiver.bf();
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_24 = this;
    this.u1q_1 = new FFIFuncConfig();
    this.v1q_1 = this.u1q_1.y1q(true);
  }
}
class FFIFuncConfig {
  constructor(wideString, altAbiConvention) {
    Companion_getInstance_25();
    wideString = wideString === VOID ? false : wideString;
    altAbiConvention = altAbiConvention === VOID ? false : altAbiConvention;
    this.w1q_1 = wideString;
    this.x1q_1 = altAbiConvention;
  }
  z1q(wideString, altAbiConvention) {
    return new FFIFuncConfig(wideString, altAbiConvention);
  }
  y1q(wideString, altAbiConvention, $super) {
    wideString = wideString === VOID ? this.w1q_1 : wideString;
    altAbiConvention = altAbiConvention === VOID ? this.x1q_1 : altAbiConvention;
    return $super === VOID ? this.z1q(wideString, altAbiConvention) : $super.z1q.call(this, wideString, altAbiConvention);
  }
  toString() {
    return 'FFIFuncConfig(wideString=' + this.w1q_1 + ', altAbiConvention=' + this.x1q_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.w1q_1);
    result = imul(result, 31) + getBooleanHashCode(this.x1q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FFIFuncConfig))
      return false;
    var tmp0_other_with_cast = other instanceof FFIFuncConfig ? other : THROW_CCE();
    if (!(this.w1q_1 === tmp0_other_with_cast.w1q_1))
      return false;
    if (!(this.x1q_1 === tmp0_other_with_cast.x1q_1))
      return false;
    return true;
  }
}
class FFIPointerArray {
  f1(index) {
    // Inline function 'korlibs.memory.fromLowHigh' call
    Companion_getInstance();
    var low = this.a1r_1[imul(index, 2) + 0 | 0];
    var high = this.a1r_1[imul(index, 2) + 1 | 0];
    var address = toLong(low).b4(new Long(-1, 0)).c4(toLong(high).y3(32));
    if (address.equals(new Long(0, 0)))
      return null;
    return CreateFFIPointer(address);
  }
  d1() {
    return this.a1r_1.length / 2 | 0;
  }
  g1() {
    return this.d1() === 0;
  }
  a1() {
    return _get_vlist__9y3qo3(this).a1();
  }
  r2() {
    return _get_vlist__9y3qo3(this).r2();
  }
  s2(index) {
    return _get_vlist__9y3qo3(this).s2(index);
  }
  t2(fromIndex, toIndex) {
    throw NotImplementedError.cd();
  }
  b1r(elements) {
    return _get_vlist__9y3qo3(this).q2(elements);
  }
  q2(elements) {
    return this.b1r(elements);
  }
  toString() {
    return 'FFIPointerArray(data=' + toString(this.a1r_1) + ')';
  }
  hashCode() {
    return hashCode(this.a1r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FFIPointerArray))
      return false;
    var tmp0_other_with_cast = other instanceof FFIPointerArray ? other : THROW_CCE();
    if (!equals(this.a1r_1, tmp0_other_with_cast.a1r_1))
      return false;
    return true;
  }
}
class FFISyncIOFile {
  constructor(impl, fullPath) {
    this.c1r_1 = impl;
    this.d1r_1 = fullPath;
  }
  e1r() {
    return substringBeforeLast(this.d1r_1, _Char___init__impl__6a9atx(47), '');
  }
  k3() {
    return substringAfterLast(this.d1r_1, _Char___init__impl__6a9atx(47));
  }
  f1r() {
    return new FFISyncIOFile(this.c1r_1, this.e1r());
  }
  g1r() {
    return this.c1r_1.h1r(this.d1r_1);
  }
  i1r() {
    return this.c1r_1.j1r(this.d1r_1);
  }
  k1r() {
    return decodeToString(this.c1r_1.l1r(this.d1r_1));
  }
  m1r() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.c1r_1.n1r(this.d1r_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.FFISyncIOFile.list.<anonymous>' call
      var tmp$ret$0 = this.l1i(item);
      destination.g(tmp$ret$0);
    }
    return destination;
  }
  l1i(child) {
    return new FFISyncIOFile(this.c1r_1, this.d1r_1 + '/' + child);
  }
}
class LDLibraries {
  constructor(fs) {
    Companion_getInstance_26();
    this.o1r_1 = fs;
    this.p1r_1 = LinkedHashSet.h1();
    this.q1r_1 = LinkedHashSet.h1();
    var tmp = this;
    tmp.r1r_1 = lazy(LDLibraries$libFoldersInitializeOnce$delegate$lambda(this));
  }
  s1r() {
    return toList(_get_libFoldersInitializeOnce__sla0ii(this));
  }
  t1r(path) {
    var file_0 = file(this.o1r_1, path);
    if (file_0.i1r()) {
      this.p1r_1.g(file_0);
    }
  }
}
class Companion_24 extends LDLibraries {
  constructor() {
    Companion_instance_25 = null;
    super(get_FFIPlatformSyncIO());
    Companion_instance_25 = this;
  }
}
class LibraryResolver {
  constructor(fs, platform) {
    Companion_getInstance_27();
    this.m1q_1 = fs;
    this.n1q_1 = platform;
    var tmp = this;
    tmp.o1q_1 = lazy(LibraryResolver$ldLibraries$delegate$lambda(this));
  }
  u1r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o1q_1;
    ldLibraries$factory();
    return this_0.h3();
  }
  p1q(names) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var inductionVariable = 0;
      var last = names.length;
      while (inductionVariable < last) {
        var element = names[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
        var result = this.v1r(element);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  v1r(name) {
    if (endsWith(name, '.dylib') || endsWith(name, '.so') || endsWith(name, '.dll')) {
      return name;
    }
    var tmp;
    if (this.n1q_1.j1s()) {
      var bases = listOf_0(['/Library/Frameworks', '/System/Library/Frameworks']);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
        var tmp0_iterator = bases.a1();
        while (tmp0_iterator.b1()) {
          var element = tmp0_iterator.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          var base = element + '/' + name + '.framework';
          var tmp_0;
          if (file(this.m1q_1, base).i1r()) {
            tmp_0 = base + '/' + name;
          } else {
            tmp_0 = null;
          }
          var result = tmp_0;
          if (!(result == null)) {
            tmp$ret$1 = result;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    } else if (this.n1q_1.i1s()) {
      var tmp$ret$9;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = listOf_0([name, name + '.dll', '../' + name + '.dll', '../../' + name + '.dll', '../../../' + name + '.dll', 'C:/WINDOWS/SYSTEM32/' + name + '.dll']);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator_0 = this_0.a1();
        while (tmp0_iterator_0.b1()) {
          var item = tmp0_iterator_0.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          var tmp$ret$2 = file(this.m1q_1, item);
          destination.g(tmp$ret$2);
        }
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList.j1();
        var tmp0_iterator_1 = destination.a1();
        while (tmp0_iterator_1.b1()) {
          var element_0 = tmp0_iterator_1.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          if (element_0.g1r()) {
            destination_0.g(element_0);
          }
        }
        var tmp0_iterator_2 = destination_0.a1();
        while (tmp0_iterator_2.b1()) {
          var element_1 = tmp0_iterator_2.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          var result_0 = element_1.d1r_1;
          if (!(result_0 == null)) {
            tmp$ret$9 = result_0;
            break $l$block_0;
          }
        }
        tmp$ret$9 = null;
      }
      tmp = tmp$ret$9;
    } else {
      var tmp_1 = asSequence(this.u1r().s1r());
      var tmp_2 = mapNotNull(tmp_1, LibraryResolver$resolve$lambda(name));
      var tmp_3 = asSequence(this.u1r().s1r());
      var exactFiles = plus_0(tmp_2, mapNotNull(tmp_3, LibraryResolver$resolve$lambda_0(name)));
      var tmp$ret$11;
      $l$block_2: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var tmp0_iterator_3 = exactFiles.a1();
        while (tmp0_iterator_3.b1()) {
          var element_2 = tmp0_iterator_3.c1();
          var tmp$ret$10;
          $l$block_1: {
            // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
            if (Companion_getInstance_101().y1r().h1s()) {
              if (contains(element_2, 'i386')) {
                tmp$ret$10 = false;
                break $l$block_1;
              }
            }
            tmp$ret$10 = true;
          }
          if (tmp$ret$10) {
            tmp$ret$11 = element_2;
            break $l$block_2;
          }
        }
        tmp$ret$11 = null;
      }
      tmp = tmp$ret$11;
    }
    return tmp;
  }
}
class Companion_25 extends LibraryResolver {
  constructor() {
    Companion_instance_26 = null;
    super(get_FFIPlatformSyncIO(), Companion_getInstance_101());
    Companion_instance_26 = this;
  }
}
class FFILibSymJS {
  constructor(lib) {
    this.l1s_1 = lib;
    var tmp = this;
    tmp.m1s_1 = lazy(FFILibSymJS$symbolsByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.n1s_1 = lazy(FFILibSymJS$dylib$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.o1s_1 = lazy(FFILibSymJS$syms$delegate$lambda(this));
    this.p1s_1 = false;
  }
  r1s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m1s_1;
    symbolsByName$factory();
    return this_0.h3();
  }
  q1s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n1s_1;
    dylib$factory();
    return this_0.h3();
  }
  s1s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o1s_1;
    syms$factory();
    return this_0.h3();
  }
  g1q(name, type) {
    if (this.s1s() == null) {
      // Inline function 'kotlin.error' call
      var tmp = toString(getKClassFromExpression(this.l1s_1));
      var tmp_0 = this.l1s_1;
      var message = "Can't get symbol '" + name + "' for " + tmp + " : '" + toString((tmp_0 instanceof FFILib ? tmp_0 : THROW_CCE()).a1q_1) + "'";
      throw IllegalStateException.n4(toString(message));
    }
    var sym = ensureNotNull(this.r1s().f3(name));
    return preprocessFunc(sym.o1p_1, this.s1s()[name], name, sym.p1p_1);
  }
  p5() {
    if (this.p1s_1)
      return Unit_instance;
    this.q1s().close();
    this.p1s_1 = true;
  }
}
class FFIPlatformSyncIO$1 {
  h1r(path) {
    var tmp;
    try {
      Deno.statSync(path);
      tmp = true;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      tmp_0 = false;
      tmp = tmp_0;
    }
    return tmp;
  }
  j1r(path) {
    var tmp;
    try {
      tmp = Deno.statSync(path).isDirectory;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      tmp_0 = false;
      tmp = tmp_0;
    }
    return tmp;
  }
  l1r(path) {
    return Deno.readFileSync(path);
  }
  n1r(path) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList_0(toArray(Deno.readDirSync(path)));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.<no name provided>.listFiles.<anonymous>' call
      var tmp$ret$0 = item.name;
      destination.g(tmp$ret$0);
    }
    return destination;
  }
}
class Entry_0 {
  constructor(slice, data) {
    this.v1s_1 = slice;
    this.w1s_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.v1s_1.toString() + ', data=' + toString_0(this.w1s_1) + ')';
  }
  hashCode() {
    var result = this.v1s_1.hashCode();
    result = imul(result, 31) + (this.w1s_1 == null ? 0 : hashCode(this.w1s_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.v1s_1.equals(tmp0_other_with_cast.v1s_1))
      return false;
    if (!equals(this.w1s_1, tmp0_other_with_cast.w1s_1))
      return false;
    return true;
  }
}
class Bitmap {
  static p1v(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.c1v_1 = new Mixin();
    $this.d1v_1 = width;
    $this.e1v_1 = height;
    $this.f1v_1 = bpp;
    $this.g1v_1 = backingArray;
    $this.h1v_1 = RectangleInt.u1v(0, 0, $this.d1v_1, $this.e1v_1);
    $this.i1v_1 = null;
    $this.j1v_1 = premultiplied;
    $this.k1v_1 = false;
    var tmp = $this;
    tmp.l1v_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.m1v_1 = 0;
    $this.n1v_1 = null;
    $this.o1v_1 = false;
    return $this;
  }
  b1i(_set____db54di) {
    this.c1v_1.b1i(_set____db54di);
  }
  c1i() {
    return this.c1v_1.c1i();
  }
  d1() {
    return SizeInt.x1v(this.d1v_1, this.e1v_1);
  }
  y1v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l1v_1;
    tempInts$factory();
    return this_0.h3();
  }
  z1v() {
    return _RgbaArray___init__impl__oib4y4(this.y1v());
  }
  a1w() {
    return imul(this.d1v_1, this.f1v_1) / 8 | 0;
  }
  b1w() {
    return imul(this.d1v_1, this.e1v_1);
  }
  c1w(x, y) {
    return imul(y, this.d1v_1) + x | 0;
  }
  d1w() {
    if (!(this.n1v_1 == null)) {
      this.n1v_1 = null;
    }
  }
  d1g() {
    return Unit_instance;
  }
  e1w(rect) {
    if (this.n1v_1 == null)
      this.n1v_1 = rect;
    else
      this.n1v_1 = Companion_instance_77.f1w(ensureNotNull(this.n1v_1), rect);
    this.m1v_1 = this.m1v_1 + 1 | 0;
    return this.m1v_1;
  }
  g1w(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.h1w(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  i1w(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.j1w(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  k1w(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.i1w(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.i1w.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  l1w(x, y, color) {
    this.j1w(x, y, _RGBA___init__impl__lqpay5(color));
  }
  m1w(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.h1w(x, y));
  }
  n1w(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.o1w(srcX);
    var srcX1 = src.o1w(srcX + width | 0);
    var srcY0 = src.p1w(srcY);
    var srcY1 = src.p1w(srcY + height | 0);
    var dstX0 = dst.o1w(dstX);
    var dstX1 = dst.o1w(dstX + width | 0);
    var dstY0 = dst.p1w(dstY);
    var dstY1 = dst.p1w(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.q1w(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  q1w(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.g1w(srcX, srcY + y | 0, width, 1, this.y1v(), 0);
        dst.i1w(dstX, dstY + y | 0, width, 1, this.y1v(), 0);
      }
       while (inductionVariable < height);
  }
  o1w(x) {
    return clamp(x, 0, this.d1v_1);
  }
  p1w(y) {
    return clamp(y, 0, this.e1v_1);
  }
  r1w() {
    var inductionVariable = 0;
    var last = this.e1v_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.s1w(y, (this.e1v_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  t1w() {
    var inductionVariable = 0;
    var last = this.d1v_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.u1w(x, (this.d1v_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  v1w(rotation) {
    var tmp;
    switch (rotation.j3_1) {
      case 0:
        tmp = this.w1w();
        break;
      case 1:
        tmp = this.x1w().t1w();
        break;
      case 2:
        tmp = this.x1w().t1w().x1w().t1w();
        break;
      case 3:
        tmp = this.x1w().r1w();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  y1w(orientation) {
    var out = this.w1w();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.t1w();
    }
    return out.v1w(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  x1w() {
    var temp = new IntArray2(this.d1v_1, this.e1v_1, readPixelsUnsafe(this, 0, 0, this.d1v_1, this.e1v_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.e1v_1;
    var height = this.d1v_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.e1v_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.d1v_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.o1j(y, x, temp.n1j(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.z1w(this.e1v_1, this.d1v_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.k1w(0, 0, this.e1v_1, this.d1v_1, out.g1j_1);
    return this_0;
  }
  s1w(y0, y1) {
    var inductionVariable = 0;
    var last = this.d1v_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.m1w(x, y0);
        var c1 = this.m1w(x, y1);
        this.l1w(x, y0, c1);
        this.l1w(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  u1w(x0, x1) {
    var inductionVariable = 0;
    var last = this.e1v_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.m1w(x0, y);
        var c1 = this.m1w(x1, y);
        this.l1w(x0, y, c1);
        this.l1w(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  z1w(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString(this) + ')');
  }
  a1x() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.z1t(this.d1v_1, this.e1v_1, VOID, this.j1v_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.g1w(0, 0, this.d1v_1, this.e1v_1, this_0.w1t_1, 0);
    return this_0;
  }
  b1x() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.a1x();
    }
    return tmp;
  }
  w1w() {
    var out = this.z1w(this.d1v_1, this.e1v_1);
    this.q1w(0, 0, out, 0, 0, this.d1v_1, this.e1v_1);
    return out;
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_27 = this;
    this.e1x_1 = Bitmap32.z1t(0, 0, VOID, true);
  }
  f1x(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.z1t(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.w1t_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  g1x(width, height, premultiplied) {
    return Bitmap32.z1t(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.c1x_1 = this$0;
  }
  h1x($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2(this, $this$iterator, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.h1x(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static z1t(width, height, ints, premultiplied) {
    Companion_getInstance_28();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.p1v(width, height, 32, premultiplied, ints);
    $this.w1t_1 = ints;
    if ($this.w1t_1.length < imul(width, height))
      throw RuntimeException.v9('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.w1t_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.x1t_1 = new Int32Array(tmp$ret$0);
    $this.y1t_1 = RectangleInt.u1v(0, 0, width, height);
    return $this;
  }
  z1w(width, height) {
    return Bitmap32.z1t(width, height, VOID, this.j1v_1);
  }
  q1w(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.q1w(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.w1t_1;
    var dstArray = dst.w1t_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy_1(srcArray, src.c1w(srcX, srcY + y | 0), dstArray, dst.c1w(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  l1w(x, y, color) {
    this.w1t_1[this.c1w(x, y)] = color;
  }
  m1w(x, y) {
    return this.w1t_1[this.c1w(x, y)];
  }
  h1w(x, y) {
    return _RGBA___init__impl__lqpay5(this.m1w(x, y));
  }
  j1w(x, y, v) {
    return this.l1w(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  i1x(n, color) {
    this.w1t_1[n] = this.j1v_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  j1x(n, color) {
    var tmp;
    if (this.j1v_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.w1t_1[n] = tmp;
  }
  d1x(n) {
    var tmp;
    if (this.j1v_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.w1t_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.w1t_1[n]);
    }
    return tmp;
  }
  k1x(n) {
    return this.j1v_1 ? _RGBAPremultiplied___init__impl__uos02x(this.w1t_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.w1t_1[n]));
  }
  l1x(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.c1w(dx, dy + y | 0);
        var srcOffset = src.c1w(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.j1x(dstOffset + x | 0, mix(dst.k1x(dstOffset + x | 0), src.k1x(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.j1v_1 === src.j1v_1) {
            arraycopy_1(src.w1t_1, srcOffset, dst.w1t_1, dstOffset, width);
          } else if (!dst.j1v_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.i1x(dstOffset + x_0 | 0, src.d1x(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.j1x(dstOffset + x_1 | 0, src.k1x(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  m1x(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.d1v_1 - dx_0 | 0;
    var availableHeight = this.e1v_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.l1x(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  n1x(src, dx, dy, mix) {
    var b = get_bounds(src);
    this.m1x(get_bmp(src), dx, dy, b.o1x(), b.p1x(), b.q1x(), b.r1x(), mix);
  }
  s1x(src, dx, dy) {
    return this.n1x(src, dx, dy, true);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.ab('Bitmap32(');
    this_0.eg(this.d1v_1);
    this_0.ab(', ');
    this_0.eg(this.e1v_1);
    if (!(this.i1v_1 == null)) {
      this_0.ab(', name=');
      this_0.ab(this.i1v_1);
    }
    this_0.ab(')');
    return this_0.toString();
  }
  s1w(y0, y1) {
    var s0 = this.c1w(0, y0);
    var s1 = this.c1w(0, y1);
    arraycopy_1(this.w1t_1, s0, this.x1t_1, 0, this.d1v_1);
    arraycopy_1(this.w1t_1, s1, this.w1t_1, s0, this.d1v_1);
    arraycopy_1(this.x1t_1, 0, this.w1t_1, s1, this.d1v_1);
  }
  w1w() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.w1t_1.slice();
    return Bitmap32.z1t(this.d1v_1, this.e1v_1, tmp$ret$1, this.j1v_1);
  }
  t1x() {
    return this.j1v_1 ? this : this.copyPremultiplied();
  }
  u1x() {
    return !this.j1v_1 ? this : this.v1x();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.w1w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.w1x();
    return this_0;
  }
  v1x() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.w1w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.x1x();
    return this_0;
  }
  w1x() {
    if (this.j1v_1)
      return Unit_instance;
    this.j1v_1 = true;
    var inductionVariable = 0;
    var last = this.b1w();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w1t_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.w1t_1[n])));
      }
       while (inductionVariable < last);
  }
  x1x() {
    if (!this.j1v_1)
      return Unit_instance;
    this.j1v_1 = false;
    var inductionVariable = 0;
    var last = this.b1w();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.w1t_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.w1t_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  a1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  y1x(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_1(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.w1t_1, this.c1w(x, y), width);
    } else {
      var m = this.c1w(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.w1t_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  a1x() {
    return this;
  }
}
class Companion_27 {}
class BitmapIndexed extends Bitmap {
  static p1z(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_31.u1y(1 << bpp) : palette;
    var $this = this.p1v(width, height, bpp, false, bytes);
    $this.i1z_1 = bytes;
    $this.j1z_1 = palette;
    if ($this.i1z_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.v9('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.s1z().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.k1z_1 = new Int8Array(tmp$ret$0);
    $this.l1z_1 = _UByteArrayInt___init__impl__xif7bu($this.s1z());
    $this.m1z_1 = 8 / bpp | 0;
    $this.n1z_1 = ilog2_0($this.m1z_1);
    $this.o1z_1 = $this.m1z_1 - 1 | 0;
    return $this;
  }
  s1z() {
    return this.i1z_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.f1v_1 + ', width=' + this.d1v_1 + ', height=' + this.e1v_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.j1z_1) + ')';
  }
  m1w(x, y) {
    return this.r1z(this.c1w(x, y));
  }
  l1w(x, y, color) {
    return this.q1z(this.c1w(x, y), color);
  }
  r1z(n) {
    var iD = this.u1z(n);
    var iM = this.v1z(n);
    return extract_0(UByteArrayInt__get_impl_px6q8a(this.l1z_1, iD), imul(this.f1v_1, iM), this.f1v_1);
  }
  q1z(n, color) {
    var iD = this.u1z(n);
    var iM = this.v1z(n);
    UByteArrayInt__set_impl_gn4532(this.l1z_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.l1z_1, iD), color, imul(this.f1v_1, iM), this.f1v_1));
  }
  h1w(x, y) {
    var tmp = this.j1z_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.m1w(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  j1w(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.cd('An operation is not implemented: ' + reason);
  }
  t1z(x, y) {
    return this.u1z(this.c1w(x, y));
  }
  u1z(n) {
    return n >>> this.n1z_1 | 0;
  }
  v1z(n) {
    return n & this.o1z_1;
  }
  s1w(y0, y1) {
    var s0 = this.t1z(0, y0);
    var s1 = this.t1z(0, y1);
    arraycopy_2(this.s1z(), s0, this.k1z_1, 0, this.a1w());
    arraycopy_2(this.s1z(), s1, this.s1z(), s0, this.a1w());
    arraycopy_2(this.k1z_1, 0, this.s1z(), s1, this.a1w());
  }
  w1z(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_2(data, 0, this.s1z(), this.c1w(x, y), width / this.m1z_1 | 0);
    } else {
      var m = this.c1w(x, y);
      var inductionVariable = 0;
      var last = width / this.m1z_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.s1z()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  a1x() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.z1t(this.d1v_1, this.e1v_1, VOID, this.j1v_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.w1t_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.j1z_1);
    var inductionVariable = 0;
    var last = this.b1w();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.r1z(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static t1y(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_31.u1y(256) : palette;
    return this.p1z(8, width, height, data, palette);
  }
  z1w(width, height) {
    return Bitmap8.t1y(width, height, VOID, this.j1z_1);
  }
  l1w(x, y, color) {
    return this.q1z(this.c1w(x, y), color);
  }
  m1w(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.l1z_1, this.c1w(x, y));
  }
  h1w(x, y) {
    var tmp = this.j1z_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.m1w(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  r1z(n) {
    return UByteArrayInt__get_impl_px6q8a(this.l1z_1, n);
  }
  q1z(n, color) {
    UByteArrayInt__set_impl_gn4532(this.l1z_1, n, color);
  }
  q1w(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.q1w(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.s1z();
        var tmp_0 = this.c1w(srcX, srcY + y | 0);
        arraycopy_2(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).s1z(), dst.c1w(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  w1w() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.s1z().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.j1z_1).slice();
    return Bitmap8.t1y(this.d1v_1, this.e1v_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.d1v_1 + ', ' + this.e1v_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.j1z_1) + ')';
  }
}
class Bitmaps {}
class FloatBitmap32 extends Bitmap {}
class MultiBitmap extends Bitmap {}
class NativeImageRef {}
class NativeImage extends Bitmap {
  static x26(width, height, data, premultiplied) {
    var $this = this.p1v(width, height, 32, premultiplied, null);
    $this.w26_1 = data;
    return $this;
  }
  a1x() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_28().g1x(this.d1v_1, this.e1v_1, this.j1v_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.g1w(0, 0, this.d1v_1, this.e1v_1, this_0.w1t_1, 0);
    return this_0;
  }
  j1w(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.z1v(), 0, v);
    this.i1w(x, y, 1, 1, this.y1v(), 0);
  }
  h1w(x, y) {
    this.g1w(x, y, 1, 1, this.y1v(), 0);
    return RgbaArray__get_impl_nzyo1o(this.z1v(), 0);
  }
  l1w(x, y, color) {
    return this.j1w(x, y, _RGBA___init__impl__lqpay5(color));
  }
  m1w(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.h1w(x, y));
  }
  r1w() {
    var tmp = this.a1x().r1w();
    this.k1w(0, 0, this.d1v_1, this.e1v_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).w1t_1);
    return this;
  }
  t1w() {
    var tmp = this.a1x().t1w();
    this.k1w(0, 0, this.d1v_1, this.e1v_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).w1t_1);
    return this;
  }
  s1w(y0, y1) {
    this.g1w(0, y0, this.d1v_1, 1, this.y1v(), 0);
    this.g1w(0, y1, this.d1v_1, 1, this.y1v(), this.d1v_1);
    this.i1w(0, y1, this.d1v_1, 1, this.y1v(), 0);
    this.i1w(0, y0, this.d1v_1, 1, this.y1v(), this.d1v_1);
  }
  u1w(x0, x1) {
    this.g1w(x0, 0, 1, this.e1v_1, this.y1v(), 0);
    this.g1w(x1, 0, 1, this.e1v_1, this.y1v(), this.d1v_1);
    this.i1w(x1, 0, 1, this.e1v_1, this.y1v(), 0);
    this.i1w(x0, 0, 1, this.e1v_1, this.y1v(), this.d1v_1);
  }
  z1w(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.k3() + '(' + this.d1v_1 + ', ' + this.e1v_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class NullBitmap extends Bitmap {
  static b28(width, height, premultiplied) {
    Companion_getInstance_30();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.p1v(width, height, 32, premultiplied, null);
  }
  j1w(x, y, v) {
    return Unit_instance;
  }
  h1w(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_28 extends NullBitmap {
  static n27() {
    Companion_instance_29 = null;
    var $this = this.b28(1, 1);
    Companion_instance_29 = $this;
    return $this;
  }
}
class ColorFormat32 {
  constructor() {
    this.n28_1 = 32;
  }
  c28() {
    return this.n28_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.o28_1 = 24;
  }
  c28() {
    return this.o28_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.p28_1 = _r;
    this.q28_1 = _g;
    this.r28_1 = _b;
    this.s28_1 = _a;
    this.t28_1 = true;
    this.u28_1 = Colors_getInstance().r20_1;
  }
  v28() {
    return this.p28_1;
  }
  w28() {
    return this.q28_1;
  }
  x28() {
    return this.r28_1;
  }
  y28(value) {
    this.s28_1 = value;
    this.t28_1 = true;
  }
  z28() {
    return this.s28_1;
  }
  a29() {
    if (this.t28_1) {
      this.t28_1 = false;
      this.u28_1 = Companion_getInstance_33().b29(this.p28_1, this.q28_1, this.r28_1, this.s28_1);
    }
    return this.u28_1;
  }
  c29(r, g, b, a) {
    this.p28_1 = r;
    this.q28_1 = g;
    this.r28_1 = b;
    this.s28_1 = a;
    this.t28_1 = true;
  }
  d29(other) {
    return this.c29(other.p28_1, other.q28_1, other.r28_1, other.s28_1);
  }
  e29(a, b) {
    return this.c29(a.v28() * b.v28(), a.w28() * b.w28(), a.x28() * b.x28(), a.z28() * b.z28());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.p28_1 + ', _g=' + this.q28_1 + ', _b=' + this.r28_1 + ', _a=' + this.s28_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.p28_1);
    result = imul(result, 31) + getNumberHashCode(this.q28_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r28_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s28_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.p28_1, tmp0_other_with_cast.p28_1))
      return false;
    if (!equals(this.q28_1, tmp0_other_with_cast.q28_1))
      return false;
    if (!equals(this.r28_1, tmp0_other_with_cast.r28_1))
      return false;
    if (!equals(this.s28_1, tmp0_other_with_cast.s28_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.r20_1 = Companion_getInstance_33().m28(255, 255, 255, 255);
    this.s20_1 = Companion_getInstance_33().m28(0, 0, 0, 255);
    this.t20_1 = Companion_getInstance_33().m28(255, 0, 0, 255);
    this.u20_1 = Companion_getInstance_33().m28(0, 255, 0, 255);
    this.v20_1 = Companion_getInstance_33().m28(0, 0, 255, 255);
    this.w20_1 = Companion_getInstance_33().m28(0, 0, 0, 0);
    this.x20_1 = Companion_getInstance_33().m28(255, 255, 255, 0);
    this.y20_1 = Companion_getInstance_33().f29(240, 248, 255);
    this.z20_1 = Companion_getInstance_33().f29(250, 235, 215);
    this.a21_1 = Companion_getInstance_33().f29(0, 255, 255);
    this.b21_1 = Companion_getInstance_33().f29(127, 255, 212);
    this.c21_1 = Companion_getInstance_33().f29(240, 255, 255);
    this.d21_1 = Companion_getInstance_33().f29(245, 245, 220);
    this.e21_1 = Companion_getInstance_33().f29(255, 228, 196);
    this.f21_1 = Companion_getInstance_33().f29(255, 235, 205);
    this.g21_1 = Companion_getInstance_33().f29(138, 43, 226);
    this.h21_1 = Companion_getInstance_33().f29(165, 42, 42);
    this.i21_1 = Companion_getInstance_33().f29(222, 184, 135);
    this.j21_1 = Companion_getInstance_33().f29(95, 158, 160);
    this.k21_1 = Companion_getInstance_33().f29(127, 255, 0);
    this.l21_1 = Companion_getInstance_33().f29(210, 105, 30);
    this.m21_1 = Companion_getInstance_33().f29(255, 127, 80);
    this.n21_1 = Companion_getInstance_33().f29(100, 149, 237);
    this.o21_1 = Companion_getInstance_33().f29(255, 248, 220);
    this.p21_1 = Companion_getInstance_33().f29(220, 20, 60);
    this.q21_1 = Companion_getInstance_33().f29(0, 0, 139);
    this.r21_1 = Companion_getInstance_33().f29(0, 255, 255);
    this.s21_1 = Companion_getInstance_33().f29(0, 139, 139);
    this.t21_1 = Companion_getInstance_33().f29(184, 134, 11);
    this.u21_1 = Companion_getInstance_33().f29(169, 169, 169);
    this.v21_1 = Companion_getInstance_33().f29(0, 100, 0);
    this.w21_1 = Companion_getInstance_33().f29(169, 169, 169);
    this.x21_1 = Companion_getInstance_33().f29(189, 183, 107);
    this.y21_1 = Companion_getInstance_33().f29(255, 0, 255);
    this.z21_1 = Companion_getInstance_33().f29(139, 0, 139);
    this.a22_1 = Companion_getInstance_33().f29(85, 107, 47);
    this.b22_1 = Companion_getInstance_33().f29(255, 140, 0);
    this.c22_1 = Companion_getInstance_33().f29(153, 50, 204);
    this.d22_1 = Companion_getInstance_33().f29(139, 0, 0);
    this.e22_1 = Companion_getInstance_33().f29(233, 150, 122);
    this.f22_1 = Companion_getInstance_33().f29(143, 188, 143);
    this.g22_1 = Companion_getInstance_33().f29(72, 61, 139);
    this.h22_1 = Companion_getInstance_33().f29(47, 79, 79);
    this.i22_1 = Companion_getInstance_33().f29(47, 79, 79);
    this.j22_1 = Companion_getInstance_33().f29(0, 206, 209);
    this.k22_1 = Companion_getInstance_33().f29(148, 0, 211);
    this.l22_1 = Companion_getInstance_33().f29(255, 20, 147);
    this.m22_1 = Companion_getInstance_33().f29(0, 191, 255);
    this.n22_1 = Companion_getInstance_33().f29(105, 105, 105);
    this.o22_1 = Companion_getInstance_33().f29(105, 105, 105);
    this.p22_1 = Companion_getInstance_33().f29(30, 144, 255);
    this.q22_1 = Companion_getInstance_33().f29(178, 34, 34);
    this.r22_1 = Companion_getInstance_33().f29(255, 250, 240);
    this.s22_1 = Companion_getInstance_33().f29(34, 139, 34);
    this.t22_1 = Companion_getInstance_33().f29(255, 0, 255);
    this.u22_1 = Companion_getInstance_33().f29(220, 220, 220);
    this.v22_1 = Companion_getInstance_33().f29(248, 248, 255);
    this.w22_1 = Companion_getInstance_33().f29(255, 215, 0);
    this.x22_1 = Companion_getInstance_33().f29(218, 165, 32);
    this.y22_1 = Companion_getInstance_33().f29(173, 255, 47);
    this.z22_1 = Companion_getInstance_33().f29(240, 255, 240);
    this.a23_1 = Companion_getInstance_33().f29(255, 105, 180);
    this.b23_1 = Companion_getInstance_33().f29(205, 92, 92);
    this.c23_1 = Companion_getInstance_33().f29(75, 0, 130);
    this.d23_1 = Companion_getInstance_33().f29(255, 255, 240);
    this.e23_1 = Companion_getInstance_33().f29(240, 230, 140);
    this.f23_1 = Companion_getInstance_33().f29(230, 230, 250);
    this.g23_1 = Companion_getInstance_33().f29(255, 240, 245);
    this.h23_1 = Companion_getInstance_33().f29(124, 252, 0);
    this.i23_1 = Companion_getInstance_33().f29(255, 250, 205);
    this.j23_1 = Companion_getInstance_33().f29(173, 216, 230);
    this.k23_1 = Companion_getInstance_33().f29(240, 128, 128);
    this.l23_1 = Companion_getInstance_33().f29(224, 255, 255);
    this.m23_1 = Companion_getInstance_33().f29(250, 250, 210);
    this.n23_1 = Companion_getInstance_33().f29(211, 211, 211);
    this.o23_1 = Companion_getInstance_33().f29(144, 238, 144);
    this.p23_1 = Companion_getInstance_33().f29(211, 211, 211);
    this.q23_1 = Companion_getInstance_33().f29(255, 182, 193);
    this.r23_1 = Companion_getInstance_33().f29(255, 160, 122);
    this.s23_1 = Companion_getInstance_33().f29(32, 178, 170);
    this.t23_1 = Companion_getInstance_33().f29(135, 206, 250);
    this.u23_1 = Companion_getInstance_33().f29(119, 136, 153);
    this.v23_1 = Companion_getInstance_33().f29(119, 136, 153);
    this.w23_1 = Companion_getInstance_33().f29(176, 196, 222);
    this.x23_1 = Companion_getInstance_33().f29(255, 255, 224);
    this.y23_1 = Companion_getInstance_33().f29(0, 255, 0);
    this.z23_1 = Companion_getInstance_33().f29(50, 205, 50);
    this.a24_1 = Companion_getInstance_33().f29(250, 240, 230);
    this.b24_1 = Companion_getInstance_33().f29(128, 0, 0);
    this.c24_1 = Companion_getInstance_33().f29(102, 205, 170);
    this.d24_1 = Companion_getInstance_33().f29(0, 0, 205);
    this.e24_1 = Companion_getInstance_33().f29(186, 85, 211);
    this.f24_1 = Companion_getInstance_33().f29(147, 112, 219);
    this.g24_1 = Companion_getInstance_33().f29(60, 179, 113);
    this.h24_1 = Companion_getInstance_33().f29(123, 104, 238);
    this.i24_1 = Companion_getInstance_33().f29(0, 250, 154);
    this.j24_1 = Companion_getInstance_33().f29(72, 209, 204);
    this.k24_1 = Companion_getInstance_33().f29(199, 21, 133);
    this.l24_1 = Companion_getInstance_33().f29(25, 25, 112);
    this.m24_1 = Companion_getInstance_33().f29(245, 255, 250);
    this.n24_1 = Companion_getInstance_33().f29(255, 228, 225);
    this.o24_1 = Companion_getInstance_33().f29(255, 228, 181);
    this.p24_1 = Companion_getInstance_33().f29(255, 222, 173);
    this.q24_1 = Companion_getInstance_33().f29(0, 0, 128);
    this.r24_1 = Companion_getInstance_33().f29(253, 245, 230);
    this.s24_1 = Companion_getInstance_33().f29(128, 128, 0);
    this.t24_1 = Companion_getInstance_33().f29(107, 142, 35);
    this.u24_1 = Companion_getInstance_33().f29(255, 165, 0);
    this.v24_1 = Companion_getInstance_33().f29(255, 69, 0);
    this.w24_1 = Companion_getInstance_33().f29(218, 112, 214);
    this.x24_1 = Companion_getInstance_33().f29(238, 232, 170);
    this.y24_1 = Companion_getInstance_33().f29(152, 251, 152);
    this.z24_1 = Companion_getInstance_33().f29(175, 238, 238);
    this.a25_1 = Companion_getInstance_33().f29(219, 112, 147);
    this.b25_1 = Companion_getInstance_33().f29(255, 239, 213);
    this.c25_1 = Companion_getInstance_33().f29(255, 218, 185);
    this.d25_1 = Companion_getInstance_33().f29(205, 133, 63);
    this.e25_1 = Companion_getInstance_33().f29(255, 192, 203);
    this.f25_1 = Companion_getInstance_33().f29(221, 160, 221);
    this.g25_1 = Companion_getInstance_33().f29(176, 224, 230);
    this.h25_1 = Companion_getInstance_33().f29(128, 0, 128);
    this.i25_1 = Companion_getInstance_33().f29(188, 143, 143);
    this.j25_1 = Companion_getInstance_33().f29(65, 105, 225);
    this.k25_1 = Companion_getInstance_33().f29(139, 69, 19);
    this.l25_1 = Companion_getInstance_33().f29(250, 128, 114);
    this.m25_1 = Companion_getInstance_33().f29(244, 164, 96);
    this.n25_1 = Companion_getInstance_33().f29(46, 139, 87);
    this.o25_1 = Companion_getInstance_33().f29(255, 245, 238);
    this.p25_1 = Companion_getInstance_33().f29(160, 82, 45);
    this.q25_1 = Companion_getInstance_33().f29(192, 192, 192);
    this.r25_1 = Companion_getInstance_33().f29(135, 206, 235);
    this.s25_1 = Companion_getInstance_33().f29(106, 90, 205);
    this.t25_1 = Companion_getInstance_33().f29(112, 128, 144);
    this.u25_1 = Companion_getInstance_33().f29(112, 128, 144);
    this.v25_1 = Companion_getInstance_33().f29(255, 250, 250);
    this.w25_1 = Companion_getInstance_33().f29(0, 255, 127);
    this.x25_1 = Companion_getInstance_33().f29(70, 130, 180);
    this.y25_1 = Companion_getInstance_33().f29(210, 180, 140);
    this.z25_1 = Companion_getInstance_33().f29(0, 128, 128);
    this.a26_1 = Companion_getInstance_33().f29(216, 191, 216);
    this.b26_1 = Companion_getInstance_33().f29(255, 99, 71);
    this.c26_1 = Companion_getInstance_33().f29(64, 224, 208);
    this.d26_1 = Companion_getInstance_33().f29(238, 130, 238);
    this.e26_1 = Companion_getInstance_33().f29(245, 222, 179);
    this.f26_1 = Companion_getInstance_33().f29(245, 245, 245);
    this.g26_1 = Companion_getInstance_33().f29(154, 205, 50);
    this.h26_1 = Companion_getInstance_33().f29(255, 255, 0);
    this.i26_1 = mapOf([to('black', new RGBA(this.s20_1)), to('white', new RGBA(this.r20_1)), to('red', new RGBA(this.t20_1)), to('green', new RGBA(this.u20_1)), to('blue', new RGBA(this.v20_1)), to('aliceblue', new RGBA(this.y20_1)), to('antiquewhite', new RGBA(this.z20_1)), to('aqua', new RGBA(this.a21_1)), to('aquamarine', new RGBA(this.b21_1)), to('azure', new RGBA(this.c21_1)), to('beige', new RGBA(this.d21_1)), to('bisque', new RGBA(this.e21_1)), to('blanchedalmond', new RGBA(this.f21_1)), to('blueviolet', new RGBA(this.g21_1)), to('brown', new RGBA(this.h21_1)), to('burlywood', new RGBA(this.i21_1)), to('cadetblue', new RGBA(this.j21_1)), to('chartreuse', new RGBA(this.k21_1)), to('chocolate', new RGBA(this.l21_1)), to('coral', new RGBA(this.m21_1)), to('cornflowerblue', new RGBA(this.n21_1)), to('cornsilk', new RGBA(this.o21_1)), to('crimson', new RGBA(this.p21_1)), to('cyan', new RGBA(this.r21_1)), to('darkblue', new RGBA(this.q21_1)), to('darkcyan', new RGBA(this.s21_1)), to('darkgoldenrod', new RGBA(this.t21_1)), to('darkgray', new RGBA(this.u21_1)), to('darkgreen', new RGBA(this.v21_1)), to('darkgrey', new RGBA(this.w21_1)), to('darkkhaki', new RGBA(this.x21_1)), to('darkmagenta', new RGBA(this.z21_1)), to('darkolivegreen', new RGBA(this.a22_1)), to('darkorange', new RGBA(this.b22_1)), to('darkorchid', new RGBA(this.c22_1)), to('darkred', new RGBA(this.d22_1)), to('darksalmon', new RGBA(this.e22_1)), to('darkseagreen', new RGBA(this.f22_1)), to('darkslateblue', new RGBA(this.g22_1)), to('darkslategray', new RGBA(this.h22_1)), to('darkslategrey', new RGBA(this.i22_1)), to('darkturquoise', new RGBA(this.j22_1)), to('darkviolet', new RGBA(this.k22_1)), to('deeppink', new RGBA(this.l22_1)), to('deepskyblue', new RGBA(this.m22_1)), to('dimgray', new RGBA(this.n22_1)), to('dimgrey', new RGBA(this.o22_1)), to('dodgerblue', new RGBA(this.p22_1)), to('firebrick', new RGBA(this.q22_1)), to('floralwhite', new RGBA(this.r22_1)), to('forestgreen', new RGBA(this.s22_1)), to('fuchsia', new RGBA(this.t22_1)), to('gainsboro', new RGBA(this.u22_1)), to('ghostwhite', new RGBA(this.v22_1)), to('gold', new RGBA(this.w22_1)), to('goldenrod', new RGBA(this.x22_1)), to('greenyellow', new RGBA(this.y22_1)), to('honeydew', new RGBA(this.z22_1)), to('hotpink', new RGBA(this.a23_1)), to('indianred', new RGBA(this.b23_1)), to('indigo', new RGBA(this.c23_1)), to('ivory', new RGBA(this.d23_1)), to('khaki', new RGBA(this.e23_1)), to('lavender', new RGBA(this.f23_1)), to('lavenderblush', new RGBA(this.g23_1)), to('lawngreen', new RGBA(this.h23_1)), to('lemonchiffon', new RGBA(this.i23_1)), to('lightblue', new RGBA(this.j23_1)), to('lightcoral', new RGBA(this.k23_1)), to('lightcyan', new RGBA(this.l23_1)), to('lightgoldenrodyellow', new RGBA(this.m23_1)), to('lightgray', new RGBA(this.n23_1)), to('lightgreen', new RGBA(this.o23_1)), to('lightgrey', new RGBA(this.p23_1)), to('lightpink', new RGBA(this.q23_1)), to('lightsalmon', new RGBA(this.r23_1)), to('lightseagreen', new RGBA(this.s23_1)), to('lightskyblue', new RGBA(this.t23_1)), to('lightslategray', new RGBA(this.u23_1)), to('lightslategrey', new RGBA(this.v23_1)), to('lightsteelblue', new RGBA(this.w23_1)), to('lightyellow', new RGBA(this.x23_1)), to('lime', new RGBA(this.y23_1)), to('limegreen', new RGBA(this.z23_1)), to('linen', new RGBA(this.a24_1)), to('magenta', new RGBA(this.y21_1)), to('maroon', new RGBA(this.b24_1)), to('mediumaquamarine', new RGBA(this.c24_1)), to('mediumblue', new RGBA(this.d24_1)), to('mediumorchid', new RGBA(this.e24_1)), to('mediumpurple', new RGBA(this.f24_1)), to('mediumseagreen', new RGBA(this.g24_1)), to('mediumslateblue', new RGBA(this.h24_1)), to('mediumspringgreen', new RGBA(this.i24_1)), to('mediumturquoise', new RGBA(this.j24_1)), to('mediumvioletred', new RGBA(this.k24_1)), to('midnightblue', new RGBA(this.l24_1)), to('mintcream', new RGBA(this.m24_1)), to('mistyrose', new RGBA(this.n24_1)), to('moccasin', new RGBA(this.o24_1)), to('navajowhite', new RGBA(this.p24_1)), to('navy', new RGBA(this.q24_1)), to('oldlace', new RGBA(this.r24_1)), to('olive', new RGBA(this.s24_1)), to('olivedrab', new RGBA(this.t24_1)), to('orange', new RGBA(this.u24_1)), to('orangered', new RGBA(this.v24_1)), to('orchid', new RGBA(this.w24_1)), to('palegoldenrod', new RGBA(this.x24_1)), to('palegreen', new RGBA(this.y24_1)), to('paleturquoise', new RGBA(this.z24_1)), to('palevioletred', new RGBA(this.a25_1)), to('papayawhip', new RGBA(this.b25_1)), to('peachpuff', new RGBA(this.c25_1)), to('peru', new RGBA(this.d25_1)), to('pink', new RGBA(this.e25_1)), to('plum', new RGBA(this.f25_1)), to('powderblue', new RGBA(this.g25_1)), to('purple', new RGBA(this.h25_1)), to('rosybrown', new RGBA(this.i25_1)), to('royalblue', new RGBA(this.j25_1)), to('saddlebrown', new RGBA(this.k25_1)), to('salmon', new RGBA(this.l25_1)), to('sandybrown', new RGBA(this.m25_1)), to('seagreen', new RGBA(this.n25_1)), to('seashell', new RGBA(this.o25_1)), to('sienna', new RGBA(this.p25_1)), to('silver', new RGBA(this.q25_1)), to('skyblue', new RGBA(this.r25_1)), to('slateblue', new RGBA(this.s25_1)), to('slategray', new RGBA(this.t25_1)), to('slategrey', new RGBA(this.u25_1)), to('snow', new RGBA(this.v25_1)), to('springgreen', new RGBA(this.w25_1)), to('steelblue', new RGBA(this.x25_1)), to('tan', new RGBA(this.y25_1)), to('teal', new RGBA(this.z25_1)), to('thistle', new RGBA(this.a26_1)), to('tomato', new RGBA(this.b26_1)), to('turquoise', new RGBA(this.c26_1)), to('violet', new RGBA(this.d26_1)), to('wheat', new RGBA(this.e26_1)), to('whitesmoke', new RGBA(this.f26_1)), to('yellowgreen', new RGBA(this.g26_1)), to('yellow', new RGBA(this.h26_1))]);
  }
  g29(str) {
    return this.h29(str, this.w20_1, true);
  }
  h29(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr_0(str, 1);
        if (!setOf([3, 4, 6, 8]).p2(hex.length))
          return this.s20_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_1(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_1(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_1(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_1(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_33().m28(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.d1() : false) {
          tmp = parts.f1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.d1() : false) {
          tmp_0 = parts.f1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.d1() : false) {
          tmp_1 = parts.f1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.d1() : false) {
          tmp_2 = parts.f1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_33().m28(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.i26_1.f3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.i29_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.j29('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().t20_1;
      } else {
        throw $p;
      }
    }
  }
  j29(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.h29(str, default_0, errorOnDefault) : $super.h29.call(this, str, new RGBA(default_0), errorOnDefault).i29_1;
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_31();
    super();
    this.l29_1 = rOffset;
    this.m29_1 = gOffset;
    this.n29_1 = bOffset;
  }
  d28(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.l29_1 | 0) & 255;
  }
  e28(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.m29_1 | 0) & 255;
  }
  f28(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.n29_1 | 0) & 255;
  }
  g28(v) {
    return 255;
  }
}
class Companion_29 extends RGB {
  constructor() {
    Companion_instance_30 = null;
    super(0, 8, 16);
    Companion_instance_30 = this;
  }
}
class Companion_30 {
  u1y(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class Companion_31 extends ColorFormat32 {
  constructor() {
    Companion_instance_32 = null;
    super();
    Companion_instance_32 = this;
    this.i28_1 = 0;
    this.j28_1 = 8;
    this.k28_1 = 16;
    this.l28_1 = 24;
  }
  b29(r, g, b, a) {
    return this.o29(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  o29(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  m28(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  f29(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  d28(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  e28(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  f28(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  g28(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_33();
    this.i29_1 = value;
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.i29_1);
  }
  p29(other) {
    return RGBA__compareTo_impl_lrfjc1(this.i29_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.i29_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.i29_1, other);
  }
}
class Companion_32 {
  q29(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_33 {}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.r29_1 = fontSize;
    this.s29_1 = id;
    this.t29_1 = texture;
    this.u29_1 = xoffset;
    this.v29_1 = yoffset;
    this.w29_1 = xadvance;
    var tmp = this;
    tmp.x29_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.y29_1 = new GlyphMetrics(this.r29_1, true, -1, Companion_getInstance_77().c2a(this.u29_1, this.v29_1, this.t29_1.j1u_1, this.t29_1.k1u_1), this.w29_1);
  }
  toString() {
    return 'Glyph(fontSize=' + this.r29_1 + ', id=' + this.s29_1 + ', texture=' + this.t29_1.toString() + ', xoffset=' + this.u29_1 + ', yoffset=' + this.v29_1 + ', xadvance=' + this.w29_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.r29_1);
    result = imul(result, 31) + this.s29_1 | 0;
    result = imul(result, 31) + this.t29_1.hashCode() | 0;
    result = imul(result, 31) + this.u29_1 | 0;
    result = imul(result, 31) + this.v29_1 | 0;
    result = imul(result, 31) + this.w29_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.r29_1, tmp0_other_with_cast.r29_1))
      return false;
    if (!(this.s29_1 === tmp0_other_with_cast.s29_1))
      return false;
    if (!this.t29_1.equals(tmp0_other_with_cast.t29_1))
      return false;
    if (!(this.u29_1 === tmp0_other_with_cast.u29_1))
      return false;
    if (!(this.v29_1 === tmp0_other_with_cast.v29_1))
      return false;
    if (!(this.w29_1 === tmp0_other_with_cast.w29_1))
      return false;
    return true;
  }
}
class BitmapFont {}
function get_3(charCode) {
  var tmp0_elvis_lhs = this.g2a(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.g2a(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.f2a() : tmp1_elvis_lhs;
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.h2a_1 = new Mixin();
    this.i2a_1 = fontSize;
    this.j2a_1 = lineHeight;
    this.k2a_1 = base;
    this.l2a_1 = glyphs;
    this.m2a_1 = kernings;
    this.n2a_1 = name;
    this.o2a_1 = distanceField;
    this.p2a_1 = this.j2a_1 - this.k2a_1;
    var tmp = this;
    tmp.q2a_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.r2a_1 = new GlyphMetrics(this.i2a_1, false, 0, Companion_getInstance_77().v2a(), 0.0);
    var tmp_0 = this;
    tmp_0.s2a_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t2a_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  b1i(_set____db54di) {
    this.h2a_1.b1i(_set____db54di);
  }
  c1i() {
    return this.h2a_1.c1i();
  }
  d2a() {
    return this.i2a_1;
  }
  e2a() {
    return this.m2a_1;
  }
  c1j() {
    return this;
  }
  g2a(codePoint) {
    return this.l2a_1.f1(codePoint);
  }
  f2a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s2a_1;
    anyGlyph$factory();
    return this_0.h3();
  }
  u2a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t2a_1;
    invalidGlyph$factory();
    return this_0.h3();
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.w2a_1 = size;
    this.x2a_1 = top;
    this.y2a_1 = ascent;
    this.z2a_1 = baseline;
    this.a2b_1 = descent;
    this.b2b_1 = bottom;
    this.c2b_1 = lineGap;
    this.d2b_1 = maxWidth;
    this.e2b_1 = unitsPerEm;
  }
  f2b() {
    // Inline function 'kotlin.math.max' call
    var a = this.y2a_1;
    var b = this.x2a_1;
    return Math.max(a, b);
  }
  g2b() {
    // Inline function 'kotlin.math.min' call
    var a = this.a2b_1;
    var b = this.b2b_1;
    return Math.min(a, b);
  }
  h2b() {
    return this.f2b() - this.g2b();
  }
  i2b() {
    return this.h2b() + this.c2b_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.ab('FontMetrics(');
    this_0.ab('size=' + niceStr(this.w2a_1, 1) + ', ');
    this_0.ab('top=' + niceStr(this.x2a_1, 1) + ', ');
    this_0.ab('ascent=' + niceStr(this.y2a_1, 1) + ', ');
    this_0.ab('baseline=' + niceStr(this.z2a_1, 1) + ', ');
    this_0.ab('descent=' + niceStr(this.a2b_1, 1) + ', ');
    this_0.ab('bottom=' + niceStr(this.b2b_1, 1) + ', ');
    this_0.ab('lineGap=' + niceStr(this.c2b_1, 1) + ', ');
    this_0.ab('unitsPerEm=' + niceStr(this.e2b_1, 1) + ', ');
    this_0.ab('maxWidth=' + niceStr(this.d2b_1, 1) + ', ');
    this_0.ab('lineHeight=' + niceStr(this.i2b(), 1));
    this_0.ab(')');
    return this_0.toString();
  }
  hashCode() {
    var result = getNumberHashCode(this.w2a_1);
    result = imul(result, 31) + getNumberHashCode(this.x2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.w2a_1, tmp0_other_with_cast.w2a_1))
      return false;
    if (!equals(this.x2a_1, tmp0_other_with_cast.x2a_1))
      return false;
    if (!equals(this.y2a_1, tmp0_other_with_cast.y2a_1))
      return false;
    if (!equals(this.z2a_1, tmp0_other_with_cast.z2a_1))
      return false;
    if (!equals(this.a2b_1, tmp0_other_with_cast.a2b_1))
      return false;
    if (!equals(this.b2b_1, tmp0_other_with_cast.b2b_1))
      return false;
    if (!equals(this.c2b_1, tmp0_other_with_cast.c2b_1))
      return false;
    if (!equals(this.d2b_1, tmp0_other_with_cast.d2b_1))
      return false;
    if (!equals(this.e2b_1, tmp0_other_with_cast.e2b_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_77().v2a() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.j2b_1 = size;
    this.k2b_1 = existing;
    this.l2b_1 = codePoint;
    this.m2b_1 = bounds;
    this.n2b_1 = xadvance;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.ab('GlyphMetrics(');
    this_0.ab('codePoint=' + this.l2b_1 + " ('" + toString_1(numberToChar(this.l2b_1)) + "'), ");
    this_0.ab('existing=' + this.k2b_1 + ', ');
    this_0.ab('xadvance=' + roundToInt(this.n2b_1) + ', ');
    this_0.ab('bounds=' + this.m2b_1.b2().toString());
    this_0.ab(')');
    return this_0.toString();
  }
  hashCode() {
    var result = getNumberHashCode(this.j2b_1);
    result = imul(result, 31) + getBooleanHashCode(this.k2b_1) | 0;
    result = imul(result, 31) + this.l2b_1 | 0;
    result = imul(result, 31) + this.m2b_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.n2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.j2b_1, tmp0_other_with_cast.j2b_1))
      return false;
    if (!(this.k2b_1 === tmp0_other_with_cast.k2b_1))
      return false;
    if (!(this.l2b_1 === tmp0_other_with_cast.l2b_1))
      return false;
    if (!this.m2b_1.equals(tmp0_other_with_cast.m2b_1))
      return false;
    if (!equals(this.n2b_1, tmp0_other_with_cast.n2b_1))
      return false;
    return true;
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_35 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pb(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.v2b_1;
      destination.x2(tmp$ret$0, element);
    }
    tmp.x2b_1 = destination;
  }
  f1(index) {
    var tmp0_elvis_lhs = this.x2b_1.f3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.v2b_1 = id;
    this.w2b_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.z2b_1 = Companion_getInstance_65().p1a('EXIF');
  }
  j2c(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx(this, ss, info, debug, $completion), $completion);
  }
  k2c(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.j2c(ss, info, debug, $completion) : $super.j2c.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.l2c_1 = function_0;
  }
  zh(a, b) {
    return this.l2c_1(a, b);
  }
  compare(a, b) {
    return this.zh(a, b);
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.j1();
      var tmp0_iterator = frames.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.s2c_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.r(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.a1();
      while (tmp0_iterator_0.b1()) {
        var item = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.u2c_1;
        destination_0.g(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.e2d_1 = frames;
    this.f2d_1 = direction;
    this.g2d_1 = name;
    this.h2d_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull(this.e2d_1);
    tmp_1.i2d_1 = tmp0_elvis_lhs == null ? ImageFrame.j2d(0) : tmp0_elvis_lhs;
  }
}
class Companion_35 {
  k2d(simple) {
    return new ImageData(listOf(Companion_instance_38.l2d(simple)));
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.m2d_1 = function_0;
  }
  zh(a, b) {
    return this.m2d_1(a, b);
  }
  compare(a, b) {
    return this.zh(a, b);
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp371_safe_receiver = firstOrNull(frames);
      var tmp0_elvis_lhs = tmp371_safe_receiver == null ? null : tmp371_safe_receiver.h1j();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp372_safe_receiver = firstOrNull(frames);
      var tmp1_elvis_lhs = tmp372_safe_receiver == null ? null : tmp372_safe_receiver.i1j();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.p2d_1 = new Mixin();
    this.q2d_1 = frames;
    this.r2d_1 = loopCount;
    this.s2d_1 = width;
    this.t2d_1 = height;
    this.u2d_1 = layers;
    this.v2d_1 = animations;
    this.w2d_1 = name;
    this.x2d_1 = new ImageAnimation(this.q2d_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.v2d_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pb(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.g2d_1;
      destination.x2(tmp$ret$0, element);
    }
    tmp_1.y2d_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.q2d_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.pb(capacity_0);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.k3();
      destination_0.x2(tmp$ret$3, element_0);
    }
    tmp_2.z2d_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.q2d_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_4);
    tmp_3.a2e_1 = sortedWith(this_2, tmp$ret$6);
  }
  b1i(_set____db54di) {
    this.p2d_1.b1i(_set____db54di);
  }
  c1i() {
    return this.p2d_1.c1i();
  }
  b2e() {
    var tmp373_safe_receiver = firstOrNull(this.a2e_1);
    var tmp0_elvis_lhs = tmp373_safe_receiver == null ? null : tmp373_safe_receiver.n2d();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.m('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString(this.q2d_1) + ')';
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_37 = this;
    this.c2e_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.d2e_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.e2e_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_38();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.f2e_1 = filename;
    this.g2e_1 = width;
    this.h2e_1 = height;
    this.i2e_1 = premultiplied;
    this.j2e_1 = asumePremultiplied;
    this.k2e_1 = requestedMaxSize;
    this.l2e_1 = debug;
    this.m2e_1 = preferKotlinDecoder;
    this.n2e_1 = tryNativeDecode;
    this.o2e_1 = format;
    this.p2e_1 = out;
    this.q2e_1 = extra;
  }
  b1i(_set____db54di) {
    this.q2e_1 = _set____db54di;
  }
  c1i() {
    return this.q2e_1;
  }
  r2e() {
    return this;
  }
  s2e() {
    var tmp0_elvis_lhs = this.i2e_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  t2e(filename) {
    return this.u2e(filename);
  }
  v2e(file) {
    return this.t2e(get_baseName(file));
  }
  w2e(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  u2e(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.f2e_1 : filename;
    width = width === VOID ? this.g2e_1 : width;
    height = height === VOID ? this.h2e_1 : height;
    premultiplied = premultiplied === VOID ? this.i2e_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.j2e_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.k2e_1 : requestedMaxSize;
    debug = debug === VOID ? this.l2e_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.m2e_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.n2e_1 : tryNativeDecode;
    format = format === VOID ? this.o2e_1 : format;
    out = out === VOID ? this.p2e_1 : out;
    extra = extra === VOID ? this.q2e_1 : extra;
    return $super === VOID ? this.w2e(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.w2e.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.f2e_1 + ', width=' + this.g2e_1 + ', height=' + this.h2e_1 + ', premultiplied=' + this.i2e_1 + ', asumePremultiplied=' + this.j2e_1 + ', requestedMaxSize=' + this.k2e_1 + ', debug=' + this.l2e_1 + ', preferKotlinDecoder=' + this.m2e_1 + ', tryNativeDecode=' + this.n2e_1 + ', format=' + toString_0(this.o2e_1) + ', out=' + toString_0(this.p2e_1) + ', extra=' + toString_0(this.q2e_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.f2e_1);
    result = imul(result, 31) + (this.g2e_1 == null ? 0 : this.g2e_1) | 0;
    result = imul(result, 31) + (this.h2e_1 == null ? 0 : this.h2e_1) | 0;
    result = imul(result, 31) + (this.i2e_1 == null ? 0 : getBooleanHashCode(this.i2e_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j2e_1) | 0;
    result = imul(result, 31) + (this.k2e_1 == null ? 0 : this.k2e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l2e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m2e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n2e_1) | 0;
    result = imul(result, 31) + (this.o2e_1 == null ? 0 : hashCode(this.o2e_1)) | 0;
    result = imul(result, 31) + (this.p2e_1 == null ? 0 : hashCode(this.p2e_1)) | 0;
    result = imul(result, 31) + (this.q2e_1 == null ? 0 : hashCode(this.q2e_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.f2e_1 === tmp0_other_with_cast.f2e_1))
      return false;
    if (!(this.g2e_1 == tmp0_other_with_cast.g2e_1))
      return false;
    if (!(this.h2e_1 == tmp0_other_with_cast.h2e_1))
      return false;
    if (!(this.i2e_1 == tmp0_other_with_cast.i2e_1))
      return false;
    if (!(this.j2e_1 === tmp0_other_with_cast.j2e_1))
      return false;
    if (!(this.k2e_1 == tmp0_other_with_cast.k2e_1))
      return false;
    if (!(this.l2e_1 === tmp0_other_with_cast.l2e_1))
      return false;
    if (!(this.m2e_1 === tmp0_other_with_cast.m2e_1))
      return false;
    if (!(this.n2e_1 === tmp0_other_with_cast.n2e_1))
      return false;
    if (!equals(this.o2e_1, tmp0_other_with_cast.o2e_1))
      return false;
    if (!equals(this.p2e_1, tmp0_other_with_cast.p2e_1))
      return false;
    if (!equals(this.q2e_1, tmp0_other_with_cast.q2e_1))
      return false;
    return true;
  }
}
class ImageFormat {
  static a2f(exts) {
    var $this = createThis(this);
    var tmp = $this;
    tmp.x2e_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.g(tmp$ret$3);
    }
    tmp_0.y2e_1 = toSet(destination);
    return $this;
  }
  r2e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x2e_1;
    decodingProps$factory();
    return this_0.h3();
  }
  b2f(s, props) {
    throw NotImplementedError.cd();
  }
  c2f(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.z2e(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.e2f_1 = bmp.d1v_1;
      this_0.f2f_1 = bmp.e1v_1;
      this_0.g2f_1 = bmp.f1v_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  z2e(s, props) {
    return this.b2f(s, props).b2e();
  }
  h2f(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.c2f(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  i2f(data, props) {
    return this.z2e(openSync(data), props);
  }
  j2f(data, props, $completion) {
    return this.i2f(data, props);
  }
  k2f(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq(this, file, props, $completion), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString(this.y2e_1) + ')';
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static p2f(formats) {
    var $this = this.a2f(['']);
    $this.n2f_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static q2f(formats) {
    return this.p2f(toList_0(formats));
  }
  r2f(_set____db54di) {
    var this_0 = this.n2f_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  s2f() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.n2f_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  o2f() {
    return this.s2f();
  }
  t2f(ext) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.o2f().a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExtOrNull.<anonymous>' call
        if (element.y2e_1.p2(ext)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  u2f(ext) {
    var tmp0_elvis_lhs = this.t2f(ext);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.o2f();
      var destination = ArrayList.j1();
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExt.<anonymous>' call
        var list = element.y2e_1;
        addAll(destination, list);
      }
      throw UnsupportedOperationException.k9("Don't know how to generate file for extension '" + ext + "' (supported extensions " + toString(destination) + ')');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageFormats(' + this.o2f().d1() + ')' + toString(this.o2f());
  }
  c2f(s, props) {
    if (this.o2f().g1())
      return null;
    var _iterator__ex2g4s = this.o2f().a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var format = _iterator__ex2g4s.c1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.c2f(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  b2f(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.o2f().a1();
      while (_iterator__ex2g4s.b1()) {
        var format = _iterator__ex2g4s.c1();
        if (format.h2f(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImage.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.b2f(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.k9('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes_1(sliceStart_0(s), 4)) + ') (' + toString_3(readBytes_1(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
  j2f(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme(this, data, props, $completion), $completion);
  }
  k2f(file, props, $completion) {
    return this.u2f(get_extensionLC_0(file)).k2f(file, props, $completion);
  }
}
class ImageFormatsMutable extends ImageFormats {
  static z2f() {
    var $this = this.q2f([]);
    $this.y2f_1 = new NonRecursiveLock();
    return $this;
  }
  static a2g(formats) {
    var $this = this.z2f();
    $this.b2g(formats.slice());
    return $this;
  }
  b2g(formats) {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.y2f_1;
      this_0.d1g();
      try {
        this.r2f(minus(plus_2(this.s2f(), formats), this));
        break $l$block;
      }finally {
        this_0.g1g();
      }
    }
    return this;
  }
}
class Companion_37 {
  c2g(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.d2g(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  l2d(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.c2g(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.c2g.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static j2d(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.p2c_1 = new Mixin();
    $this.q2c_1 = index;
    $this.r2c_1 = fastTime;
    $this.s2c_1 = layerData;
    $this.t2c_1 = firstOrNull($this.s2c_1);
    return $this;
  }
  b1i(_set____db54di) {
    this.p2c_1.b1i(_set____db54di);
  }
  c1i() {
    return this.p2c_1.c1i();
  }
  e2g() {
    return toDuration_2(this.r2c_1);
  }
  static d2g(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.j2d(index, get_fast(time), layerData);
  }
  f2g() {
    var tmp377_safe_receiver = this.t2c_1;
    var tmp0_elvis_lhs = tmp377_safe_receiver == null ? null : tmp377_safe_receiver.d2d_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  g2g() {
    var tmp378_safe_receiver = this.t2c_1;
    var tmp0_elvis_lhs = tmp378_safe_receiver == null ? null : tmp378_safe_receiver.v2c_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  h2g() {
    var tmp379_safe_receiver = this.t2c_1;
    var tmp0_elvis_lhs = tmp379_safe_receiver == null ? null : tmp379_safe_receiver.w2c_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  o2d() {
    var tmp380_safe_receiver = this.t2c_1;
    var tmp0_elvis_lhs = tmp380_safe_receiver == null ? null : tmp380_safe_receiver.x2c_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  h1j() {
    return this.f2g().j1u_1;
  }
  i1j() {
    return this.f2g().k1u_1;
  }
  n2d() {
    var tmp382_safe_receiver = this.t2c_1;
    var tmp0_elvis_lhs = tmp382_safe_receiver == null ? null : tmp382_safe_receiver.n2d();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  k3() {
    return this.f2g().e1u_1;
  }
  toString() {
    return 'ImageFrame(' + this.f2g().toString() + ', time=' + Duration__toString_impl_8d916b(this.e2g()) + ', targetX=' + this.g2g() + ', targetY=' + this.h2g() + ', main=' + this.o2d() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.u2c_1 = layer;
    this.v2c_1 = targetX;
    this.w2c_1 = targetY;
    this.x2c_1 = main;
    this.y2c_1 = includeInAtlas;
    this.z2c_1 = tilemap;
    this.a2d_1 = ninePatchSlice;
    this.b2d_1 = null;
    this.c2d_1 = null;
    this.d2d_1 = slice;
  }
  h1j() {
    return this.d2d_1.j1u_1;
  }
  i1j() {
    return this.d2d_1.k1u_1;
  }
  n2d() {
    if (get_bmp(this.d2d_1).d1v_1 === this.h1j() && get_bmp(this.d2d_1).e1v_1 === this.i1j())
      return get_bmp(this.d2d_1);
    if (this.b2d_1 == null)
      this.b2d_1 = extract(this.d2d_1);
    return ensureNotNull(this.b2d_1);
  }
}
class ImageInfo {
  constructor() {
    this.d2f_1 = new Mixin();
    this.e2f_1 = 0;
    this.f2f_1 = 0;
    this.g2f_1 = 8;
  }
  b1i(_set____db54di) {
    this.d2f_1.b1i(_set____db54di);
  }
  c1i() {
    return this.d2f_1.c1i();
  }
  toString() {
    var tmp = this.e2f_1;
    var tmp_0 = this.f2f_1;
    var tmp_1 = this.g2f_1;
    var tmp383_safe_receiver = this.c1i();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString_0(tmp383_safe_receiver == null ? null : toMap(tmp383_safe_receiver)) + ')';
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_39 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i2g_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.m2c_1 = index;
    this.n2c_1 = name;
    this.o2c_1 = type;
  }
}
class NativeImageFormatProvider {
  f2h(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt(this, vfs, path, props, $completion), $completion);
  }
  j2f(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme_0(this, data, props, $completion), $completion);
  }
  g2h(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0(this, file, props, $completion), $completion);
  }
  k2f(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1(this, file, props, $completion), $completion);
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  o2f() {
    return get_RegisteredImageFormats();
  }
  l2g(data, props, $completion) {
    return this.m2g(this.o2f().i2f(data, props), props);
  }
  n2g(bmp) {
    return BitmapNativeImage.e2h(bmp);
  }
  m2g(bmp, props) {
    var bmp32 = bmp.b1x();
    return new NativeImageResult(this.n2g(props.j2e_1 ? asumePremultiplied(bmp32) : props.s2e() ? bmp32.t1x() : bmp32.u1x()));
  }
  y26(width, height, premultiplied) {
    return this.n2g(Bitmap32.z1t(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.d1v_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.e1v_1 : originalHeight;
    this.h2h_1 = image;
    this.i2h_1 = originalWidth;
    this.j2h_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.h2h_1.toString() + ', originalWidth=' + this.i2h_1 + ', originalHeight=' + this.j2h_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.h2h_1);
    result = imul(result, 31) + this.i2h_1 | 0;
    result = imul(result, 31) + this.j2h_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.h2h_1, tmp0_other_with_cast.h2h_1))
      return false;
    if (!(this.i2h_1 === tmp0_other_with_cast.i2h_1))
      return false;
    if (!(this.j2h_1 === tmp0_other_with_cast.j2h_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static k2h(bitmap) {
    var $this = this.x26(bitmap.d1v_1, bitmap.e1v_1, bitmap, bitmap.j1v_1);
    $this.c2h_1 = bitmap;
    $this.d2h_1 = $this.c2h_1.w1t_1;
    return $this;
  }
  k3() {
    return 'BitmapNativeImage';
  }
  static e2h(bitmap) {
    return this.k2h(bitmap.b1x());
  }
  a1x() {
    return this.c2h_1;
  }
  g1w(x, y, width, height, out, offset) {
    return this.c2h_1.g1w(x, y, width, height, out, offset);
  }
  i1w(x, y, width, height, out, offset) {
    return this.c2h_1.i1w(x, y, width, height, out, offset);
  }
  j1w(x, y, v) {
    return this.c2h_1.j1w(x, y, v);
  }
  h1w(x, y) {
    return this.c2h_1.h1w(x, y);
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_40 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pb(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.w2h_1;
      destination.x2(tmp$ret$0, element);
    }
    tmp.y2h_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.z2h_1 = startingRow;
    this.a2i_1 = startingCol;
    this.b2i_1 = rowIncrement;
    this.c2i_1 = colIncrement;
    this.d2i_1 = blockHeight;
    this.e2i_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.c2i_1;
    var tmp$ret$0 = log2(x);
    tmp.f2i_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.z2h_1 + ', startingCol=' + this.a2i_1 + ', rowIncrement=' + this.b2i_1 + ', colIncrement=' + this.c2i_1 + ', blockHeight=' + this.d2i_1 + ', blockWidth=' + this.e2i_1 + ')';
  }
  hashCode() {
    var result = this.z2h_1;
    result = imul(result, 31) + this.a2i_1 | 0;
    result = imul(result, 31) + this.b2i_1 | 0;
    result = imul(result, 31) + this.c2i_1 | 0;
    result = imul(result, 31) + this.d2i_1 | 0;
    result = imul(result, 31) + this.e2i_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.z2h_1 === tmp0_other_with_cast.z2h_1))
      return false;
    if (!(this.a2i_1 === tmp0_other_with_cast.a2i_1))
      return false;
    if (!(this.b2i_1 === tmp0_other_with_cast.b2i_1))
      return false;
    if (!(this.c2i_1 === tmp0_other_with_cast.c2i_1))
      return false;
    if (!(this.d2i_1 === tmp0_other_with_cast.d2i_1))
      return false;
    if (!(this.e2i_1 === tmp0_other_with_cast.e2i_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.w2h_1 = id;
    this.x2h_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.g2i_1 = width;
    this.h2i_1 = height;
    this.i2i_1 = bitsPerChannel;
    this.j2i_1 = colorspace;
    this.k2i_1 = compressionmethod;
    this.l2i_1 = filtermethod;
    this.m2i_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.j2i_1.j3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.n2i_1 = tmp_0;
    this.o2i_1 = imul(imul(this.g2i_1, this.n2i_1), this.i2i_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.p2i_1 = header;
    this.q2i_1 = _UByteArrayInt___init__impl__xif7bu_0(this.p2i_1.o2i_1);
    this.r2i_1 = _UByteArrayInt___init__impl__xif7bu_0(this.p2i_1.o2i_1);
    this.s2i_1 = Companion_instance_31.u1y(this.p2i_1.g2i_1);
  }
  b2j() {
    var temp = this.r2i_1;
    this.r2i_1 = this.q2i_1;
    this.q2i_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.l2j_1 = $data;
    this.m2j_1 = $info;
  }
  dd($completion) {
    return EXIF_getInstance().k2c(openAsync(readAll_0(this.l2j_1)), this.m2j_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static n2j() {
    PNG_instance = null;
    var $this = this.a2f(['png']);
    PNG_instance = $this;
    $this.v2i_1 = -1991225785;
    $this.w2i_1 = 218765834;
    $this.x2i_1 = listOf_0([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.y2i_1 = listOf(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  c2f(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  b2f(s, props) {
    var tmp = Companion_instance_36;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.k2d(tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE());
  }
  o2j(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  z2i(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.o2j(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.cd('An operation is not implemented: ' + reason);
    }
  }
  a2j(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.z2i(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.z2i.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class HtmlCanvas {
  p2j(width, height) {
    if (Companion_getInstance_101().q2j()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.n4(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  m2k(width, height) {
    return HtmlCanvas_instance.p2j(width, height);
  }
  n2k(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  o2k(bmp, canvas) {
    return this.n2k(_RgbaArray___init__impl__oib4y4(bmp.u1x().w1t_1), bmp.d1v_1, bmp.e1v_1, canvas);
  }
  r2j(bmp) {
    return this.o2k(bmp, this.m2k(bmp.d1v_1, bmp.e1v_1));
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
  o2f() {
    return get_RegisteredImageFormats();
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  l2g(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0(this, data, props, $completion), $completion);
  }
  f2h(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1(this, vfs, path, props, $completion), $completion);
  }
  y26(width, height, premultiplied) {
    return HtmlNativeImage.l2k(HtmlCanvas_instance.p2j(width, height));
  }
}
class HtmlNativeImage extends NativeImage {
  static z2k(texSourceBase, width, height) {
    var $this = this.x26(width, height, texSourceBase, true);
    $this.g2k_1 = texSourceBase;
    $this.h2k_1 = $this.g2k_1;
    var tmp = $this;
    tmp.i2k_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.j2k_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.k2k_1 = Monotonic_instance.ji();
    return $this;
  }
  k3() {
    return 'HtmlNativeImage';
  }
  static w2k(img) {
    return this.z2k(img, img.width, img.height);
  }
  static l2k(canvas) {
    return this.z2k(canvas, canvas.width, canvas.height);
  }
  y2k() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i2k_1;
    lazyCanvasElement$factory();
    return this_0.h3();
  }
  a2l() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j2k_1;
    ctx$factory();
    return this_0.h3();
  }
  g1w(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.g2k_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.ji();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.k2k_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance_0();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.k2k_1 = now;
        this.a2l().clearRect(0.0, 0.0, width, height);
        this.a2l().drawImage(this.g2k_1, 0.0, 0.0);
      }
    }
    var idata = this.a2l().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy_1(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.k1v_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  i1w(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.a2l().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy_1(out, offset, data, 0, size);
    if (!this.k1v_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.a2l().putImageData(idata, x, y);
  }
  b2l(type, quality) {
    return this.y2k().toDataURL(type, quality);
  }
  c2l(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.b2l(type, quality) : $super.b2l.call(this, type, quality);
  }
}
class BrowserImage {
  p2k(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd(this, bytes, props, $completion), $completion);
  }
  f2l(img) {
    return this.x2k(img, img.width, img.height);
  }
  x2k(img, width, height) {
    var canvas = HtmlCanvas_instance.p2j(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  v2k(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.gt();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_101().q2j()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.n4(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.rq();
  }
  e2l(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_38().c2e_1 : props;
    return $super === VOID ? this.v2k(jsUrl, props, $completion) : $super.v2k.call(this, jsUrl, props, $completion);
  }
  d2l(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi(this, jsUrl, $completion), $completion);
  }
}
class Companion_40 {}
class RequestContext {
  constructor(initialClazz) {
    this.h2l_1 = initialClazz;
  }
  toString() {
    return 'RequestContext(initialClazz=' + toString(this.h2l_1) + ')';
  }
  hashCode() {
    return this.h2l_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestContext))
      return false;
    var tmp0_other_with_cast = other instanceof RequestContext ? other : THROW_CCE();
    if (!this.h2l_1.equals(tmp0_other_with_cast.h2l_1))
      return false;
    return true;
  }
}
class NotMappedException extends RuntimeException {
  static p2l(clazz, requestedByClass, ctx, msg) {
    msg = msg === VOID ? 'Not mapped ' + toString(clazz) + ' requested by ' + toString(requestedByClass) + ' in ' + ctx.toString() : msg;
    var $this = this.v9(msg);
    captureStack($this, $this.o2l_1);
    $this.k2l_1 = clazz;
    $this.l2l_1 = requestedByClass;
    $this.m2l_1 = ctx;
    $this.n2l_1 = msg;
    return $this;
  }
}
class Injector {
  constructor(parent, level) {
    parent = parent === VOID ? null : parent;
    level = level === VOID ? 0 : level;
    this.q2l_1 = parent;
    this.r2l_1 = level;
    this.s2l_1 = null;
    this.t2l_1 = LinkedHashMap.ob();
    var tmp = this;
    var tmp610_safe_receiver = this.q2l_1;
    var tmp0_elvis_lhs = tmp610_safe_receiver == null ? null : tmp610_safe_receiver.u2l_1;
    tmp.u2l_1 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    this.w2l(getKClass(Injector), this);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.v2l_1 = ArrayList.j1();
  }
  x2l() {
    var tmp0_elvis_lhs = this.s2l_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp611_safe_receiver = this.q2l_1;
      tmp = tmp611_safe_receiver == null ? null : tmp611_safe_receiver.s2l_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  y2l() {
    return new Injector(this, this.r2l_1 + 1 | 0);
  }
  w2l(clazz, instance) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapInstance.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.t2l_1;
    var value = new InstanceObjectProvider(instance);
    this_0.x2(clazz, value);
    return this;
  }
  z2l(clazz, gen) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapSingleton.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.t2l_1;
    var value = new SingletonObjectProvider(gen);
    this_0.x2(clazz, value);
    return this;
  }
  a2m(clazz, gen) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.inject.Injector.mapPrototype.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.t2l_1;
    var value = new PrototypeObjectProvider(gen);
    this_0.x2(clazz, value);
    return this;
  }
  b2m(clazz, ctx) {
    var tmp0_elvis_lhs = this.t2l_1.f3(clazz);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp614_safe_receiver = this.q2l_1;
      tmp = tmp614_safe_receiver == null ? null : tmp614_safe_receiver.b2m(clazz, ctx);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp615_safe_receiver = this.x2l();
      var tmp616_safe_receiver = tmp615_safe_receiver == null ? null : tmp615_safe_receiver(clazz, ctx);
      var tmp_1;
      if (tmp616_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.inject.Injector.getProviderOrNull.<anonymous>' call
        // Inline function 'kotlin.collections.set' call
        this.t2l_1.x2(clazz, tmp616_safe_receiver);
        tmp_1 = tmp616_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp_2 = tmp_0;
    return (tmp_2 == null ? true : isInterface(tmp_2, ObjectProvider)) ? tmp_2 : null;
  }
  c2m(clazz, ctx) {
    var tmp0_elvis_lhs = this.b2m(clazz, ctx);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NotMappedException.p2l(clazz, ctx.h2l_1, ctx, "Class '" + toString(clazz) + "' doesn't have constructors " + ctx.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  d2m(clazz, ctx) {
    return this.c2m(clazz, ctx).e2m(this);
  }
  f2m(clazz, ctx, $super) {
    ctx = ctx === VOID ? new RequestContext(clazz) : ctx;
    return $super === VOID ? this.d2m(clazz, ctx) : $super.d2m.call(this, clazz, ctx);
  }
  toString() {
    return 'Injector(level=' + this.r2l_1 + ')';
  }
  g2m(instance) {
    if (!(instance == null) ? isInterface(instance, InjectorDependency) : false) {
      instance.h2m(this);
    }
    if (!(instance == null) ? isInterface(instance, InjectorDestructor) : false) {
      this.v2l_1.g(instance);
    }
    return instance;
  }
  i2m() {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.t2l_1.c3().a1();
    while (_iterator__ex2g4s.b1()) {
      var pair = _iterator__ex2g4s.c1();
      pair.h3().i2m();
    }
    var _iterator__ex2g4s_0 = this.v2l_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var deinit = _iterator__ex2g4s_0.c1();
      deinit.i2m();
    }
    this.v2l_1.z2();
  }
}
class InjectorDependency {}
class ObjectProvider {}
class InstanceObjectProvider {
  constructor(instance) {
    this.j2m_1 = instance;
  }
  e2m(injector) {
    return this.j2m_1;
  }
  i2m() {
    var tmp = this.j2m_1;
    var tmp608_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp608_safe_receiver == null)
      null;
    else {
      tmp608_safe_receiver.i2m();
    }
  }
  toString() {
    return 'InstanceObjectProvider(' + toString_0(this.j2m_1) + ')';
  }
}
class SingletonObjectProvider {
  constructor(generator) {
    this.k2m_1 = generator;
    this.l2m_1 = null;
  }
  e2m(injector) {
    if (this.l2m_1 == null)
      this.l2m_1 = injector.g2m(this.k2m_1(injector));
    return ensureNotNull(this.l2m_1);
  }
  i2m() {
    var tmp = this.l2m_1;
    var tmp607_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp607_safe_receiver == null)
      null;
    else {
      tmp607_safe_receiver.i2m();
    }
  }
  toString() {
    return 'SingletonObjectProvider(' + toString_0(this.l2m_1) + ')';
  }
}
class PrototypeObjectProvider {
  constructor(generator) {
    this.m2m_1 = generator;
  }
  e2m(injector) {
    return injector.g2m(this.m2m_1(injector));
  }
  i2m() {
    return Unit_instance;
  }
  toString() {
    return 'PrototypeObjectProvider()';
  }
}
class InjectorDestructor {}
class Companion_41 {}
class InjectorContext {
  constructor(injector) {
    this.n2m_1 = injector;
  }
  g3() {
    return Companion_instance_42;
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_43 = this;
    this.o2m_1 = get_defaultSystemFS();
  }
}
class NullSyncSystemFS {}
class toAsync$1 {
  constructor($ioDispatcher, $sync) {
    this.p2m_1 = $ioDispatcher;
    this.q2m_1 = $sync;
  }
}
class Companion_43 {
  constructor() {
    Companion_instance_44 = this;
    this.r2m_1 = get_defaultHttpFetch();
  }
  s2m(method, host, port, path, secure, headers, body, $completion) {
    return this.r2m_1.s2m(method, host, port, path, secure, headers, body, $completion);
  }
}
class HttpFetchResult {
  constructor(status, statusText, headers, bodyRaw) {
    this.t2m_1 = status;
    this.u2m_1 = statusText;
    this.v2m_1 = headers;
    this.w2m_1 = bodyRaw;
  }
  toString() {
    return 'HttpFetchResult(status=' + this.t2m_1 + ', statusText=' + this.u2m_1 + ', headers=' + toString(this.v2m_1) + ', bodyRaw=' + toString(this.w2m_1) + ')';
  }
  hashCode() {
    var result = this.t2m_1;
    result = imul(result, 31) + getStringHashCode(this.u2m_1) | 0;
    result = imul(result, 31) + hashCode(this.v2m_1) | 0;
    result = imul(result, 31) + hashCode(this.w2m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpFetchResult))
      return false;
    var tmp0_other_with_cast = other instanceof HttpFetchResult ? other : THROW_CCE();
    if (!(this.t2m_1 === tmp0_other_with_cast.t2m_1))
      return false;
    if (!(this.u2m_1 === tmp0_other_with_cast.u2m_1))
      return false;
    if (!equals(this.v2m_1, tmp0_other_with_cast.v2m_1))
      return false;
    if (!equals(this.w2m_1, tmp0_other_with_cast.w2m_1))
      return false;
    return true;
  }
}
class defaultHttpFetch$1 {
  s2m(method, host, port, path, secure, headers, body, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_fetch__osg116(this, method, host, port, path, secure, headers, body, $completion), $completion);
  }
}
class AsyncRingBuffer {
  constructor(bufferSize) {
    bufferSize = bufferSize === VOID ? 1024 : bufferSize;
    this.x2m_1 = bufferSize;
    this.y2m_1 = null;
    this.z2m_1 = Channel(-1);
    this.a2n_1 = Channel(-1);
    this.b2n_1 = new SimpleBytesDeque(ilog2_0(this.x2m_1) + 1 | 0);
    this.c2n_1 = false;
  }
  b1c(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_1(this, buffer, offset, len, $completion), $completion);
  }
  u1f(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0(this, buffer, offset, len, $completion), $completion);
  }
  y1e($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_1(this, $completion), $completion);
  }
  toString() {
    return 'AsyncByteArrayDeque(' + this.y2m_1 + ')';
  }
}
class Companion_44 {
  constructor() {
    this.l2n_1 = 8388608;
  }
}
class AsyncRingBufferChunked {
  constructor(maxSize) {
    maxSize = maxSize === VOID ? 8388608 : maxSize;
    this.p2n_1 = maxSize;
    this.q2n_1 = null;
    this.r2n_1 = new SimpleChunkedByteDeque();
    this.s2n_1 = false;
  }
  b1c(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_2(this, buffer, offset, len, $completion), $completion);
  }
  u1f(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_1(this, buffer, offset, len, $completion), $completion);
  }
  y1e($completion) {
    this.s2n_1 = true;
  }
  toString() {
    return 'AsyncByteArrayDequeV2(' + this.q2n_1 + ')';
  }
}
class toAsync$o$write$slambda {
  constructor(this$0, $buffer, $offset, $len) {
    this.z2n_1 = this$0;
    this.a2o_1 = $buffer;
    this.b2o_1 = $offset;
    this.c2o_1 = $len;
  }
  r17($this$withContext, $completion) {
    this.z2n_1.x2n_1.t2n(this.a2o_1, this.b2o_1, this.c2o_1);
    return Unit_instance;
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$close$slambda {
  constructor(this$0) {
    this.d2o_1 = this$0;
  }
  r17($this$launch, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
    var tmp = this.d2o_1.x2n_1;
    var tmp634_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp634_safe_receiver == null)
      null;
    else {
      tmp634_safe_receiver.p5();
    }
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$1_0 {
  constructor($this_toAsync, $dispatcher) {
    this.y2n_1 = $dispatcher;
    this.x2n_1 = $this_toAsync;
  }
  b1c(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_3(this, buffer, offset, len, $completion), $completion);
  }
  y1e($completion) {
    var dispatcher = this.y2n_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope_0(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda_1(this));
    } else {
      // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
      var tmp_0 = this.x2n_1;
      var tmp634_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp634_safe_receiver == null)
        null;
      else {
        tmp634_safe_receiver.p5();
      }
    }
    return Unit_instance;
  }
}
class toAsync$o$read$slambda {
  constructor(this$0, $buffer, $offset, $len) {
    this.h2o_1 = this$0;
    this.i2o_1 = $buffer;
    this.j2o_1 = $offset;
    this.k2o_1 = $len;
  }
  r17($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
    return this.h2o_1.e2o_1.x1f(this.i2o_1, this.j2o_1, this.k2o_1);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$close$slambda_0 {
  constructor(this$0) {
    this.l2o_1 = this$0;
  }
  r17($this$launch, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
    var tmp = this.l2o_1.e2o_1;
    var tmp631_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp631_safe_receiver == null)
      null;
    else {
      tmp631_safe_receiver.p5();
    }
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$getPosition$slambda {
  constructor(this$0) {
    this.m2o_1 = this$0;
  }
  r17($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.getPosition.<anonymous>' call
    var tmp = this.m2o_1.e2o_1;
    var tmp632_safe_receiver = isInterface(tmp, SyncPositionStream) ? tmp : null;
    return tmp632_safe_receiver == null ? null : tmp632_safe_receiver.g2o();
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$getLength$slambda {
  constructor(this$0) {
    this.n2o_1 = this$0;
  }
  r17($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.getLength.<anonymous>' call
    var tmp = this.n2o_1.e2o_1;
    var tmp633_safe_receiver = isInterface(tmp, SyncLengthStream) ? tmp : null;
    return tmp633_safe_receiver == null ? null : tmp633_safe_receiver.a();
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$2 {
  constructor($this_toAsync, $dispatcher) {
    this.f2o_1 = $dispatcher;
    this.e2o_1 = $this_toAsync;
  }
  u1f(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_2(this, buffer, offset, len, $completion), $completion);
  }
  y1e($completion) {
    var dispatcher = this.f2o_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope_0(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda_2(this));
    } else {
      // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
      var tmp_0 = this.e2o_1;
      var tmp631_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp631_safe_receiver == null)
        null;
      else {
        tmp631_safe_receiver.p5();
      }
    }
    return Unit_instance;
  }
  b1g($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getPosition__nbsewl(this, $completion), $completion);
  }
  i1f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94_0(this, $completion), $completion);
  }
}
class AsyncStreamBase {
  static v2o($box) {
    return createThis(this, $box);
  }
  o2o(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.m7();
  }
  w2o(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.m7();
  }
  i1f($completion) {
    throw UnsupportedOperationException.m7();
  }
  y1e($completion) {
    return Unit_instance;
  }
}
class SliceAsyncStreamBase extends AsyncStreamBase {
  static u2o(base, baseStart, baseEnd, closeParent) {
    var $this = this.v2o();
    $this.p2o_1 = base;
    $this.q2o_1 = baseStart;
    $this.r2o_1 = baseEnd;
    $this.s2o_1 = closeParent;
    $this.t2o_1 = $this.r2o_1.q1($this.q2o_1);
    return $this;
  }
  o2o(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jk();
    var targetLen = _destruct__k2r9zo.kk();
    return this.p2o_1.o2o(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  w2o(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jk();
    var targetLen = _destruct__k2r9zo.kk();
    return this.p2o_1.w2o(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  i1f($completion) {
    return this.t2o_1;
  }
  y1e($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_2(this, $completion), $completion);
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.p2o_1) + ', ' + this.q2o_1.toString() + ', ' + this.r2o_1.toString() + ')';
  }
}
class BufferedStreamBase extends AsyncStreamBase {
  static d2p(base, blockSize, blocksToRead) {
    blockSize = blockSize === VOID ? 2048 : blockSize;
    blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
    var $this = this.v2o();
    $this.x2o_1 = base;
    $this.y2o_1 = blockSize;
    $this.z2o_1 = blocksToRead;
    $this.a2p_1 = imul($this.y2o_1, $this.z2o_1);
    var tmp = $this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.b2p_1 = new Int8Array([]);
    $this.c2p_1 = new Long(-1, -1);
    return $this;
  }
  o2o(position, buffer, offset, len, $completion) {
    return this.e2p(position, buffer, offset, len, $completion);
  }
  toString() {
    return 'Buffered[' + this.z2o_1 + '*' + this.y2o_1 + ']:' + toString(this.x2o_1);
  }
  e2p(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__read__lo0dlr(this, position, buffer, offset, len, $completion), $completion);
  }
  w2o(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_4(this, position, buffer, offset, len, $completion), $completion);
  }
  i1f($completion) {
    return this.x2o_1.i1f($completion);
  }
  y1e($completion) {
    return this.x2o_1.y1e($completion);
  }
}
class MemoryAsyncStreamBase extends AsyncStreamBase {
  static h2p(data) {
    var $this = this.v2o();
    $this.g2p_1 = data;
    return $this;
  }
  static i2p(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.h2p(ByteArrayBuilder.s1d(initialCapacity));
  }
  j2p() {
    return this.g2p_1.d1();
  }
  i1f($completion) {
    return toLong(this.j2p());
  }
  k2p(position) {
    if (position.p1(new Long(0, 0)) < 0)
      throw IllegalArgumentException.m('Invalid position ' + position.toString());
  }
  o2o(position, buffer, offset, len, $completion) {
    this.k2p(position);
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.j2p());
    if (!contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = toLong(this.j2p());
    // Inline function 'kotlin.Long.plus' call
    var b = position.q3(toLong(len));
    var end = a.p1(b) <= 0 ? a : b;
    // Inline function 'kotlin.math.max' call
    var a_0 = end.q1(position).b2();
    var actualLen = Math.max(a_0, 0);
    arraycopy_2(this.g2p_1.p1d_1, position.b2(), buffer, offset, actualLen);
    return actualLen;
  }
  w2o(position, buffer, offset, len, $completion) {
    this.k2p(position);
    var tmp = this.g2p_1;
    // Inline function 'kotlin.math.max' call
    var a = this.g2p_1.d1();
    // Inline function 'kotlin.Long.plus' call
    var b = position.q3(toLong(len)).b2();
    var tmp$ret$1 = Math.max(a, b);
    tmp.l2p(tmp$ret$1);
    arraycopy_2(buffer, offset, this.g2p_1.p1d_1, position.b2(), len);
  }
  y1e($completion) {
    return Unit_instance;
  }
  toString() {
    return 'MemoryAsyncStreamBase(' + this.g2p_1.d1() + ')';
  }
}
class AsyncPositionLengthStream {}
function hasAvailable($completion) {
  return this.h1f($completion);
}
function getAvailable($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_getAvailable__v3o1wr(this, $completion), $completion);
}
class AsyncStream {
  constructor(base, position, queue) {
    position = position === VOID ? new Long(0, 0) : position;
    queue = queue === VOID ? false : queue;
    this.a2c_1 = new Mixin();
    this.b2c_1 = base;
    this.c2c_1 = position;
    this.d2c_1 = queue;
    this.e2c_1 = Mutex();
    this.f2c_1 = Mutex();
  }
  b1i(_set____db54di) {
    this.a2c_1.b1i(_set____db54di);
  }
  c1i() {
    return this.a2c_1.c1i();
  }
  toString() {
    return 'AsyncStream(' + toString(this.b2c_1) + ', position=' + this.c2c_1.toString() + ')';
  }
  u1f(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_3(this, buffer, offset, len, $completion), $completion);
  }
  b1c(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_5(this, buffer, offset, len, $completion), $completion);
  }
  h1f($completion) {
    return this.b2c_1.h1f($completion);
  }
  b1g($completion) {
    return this.c2c_1;
  }
  i1f($completion) {
    return this.b2c_1.i1f($completion);
  }
  y1e($completion) {
    return this.b2c_1.y1e($completion);
  }
}
class asyncStreamWriter$1$ensureJob$2$1 {
  constructor(this$0) {
    this.z2p_1 = this$0;
  }
  b1c(buffer, offset, len, $completion) {
    return this.z2p_1.u2p_1.b1c(buffer, offset, len, $completion);
  }
  y1e($completion) {
    return this.z2p_1.u2p_1.y1e($completion);
  }
}
class asyncStreamWriter$o$ensureJob$slambda {
  constructor($process, this$0) {
    this.s2p_1 = $process;
    this.t2p_1 = this$0;
  }
  r17($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3(this, $this$launch, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class asyncStreamWriter$1 {
  constructor($lazy, $bufferSize, $name, $process) {
    this.y2p_1 = $process;
    var tmp = this;
    var tmp_0;
    if ($lazy) {
      // Inline function 'kotlin.also' call
      var this_0 = new AsyncRingBuffer($bufferSize);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.stream.<no name provided>.deque.<anonymous>' call
      this_0.y2m_1 = $name;
      tmp_0 = this_0;
    } else {
      // Inline function 'kotlin.also' call
      var this_1 = new AsyncRingBufferChunked($bufferSize);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.stream.<no name provided>.deque.<anonymous>' call
      this_1.q2n_1 = $name;
      tmp_0 = this_1;
    }
    tmp.u2p_1 = tmp_0;
    this.v2p_1 = null;
    this.w2p_1 = null;
    this.x2p_1 = new Int8Array(1);
  }
  u1f(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_4(this, buffer, offset, len, $completion), $completion);
  }
  y1e($completion) {
    var tmp641_safe_receiver = this.w2p_1;
    if (tmp641_safe_receiver == null)
      null;
    else {
      tmp641_safe_receiver.xp();
    }
    this.w2p_1 = null;
  }
}
class SyncLengthStream {}
class SyncStreamBase {
  static f2q() {
    var $this = createThis(this);
    $this.d2q_1 = new Int8Array(16);
    return $this;
  }
  j2q() {
    return false;
  }
  h2q(position, buffer, offset, len) {
    throw UnsupportedOperationException.m7();
  }
  i2q(position, buffer, offset, len) {
    throw UnsupportedOperationException.m7();
  }
  a() {
    throw UnsupportedOperationException.m7();
  }
  p5() {
    return Unit_instance;
  }
  e2q(position) {
    return new SyncStream(this, position);
  }
  k2q(position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.e2q(position) : $super.e2q.call(this, position);
  }
}
class MemorySyncStreamBase extends SyncStreamBase {
  static c2q(data) {
    var $this = this.f2q();
    $this.b2q_1 = data;
    return $this;
  }
  static g2q(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.c2q(ByteArrayBuilder.s1d(initialCapacity));
  }
  j2p() {
    return this.b2q_1.d1();
  }
  a() {
    return toLong(this.b2q_1.d1());
  }
  k2p(position) {
    if (position.p1(new Long(0, 0)) < 0)
      throw IllegalArgumentException.m('Invalid position ' + position.toString());
  }
  h2q(position, buffer, offset, len) {
    this.k2p(position);
    var ipos = position.b2();
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.j2p());
    if (!contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = this.j2p();
    var b = ipos + len | 0;
    var end = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = end - ipos | 0;
    var actualLen = Math.max(a_0, 0);
    arraycopy_2(this.b2q_1.p1d_1, ipos, buffer, offset, actualLen);
    return actualLen;
  }
  i2q(position, buffer, offset, len) {
    this.k2p(position);
    var tmp = this.b2q_1;
    // Inline function 'kotlin.math.max' call
    var a = this.b2q_1.d1();
    // Inline function 'kotlin.Long.plus' call
    var b = position.q3(toLong(len)).b2();
    var tmp$ret$1 = Math.max(a, b);
    tmp.l2p(tmp$ret$1);
    arraycopy_2(buffer, offset, this.b2q_1.p1d_1, position.b2(), len);
  }
  p5() {
    return Unit_instance;
  }
  toString() {
    return 'MemorySyncStreamBase(' + this.b2q_1.d1() + ')';
  }
}
class SyncInputStream {}
function read() {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.SyncInputStream.read.<anonymous>' call
  var it = new Int8Array(1);
  return this.x1f(it, 0, 1) > 0 ? it[0] & 255 : -1;
}
class SyncPositionStream {}
class SyncOutputStream {}
function write(byte) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = new Int8Array(1);
  it[0] = toByte(byte);
  this.t2n(it, 0, 1);
  return Unit_instance;
}
class SyncStream {
  constructor(base, position) {
    position = position === VOID ? new Long(0, 0) : position;
    this.c2j_1 = new Mixin();
    this.d2j_1 = base;
    this.e2j_1 = this.d2j_1.d2q_1;
    this.f2j_1 = this.d2j_1.j2q();
    this.g2j_1 = position;
    this.h2j_1 = position;
    this.i2j_1 = position;
    this.j2j_1 = new Long(0, 0);
  }
  b1i(_set____db54di) {
    this.c2j_1.b1i(_set____db54di);
  }
  c1i() {
    return this.c2j_1.c1i();
  }
  l2q(value) {
    if (this.f2j_1)
      this.g2j_1 = value;
    else {
      this.m2q(value);
    }
  }
  n2q() {
    return this.f2j_1 ? this.g2j_1 : this.g2o();
  }
  o2q(value) {
    if (this.f2j_1)
      this.h2j_1 = value;
    else {
      this.m2q(value);
    }
  }
  p2q() {
    return this.f2j_1 ? this.h2j_1 : this.g2o();
  }
  m2q(value) {
    var tmp;
    if (this.f2j_1) {
      this.l2q(value);
      tmp = Unit_instance;
    } else {
      this.i2j_1 = value;
      tmp = Unit_instance;
    }
    return tmp;
  }
  g2o() {
    return this.f2j_1 ? this.n2q() : this.i2j_1;
  }
  x1f(buffer, offset, len) {
    var read = this.d2j_1.h2q(this.n2q(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.n2q().q3(toLong(read));
    this.l2q(tmp$ret$0);
    return read;
  }
  q2q() {
    var size = this.x1f(this.e2j_1, 0, 1);
    if (size <= 0)
      return -1;
    return this.e2j_1[0] & 255;
  }
  t2n(buffer, offset, len) {
    this.d2j_1.i2q(this.p2q(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.p2q().q3(toLong(len));
    this.o2q(tmp$ret$0);
  }
  r2q(byte) {
    this.e2j_1[0] = toByte(byte);
    this.t2n(this.e2j_1, 0, 1);
  }
  a() {
    return this.d2j_1.a();
  }
  p5() {
    return this.d2j_1.p5();
  }
  k2n() {
    return this.a().q1(this.n2q());
  }
  s2q() {
    return this.k2n();
  }
  toString() {
    return 'SyncStream(' + toString(this.d2j_1) + ', ' + this.g2o().toString() + ')';
  }
}
class SliceSyncStreamBase extends SyncStreamBase {
  static y2q(base, baseStart, baseEnd) {
    var $this = this.f2q();
    $this.u2q_1 = base;
    $this.v2q_1 = baseStart;
    $this.w2q_1 = baseEnd;
    $this.x2q_1 = $this.w2q_1.q1($this.v2q_1);
    return $this;
  }
  j2q() {
    return this.u2q_1.j2q();
  }
  a() {
    return this.x2q_1;
  }
  h2q(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jk();
    var targetLen = _destruct__k2r9zo.kk();
    return this.u2q_1.h2q(targetStartPosition, buffer, offset, targetLen);
  }
  i2q(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jk();
    var targetLen = _destruct__k2r9zo.kk();
    return this.u2q_1.i2q(targetStartPosition, buffer, offset, targetLen);
  }
  p5() {
    return Unit_instance;
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.u2q_1) + ', ' + this.v2q_1.toString() + ', ' + this.w2q_1.toString() + ')';
  }
}
class FinalVfsFile {
  static z2q(file) {
    var $this = createThis(this);
    $this.s2h_1 = file;
    return $this;
  }
  static a2r(vfs, path) {
    return this.z2q(vfs.l1i(path));
  }
  t2h() {
    return this.s2h_1.o2h_1;
  }
  e1r() {
    return this.s2h_1.p2h_1;
  }
  toString() {
    return 'FinalVfsFile(file=' + this.s2h_1.toString() + ')';
  }
  hashCode() {
    return this.s2h_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this.s2h_1.equals(tmp0_other_with_cast.s2h_1))
      return false;
    return true;
  }
}
class VfsNamed {
  constructor(pathInfo) {
    this.d2r_1 = pathInfo;
  }
  c2r() {
    return this.d2r_1;
  }
}
class Vfs$Proxy$initOnce$slambda {
  constructor(this$0) {
    this.e2r_1 = this$0;
  }
  r17($this$async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4(this, $this$async, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Vfs {
  constructor($box) {
    boxApply(this, $box);
  }
  g2s() {
    return '';
  }
  h2s(path) {
    return _PathInfo___get_fullPath__impl__21fx6x(lightCombine(get_pathInfo(this.g2s()), get_pathInfo(path)));
  }
  i2s() {
    return new VfsFile(this, '');
  }
  l1i(path) {
    return this.i2s().l1i(path);
  }
  l2h(path) {
    return this.i2s().l1i(path);
  }
  y1e($completion) {
    return Unit_instance;
  }
  j2s(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) {
    // Inline function 'kotlin.also' call
    var this_0 = new VfsStat(this.l2h(path), true, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, VOID, id);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.Vfs.createExistsStat.<anonymous>' call
    if (cache)
      this_0.m2r_1.q2h_1 = this_0;
    return this_0;
  }
  k2s(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache, $super) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance_107().o2s_1 : createTime;
    modifiedTime = modifiedTime === VOID ? Companion_getInstance_107().o2s_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    id = id === VOID ? null : id;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.j2s(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) : $super.j2s.call(this, path, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, id, cache);
  }
  l2s(path, extraInfo, cache, exception) {
    return new VfsStat(this.l2h(path), false, false, new Long(0, 0), new Long(-1, -1), new Long(-1, -1), 511, 'nobody', 'nobody', Companion_getInstance_107().o2s_1, Companion_getInstance_107().o2s_1, Companion_getInstance_107().o2s_1, extraInfo, VOID, VOID, exception);
  }
  m2s(path, extraInfo, cache, exception, $super) {
    extraInfo = extraInfo === VOID ? null : extraInfo;
    cache = cache === VOID ? false : cache;
    exception = exception === VOID ? null : exception;
    return $super === VOID ? this.l2s(path, extraInfo, cache, exception) : $super.l2s.call(this, path, extraInfo, cache, exception);
  }
  d2s(path, mode, $completion) {
    unsupported(this);
  }
  e2s(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t_0(this, path, range, $completion), $completion);
  }
  f2s(path, $completion) {
    return this.m2s(path);
  }
  b2r(path, $completion) {
    return FinalVfsFile.a2r(this, path);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
}
class Proxy extends Vfs {
  constructor() {
    super();
    this.f2r_1 = null;
  }
  b2r(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getUnderlyingUnscapedFile__y1cdv2(this, path, $completion), $completion);
  }
  g2r($completion) {
  }
  h2r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_initOnce__uuyf07(this, $completion), $completion);
  }
  d2s(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea(this, path, mode, $completion), $completion);
  }
  e2s(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t(this, path, range, $completion), $completion);
  }
  f2s(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc(this, path, $completion), $completion);
  }
}
class VfsStat {
  constructor(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance_107().o2s_1 : createTime;
    modifiedTime = modifiedTime === VOID ? createTime : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    kind = kind === VOID ? null : kind;
    id = id === VOID ? null : id;
    exception = exception === VOID ? null : exception;
    this.m2r_1 = file;
    this.n2r_1 = exists;
    this.o2r_1 = isDirectory;
    this.p2r_1 = size;
    this.q2r_1 = device;
    this.r2r_1 = inode;
    this.s2r_1 = mode;
    this.t2r_1 = owner;
    this.u2r_1 = group;
    this.v2r_1 = createTime;
    this.w2r_1 = modifiedTime;
    this.x2r_1 = lastAccessTime;
    this.y2r_1 = extraInfo;
    this.z2r_1 = kind;
    this.a2s_1 = id;
    this.b2s_1 = exception;
  }
  c2r() {
    return this.m2r_1.c2r();
  }
  q2s(showFile) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList.r(16);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.VfsStat.toString.<anonymous>' call
    if (showFile)
      this_0.g('file=' + this.m2r_1.toString());
    else
      this_0.g('file=' + this.m2r_1.g2s());
    this_0.g('exists=' + this.n2r_1);
    this_0.g('isDirectory=' + this.o2r_1);
    this_0.g('size=' + this.p2r_1.toString());
    this_0.g('device=' + this.q2r_1.toString());
    this_0.g('inode=' + this.r2r_1.toString());
    this_0.g('mode=' + this.s2r_1);
    this_0.g('owner=' + this.t2r_1);
    this_0.g('group=' + this.u2r_1);
    this_0.g('createTime=' + DateTime__toString_impl_cnueje(this.v2r_1));
    this_0.g('modifiedTime=' + DateTime__toString_impl_cnueje(this.w2r_1));
    this_0.g('lastAccessTime=' + DateTime__toString_impl_cnueje(this.x2r_1));
    this_0.g('extraInfo=' + toString_0(this.y2r_1));
    if (!(this.z2r_1 == null)) {
      this_0.g('kind=' + toString_0(this.z2r_1));
    }
    this_0.g('id=' + this.a2s_1);
    return 'VfsStat(' + joinToString_0(this_0, ', ') + ')';
  }
  toString() {
    return this.q2s(true);
  }
  r2s(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    return new VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception);
  }
  c2s(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception, $super) {
    file = file === VOID ? this.m2r_1 : file;
    exists = exists === VOID ? this.n2r_1 : exists;
    isDirectory = isDirectory === VOID ? this.o2r_1 : isDirectory;
    size = size === VOID ? this.p2r_1 : size;
    device = device === VOID ? this.q2r_1 : device;
    inode = inode === VOID ? this.r2r_1 : inode;
    mode = mode === VOID ? this.s2r_1 : mode;
    owner = owner === VOID ? this.t2r_1 : owner;
    group = group === VOID ? this.u2r_1 : group;
    createTime = createTime === VOID ? this.v2r_1 : createTime;
    modifiedTime = modifiedTime === VOID ? this.w2r_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? this.x2r_1 : lastAccessTime;
    extraInfo = extraInfo === VOID ? this.y2r_1 : extraInfo;
    kind = kind === VOID ? this.z2r_1 : kind;
    id = id === VOID ? this.a2s_1 : id;
    exception = exception === VOID ? this.b2s_1 : exception;
    return $super === VOID ? this.r2s(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) : $super.r2s.call(this, file, exists, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, kind, id, exception);
  }
  hashCode() {
    var result = this.m2r_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.n2r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o2r_1) | 0;
    result = imul(result, 31) + this.p2r_1.hashCode() | 0;
    result = imul(result, 31) + this.q2r_1.hashCode() | 0;
    result = imul(result, 31) + this.r2r_1.hashCode() | 0;
    result = imul(result, 31) + this.s2r_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.t2r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u2r_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.v2r_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.w2r_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.x2r_1) | 0;
    result = imul(result, 31) + (this.y2r_1 == null ? 0 : hashCode(this.y2r_1)) | 0;
    result = imul(result, 31) + (this.z2r_1 == null ? 0 : hashCode(this.z2r_1)) | 0;
    result = imul(result, 31) + (this.a2s_1 == null ? 0 : getStringHashCode(this.a2s_1)) | 0;
    result = imul(result, 31) + (this.b2s_1 == null ? 0 : hashCode(this.b2s_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this.m2r_1.equals(tmp0_other_with_cast.m2r_1))
      return false;
    if (!(this.n2r_1 === tmp0_other_with_cast.n2r_1))
      return false;
    if (!(this.o2r_1 === tmp0_other_with_cast.o2r_1))
      return false;
    if (!this.p2r_1.equals(tmp0_other_with_cast.p2r_1))
      return false;
    if (!this.q2r_1.equals(tmp0_other_with_cast.q2r_1))
      return false;
    if (!this.r2r_1.equals(tmp0_other_with_cast.r2r_1))
      return false;
    if (!(this.s2r_1 === tmp0_other_with_cast.s2r_1))
      return false;
    if (!(this.t2r_1 === tmp0_other_with_cast.t2r_1))
      return false;
    if (!(this.u2r_1 === tmp0_other_with_cast.u2r_1))
      return false;
    if (!equals(this.v2r_1, tmp0_other_with_cast.v2r_1))
      return false;
    if (!equals(this.w2r_1, tmp0_other_with_cast.w2r_1))
      return false;
    if (!equals(this.x2r_1, tmp0_other_with_cast.x2r_1))
      return false;
    if (!equals(this.y2r_1, tmp0_other_with_cast.y2r_1))
      return false;
    if (!equals(this.z2r_1, tmp0_other_with_cast.z2r_1))
      return false;
    if (!(this.a2s_1 == tmp0_other_with_cast.a2s_1))
      return false;
    if (!equals(this.b2s_1, tmp0_other_with_cast.b2s_1))
      return false;
    return true;
  }
}
class VfsOpenMode extends Enum {
  constructor(name, ordinal, cmode, write, createIfNotExists, truncate, read, append, createNew) {
    createIfNotExists = createIfNotExists === VOID ? false : createIfNotExists;
    truncate = truncate === VOID ? false : truncate;
    read = read === VOID ? true : read;
    append = append === VOID ? false : append;
    createNew = createNew === VOID ? false : createNew;
    super(name, ordinal);
    this.u2s_1 = cmode;
    this.v2s_1 = write;
    this.w2s_1 = createIfNotExists;
    this.x2s_1 = truncate;
    this.y2s_1 = read;
    this.z2s_1 = append;
    this.a2t_1 = createNew;
  }
}
class Companion_45 {}
class VfsCachedStatContext {
  constructor(stat) {
    this.b2t_1 = stat;
  }
  g3() {
    return Companion_instance_46;
  }
}
class VfsFile extends VfsNamed {
  constructor(vfs, path) {
    super(get_pathInfo(path));
    this.n2h_1 = new Mixin();
    this.o2h_1 = vfs;
    this.p2h_1 = path;
    this.q2h_1 = null;
  }
  b1i(_set____db54di) {
    this.n2h_1.b1i(_set____db54di);
  }
  c1i() {
    return this.n2h_1.c1i();
  }
  i2s() {
    return this.o2h_1.i2s();
  }
  g2s() {
    return this.o2h_1.h2s(this.p2h_1);
  }
  l1i(path) {
    return new VfsFile(this.o2h_1, _PathInfo___get_fullPath__impl__21fx6x(combine(get_pathInfo(this.p2h_1), get_pathInfo(path))));
  }
  j2r(mode, $completion) {
    return this.o2h_1.d2s(this.p2h_1, mode, $completion);
  }
  k2r(range, $completion) {
    return this.o2h_1.e2s(this.p2h_1, range, $completion);
  }
  q2k($completion) {
    return this.o2h_1.e2s(this.p2h_1, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
  }
  c2t($completion) {
    return this.q2k($completion);
  }
  r2h($completion) {
    return this.q2k($completion);
  }
  d2t(charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readString__6uahun_0(this, charset, $completion), $completion);
  }
  e2t(charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.d2t(charset, $completion) : $super.d2t.call(this, charset, $completion);
  }
  l2r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_0(this, $completion), $completion);
  }
  f2t() {
    return Companion_instance_47.g2t(this);
  }
  toString() {
    return this.o2h_1.toString() + '[' + this.p2h_1 + ']';
  }
  hashCode() {
    var result = hashCode(this.o2h_1);
    result = imul(result, 31) + getStringHashCode(this.p2h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals(this.o2h_1, tmp0_other_with_cast.o2h_1))
      return false;
    if (!(this.p2h_1 === tmp0_other_with_cast.p2h_1))
      return false;
    return true;
  }
}
class Companion_46 {
  g2t(jailRoot) {
    return (new JailVfs(jailRoot, Unit_instance)).i2s();
  }
}
class JailVfs extends Proxy {
  constructor(jailRoot, dummy) {
    super();
    this.i2t_1 = jailRoot;
    this.j2t_1 = normalize(this.i2t_1.c2r());
  }
  i2r(path, $completion) {
    return this.i2t_1.l1i(trim_0(normalize(get_pathInfo(path)), charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  g2s() {
    return this.i2t_1.g2s();
  }
  toString() {
    return 'JailVfs(' + this.i2t_1.toString() + ')';
  }
}
class Companion_47 {}
class LocalVfs extends Vfs {
  constructor(fs) {
    fs = fs === VOID ? Companion_getInstance_44() : fs;
    super();
    this.k2t_1 = fs;
  }
  toString() {
    return 'LocalVfs';
  }
}
class UrlVfs extends Vfs {
  constructor(url, dummy, failFromStatus) {
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super();
    this.r2k_1 = url;
    this.s2k_1 = failFromStatus;
    this.t2k_1 = this.r2k_1;
  }
  g2s() {
    return this.t2k_1;
  }
  u2k(path) {
    var result = trim_0(this.r2k_1, charArrayOf([_Char___init__impl__6a9atx(47)])) + toString_1(_Char___init__impl__6a9atx(47)) + trim_0(path, charArrayOf([_Char___init__impl__6a9atx(47)]));
    return result;
  }
}
class _launch$slambda {
  constructor($callback) {
    this.l2t_1 = $callback;
  }
  r17($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5(this, $this$launch, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class launchUnscopedAndWait$1 {
  constructor($this_launchUnscopedAndWait, $deferred) {
    this.n2t_1 = $deferred;
    this.m2t_1 = $this_launchUnscopedAndWait;
  }
  zb() {
    return this.m2t_1;
  }
  bc(result) {
    completeWith(this.n2t_1, result);
  }
}
class launchUnscoped$1 {
  constructor($this_launchUnscoped) {
    this.o2t_1 = $this_launchUnscoped;
  }
  zb() {
    return this.o2t_1;
  }
  uk(result) {
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      var tmp667_safe_receiver = Result__exceptionOrNull_impl_p6xea9(result);
      if (tmp667_safe_receiver == null)
        null;
      else {
        printStackTrace(tmp667_safe_receiver);
      }
    }
  }
  bc(result) {
    return this.uk(result);
  }
}
class CatalogVfs$open$slambda {
  constructor(this$0, $path, $mode) {
    this.p2t_1 = this$0;
    this.q2t_1 = $path;
    this.r2t_1 = $mode;
  }
  r17($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6(this, $this$withContext, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.r17((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class CatalogVfs$open$2 extends AsyncStreamBase {
  static c2u(this$0, $base, $maxSize, $box) {
    if ($box === VOID)
      $box = {};
    $box.s2t_1 = this$0;
    $box.t2t_1 = $base;
    $box.u2t_1 = $maxSize;
    return this.v2o($box);
  }
  toString() {
    return 'CatalogVfs@' + this.s2t_1.w2t_1.toString() + ':' + toString(this.t2t_1);
  }
  o2o(position, buffer, offset, len, $completion) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = toLong(len);
    var b = this.u2t_1._v.q1(position);
    var rlen = (a.p1(b) <= 0 ? a : b).b2();
    return this.t2t_1.o2o(position, buffer, offset, rlen, $completion);
  }
  w2o(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_6(this, position, buffer, offset, len, $completion), $completion);
  }
  i1f($completion) {
    return this.u2t_1._v;
  }
  y1e($completion) {
    return this.t2t_1.y1e($completion);
  }
}
class CatalogVfs extends Proxy {
  constructor(parent) {
    super();
    this.w2t_1 = parent;
    this.x2t_1 = new Long(2097152, 0);
    this.y2t_1 = Companion_getInstance_65().p1a('CatalogVfs');
    this.z2t_1 = LinkedHashMap.ob();
    this.a2u_1 = FastStringMap();
  }
  e2s(path, range, $completion) {
    return super.e2s(path, range, $completion);
  }
  d2s(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea_0(this, path, mode, $completion), $completion);
  }
  i2r(path, $completion) {
    return this.w2t_1.l1i(path);
  }
  f2s(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_1(this, path, $completion), $completion);
  }
  b2u(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_statOrNull__vj5496(this, path, $completion), $completion);
  }
  d2u(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_cachedListSimpleStatsOrNull__bbx84j(this, path, $completion), $completion);
  }
  e2u(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_listSimpleStatsOrNull__lelcpx(this, path, $completion), $completion);
  }
}
class StandardVfs {
  i2u() {
    throw NotImplementedError.cd();
  }
}
class sam$kotlin_Comparator$0_2 {
  constructor(function_0) {
    this.m2u_1 = function_0;
  }
  zh(a, b) {
    return this.m2u_1(a, b);
  }
  compare(a, b) {
    return this.zh(a, b);
  }
}
class MountableVfs extends Proxy {
  constructor(closeMounts) {
    super();
    this.k2u_1 = closeMounts;
    this.l2u_1 = ArrayList.j1();
  }
  y1e($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_3(this, $completion), $completion);
  }
  n2u(folder, file) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfs.mount.<anonymous>' call
    unmountInternal(this, folder);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.l2u_1;
    var element = to(normalize(get_pathInfo(folder)), file);
    this_0.g(element);
    resort(this);
    return this;
  }
  i2r(path, $completion) {
    var rpath = normalize(get_pathInfo(path));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.l2u_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.io.file.std.MountableVfs.access.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = this_0.f1(_unary__edvuaz);
      var base = destruct.jk();
      var file = destruct.kk();
      if (startsWith(rpath, base)) {
        // Inline function 'kotlin.text.substring' call
        var startIndex = base.length;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = rpath.substring(startIndex);
        return file.l1i(tmp$ret$1);
      }
    }
    throw FileNotFoundException.r2u(path);
  }
  toString() {
    return 'MountableVfs';
  }
}
class StandardPathsBase {}
function appPreferencesFolder(appId) {
  return Companion_getInstance_101().j1s() ? '/Users/' + Companion_instance_96.l1i('USER') + '/Library/Preferences/' + appId : Companion_getInstance_101().i1s() ? '' + Companion_instance_96.l1i('APPDATA') + '/' + appId : '' + Companion_instance_96.l1i('HOME') + '/.config/' + appId;
}
class FinalUrlVfs$open$2 extends AsyncStreamBase {
  static a2w(this$0, $path, $mode, $fullUrl, $stat, $box) {
    if ($box === VOID)
      $box = {};
    $box.h2v_1 = this$0;
    $box.i2v_1 = $path;
    $box.j2v_1 = $mode;
    $box.k2v_1 = $fullUrl;
    $box.l2v_1 = $stat;
    return this.v2o($box);
  }
  toString() {
    return 'UrlVfs:' + this.h2v_1.r2k_1 + ':' + this.i2v_1 + ':' + this.j2v_1.toString();
  }
  o2o(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_5(this, position, buffer, offset, len, $completion), $completion);
  }
  h1f($completion) {
    return this.l2v_1.p2r_1.p1(new Long(0, 0)) >= 0;
  }
  i1f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94_1(this, $completion), $completion);
  }
}
class FinalUrlVfs extends UrlVfs {
  constructor(url, dummy, client, failFromStatus) {
    client = client === VOID ? createHttpClient() : client;
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super(url, dummy, failFromStatus);
    this.w2v_1 = dummy;
    this.x2v_1 = client;
    this.y2v_1 = url;
  }
  g2s() {
    return this.y2v_1;
  }
  d2s(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea_1(this, path, mode, $completion), $completion);
  }
  e2s(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t_1(this, path, range, $completion), $completion);
  }
  f2s(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_2(this, path, $completion), $completion);
  }
  toString() {
    return 'UrlVfs';
  }
}
class Companion_48 {
  constructor() {
    Companion_instance_49 = this;
    this.s2w_1 = 0;
    this.t2w_1 = Regex.wg('^([a-zA-Z0-9+.-]+)(?::([a-zA-Z]+))?:');
  }
  u2w(scheme) {
    switch (scheme) {
      case 'ftp':
        return 21;
      case 'ftps':
        return 990;
      case 'http':
      case 'ws':
        return 80;
      case 'https':
      case 'wss':
        return 443;
      default:
        return -1;
    }
  }
  v2w(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) {
    var tmp;
    if (scheme == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = scheme.toLowerCase();
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (subScheme == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = subScheme.toLowerCase();
    }
    return new URL_0(opaque, tmp_0, tmp_1, userInfo, host, path, query, fragment, port);
  }
  w2w(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port, $super) {
    scheme = scheme === VOID ? null : scheme;
    subScheme = subScheme === VOID ? null : subScheme;
    userInfo = userInfo === VOID ? null : userInfo;
    host = host === VOID ? null : host;
    path = path === VOID ? '' : path;
    query = query === VOID ? null : query;
    fragment = fragment === VOID ? null : fragment;
    opaque = opaque === VOID ? false : opaque;
    port = port === VOID ? this.s2w_1 : port;
    return $super === VOID ? this.v2w(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) : $super.v2w.call(this, scheme, subScheme, userInfo, host, path, query, fragment, opaque, port);
  }
  p1a(url) {
    var r = new StrReader(url);
    var schemeColon = r.c2x(this.t2w_1);
    var tmp;
    if (!(schemeColon == null)) {
      var isHierarchical = !(r.d2x('//') == null);
      var nonScheme = r.e2x();
      var schemeParts = split(dropLast_0(schemeColon, 1), [':']);
      var scheme = schemeParts.f1(0);
      var subScheme = getOrNull(schemeParts, 1);
      var nonFragment = substringBefore(nonScheme, _Char___init__impl__6a9atx(35));
      var fragment = substringAfterOrNull(nonScheme, _Char___init__impl__6a9atx(35));
      var nonQuery = substringBefore(nonFragment, _Char___init__impl__6a9atx(63));
      var query = substringAfterOrNull(nonFragment, _Char___init__impl__6a9atx(63));
      var authority = substringBefore(nonQuery, _Char___init__impl__6a9atx(47));
      var path = substringAfterOrNull(nonQuery, _Char___init__impl__6a9atx(47));
      var hostWithPort = substringAfter(authority, _Char___init__impl__6a9atx(64));
      var userInfo = substringBeforeOrNull(authority, _Char___init__impl__6a9atx(64));
      var host = substringBefore(hostWithPort, _Char___init__impl__6a9atx(58));
      var port = substringAfterOrNull(hostWithPort, _Char___init__impl__6a9atx(58));
      var tmp701_opaque = !isHierarchical;
      // Inline function 'kotlin.takeIf' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      // Inline function 'korlibs.io.net.Companion.invoke.<anonymous>' call
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(host) > 0) {
        tmp_0 = host;
      } else {
        tmp_0 = null;
      }
      var tmp702_host = tmp_0;
      var tmp703_path = !(path == null) ? '/' + path : '';
      var tmp0_elvis_lhs = port == null ? null : toIntOrNull(port);
      var tmp704_port = tmp0_elvis_lhs == null ? this.s2w_1 : tmp0_elvis_lhs;
      tmp = this.v2w(scheme, subScheme, userInfo, tmp702_host, tmp703_path, query, fragment, tmp701_opaque, tmp704_port);
    } else {
      var nonFragment_0 = substringBefore(url, _Char___init__impl__6a9atx(35));
      var fragment_0 = substringAfterOrNull(url, _Char___init__impl__6a9atx(35));
      var path_0 = substringBefore(nonFragment_0, _Char___init__impl__6a9atx(63));
      var query_0 = substringAfterOrNull(nonFragment_0, _Char___init__impl__6a9atx(63));
      tmp = this.w2w(null, null, null, null, path_0, query_0, fragment_0, false);
    }
    return tmp;
  }
  f2x(url) {
    return !((new StrReader(url)).c2x(this.t2w_1) == null);
  }
  g2x(base, access) {
    var refinedAccess = startsWith(access, '//') && contains(base, ':') ? substringBefore_0(base, ':') + ':' + access : access;
    if (this.f2x(refinedAccess))
      return refinedAccess;
    if (isBlank(base)) {
      throw MalformedInputException.j2x('The base URL should not be empty, or the access URL must be absolute.');
    }
    if (!this.f2x(base)) {
      throw MalformedInputException.j2x('At least one of the base URL or access URL must be absolute.');
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(refinedAccess) === 0) {
      tmp = base;
    } else {
      if (startsWith(refinedAccess, '/')) {
        tmp = Companion_getInstance_50().p1a(base).f2v(VOID, VOID, VOID, VOID, VOID, normalizeUrl(refinedAccess), null).g2v();
      } else {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.io.net.Companion.resolve.<anonymous>' call
        var $this$run = Companion_getInstance_50().p1a(base);
        var tmp_0;
        if (startsWith(refinedAccess, '?') || startsWith(refinedAccess, '#')) {
          tmp_0 = $this$run.y2u_1 + refinedAccess;
        } else {
          tmp_0 = substringBeforeLast($this$run.y2u_1, _Char___init__impl__6a9atx(47)) + '/' + refinedAccess;
        }
        var refinedPath = tmp_0;
        tmp = $this$run.f2v(VOID, VOID, VOID, VOID, VOID, '/' + trimStart(normalizeUrl(refinedPath), charArrayOf([_Char___init__impl__6a9atx(47)])), null).g2v();
      }
    }
    return tmp;
  }
}
class URL_0 {
  constructor(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    Companion_getInstance_50();
    this.t2u_1 = isOpaque;
    this.u2u_1 = scheme;
    this.v2u_1 = subScheme;
    this.w2u_1 = userInfo;
    this.x2u_1 = host;
    this.y2u_1 = path;
    this.z2u_1 = query;
    this.a2v_1 = fragment;
    this.b2v_1 = defaultPort;
    var tmp = this;
    tmp.c2v_1 = lazy(URL$fullUrl$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.d2v_1 = lazy(URL$fullUrlWithoutScheme$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.e2v_1 = lazy(URL$pathWithQuery$delegate$lambda(this));
  }
  l2x() {
    return this.u2u_1 === 'https' || this.u2u_1 === 'wss' || this.u2u_1 === 'ftps';
  }
  m2x() {
    return Companion_getInstance_50().u2w(this.u2u_1);
  }
  n2x() {
    return this.b2v_1 === Companion_getInstance_50().s2w_1 ? this.m2x() : this.b2v_1;
  }
  g2v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c2v_1;
    fullUrl$factory();
    return this_0.h3();
  }
  o2x(includeScheme, out) {
    if (includeScheme && !(this.u2u_1 == null)) {
      out.ab('' + this.u2u_1 + ':');
      if (!(this.v2u_1 == null)) {
        out.ab('' + this.v2u_1 + ':');
      }
      if (!this.t2u_1) {
        out.ab('//');
      }
    }
    if (!(this.w2u_1 == null)) {
      out.ab('' + this.w2u_1 + '@');
    }
    if (!(this.x2u_1 == null)) {
      out.ab(this.x2u_1);
    }
    if (!(this.n2x() === Companion_getInstance_50().s2w_1) && !(this.n2x() === this.m2x())) {
      out.bb(_Char___init__impl__6a9atx(58)).eg(this.n2x());
    }
    out.ab(this.y2u_1);
    if (!(this.z2u_1 == null)) {
      out.ab('?' + this.z2u_1);
    }
    if (!(this.a2v_1 == null)) {
      out.ab('#' + this.a2v_1);
    }
    return out;
  }
  k2x(includeScheme, out, $super) {
    includeScheme = includeScheme === VOID ? true : includeScheme;
    out = out === VOID ? StringBuilder.i() : out;
    return $super === VOID ? this.o2x(includeScheme, out) : $super.o2x.call(this, includeScheme, out);
  }
  toString() {
    return this.g2v();
  }
  p2x(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    return new URL_0(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  }
  f2v(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort, $super) {
    isOpaque = isOpaque === VOID ? this.t2u_1 : isOpaque;
    scheme = scheme === VOID ? this.u2u_1 : scheme;
    subScheme = subScheme === VOID ? this.v2u_1 : subScheme;
    userInfo = userInfo === VOID ? this.w2u_1 : userInfo;
    host = host === VOID ? this.x2u_1 : host;
    path = path === VOID ? this.y2u_1 : path;
    query = query === VOID ? this.z2u_1 : query;
    fragment = fragment === VOID ? this.a2v_1 : fragment;
    defaultPort = defaultPort === VOID ? this.b2v_1 : defaultPort;
    return $super === VOID ? this.p2x(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) : $super.p2x.call(this, isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  }
  hashCode() {
    var result = getBooleanHashCode(this.t2u_1);
    result = imul(result, 31) + (this.u2u_1 == null ? 0 : getStringHashCode(this.u2u_1)) | 0;
    result = imul(result, 31) + (this.v2u_1 == null ? 0 : getStringHashCode(this.v2u_1)) | 0;
    result = imul(result, 31) + (this.w2u_1 == null ? 0 : getStringHashCode(this.w2u_1)) | 0;
    result = imul(result, 31) + (this.x2u_1 == null ? 0 : getStringHashCode(this.x2u_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2u_1) | 0;
    result = imul(result, 31) + (this.z2u_1 == null ? 0 : getStringHashCode(this.z2u_1)) | 0;
    result = imul(result, 31) + (this.a2v_1 == null ? 0 : getStringHashCode(this.a2v_1)) | 0;
    result = imul(result, 31) + this.b2v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof URL_0))
      return false;
    var tmp0_other_with_cast = other instanceof URL_0 ? other : THROW_CCE();
    if (!(this.t2u_1 === tmp0_other_with_cast.t2u_1))
      return false;
    if (!(this.u2u_1 == tmp0_other_with_cast.u2u_1))
      return false;
    if (!(this.v2u_1 == tmp0_other_with_cast.v2u_1))
      return false;
    if (!(this.w2u_1 == tmp0_other_with_cast.w2u_1))
      return false;
    if (!(this.x2u_1 == tmp0_other_with_cast.x2u_1))
      return false;
    if (!(this.y2u_1 === tmp0_other_with_cast.y2u_1))
      return false;
    if (!(this.z2u_1 == tmp0_other_with_cast.z2u_1))
      return false;
    if (!(this.a2v_1 == tmp0_other_with_cast.a2v_1))
      return false;
    if (!(this.b2v_1 === tmp0_other_with_cast.b2v_1))
      return false;
    return true;
  }
}
class Companion_49 {
  constructor() {
    Companion_instance_50 = this;
    this.b2w_1 = Methods_OPTIONS_getInstance();
    this.c2w_1 = Methods_GET_getInstance();
    this.d2w_1 = Methods_HEAD_getInstance();
    this.e2w_1 = Methods_POST_getInstance();
    this.f2w_1 = Methods_PUT_getInstance();
    this.g2w_1 = Methods_DELETE_getInstance();
    this.h2w_1 = Methods_TRACE_getInstance();
    this.i2w_1 = Methods_CONNECT_getInstance();
    this.j2w_1 = Methods_PATCH_getInstance();
    this.k2w_1 = listOf_0([this.b2w_1, this.c2w_1, this.d2w_1, this.e2w_1, this.f2w_1, this.g2w_1, this.h2w_1, this.i2w_1, this.j2w_1]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.k2w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Companion.valuesMap.<anonymous>' call
      var tmp$ret$0 = to(item.i3_1, item);
      destination.g(tmp$ret$0);
    }
    tmp.l2w_1 = toMap_0(destination);
  }
}
class Companion_50 {}
class Companion_51 {
  constructor() {
    this.q2w_1 = 'Content-Length';
    this.r2w_1 = 'Content-Type';
  }
}
class sam$kotlin_Comparator$0_3 {
  constructor(function_0) {
    this.q2x_1 = function_0;
  }
  zh(a, b) {
    return this.q2x_1(a, b);
  }
  compare(a, b) {
    return this.zh(a, b);
  }
}
class Methods extends Enum {}
class IOException extends Exception {
  static d2y(msg) {
    var $this = this.f5(msg);
    captureStack($this, $this.c2y_1);
    return $this;
  }
}
class HttpException extends IOException {
  static y2x(statusCode, msg, statusText, headers) {
    msg = msg === VOID ? 'Error' + statusCode : msg;
    var tmp;
    if (statusText === VOID) {
      var tmp0_elvis_lhs = HttpStatusMessage_getInstance().z2x_1.f3(statusCode);
      tmp = tmp0_elvis_lhs == null ? 'Error' + statusCode : tmp0_elvis_lhs;
    } else {
      tmp = statusText;
    }
    statusText = tmp;
    headers = headers === VOID ? Headers.a2y([]) : headers;
    var $this = this.d2y('' + statusCode + ' ' + statusText + ' - ' + msg);
    captureStack($this, $this.x2x_1);
    $this.t2x_1 = statusCode;
    $this.u2x_1 = msg;
    $this.v2x_1 = statusText;
    $this.w2x_1 = headers;
    return $this;
  }
}
class Headers {
  static e2y(items) {
    var $this = createThis(this);
    $this.m2w_1 = items;
    return $this;
  }
  static a2y(items) {
    return this.e2y(toList_0(items));
  }
  static n2w(map) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(map.d1());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = map.c3().a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Headers.<init>.<anonymous>' call
      var tmp$ret$1 = to(item.g3(), item.h3());
      destination.g(tmp$ret$1);
    }
    return this.e2y(destination);
  }
  a1() {
    return this.m2w_1.a1();
  }
  l1i(key) {
    return this.f2y(key);
  }
  f2y(key) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.m2w_1.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.io.net.http.Headers.getFirst.<anonymous>' call
        if (equals_0(element.hk_1, key, true)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp708_safe_receiver = tmp$ret$1;
    return tmp708_safe_receiver == null ? null : tmp708_safe_receiver.ik_1;
  }
  g2y() {
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var this_0 = this.m2w_1;
    var destination = LinkedHashMap.ob();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var key = element.hk_1.toLowerCase();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.f3(key);
      var tmp;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList.j1();
        destination.x2(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.g(element);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.r(destination.d1());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = destination.c3().a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      var tmp_0 = first(item.h3()).hk_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = item.h3();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.r(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_1 = this_1.a1();
      while (tmp0_iterator_1.b1()) {
        var item_0 = tmp0_iterator_1.c1();
        // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>.<anonymous>' call
        var tmp$ret$8 = item_0.ik_1;
        destination_1.g(tmp$ret$8);
      }
      var tmp$ret$11 = to(tmp_0, destination_1);
      destination_0.g(tmp$ret$11);
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = Http$Headers$toListGrouped$lambda;
    var tmp$ret$14 = new sam$kotlin_Comparator$0_3(tmp_1);
    return sortedWith(destination_0, tmp$ret$14);
  }
  h2y(newHeaders) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(newHeaders, 10));
    var tmp0_iterator = newHeaders.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.hk_1.toLowerCase();
      destination.g(tmp$ret$2);
    }
    var replaceKeys = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.m2w_1;
    var destination_0 = ArrayList.j1();
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = element.hk_1.toLowerCase();
      if (!replaceKeys.p2(tmp$ret$6)) {
        destination_0.g(element);
      }
    }
    return Headers.e2y(plus_1(destination_0, toList(newHeaders)));
  }
  i2y(newHeaders) {
    return this.h2y(toList_0(newHeaders));
  }
  j2y(newHeaders) {
    return this.h2y(toList(newHeaders));
  }
  toString() {
    return 'Headers(' + joinToString_0(this.g2y(), ', ') + ')';
  }
  hashCode() {
    return hashCode(this.m2w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Headers))
      return false;
    var tmp0_other_with_cast = other instanceof Headers ? other : THROW_CCE();
    if (!equals(this.m2w_1, tmp0_other_with_cast.m2w_1))
      return false;
    return true;
  }
}
class Companion_52 {
  k2y(status, statusText, headers, rawContent, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7(this, status, statusText, headers, rawContent, $completion), $completion);
  }
}
class Companion_53 {
  constructor() {
    Companion_instance_54 = this;
    this.n2y_1 = new RequestConfig();
  }
}
class Response {
  constructor(status, statusText, headers, rawContent, content) {
    this.m2v_1 = status;
    this.n2v_1 = statusText;
    this.o2v_1 = headers;
    this.p2v_1 = rawContent;
    this.q2v_1 = content;
    this.r2v_1 = this.m2v_1 < 400;
    var tmp = this;
    tmp.s2v_1 = lazy(HttpClient$Response$responseCharset$delegate$lambda);
  }
  l2y($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readAllBytes__ja4yyw(this, $completion), $completion);
  }
  o2y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s2v_1;
    responseCharset$factory();
    return this_0.h3();
  }
  p2y(charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readAllString__7ikxrc(this, charset, $completion), $completion);
  }
  m2y(charset, $completion, $super) {
    charset = charset === VOID ? this.o2y() : charset;
    return $super === VOID ? this.p2y(charset, $completion) : $super.p2y.call(this, charset, $completion);
  }
  p2w($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_checkErrors__u7iznj(this, $completion), $completion);
  }
  q2y(content) {
    return new CompletedResponse(this.m2v_1, this.n2v_1, this.o2v_1, content);
  }
  toString() {
    return 'Response(status=' + this.m2v_1 + ', statusText=' + this.n2v_1 + ', headers=' + this.o2v_1.toString() + ', rawContent=' + toString(this.p2v_1) + ', content=' + toString(this.q2v_1) + ')';
  }
  hashCode() {
    var result = this.m2v_1;
    result = imul(result, 31) + getStringHashCode(this.n2v_1) | 0;
    result = imul(result, 31) + this.o2v_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.p2v_1) | 0;
    result = imul(result, 31) + hashCode(this.q2v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Response))
      return false;
    var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
    if (!(this.m2v_1 === tmp0_other_with_cast.m2v_1))
      return false;
    if (!(this.n2v_1 === tmp0_other_with_cast.n2v_1))
      return false;
    if (!this.o2v_1.equals(tmp0_other_with_cast.o2v_1))
      return false;
    if (!equals(this.p2v_1, tmp0_other_with_cast.p2v_1))
      return false;
    if (!equals(this.q2v_1, tmp0_other_with_cast.q2v_1))
      return false;
    return true;
  }
}
class CompletedResponse {
  constructor(status, statusText, headers, content) {
    this.r2y_1 = status;
    this.s2y_1 = statusText;
    this.t2y_1 = headers;
    this.u2y_1 = content;
    this.v2y_1 = this.r2y_1 < 400;
  }
  toString() {
    return 'CompletedResponse(status=' + this.r2y_1 + ', statusText=' + this.s2y_1 + ', headers=' + this.t2y_1.toString() + ', content=' + toString_0(this.u2y_1) + ')';
  }
  hashCode() {
    var result = this.r2y_1;
    result = imul(result, 31) + getStringHashCode(this.s2y_1) | 0;
    result = imul(result, 31) + this.t2y_1.hashCode() | 0;
    result = imul(result, 31) + (this.u2y_1 == null ? 0 : hashCode(this.u2y_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedResponse))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedResponse ? other : THROW_CCE();
    if (!(this.r2y_1 === tmp0_other_with_cast.r2y_1))
      return false;
    if (!(this.s2y_1 === tmp0_other_with_cast.s2y_1))
      return false;
    if (!this.t2y_1.equals(tmp0_other_with_cast.t2y_1))
      return false;
    if (!equals(this.u2y_1, tmp0_other_with_cast.u2y_1))
      return false;
    return true;
  }
}
class RequestConfig {
  constructor(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    Companion_getInstance_55();
    followRedirects = followRedirects === VOID ? true : followRedirects;
    throwErrors = throwErrors === VOID ? false : throwErrors;
    maxRedirects = maxRedirects === VOID ? 10 : maxRedirects;
    referer = referer === VOID ? null : referer;
    simulateBrowser = simulateBrowser === VOID ? false : simulateBrowser;
    this.w2y_1 = followRedirects;
    this.x2y_1 = throwErrors;
    this.y2y_1 = maxRedirects;
    this.z2y_1 = referer;
    this.a2z_1 = simulateBrowser;
  }
  b2z(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    return new RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  c2z(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $super) {
    followRedirects = followRedirects === VOID ? this.w2y_1 : followRedirects;
    throwErrors = throwErrors === VOID ? this.x2y_1 : throwErrors;
    maxRedirects = maxRedirects === VOID ? this.y2y_1 : maxRedirects;
    referer = referer === VOID ? this.z2y_1 : referer;
    simulateBrowser = simulateBrowser === VOID ? this.a2z_1 : simulateBrowser;
    return $super === VOID ? this.b2z(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) : $super.b2z.call(this, followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  toString() {
    return 'RequestConfig(followRedirects=' + this.w2y_1 + ', throwErrors=' + this.x2y_1 + ', maxRedirects=' + this.y2y_1 + ', referer=' + this.z2y_1 + ', simulateBrowser=' + this.a2z_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.w2y_1);
    result = imul(result, 31) + getBooleanHashCode(this.x2y_1) | 0;
    result = imul(result, 31) + this.y2y_1 | 0;
    result = imul(result, 31) + (this.z2y_1 == null ? 0 : getStringHashCode(this.z2y_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a2z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestConfig))
      return false;
    var tmp0_other_with_cast = other instanceof RequestConfig ? other : THROW_CCE();
    if (!(this.w2y_1 === tmp0_other_with_cast.w2y_1))
      return false;
    if (!(this.x2y_1 === tmp0_other_with_cast.x2y_1))
      return false;
    if (!(this.y2y_1 === tmp0_other_with_cast.y2y_1))
      return false;
    if (!(this.z2y_1 == tmp0_other_with_cast.z2y_1))
      return false;
    if (!(this.a2z_1 === tmp0_other_with_cast.a2z_1))
      return false;
    return true;
  }
}
class HttpClient {}
function request(method, url, headers, content, config, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_request__hjt9xh(this, method, url, headers, content, config, $completion), $completion);
}
function request$default(method, url, headers, content, config, $completion, $super) {
  headers = headers === VOID ? Headers.a2y([]) : headers;
  content = content === VOID ? null : content;
  config = config === VOID ? Companion_getInstance_55().n2y_1 : config;
  return $super === VOID ? this.l2z(method, url, headers, content, config, $completion) : request(method, url, headers, content, config, $completion);
}
function requestAsBytes(method, url, headers, content, config, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_requestAsBytes__v4smbm(this, method, url, headers, content, config, $completion), $completion);
}
function requestAsBytes$default(method, url, headers, content, config, $completion, $super) {
  headers = headers === VOID ? Headers.a2y([]) : headers;
  content = content === VOID ? null : content;
  config = config === VOID ? new RequestConfig() : config;
  return $super === VOID ? this.n2z(method, url, headers, content, config, $completion) : requestAsBytes(method, url, headers, content, config, $completion);
}
function readBytes(url, config, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytes__epy2u7_0(this, url, config, $completion), $completion);
}
function readBytes$default(url, config, $completion, $super) {
  config = config === VOID ? new RequestConfig() : config;
  return $super === VOID ? this.o2z(url, config, $completion) : readBytes(url, config, $completion);
}
class Companion_54 {
  constructor() {
    Companion_instance_55 = this;
    this.d2z_1 = createHttpClientFromFetch$accessor$36sicd();
    this.e2z_1 = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36';
    this.f2z_1 = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8';
    this.g2z_1 = 'en-us';
    this.h2z_1 = 'gzip, deflate';
    this.i2z_1 = 'Close';
  }
  k2z(method, url, headers, content, $completion) {
    return this.d2z_1.k2z(method, url, headers, content, $completion);
  }
  l2z(method, url, headers, content, config, $completion) {
    return this.d2z_1.l2z(method, url, headers, content, config, $completion);
  }
  n2z(method, url, headers, content, config, $completion) {
    return this.d2z_1.n2z(method, url, headers, content, config, $completion);
  }
  o2z(url, config, $completion) {
    return this.d2z_1.o2z(url, config, $completion);
  }
  j2z(headers, host) {
    var out = Headers.a2y([to('User-Agent', this.e2z_1), to('Accept', this.f2z_1), to('Accept-Language', this.g2z_1), to('Accept-Encoding', this.h2z_1), to('Connection', this.i2z_1)]).j2y(headers);
    return !(host == null) ? out.i2y([to('Host', host)]) : out;
  }
}
class HttpStatusMessage {
  constructor() {
    HttpStatusMessage_instance = this;
    this.z2x_1 = linkedMapOf([to(100, 'Continue'), to(101, 'Switching Protocols'), to(200, 'OK'), to(201, 'Created'), to(202, 'Accepted'), to(203, 'Non-Authoritative Information'), to(204, 'No Content'), to(205, 'Reset Content'), to(206, 'Partial Content'), to(300, 'Multiple Choices'), to(301, 'Moved Permanently'), to(302, 'Found'), to(303, 'See Other'), to(304, 'Not Modified'), to(305, 'Use Proxy'), to(307, 'Temporary Redirect'), to(400, 'Bad Request'), to(401, 'Unauthorized'), to(402, 'Payment Required'), to(403, 'Forbidden'), to(404, 'Not Found'), to(405, 'Method Not Allowed'), to(406, 'Not Acceptable'), to(407, 'Proxy Authentication Required'), to(408, 'Request Timeout'), to(409, 'Conflict'), to(410, 'Gone'), to(411, 'Length Required'), to(412, 'Precondition Failed'), to(413, 'Request Entity Too Large'), to(414, 'Request-URI Too Long'), to(415, 'Unsupported Media Type'), to(416, 'Requested Range Not Satisfiable'), to(417, 'Expectation Failed'), to(418, "I'm a teapot"), to(422, 'Unprocessable Entity (WebDAV - RFC 4918)'), to(423, 'Locked (WebDAV - RFC 4918)'), to(424, 'Failed Dependency (WebDAV) (RFC 4918)'), to(425, 'Unassigned'), to(426, 'Upgrade Required (RFC 7231)'), to(428, 'Precondition Required'), to(429, 'Too Many Requests'), to(431, 'Request Header Fileds Too Large)'), to(449, 'Error449'), to(451, 'Unavailable for Legal Reasons'), to(500, 'Internal Server Error'), to(501, 'Not Implemented'), to(502, 'Bad Gateway'), to(503, 'Service Unavailable'), to(504, 'Gateway Timeout'), to(505, 'HTTP Version Not Supported'), to(506, 'Variant Also Negotiates (RFC 2295)'), to(507, 'Insufficient Storage (WebDAV - RFC 4918)'), to(508, 'Loop Detected (WebDAV)'), to(509, 'Bandwidth Limit Exceeded'), to(510, 'Not Extended (RFC 2774)'), to(511, 'Network Authentication Required')]);
  }
}
class ProxiedHttpFactory {
  constructor(parent) {
    this.q2z_1 = parent;
    this.r2z_1 = parent;
  }
  p2z() {
    return this.q2z_1.p2z();
  }
}
class withTransferEncoding$slambda {
  constructor($input) {
    this.s2z_1 = $input;
  }
  z1d(out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8(this, out, $completion), $completion);
  }
  ed(p1, $completion) {
    return this.z1d((!(p1 == null) ? isInterface(p1, AsyncOutputStream) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class createHttpClientFromFetch$1 {
  constructor($fetch) {
    this.u2z_1 = $fetch;
    this.t2z_1 = false;
  }
  k2z(method, url, headers, content, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_requestInternal__facax4(this, method, url, headers, content, $completion), $completion);
  }
}
class Resources {
  constructor(coroutineContext, root, parent) {
    root = root === VOID ? get_resourcesVfs() : root;
    parent = parent === VOID ? null : parent;
    this.v2z_1 = coroutineContext;
    this.w2z_1 = root;
    this.x2z_1 = parent;
    this.y2z_1 = LinkedHashMap.ob();
  }
}
class Text {}
class Marker {}
class Line {
  constructor(str) {
    this.a30_1 = str;
  }
  z2z() {
    return this.a30_1;
  }
  toString() {
    return 'Line(str=' + this.a30_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.a30_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!(this.a30_1 === tmp0_other_with_cast.a30_1))
      return false;
    return true;
  }
}
class LineDeferred {}
class EmptyLineOnce {}
class Indent {}
class Unindent {}
class INDENTS {
  f1(index) {
    return INDENTS_getInstance_0().f1(index);
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_56 = this;
    var tmp = this;
    // Inline function 'korlibs.io.util.Companion.gen' call
    Companion_getInstance_57();
    var indenter = new Indenter();
    // Inline function 'korlibs.io.util.Companion.EMPTY.<anonymous>' call
    tmp.e30_1 = indenter;
  }
  f30(init) {
    // Inline function 'korlibs.io.util.Companion.gen' call
    var indenter = new Indenter();
    init(indenter);
    return indenter;
  }
}
class IndenterEvaluator {
  constructor(markHandler, indentEmptyLines, doIndent) {
    this.g30_1 = markHandler;
    this.h30_1 = indentEmptyLines;
    this.i30_1 = doIndent;
    this.j30_1 = StringBuilder.i();
    this.k30_1 = 0;
    this.l30_1 = true;
    this.m30_1 = 0;
    this.n30_1 = false;
  }
  o30(str) {
    return this.j30_1.ab(str);
  }
  p30(str) {
    return this.j30_1.bb(str);
  }
  q30() {
    if (this.i30_1) {
      this.p30(_Char___init__impl__6a9atx(10));
    }
    this.k30_1 = this.k30_1 + 1 | 0;
    this.l30_1 = true;
  }
  r30(actions) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < actions.d1()) {
      // Inline function 'korlibs.io.util.IndenterEvaluator.eval.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var action = actions.f1(_unary__edvuaz);
      if (isInterface(action, Text)) {
        if (this.l30_1) {
          var tmp;
          if (!this.h30_1) {
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = action.z2z();
            tmp = charSequenceLength(this_0) === 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            this.q30();
          } else {
            if (this.i30_1)
              this.o30(INDENTS_instance.f1(this.m30_1));
            else
              this.o30(' ');
          }
        }
        this.o30(action.z2z());
        if (action instanceof Line) {
          var tmp_0 = this;
          var tmp_1 = this.k30_1;
          // Inline function 'kotlin.text.count' call
          var count = 0;
          var indexedObject = action.a30_1;
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(indexedObject)) {
            var element = charSequenceGet(indexedObject, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.io.util.IndenterEvaluator.eval.<anonymous>.<anonymous>' call
            if (element === _Char___init__impl__6a9atx(10)) {
              count = count + 1 | 0;
            }
          }
          tmp_0.k30_1 = tmp_1 + count | 0;
          this.q30();
        } else {
          this.l30_1 = false;
        }
        this.n30_1 = true;
      } else {
        if (action instanceof LineDeferred) {
          this.r30(action.w30_1().t30_1);
        } else {
          if (equals(action, Indent_instance) || equals(action, Unindent_instance)) {
            this.n30_1 = false;
            this.m30_1 = this.m30_1 + (equals(action, Indent_instance) ? 1 : -1) | 0;
          } else {
            if (equals(action, EmptyLineOnce_instance)) {
              if (this.n30_1) {
                this.q30();
                this.n30_1 = false;
              }
            } else {
              if (action instanceof Marker) {
                var tmp756_safe_receiver = this.g30_1;
                if (tmp756_safe_receiver == null)
                  null;
                else
                  tmp756_safe_receiver(this.j30_1, this.k30_1, action.s30_1);
              }
            }
          }
        }
      }
    }
  }
}
class Indenter {
  constructor(actions) {
    Companion_getInstance_57();
    var tmp;
    if (actions === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList.j1();
    } else {
      tmp = actions;
    }
    actions = tmp;
    this.t30_1 = actions;
    this.u30_1 = true;
    this.v30_1 = '';
  }
  x30(indenter) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.line.<anonymous>' call
    this.t30_1.e1(indenter.t30_1);
    return this;
  }
  y30(str) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.line.<anonymous>' call
    this.t30_1.g(new Line(str));
    return this;
  }
  z30() {
    this.t30_1.g(Indent_instance);
  }
  a31() {
    this.t30_1.g(Unindent_instance);
  }
  b31(markHandler, doIndent) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IndenterEvaluator(markHandler, this.u30_1, doIndent);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.toString.<anonymous>' call
    this_0.r30(this.t30_1);
    return this_0.j30_1.toString();
  }
  toString() {
    return this.b31(null, true);
  }
}
class Companion_56 {}
class BaseStrReader {
  g31() {
    return !this.d31();
  }
  f31() {
    return this.l31(0);
  }
  h31() {
    var out = this.f31();
    this.j31(1);
    return out;
  }
  d2x(lit, consume, $super) {
    consume = consume === VOID ? true : consume;
    return $super === VOID ? this.k31(lit, consume) : $super.k31.call(this, lit, consume);
  }
  i31(count) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.e31(count);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.BaseStrReader.read.<anonymous>' call
    this.j31(count);
    return this_0;
  }
}
class StrReader extends BaseStrReader {
  constructor(str, file, pos) {
    file = file === VOID ? 'file' : file;
    pos = pos === VOID ? 0 : pos;
    super();
    this.x2w_1 = str;
    this.y2w_1 = file;
    this.z2w_1 = pos;
    this.a2x_1 = charArray(this.x2w_1.length);
    this.b2x_1 = this.x2w_1.length;
  }
  c31() {
    return this.z2w_1;
  }
  s2q() {
    return this.b2x_1 - this.z2w_1 | 0;
  }
  d31() {
    return this.z2w_1 >= this.x2w_1.length;
  }
  e31(count) {
    return substr(this, this.z2w_1, count);
  }
  f31() {
    return this.g31() ? charSequenceGet(this.x2w_1, this.z2w_1) : _Char___init__impl__6a9atx(0);
  }
  h31() {
    return this.g31() ? charSequenceGet(this.x2w_1, posSkip(this, 1)) : _Char___init__impl__6a9atx(0);
  }
  e2x() {
    return this.i31(this.s2q());
  }
  j31(count) {
    this.z2w_1 = this.z2w_1 + count | 0;
    return this;
  }
  k31(lit, consume) {
    if (!substringEquals(StringCompanionObject_instance, this.x2w_1, this.z2w_1, lit, 0, lit.length))
      return null;
    if (consume)
      this.z2w_1 = this.z2w_1 + lit.length | 0;
    return lit;
  }
  c2x(v) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.x2w_1;
    var startIndex = this.z2w_1;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this_0.substring(startIndex);
    var tmp0_elvis_lhs = v.zg(tmp$ret$1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    var m = ensureNotNull(result.wh().f1(0)).fh_1;
    this.z2w_1 = this.z2w_1 + m.length | 0;
    return m;
  }
  l31(offset) {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = this.x2w_1;
    var index = this.z2w_1 + offset | 0;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, index);
    } else {
      // Inline function 'korlibs.io.util.StrReader.peekOffset.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    return tmp;
  }
}
class DemoWorkerTask$execute$slambda {
  m31(params, $completion) {
    println('TEST!!!!! ' + toString(params));
    return 11;
  }
  ed(p1, $completion) {
    return this.m31((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class WorkerTask {
  constructor() {
    this.t31_1 = null;
    this.u31_1 = false;
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp.v31_1 = emptyList();
    this.w31_1 = null;
    this.x31_1 = false;
  }
  z31(_set____db54di) {
    this.v31_1 = _set____db54di;
  }
  a32() {
    if (!this.x31_1) {
      // Inline function 'kotlin.error' call
      var message = 'Must wrap function around runSuspend';
      throw IllegalStateException.n4(toString(message));
    }
    return this.v31_1;
  }
  b32(_set____db54di) {
    this.w31_1 = _set____db54di;
  }
  c32() {
    return this.w31_1;
  }
  y31(block) {
    this.x31_1 = true;
    try {
      if (this.u31_1) {
        this.t31_1 = currentStackTrace();
        return Unit_instance;
      }
      var deferred = CompletableDeferred();
      var tmp = EmptyCoroutineContext_getInstance();
      launchImmediately(tmp, WorkerTask$runSuspend$slambda_0(deferred, this, block));
      this.w31_1 = deferred;
    }finally {
      this.x31_1 = false;
    }
  }
  s31() {
    return Unit_instance;
  }
  d32() {
    this.u31_1 = true;
    try {
      this.s31();
      return ensureNotNull(this.t31_1);
    }finally {
      this.u31_1 = false;
    }
  }
}
class DemoWorkerTask extends WorkerTask {
  s31() {
    return this.y31(DemoWorkerTask$execute$slambda_0());
  }
}
class WorkerTask$runSuspend$slambda {
  constructor($deferred, this$0, $block) {
    this.e32_1 = $deferred;
    this.f32_1 = this$0;
    this.g32_1 = $block;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9(this, $completion), $completion);
  }
}
class _WorkerImpl {
  h32() {
    return Unit_instance;
  }
  i32() {
    return false;
  }
}
class Companion_57 {}
class BlobAsyncBaseStream extends AsyncStreamBase {
  static k32(blob) {
    var $this = this.v2o();
    $this.j32_1 = blob;
    return $this;
  }
  y1e($completion) {
  }
  o2o(position, buffer, offset, len, $completion) {
    var deferred = CompletableDeferred();
    var reader = new FileReader();
    reader.onload = BlobAsyncBaseStream$read$lambda(reader, len, buffer, offset, deferred);
    reader.onerror = BlobAsyncBaseStream$read$lambda_0(deferred, reader);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.j32_1;
    reader.readAsArrayBuffer(tmp$ret$1.slice(position.e4(), position.e4() + len));
    return deferred.hr($completion);
  }
  i1f($completion) {
    return numberToLong(this.j32_1.size);
  }
}
class toVfs$1 extends Vfs {
  constructor($file, $box) {
    if ($box === VOID)
      $box = {};
    $box.m32_1 = $file;
    super($box);
    this.l32_1 = $file.name;
  }
  g2s() {
    return this.l32_1;
  }
  d2s(path, mode, $completion) {
    return openAsync_0(this.m32_1);
  }
}
class standardVfs$1 extends StandardVfs {
  constructor() {
    super();
    var tmp = this;
    tmp.q32_1 = lazy(standardVfs$o$resourcesVfs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.r32_1 = lazy(standardVfs$o$rootLocalVfs$delegate$lambda);
  }
  i2u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q32_1;
    resourcesVfs$factory();
    return this_0.h3();
  }
}
class StandardPaths {}
class httpFactory$2$1 {
  p2z() {
    return get_jsRuntime().s32();
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_59 = this;
    this.t32_1 = Companion_getInstance_65().p1a('JsRuntime');
  }
}
class JsRuntime {
  constructor() {
    Companion_getInstance_60();
    this.n32_1 = 'unknown';
    this.o32_1 = get_isDenoJs() ? 'deno.js' : get_isWeb() ? 'web.js' : get_isNodeJs() ? 'node.js' : get_isWorker() ? 'worker.js' : get_isShell() ? 'shell.js' : 'js';
  }
  p32(path) {
    throw NotImplementedError.cd();
  }
  s32() {
    throw NotImplementedError.cd();
  }
}
class JsRuntimeBrowser extends JsRuntime {
  constructor() {
    Companion_getInstance_61();
    super();
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.w32_1 = navigator.platform;
    var tmp_0 = this;
    tmp_0.x32_1 = lazy(JsRuntimeBrowser$href$delegate$lambda);
    var tmp_1 = this;
    tmp_1.y32_1 = lazy(JsRuntimeBrowser$baseUrl$delegate$lambda(this));
  }
  z32() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x32_1;
    href$factory();
    return this_0.h3();
  }
  a33() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y32_1;
    baseUrl$factory();
    return this_0.h3();
  }
  b33() {
    return this.a33();
  }
  p32(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.io.file.std.withCatalogJail' call
    var this_0 = UrlVfs_2(this.b33()).l1i(path);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.withCatalogJail.<anonymous>' call
    var this_1 = (new CatalogVfs(this_0.f2t())).i2s().i2s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.runtime.JsRuntimeBrowser.openVfs.<anonymous>' call
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_60().t32_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_2.k1a(level)) {
      // Inline function 'korlibs.io.runtime.JsRuntimeBrowser.openVfs.<anonymous>.<anonymous>' call
      var tmp$ret$3 = 'BROWSER openVfs: currentDir=' + this.b33() + ', path=' + path + ', urlVfs=' + this_1.toString();
      this_2.j1a(level, tmp$ret$3);
      tmp = Unit_instance;
    }
    return this_1;
  }
  s32() {
    return Companion_getInstance_56();
  }
}
class Companion_59 extends JsRuntimeBrowser {
  constructor() {
    Companion_instance_60 = null;
    super();
    Companion_instance_60 = this;
  }
}
class JsRuntimeDeno extends JsRuntimeBrowser {
  constructor() {
    Companion_getInstance_62();
    super();
  }
  b33() {
    try {
      var str = (new URL('.', Deno.mainModule)).pathname;
      var tmp;
      if (Companion_getInstance_101().i1s()) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = str.substring(1);
      } else {
        tmp = str;
      }
      return tmp;
    } catch ($p) {
      var e = $p;
      return '.';
    }
  }
  p32(path) {
    return (new DenoLocalVfs()).l1i(path === '.' ? this.b33() : path);
  }
}
class Companion_60 extends JsRuntimeDeno {
  constructor() {
    Companion_instance_61 = null;
    super();
    Companion_instance_61 = this;
  }
}
class DenoLocalVfs extends LocalVfs {
  d2s(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea_2(this, path, mode, $completion), $completion);
  }
  f2s(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_3(this, path, $completion), $completion);
  }
}
class DenoAsyncStreamBase extends AsyncStreamBase {
  static j33(file) {
    var $this = this.v2o();
    $this.h33_1 = file;
    $this.i33_1 = false;
    return $this;
  }
  o2o(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_6(this, position, buffer, offset, len, $completion), $completion);
  }
  w2o(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_7(this, position, buffer, offset, len, $completion), $completion);
  }
  i1f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94_2(this, $completion), $completion);
  }
  y1e($completion) {
    if (this.i33_1)
      return Unit_instance;
    this.h33_1.close();
    this.i33_1 = true;
  }
}
class workerImpl$o$insideWorker$lambda$lambda$slambda {
  constructor($workerTask, $id) {
    this.l33_1 = $workerTask;
    this.m33_1 = $id;
  }
  dd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10(this, $completion), $completion);
  }
}
class workerImpl$1 extends _WorkerImpl {
  constructor() {
    super();
    this.n33_1 = 0;
  }
  o33() {
    return !(get_workerUrl() == null);
  }
  i32() {
    var tmp;
    if (get_isDenoJs()) {
      tmp = Deno.mainModule;
    } else {
      var tmp90_safe_receiver = lastOrNull(Companion_instance_62.r33().q33_1);
      tmp = tmp90_safe_receiver == null ? null : tmp90_safe_receiver.t33_1;
    }
    set_workerUrl(tmp);
    if (get_workerUrl() == null) {
      println('workerUrl = null, STACKTRACE:' + stackTraceToString(Exception.gd()));
    }
    if (get_isWorker_0() && this.o33()) {
      // Inline function 'kotlin.js.asDynamic' call
      get_jsGlobalThis().onmessage = workerImpl$o$insideWorker$lambda;
    }
    return get_isWorker_0();
  }
}
class Entry_1 {
  constructor(method, file, line, column) {
    column = column === VOID ? -1 : column;
    this.s33_1 = method;
    this.t33_1 = file;
    this.u33_1 = line;
    this.v33_1 = column;
  }
  toString() {
    return 'Entry(method=' + this.s33_1 + ', file=' + this.t33_1 + ', line=' + this.u33_1 + ', column=' + this.v33_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.s33_1);
    result = imul(result, 31) + getStringHashCode(this.t33_1) | 0;
    result = imul(result, 31) + this.u33_1 | 0;
    result = imul(result, 31) + this.v33_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_1))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_1 ? other : THROW_CCE();
    if (!(this.s33_1 === tmp0_other_with_cast.s33_1))
      return false;
    if (!(this.t33_1 === tmp0_other_with_cast.t33_1))
      return false;
    if (!(this.u33_1 === tmp0_other_with_cast.u33_1))
      return false;
    if (!(this.v33_1 === tmp0_other_with_cast.v33_1))
      return false;
    return true;
  }
}
class Companion_61 {
  w33(stack, message) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var entries = ArrayList.j1();
    // Inline function 'kotlin.collections.arrayListOf' call
    var messageLines = ArrayList.j1();
    var isChrome = false;
    var iterator = lines(stack).a1();
    var index = 0;
    $l$loop: while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var strLine = iterator.c1();
      // Inline function 'kotlin.text.trimEnd' call
      var strLine_0 = toString(trimEnd_0(isCharSequence(strLine) ? strLine : THROW_CCE()));
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(strLine_0) === 0) {
        tmp = !isChrome;
      } else {
        tmp = false;
      }
      if (tmp)
        continue $l$loop;
      if ((startsWith(strLine_0, 'Error: ') || strLine_0 === 'Error') && index_0 === 0) {
        isChrome = true;
        var tmp_0 = messageLines;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = strLine_0.substring(7);
        tmp_0.g(tmp$ret$5);
      } else if (startsWith(strLine_0, '    at ')) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$7 = strLine_0.substring(7);
        var part = trimEnd(tmp$ret$7, charArrayOf([_Char___init__impl__6a9atx(41)]));
        var column = substringAfterLast(part, _Char___init__impl__6a9atx(58));
        var part0 = substringBeforeLast(part, _Char___init__impl__6a9atx(58));
        var line = substringAfterLast(part0, _Char___init__impl__6a9atx(58));
        var part1 = substringBeforeLast(part0, _Char___init__impl__6a9atx(58));
        var tmp_1;
        if (contains_1(part1, _Char___init__impl__6a9atx(40))) {
          // Inline function 'kotlin.collections.map' call
          var this_0 = split(part1, ['(']);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var item = tmp0_iterator.c1();
            // Inline function 'korlibs.js.Companion.parse.<anonymous>' call
            // Inline function 'kotlin.text.trim' call
            var tmp$ret$9 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
            destination.g(tmp$ret$9);
          }
          tmp_1 = destination;
        } else {
          // Inline function 'kotlin.text.trim' call
          var tmp$ret$12 = toString(trim(isCharSequence(part1) ? part1 : THROW_CCE()));
          tmp_1 = listOf_0(['', tmp$ret$12]);
        }
        var _destruct__k2r9zo = tmp_1;
        // Inline function 'kotlin.collections.component1' call
        var method = _destruct__k2r9zo.f1(0);
        // Inline function 'kotlin.collections.component2' call
        var file = _destruct__k2r9zo.f1(1);
        // Inline function 'kotlin.collections.plusAssign' call
        var tmp0_elvis_lhs = toIntOrNull(line);
        var tmp_2 = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = toIntOrNull(column);
        var element = new Entry_1(method, file, tmp_2, tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs);
        entries.g(element);
      } else if (isChrome) {
        messageLines.g(strLine_0);
      } else {
        var cline = strLine_0;
        // Inline function 'kotlin.collections.arrayListOf' call
        var numParts = ArrayList.j1();
        var inductionVariable = 0;
        if (inductionVariable < 2)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_3 = Regex.wg('^(.*):(\\d+)$');
            var tmp_4 = cline;
            cline = tmp_3.ah(tmp_4, JSStackTrace$Companion$parse$lambda(numParts));
          }
           while (inductionVariable < 2);
        var file_0 = substringAfterLast(cline, _Char___init__impl__6a9atx(64));
        var method_0 = substringBeforeLast(cline, _Char___init__impl__6a9atx(64));
        var tmp2_elvis_lhs = firstOrNull(numParts);
        var line_0 = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
        var tmp_5;
        if (numParts.d1() >= 2) {
          var tmp3_elvis_lhs = lastOrNull(numParts);
          tmp_5 = tmp3_elvis_lhs == null ? -1 : tmp3_elvis_lhs;
        } else {
          tmp_5 = -1;
        }
        var column_0 = tmp_5;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = new Entry_1(method_0, file_0, line_0, column_0);
        entries.g(element_0);
      }
    }
    if (!isChrome) {
      messageLines = arrayListOf([message == null ? '' : message]);
    }
    if (entries.g1()) {
      entries.g(new Entry_1('<unknown>', '<unknown>', -1));
    }
    return new JSStackTrace(joinToString_0(messageLines, '\n'), entries);
  }
  x33(e) {
    return this.w33(stackTraceToString(e), e.message);
  }
  r33() {
    return this.x33(Exception.f5(''));
  }
}
class JSStackTrace {
  constructor(message, entries) {
    this.p33_1 = message;
    this.q33_1 = entries;
  }
  toString() {
    return 'JSStackTrace(message=' + this.p33_1 + ', entries=' + toString(this.q33_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.p33_1);
    result = imul(result, 31) + hashCode(this.q33_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JSStackTrace))
      return false;
    var tmp0_other_with_cast = other instanceof JSStackTrace ? other : THROW_CCE();
    if (!(this.p33_1 === tmp0_other_with_cast.p33_1))
      return false;
    if (!equals(this.q33_1, tmp0_other_with_cast.q33_1))
      return false;
    return true;
  }
}
class Color extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.a34_1 = index;
  }
}
class AnsiEscape {}
function appendAnsiScape(_this__u8e3s4, code, extra, char) {
  _this__u8e3s4.bb(_Char___init__impl__6a9atx(27));
  _this__u8e3s4.bb(_Char___init__impl__6a9atx(91));
  _this__u8e3s4.eg(code);
  if (!(extra == null)) {
    _this__u8e3s4.ab(extra);
  }
  _this__u8e3s4.bb(char);
  return _this__u8e3s4;
}
function appendAnsiScape$default(_this__u8e3s4, code, extra, char, $super) {
  extra = extra === VOID ? null : extra;
  char = char === VOID ? _Char___init__impl__6a9atx(109) : char;
  return $super === VOID ? this.b34(_this__u8e3s4, code, extra, char) : appendAnsiScape(_this__u8e3s4, code, extra, char);
}
function appendReset(_this__u8e3s4) {
  return this.c34(_this__u8e3s4, 0);
}
function appendFgColor(_this__u8e3s4, color, bright) {
  return this.c34(_this__u8e3s4, 30 + color.a34_1 | 0, bright ? ';1' : null);
}
function appendFgColor$default(_this__u8e3s4, color, bright, $super) {
  bright = bright === VOID ? false : bright;
  return $super === VOID ? this.e34(_this__u8e3s4, color, bright) : appendFgColor(_this__u8e3s4, color, bright);
}
class Kind extends Enum {
  constructor(name, ordinal, level, color) {
    super(name, ordinal);
    this.i34_1 = level;
    this.j34_1 = color;
  }
}
class BaseConsole {
  l34(kind, msg) {
    var hook = baseConsoleHook;
    if (!(hook == null)) {
      hook(kind, msg, BaseConsole$logInternal$ref(this));
    } else {
      this.k34(kind, msg.slice());
    }
  }
  k34(kind, msg) {
    println(this.m34(kind, msg.slice()));
  }
  m34(kind, msg) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.logger.BaseConsole.logToString.<anonymous>' call
    var color = kind.j34_1;
    if (!(color == null)) {
      this.f34(this_0, color);
    }
    joinTo(msg, this_0, ', ');
    if (!(color == null)) {
      this.d34(this_0);
    }
    return this_0.toString();
  }
  n34(msg) {
    return this.l34(Kind_LOG_getInstance(), msg.slice());
  }
  o34(msg) {
    return this.l34(Kind_WARN_getInstance(), msg.slice());
  }
  p34(msg) {
    return this.l34(Kind_ERROR_getInstance(), msg.slice());
  }
}
class Companion_62 {
  constructor() {
    Companion_instance_63 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pb(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.logger.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$0 = element.i3_1;
      destination.x2(tmp$ret$0, element);
    }
    tmp.q34_1 = destination;
  }
  l1i(name) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toUpperCase();
    var tmp0_elvis_lhs = this.q34_1.f3(tmp$ret$1);
    return tmp0_elvis_lhs == null ? Level_NONE_getInstance() : tmp0_elvis_lhs;
  }
}
class Companion_63 {
  constructor() {
    Companion_instance_64 = this;
    this.l1a_1 = new Object();
    this.m1a_1 = HashMap.u7();
    this.n1a_1 = null;
    this.o1a_1 = DefaultLogOutput_instance;
  }
  p1a(name) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.l1a_1;
    var normalizedName = normalizeName(Companion_getInstance_65(), name);
    if (Companion_getInstance_65().m1a_1.f3(normalizedName) == null) {
      var logger = new Logger(name, normalizedName, true);
      var tmp768_safe_receiver = get_miniEnvironmentVariablesUC().f3('LOG_' + normalizedName);
      if (tmp768_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.logger.Companion.invoke.<anonymous>.<anonymous>' call
        logger.r34(Companion_getInstance_64().l1i(tmp768_safe_receiver));
      }
      if (Companion_getInstance_65().m1a_1.g1()) {
        var tmp769_safe_receiver = get_miniEnvironmentVariablesUC().f3('LOG_LEVEL');
        if (tmp769_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.logger.Companion.invoke.<anonymous>.<anonymous>' call
          Companion_getInstance_65().n1a_1 = Companion_getInstance_64().l1i(tmp769_safe_receiver);
        }
      }
      // Inline function 'kotlin.collections.set' call
      Companion_getInstance_65().m1a_1.x2(normalizedName, logger);
    }
    return ensureNotNull(Companion_getInstance_65().m1a_1.f3(normalizedName));
  }
}
class Level extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.u34_1 = index;
  }
}
class ConsoleLogOutput {
  v34(logger, level, msg) {
    switch (level.j3_1) {
      case 2:
        Console_getInstance().p34([logger.d1a_1, msg]);
        break;
      case 3:
        Console_getInstance().o34([logger.d1a_1, msg]);
        break;
      default:
        Console_getInstance().n34([logger.d1a_1, msg]);
        break;
    }
  }
}
class Logger {
  constructor(name, normalizedName, dummy) {
    Companion_getInstance_65();
    this.d1a_1 = name;
    this.e1a_1 = normalizedName;
    this.f1a_1 = dummy;
    this.g1a_1 = null;
    this.h1a_1 = null;
    this.i1a_1 = null;
  }
  r34(value) {
    this.h1a_1 = value;
  }
  u1s() {
    var tmp0_elvis_lhs = this.h1a_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? Companion_getInstance_65().n1a_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Level_WARN_getInstance() : tmp1_elvis_lhs;
  }
  w34() {
    var tmp0_elvis_lhs = this.i1a_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_65().o1a_1 : tmp0_elvis_lhs;
  }
  k1a(level) {
    return level.u34_1 <= this.u1s().u34_1;
  }
  j1a(level, msg) {
    this.w34().v34(this, level, msg);
  }
}
class DefaultLogOutput {
  v34(logger, level, msg) {
    return ConsoleLogOutput_instance.v34(logger, level, msg);
  }
}
class Console extends BaseConsole {
  constructor() {
    Console_instance = null;
    super();
    Console_instance = this;
  }
  k34(kind, msg) {
    switch (kind.j3_1) {
      case 0:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 1:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 2:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.info.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 3:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 4:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 5:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
}
class NumberParser {
  constructor() {
    NumberParser_instance = this;
    this.y34_1 = _Char___init__impl__6a9atx(0);
  }
}
class Easing {}
function invoke(it) {
  return this.a35(it);
}
function invoke_0(it) {
  return _Ratio___init__impl__9mwvn2(this.a35(Ratio__toFloat_impl_1ftup5(it)));
}
class sam$korlibs_math_interpolation_Easing$0 {
  constructor(function_0) {
    this.z34_1 = function_0;
  }
  a35(it) {
    return this.z34_1(it);
  }
}
class sam$korlibs_math_interpolation_Easing$0_0 {
  constructor(function_0) {
    this.d35_1 = function_0;
  }
  a35(it) {
    return this.d35_1(it);
  }
}
class Companion_64 {
  constructor() {
    Companion_instance_65 = this;
    var tmp = this;
    var tmp_0 = Easing$Companion$LINEAR$lambda;
    tmp.e35_1 = new sam$korlibs_math_interpolation_Easing$0(tmp_0);
    var tmp_1 = this;
    var tmp_2 = Easing$Companion$SMOOTH$lambda;
    tmp_1.f35_1 = new sam$korlibs_math_interpolation_Easing$0_0(tmp_2);
  }
}
class Companion_65 {
  constructor() {
    Companion_instance_66 = this;
    this.h35_1 = _Ratio___init__impl__9mwvn2(0.0);
    this.i35_1 = _Ratio___init__impl__9mwvn2(0.25);
    this.j35_1 = _Ratio___init__impl__9mwvn2(0.5);
    this.k35_1 = _Ratio___init__impl__9mwvn2(1.0);
    this.l35_1 = _Ratio___init__impl__9mwvn2_0(NaN);
  }
}
class Ratio {
  constructor(value) {
    Companion_getInstance_67();
    this.g35_1 = value;
  }
  m35(other) {
    return Ratio__compareTo_impl_z2ienc(this.g35_1, other);
  }
  d(other) {
    return Ratio__compareTo_impl_z2ienc_0(this, other);
  }
  toString() {
    return Ratio__toString_impl_mfgt3e(this.g35_1);
  }
  hashCode() {
    return Ratio__hashCode_impl_quhc2v(this.g35_1);
  }
  equals(other) {
    return Ratio__equals_impl_mfc2gt(this.g35_1, other);
  }
}
class Companion_66 {
  constructor() {
    Companion_instance_67 = this;
    this.n35_1 = Anchor2D.y35(0.0, 0.0);
    this.o35_1 = Anchor2D.y35(0.5, 0.0);
    this.p35_1 = Anchor2D.y35(1.0, 0.0);
    this.q35_1 = Anchor2D.y35(0.0, 0.5);
    this.r35_1 = Anchor2D.y35(0.5, 0.5);
    this.s35_1 = Anchor2D.y35(1.0, 0.5);
    this.t35_1 = Anchor2D.y35(0.0, 1.0);
    this.u35_1 = Anchor2D.y35(0.5, 1.0);
    this.v35_1 = Anchor2D.y35(1.0, 1.0);
  }
  z35() {
    return this.r35_1;
  }
}
class Anchor2D {
  static a36(sx, sy) {
    Companion_getInstance_68();
    var $this = createThis(this);
    $this.w35_1 = sx;
    $this.x35_1 = sy;
    return $this;
  }
  static y35(sx, sy) {
    Companion_getInstance_68();
    return this.a36(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.w35_1 + ', sy=' + this.x35_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.w35_1);
    result = imul(result, 31) + getNumberHashCode(this.x35_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.w35_1, tmp0_other_with_cast.w35_1))
      return false;
    if (!equals(this.x35_1, tmp0_other_with_cast.x35_1))
      return false;
    return true;
  }
}
class Companion_67 {
  constructor() {
    Companion_instance_68 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_69();
    var ratio = toRatio_0(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y_0(ratio, 6.283185307179586);
    tmp.c36_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_69();
    var ratio_0 = toRatio_0(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y_0(ratio_0, 6.283185307179586);
    tmp_0.d36_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_69();
    var ratio_1 = toRatio_0(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y_0(ratio_1, 6.283185307179586);
    tmp_1.e36_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_69();
    var ratio_2 = toRatio_0(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y_0(ratio_2, 6.283185307179586);
    tmp_2.f36_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_69();
    var ratio_3 = toRatio_0(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y_0(ratio_3, 6.283185307179586);
    tmp_3.g36_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_69();
    var ratio_4 = toRatio_0(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y_0(ratio_4, 6.283185307179586);
    tmp_4.h36_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_69();
    this.b36_1 = radians;
  }
  i36(other) {
    return Angle__compareTo_impl_a0hfds(this.b36_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.b36_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.b36_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.b36_1, other);
  }
}
class Companion_68 {
  constructor() {
    Companion_instance_69 = this;
    this.n36_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_77().o36());
  }
  p36() {
    return this.n36_1;
  }
  q36(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_77().b37(Companion_getInstance_82().z36(p1, p2, p3, p4), Companion_getInstance_82().a37(p1, p2, p3, p4)));
  }
}
class Companion_69 {
  constructor() {
    Companion_instance_70 = this;
    this.l37_1 = Line2D.p37(Companion_getInstance_82().r36_1, Companion_getInstance_82().r36_1);
    this.m37_1 = Line2D.p37(Companion_getInstance_82().s36_1, Companion_getInstance_82().s36_1);
  }
}
class Line2D {
  static p37(a, b) {
    Companion_getInstance_71();
    var $this = createThis(this);
    $this.n37_1 = a;
    $this.o37_1 = b;
    return $this;
  }
  static q37() {
    Companion_getInstance_71();
    return this.p37(Vector2D.r37(), Vector2D.r37());
  }
  static s37(x0, y0, x1, y1) {
    Companion_getInstance_71();
    return this.p37(Vector2D.t37(x0, y0), Vector2D.t37(x1, y1));
  }
  toString() {
    return 'Line(' + this.n37_1.toString() + ', ' + this.o37_1.toString() + ')';
  }
  hashCode() {
    var result = this.n37_1.hashCode();
    result = imul(result, 31) + this.o37_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.n37_1.equals(tmp0_other_with_cast.n37_1))
      return false;
    if (!this.o37_1.equals(tmp0_other_with_cast.o37_1))
      return false;
    return true;
  }
}
class Companion_70 {
  constructor() {
    Companion_instance_71 = this;
    this.j20_1 = new MarginInt(0, 0, 0, 0);
  }
}
class MarginInt {
  constructor(top, right, bottom, left) {
    Companion_getInstance_72();
    this.l20_1 = top;
    this.m20_1 = right;
    this.n20_1 = bottom;
    this.o20_1 = left;
  }
  u37() {
    return !(this.l20_1 === 0) || !(this.o20_1 === 0) || !(this.m20_1 === 0) || !(this.n20_1 === 0);
  }
  p20() {
    return this.o20_1 + this.m20_1 | 0;
  }
  q20() {
    return this.l20_1 + this.n20_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.l20_1 + ', right=' + this.m20_1 + ', bottom=' + this.n20_1 + ', left=' + this.o20_1 + ')';
  }
  hashCode() {
    var result = this.l20_1;
    result = imul(result, 31) + this.m20_1 | 0;
    result = imul(result, 31) + this.n20_1 | 0;
    result = imul(result, 31) + this.o20_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.l20_1 === tmp0_other_with_cast.l20_1))
      return false;
    if (!(this.m20_1 === tmp0_other_with_cast.m20_1))
      return false;
    if (!(this.n20_1 === tmp0_other_with_cast.n20_1))
      return false;
    if (!(this.o20_1 === tmp0_other_with_cast.o20_1))
      return false;
    return true;
  }
}
class Companion_71 {
  constructor() {
    Companion_instance_72 = this;
    this.v37_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.w37_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.x37_1 = this.w37_1;
  }
  v2a() {
    return this.v37_1;
  }
  y37(l, r) {
    if (l.g37())
      return r;
    if (r.g37())
      return l;
    return new Matrix(l.z37_1 * r.z37_1 + l.a38_1 * r.b38_1, l.z37_1 * r.a38_1 + l.a38_1 * r.c38_1, l.b38_1 * r.z37_1 + l.c38_1 * r.b38_1, l.b38_1 * r.a38_1 + l.c38_1 * r.c38_1, l.d38_1 * r.z37_1 + l.e38_1 * r.b38_1 + r.d38_1, l.d38_1 * r.a38_1 + l.e38_1 * r.c38_1 + r.e38_1);
  }
  f38(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_82().v36_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_82().v36_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_82().v36_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_82().v36_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  g38(a, b, c, d, tx, ty, p) {
    return Vector2D.h38(a * p.l36_1 + c * p.m36_1 + tx, d * p.m36_1 + b * p.l36_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_73();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.z37_1 = a;
    this.a38_1 = b;
    this.b38_1 = c;
    this.c38_1 = d;
    this.d38_1 = tx;
    this.e38_1 = ty;
  }
  i38(other) {
    return Companion_getInstance_73().y37(this, other);
  }
  g37() {
    return isNaN_0(this.z37_1);
  }
  j38() {
    return !this.g37();
  }
  k38() {
    return this.z37_1 === 1.0 && this.a38_1 === 0.0 && this.b38_1 === 0.0 && this.c38_1 === 1.0 && this.d38_1 === 0.0 && this.e38_1 === 0.0;
  }
  l38(x, y) {
    return this.m38(x, y);
  }
  n38(x, y) {
    return this.o38(x, y);
  }
  m38(x, y) {
    return this.z37_1 * x + this.b38_1 * y + this.d38_1;
  }
  o38(x, y) {
    return this.c38_1 * y + this.a38_1 * x + this.e38_1;
  }
  p38(scaleX, scaleY) {
    return new Matrix(this.z37_1 * scaleX, this.a38_1 * scaleX, this.b38_1 * scaleY, this.c38_1 * scaleY, this.d38_1 * scaleX, this.e38_1 * scaleY);
  }
  q38(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.p38(scaleX, scaleY) : $super.p38.call(this, scaleX, scaleY);
  }
  r38(scaleX, scaleY) {
    return new Matrix(this.z37_1 * scaleX, this.a38_1 * scaleX, this.b38_1 * scaleY, this.c38_1 * scaleY, this.d38_1, this.e38_1);
  }
  s38(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.r38(scaleX, scaleY) : $super.r38.call(this, scaleX, scaleY);
  }
  t38(delta) {
    return new Matrix(this.z37_1, this.a38_1, this.b38_1, this.c38_1, this.d38_1 + delta.l36_1, this.e38_1 + delta.m36_1);
  }
  u38(x, y) {
    return this.t38(Vector2D.h38(x, y));
  }
  v38(delta) {
    return new Matrix(this.z37_1, this.a38_1, this.b38_1, this.c38_1, this.d38_1 + (this.z37_1 * delta.l36_1 + this.b38_1 * delta.m36_1), this.e38_1 + (this.a38_1 * delta.l36_1 + this.c38_1 * delta.m36_1));
  }
  w38(deltaX, deltaY) {
    return this.v38(Vector2D.h38(deltaX, deltaY));
  }
  x38() {
    if (this.g37())
      return Companion_getInstance_73().v37_1;
    var m = this;
    var norm = m.z37_1 * m.c38_1 - m.a38_1 * m.b38_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.d38_1, -m.e38_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.z37_1 * inorm;
      var a = m.c38_1 * inorm;
      var b = m.a38_1 * -inorm;
      var c = m.b38_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.d38_1 - c * m.e38_1, -b * m.d38_1 - d * m.e38_1);
    }
    return tmp;
  }
  y38() {
    return this.z38();
  }
  z38() {
    return Companion_getInstance_74().b39(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.z37_1) + ', ' + get_niceStr(this.a38_1) + ', ' + get_niceStr(this.b38_1) + ', ' + get_niceStr(this.c38_1) + ', ' + get_niceStr(this.d38_1) + ', ' + get_niceStr(this.e38_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.z37_1);
    result = imul(result, 31) + getNumberHashCode(this.a38_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b38_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c38_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d38_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e38_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.z37_1, tmp0_other_with_cast.z37_1))
      return false;
    if (!equals(this.a38_1, tmp0_other_with_cast.a38_1))
      return false;
    if (!equals(this.b38_1, tmp0_other_with_cast.b38_1))
      return false;
    if (!equals(this.c38_1, tmp0_other_with_cast.c38_1))
      return false;
    if (!equals(this.d38_1, tmp0_other_with_cast.d38_1))
      return false;
    if (!equals(this.e38_1, tmp0_other_with_cast.e38_1))
      return false;
    return true;
  }
}
class Companion_72 {
  constructor() {
    Companion_instance_73 = this;
    this.a39_1 = MatrixTransform.j39(0.0, 0.0, 1.0, 1.0, Companion_getInstance_69().d36_1, Companion_getInstance_69().d36_1, Companion_getInstance_69().d36_1);
  }
  k39(matrix, pivotX, pivotY) {
    var a = matrix.z37_1;
    var b = matrix.a38_1;
    var c = matrix.b38_1;
    var d = matrix.c38_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians(skewY);
      tskewX = get_radians(0.0);
      tskewY = get_radians(0.0);
    } else {
      trotation = get_radians_0(0);
      tskewX = get_radians(skewX);
      tskewY = get_radians(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.d38_1;
      ty = matrix.e38_1;
    } else {
      tx = matrix.d38_1 + (pivotX * a + pivotY * c);
      ty = matrix.e38_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.j39(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  b39(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.k39(matrix, pivotX, pivotY) : $super.k39.call(this, matrix, pivotX, pivotY);
  }
}
class MatrixTransform {
  static j39(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_74();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_69().d36_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_69().d36_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_69().d36_1 : rotation;
    var $this = createThis(this);
    $this.c39_1 = x;
    $this.d39_1 = y;
    $this.e39_1 = scaleX;
    $this.f39_1 = scaleY;
    $this.g39_1 = skewX;
    $this.h39_1 = skewY;
    $this.i39_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.c39_1) + ', y=' + get_niceStr(this.d39_1) + ', scaleX=' + this.e39_1 + ', scaleY=' + this.f39_1 + ', skewX=' + Angle__toString_impl_786qky(this.g39_1) + ', skewY=' + Angle__toString_impl_786qky(this.h39_1) + ', rotation=' + Angle__toString_impl_786qky(this.i39_1) + ')';
  }
  static l39() {
    Companion_getInstance_74();
    return this.j39(0.0, 0.0, 1.0, 1.0, Companion_getInstance_69().d36_1, Companion_getInstance_69().d36_1, Companion_getInstance_69().d36_1);
  }
  hashCode() {
    var result = getNumberHashCode(this.c39_1);
    result = imul(result, 31) + getNumberHashCode(this.d39_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e39_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f39_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.g39_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.h39_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.i39_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.c39_1, tmp0_other_with_cast.c39_1))
      return false;
    if (!equals(this.d39_1, tmp0_other_with_cast.d39_1))
      return false;
    if (!equals(this.e39_1, tmp0_other_with_cast.e39_1))
      return false;
    if (!equals(this.f39_1, tmp0_other_with_cast.f39_1))
      return false;
    if (!equals(this.g39_1, tmp0_other_with_cast.g39_1))
      return false;
    if (!equals(this.h39_1, tmp0_other_with_cast.h39_1))
      return false;
    if (!equals(this.i39_1, tmp0_other_with_cast.i39_1))
      return false;
    return true;
  }
}
class Companion_73 {
  constructor() {
    Companion_instance_74 = this;
    this.m39_1 = 0;
    this.n39_1 = 1;
    this.o39_1 = 2;
    this.p39_1 = 3;
    this.q39_1 = 4;
    this.r39_1 = 5;
    this.s39_1 = 6;
    this.t39_1 = 7;
    this.u39_1 = 8;
    this.v39_1 = 9;
    this.w39_1 = 10;
    this.x39_1 = 11;
    this.y39_1 = 12;
    this.z39_1 = 13;
    this.a3a_1 = 14;
    this.b3a_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.c3a_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.d3a_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.e3a_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.f3a_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.g3a_1 = Matrix4.i3a();
  }
  j3a(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.k3a(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  l3a(l, r) {
    return Companion_getInstance_75().j3a(l.m3a() * r.m3a() + l.n3a() * r.o3a() + l.p3a() * r.q3a() + l.r3a() * r.s3a(), l.m3a() * r.n3a() + l.n3a() * r.t3a() + l.p3a() * r.u3a() + l.r3a() * r.v3a(), l.m3a() * r.p3a() + l.n3a() * r.w3a() + l.p3a() * r.x3a() + l.r3a() * r.y3a(), l.m3a() * r.r3a() + l.n3a() * r.z3a() + l.p3a() * r.a3b() + l.r3a() * r.b3b(), l.o3a() * r.m3a() + l.t3a() * r.o3a() + l.w3a() * r.q3a() + l.z3a() * r.s3a(), l.o3a() * r.n3a() + l.t3a() * r.t3a() + l.w3a() * r.u3a() + l.z3a() * r.v3a(), l.o3a() * r.p3a() + l.t3a() * r.w3a() + l.w3a() * r.x3a() + l.z3a() * r.y3a(), l.o3a() * r.r3a() + l.t3a() * r.z3a() + l.w3a() * r.a3b() + l.z3a() * r.b3b(), l.q3a() * r.m3a() + l.u3a() * r.o3a() + l.x3a() * r.q3a() + l.a3b() * r.s3a(), l.q3a() * r.n3a() + l.u3a() * r.t3a() + l.x3a() * r.u3a() + l.a3b() * r.v3a(), l.q3a() * r.p3a() + l.u3a() * r.w3a() + l.x3a() * r.x3a() + l.a3b() * r.y3a(), l.q3a() * r.r3a() + l.u3a() * r.z3a() + l.x3a() * r.a3b() + l.a3b() * r.b3b(), l.s3a() * r.m3a() + l.v3a() * r.o3a() + l.y3a() * r.q3a() + l.b3b() * r.s3a(), l.s3a() * r.n3a() + l.v3a() * r.t3a() + l.y3a() * r.u3a() + l.b3b() * r.v3a(), l.s3a() * r.p3a() + l.v3a() * r.w3a() + l.y3a() * r.x3a() + l.b3b() * r.y3a(), l.s3a() * r.r3a() + l.v3a() * r.z3a() + l.y3a() * r.a3b() + l.b3b() * r.b3b());
  }
  c3b(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_75().j3a(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  d3b(left, right, bottom, top, near, far) {
    return this.c3b(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static e3b(data) {
    Companion_getInstance_75();
    var $this = createThis(this);
    $this.h3a_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.h3a_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.n4(toString(message));
    }
    return $this;
  }
  m3a() {
    return this.h3a_1[0];
  }
  o3a() {
    return this.h3a_1[1];
  }
  q3a() {
    return this.h3a_1[2];
  }
  s3a() {
    return this.h3a_1[3];
  }
  n3a() {
    return this.h3a_1[4];
  }
  t3a() {
    return this.h3a_1[5];
  }
  u3a() {
    return this.h3a_1[6];
  }
  v3a() {
    return this.h3a_1[7];
  }
  p3a() {
    return this.h3a_1[8];
  }
  w3a() {
    return this.h3a_1[9];
  }
  x3a() {
    return this.h3a_1[10];
  }
  y3a() {
    return this.h3a_1[11];
  }
  r3a() {
    return this.h3a_1[12];
  }
  z3a() {
    return this.h3a_1[13];
  }
  a3b() {
    return this.h3a_1[14];
  }
  b3b() {
    return this.h3a_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals_1(this.h3a_1, other.h3a_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.h3a_1);
  }
  f3b(that) {
    return Companion_getInstance_75().l3a(this, that);
  }
  static k3a(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_75();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.e3b(tmp$ret$0);
  }
  static i3a() {
    Companion_getInstance_75();
    return this.k3a(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  n1j(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.n4(toString(message));
    }
    return this.h3a_1[imul(row, 4) + column | 0];
  }
  g3b(index) {
    if (!(0 <= index ? index <= (this.h3a_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.n4(toString(message));
    }
    return this.h3a_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.ab('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.ab('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.ab(', ');
            }
            var v = this.n1j(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.eg(numberToInt(v));
            else {
              this_0.gg(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.ab(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.ab(')');
    return this_0.toString();
  }
}
class Companion_74 {
  constructor() {
    this.j36_1 = 1.0E-7;
  }
  k36(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.l36_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.m36_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.n4(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.m3b_1 = value;
  }
}
class Companion_75 {
  constructor() {
    Companion_instance_76 = this;
    this.z29_1 = Companion_getInstance_77().c2a(0, 0, 0, 0);
    this.a2a_1 = Companion_getInstance_77().n3b(-Infinity, -Infinity, Infinity, Infinity);
    this.b2a_1 = Companion_getInstance_77().n3b(NaN, NaN, 0.0, 0.0);
  }
  o36() {
    return this.b2a_1;
  }
  v2a() {
    return this.z29_1;
  }
  f37(p, s) {
    return new Rectangle(p.l36_1, p.m36_1, s.c37_1, s.d37_1);
  }
  c2a(x, y, width, height) {
    return Companion_getInstance_77().f37(Vector2D.t37(x, y), Size2D.e37(width, height));
  }
  n3b(x, y, width, height) {
    return Companion_getInstance_77().f37(Vector2D.o3b(x, y), Size2D.p3b(width, height));
  }
  q3b(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  k20(left, top, right, bottom) {
    return this.q3b(left, top, right, bottom);
  }
  b37(point1, point2) {
    var tmp = Companion_getInstance_77();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.h38(point2.l36_1 - point1.l36_1, point2.m36_1 - point1.m36_1);
    return tmp.f37(point1, toSize(tmp$ret$0));
  }
  r3b(a, b) {
    return a.o2b_1 >= b.o2b_1 && a.p2b_1 >= b.p2b_1 && a.o2b_1 + a.q2b_1 <= b.o2b_1 + b.q2b_1 && a.p2b_1 + a.r2b_1 <= b.p2b_1 + b.r2b_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_77();
    this.o2b_1 = x;
    this.p2b_1 = y;
    this.q2b_1 = width;
    this.r2b_1 = height;
    this.s2b_1 = true;
  }
  d1() {
    return Size2D.s3b(this.q2b_1, this.r2b_1);
  }
  t3b() {
    return isNaN_0(this.o2b_1);
  }
  g37() {
    return this.t3b();
  }
  j38() {
    return !this.g37();
  }
  toString() {
    return this.g37() ? 'null' : 'Rectangle(x=' + get_niceStr(this.o2b_1) + ', y=' + get_niceStr(this.p2b_1) + ', width=' + get_niceStr(this.q2b_1) + ', height=' + get_niceStr(this.r2b_1) + ')';
  }
  o1x() {
    return this.o2b_1;
  }
  p1x() {
    return this.p2b_1;
  }
  q1x() {
    return this.o2b_1 + this.q2b_1;
  }
  r1x() {
    return this.p2b_1 + this.r2b_1;
  }
  h37() {
    return Vector2D.h38(this.o1x(), this.p1x());
  }
  u3b() {
    return Vector2D.h38(this.q1x(), this.p1x());
  }
  v3b() {
    return Vector2D.h38(this.o1x(), this.r1x());
  }
  j37() {
    return Vector2D.h38(this.q1x(), this.r1x());
  }
  w3b(that) {
    return this.x3b(that) && this.y3b(that);
  }
  x3b(that) {
    return that.o1x() <= this.q1x() && that.q1x() >= this.o1x();
  }
  y3b(that) {
    return that.p1x() <= this.r1x() && that.r1x() >= this.p1x();
  }
  b2() {
    return RectangleInt.u1v(numberToInt(this.o2b_1), numberToInt(this.p2b_1), numberToInt(this.q2b_1), numberToInt(this.r2b_1));
  }
  z3b(border) {
    return Companion_getInstance_77().q3b(this.o1x() - border.o20_1, this.p1x() - border.l20_1, this.q1x() + border.m20_1, this.r1x() + border.n20_1);
  }
  t38(delta) {
    return this.a3c(this.o2b_1 + delta.l36_1, this.p2b_1 + delta.m36_1);
  }
  b3c(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.h37();
      if (m.g37()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.h38(m.m38(p.l36_1, p.m36_1), m.o38(p.l36_1, p.m36_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.u3b();
      if (m.g37()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.h38(m.m38(p_0.l36_1, p_0.m36_1), m.o38(p_0.l36_1, p_0.m36_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.v3b();
      if (m.g37()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.h38(m.m38(p_1.l36_1, p_1.m36_1), m.o38(p_1.l36_1, p_1.m36_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.j37();
      if (m.g37()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.h38(m.m38(p_2.l36_1, p_2.m36_1), m.o38(p_2.l36_1, p_2.m36_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_82().z36(tl, tr, bl, br);
    var max = Companion_getInstance_82().a37(tl, tr, bl, br);
    return Companion_getInstance_77().b37(min, max);
  }
  c3c() {
    return Companion_getInstance_77().b37(Companion_getInstance_82().i37(this.h37(), this.j37()), Companion_getInstance_82().k37(this.h37(), this.j37()));
  }
  d3c(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  a3c(x, y, width, height, $super) {
    x = x === VOID ? this.o2b_1 : x;
    y = y === VOID ? this.p2b_1 : y;
    width = width === VOID ? this.q2b_1 : width;
    height = height === VOID ? this.r2b_1 : height;
    return $super === VOID ? this.d3c(x, y, width, height) : $super.d3c.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.o2b_1);
    result = imul(result, 31) + getNumberHashCode(this.p2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.o2b_1, tmp0_other_with_cast.o2b_1))
      return false;
    if (!equals(this.p2b_1, tmp0_other_with_cast.p2b_1))
      return false;
    if (!equals(this.q2b_1, tmp0_other_with_cast.q2b_1))
      return false;
    if (!equals(this.r2b_1, tmp0_other_with_cast.r2b_1))
      return false;
    return true;
  }
}
class Companion_76 {
  f1w(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.o1x();
    var b_0 = b.o1x();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.p1x();
    var b_1 = b.p1x();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.q1x();
    var b_2 = b.q1x();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.r1x();
    var b_3 = b.r1x();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.k20(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  e3c(topLeft, bottomRight) {
    var size = bottomRight.h3c(topLeft);
    return RectangleInt.u1v(topLeft.f3c_1, topLeft.g3c_1, size.f3c_1, size.g3c_1);
  }
  k20(left, top, right, bottom) {
    return this.e3c(Vector2I.i3c(left, top), Vector2I.i3c(right, bottom));
  }
}
class RectangleInt {
  static u1v(x, y, width, height) {
    var $this = createThis(this);
    $this.q1v_1 = x;
    $this.r1v_1 = y;
    $this.s1v_1 = width;
    $this.t1v_1 = height;
    return $this;
  }
  static j3c() {
    return this.u1v(0, 0, 0, 0);
  }
  b1w() {
    return imul(this.s1v_1, this.t1v_1);
  }
  o1x() {
    return this.q1v_1;
  }
  p1x() {
    return this.r1v_1;
  }
  q1x() {
    return this.q1v_1 + this.s1v_1 | 0;
  }
  r1x() {
    return this.r1v_1 + this.t1v_1 | 0;
  }
  k3c(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn_1(left, 0, this.s1v_1);
    var right_0 = !clamped ? right : coerceIn_1(right, 0, this.s1v_1);
    var top_0 = !clamped ? top : coerceIn_1(top, 0, this.t1v_1);
    var bottom_0 = !clamped ? bottom : coerceIn_1(bottom, 0, this.t1v_1);
    return Companion_instance_77.k20(this.q1v_1 + left_0 | 0, this.r1v_1 + top_0 | 0, this.q1v_1 + right_0 | 0, this.r1v_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.q1v_1 + ', y=' + this.r1v_1 + ', width=' + this.s1v_1 + ', height=' + this.t1v_1 + ')';
  }
  z3b(border) {
    return Companion_instance_77.k20(this.o1x() - border.o20_1 | 0, this.p1x() - border.l20_1 | 0, this.q1x() + border.m20_1 | 0, this.r1x() + border.n20_1 | 0);
  }
  hashCode() {
    var result = this.q1v_1;
    result = imul(result, 31) + this.r1v_1 | 0;
    result = imul(result, 31) + this.s1v_1 | 0;
    result = imul(result, 31) + this.t1v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.q1v_1 === tmp0_other_with_cast.q1v_1))
      return false;
    if (!(this.r1v_1 === tmp0_other_with_cast.r1v_1))
      return false;
    if (!(this.s1v_1 === tmp0_other_with_cast.s1v_1))
      return false;
    if (!(this.t1v_1 === tmp0_other_with_cast.t1v_1))
      return false;
    return true;
  }
}
class Companion_77 {
  constructor() {
    Companion_instance_78 = this;
    this.l3c_1 = Scale.m3c(1.0, 1.0);
  }
}
class Scale {
  static j3b(scaleX, scaleY) {
    Companion_getInstance_79();
    var $this = createThis(this);
    $this.h3b_1 = scaleX;
    $this.i3b_1 = scaleY;
    return $this;
  }
  n3c() {
    return this.h3b_1 * 0.5 + this.i3b_1 * 0.5;
  }
  static o3c() {
    Companion_getInstance_79();
    return this.m3c(1.0, 1.0);
  }
  static p3c(scale) {
    Companion_getInstance_79();
    return this.j3b(scale, scale);
  }
  static q3c(scale) {
    Companion_getInstance_79();
    return this.p3c(scale);
  }
  static m3c(scaleX, scaleY) {
    Companion_getInstance_79();
    return this.j3b(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.h3b_1 + ', scaleY=' + this.i3b_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.h3b_1);
    result = imul(result, 31) + getNumberHashCode(this.i3b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.h3b_1, tmp0_other_with_cast.h3b_1))
      return false;
    if (!equals(this.i3b_1, tmp0_other_with_cast.i3b_1))
      return false;
    return true;
  }
}
class Companion_78 {
  constructor() {
    Companion_instance_79 = this;
    var tmp = this;
    tmp.v3c_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.w3c_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.x3c_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.y3c_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  z3c() {
    return this.x3c_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_80();
    name = name === VOID ? null : name;
    this.a3d_1 = name;
    this.b3d_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.a3d_1 + ')';
  }
  c3d(item, container) {
    return toInt_1(this.b3d_1(toFloat(item), toFloat(container)));
  }
}
class SizeInt {
  static x1v(width, height) {
    var $this = createThis(this);
    $this.v1v_1 = width;
    $this.w1v_1 = height;
    return $this;
  }
  static d3d() {
    return this.x1v(0, 0);
  }
  toString() {
    return '' + this.v1v_1 + 'x' + this.w1v_1;
  }
  hashCode() {
    var result = this.v1v_1;
    result = imul(result, 31) + this.w1v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.v1v_1 === tmp0_other_with_cast.v1v_1))
      return false;
    if (!(this.w1v_1 === tmp0_other_with_cast.w1v_1))
      return false;
    return true;
  }
}
class Companion_79 {
  constructor() {
    Companion_instance_80 = this;
    this.e3d_1 = Size2D.s3b(0.0, 0.0);
  }
}
class Size2D {
  static s3b(width, height) {
    Companion_getInstance_81();
    var $this = createThis(this);
    $this.c37_1 = width;
    $this.d37_1 = height;
    return $this;
  }
  static f3d() {
    Companion_getInstance_81();
    return this.s3b(0.0, 0.0);
  }
  static p3b(width, height) {
    Companion_getInstance_81();
    return this.s3b(width, height);
  }
  static e37(width, height) {
    Companion_getInstance_81();
    return this.s3b(width, height);
  }
  g3d(s) {
    return Size2D.s3b(this.c37_1 * s, this.d37_1 * s);
  }
  t3c(s) {
    return this.g3d(s);
  }
  r3c(other) {
    return Scale.j3b(this.c37_1 / other.c37_1, this.d37_1 / other.d37_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.c37_1) + ', height=' + get_niceStr(this.d37_1) + ')';
  }
  jk() {
    return this.c37_1;
  }
  kk() {
    return this.d37_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.c37_1);
    result = imul(result, 31) + getNumberHashCode(this.d37_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.c37_1, tmp0_other_with_cast.c37_1))
      return false;
    if (!equals(this.d37_1, tmp0_other_with_cast.d37_1))
      return false;
    return true;
  }
}
class Companion_80 {
  constructor() {
    Companion_instance_81 = this;
    this.r36_1 = Vector2D.h38(0.0, 0.0);
    this.s36_1 = Vector2D.h38(NaN, NaN);
    this.t36_1 = Vector2D.h38(-1.0, 0.0);
    this.u36_1 = Vector2D.h38(+1.0, 0.0);
    this.v36_1 = Vector2D.h38(0.0, +1.0);
    this.w36_1 = Vector2D.h38(0.0, -1.0);
    this.x36_1 = Vector2D.h38(0.0, -1.0);
    this.y36_1 = Vector2D.h38(0.0, +1.0);
  }
  h3d(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  i3d(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  j3d(a, b) {
    return this.h3d(a.l36_1, a.m36_1, b.l36_1, b.m36_1);
  }
  i37(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.l36_1;
    var b = p2.l36_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.m36_1;
    var b_0 = p2.m36_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.h38(tmp, tmp$ret$1);
  }
  z36(p1, p2, p3, p4) {
    return Vector2D.h38(minOf(p1.l36_1, new Float64Array([p2.l36_1, p3.l36_1, p4.l36_1])), minOf(p1.m36_1, new Float64Array([p2.m36_1, p3.m36_1, p4.m36_1])));
  }
  k37(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.l36_1;
    var b = p2.l36_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.m36_1;
    var b_0 = p2.m36_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.h38(tmp, tmp$ret$1);
  }
  a37(p1, p2, p3, p4) {
    return Vector2D.h38(maxOf(p1.l36_1, new Float64Array([p2.l36_1, p3.l36_1, p4.l36_1])), maxOf(p1.m36_1, new Float64Array([p2.m36_1, p3.m36_1, p4.m36_1])));
  }
}
class Vector2D {
  static h38(x, y) {
    Companion_getInstance_82();
    var $this = createThis(this);
    $this.l36_1 = x;
    $this.m36_1 = y;
    return $this;
  }
  static o3b(x, y) {
    Companion_getInstance_82();
    return this.h38(x, y);
  }
  static t37(x, y) {
    Companion_getInstance_82();
    return this.h38(x, y);
  }
  static r37() {
    Companion_getInstance_82();
    return this.h38(0.0, 0.0);
  }
  u3c() {
    // Inline function 'kotlin.math.min' call
    var a = this.l36_1;
    var b = this.m36_1;
    return Math.min(a, b);
  }
  s3c() {
    // Inline function 'kotlin.math.max' call
    var a = this.l36_1;
    var b = this.m36_1;
    return Math.max(a, b);
  }
  k3d() {
    return '(' + get_niceStr(this.l36_1) + ', ' + get_niceStr(this.m36_1) + ')';
  }
  toString() {
    return this.k3d();
  }
  jk() {
    return this.l36_1;
  }
  kk() {
    return this.m36_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.l36_1);
    result = imul(result, 31) + getNumberHashCode(this.m36_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.l36_1, tmp0_other_with_cast.l36_1))
      return false;
    if (!equals(this.m36_1, tmp0_other_with_cast.m36_1))
      return false;
    return true;
  }
}
class Companion_81 {
  constructor() {
    Companion_instance_82 = this;
    this.m19_1 = new Vector3F(NaN, NaN, NaN);
    this.n19_1 = new Vector3F(0.0, 0.0, 0.0);
    this.o19_1 = new Vector3F(1.0, 1.0, 1.0);
    this.p19_1 = new Vector3F(0.0, 0.0, 1.0);
    this.q19_1 = new Vector3F(0.0, 0.0, -1.0);
    this.r19_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.s19_1 = new Vector3F(1.0, 0.0, 0.0);
    this.t19_1 = new Vector3F(0.0, 1.0, 0.0);
    this.u19_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_83();
    this.l3d_1 = x;
    this.m3d_1 = y;
    this.n3d_1 = z;
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.l3d_1) + ', ' + get_niceStr_0(this.m3d_1) + ', ' + get_niceStr_0(this.n3d_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.l3d_1);
    result = imul(result, 31) + getNumberHashCode(this.m3d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n3d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.l3d_1, tmp0_other_with_cast.l3d_1))
      return false;
    if (!equals(this.m3d_1, tmp0_other_with_cast.m3d_1))
      return false;
    if (!equals(this.n3d_1, tmp0_other_with_cast.n3d_1))
      return false;
    return true;
  }
}
class Companion_82 {
  constructor() {
    Companion_instance_83 = this;
    this.o3d_1 = Vector2I.i3c(0, 0);
  }
}
class Vector2I {
  static i3c(x, y) {
    Companion_getInstance_84();
    var $this = createThis(this);
    $this.f3c_1 = x;
    $this.g3c_1 = y;
    return $this;
  }
  static p3d() {
    Companion_getInstance_84();
    return this.i3c(0, 0);
  }
  h3c(that) {
    return Vector2I.i3c(this.f3c_1 - that.f3c_1 | 0, this.g3c_1 - that.g3c_1 | 0);
  }
  toString() {
    return '(' + this.f3c_1 + ', ' + this.g3c_1 + ')';
  }
  hashCode() {
    var result = this.f3c_1;
    result = imul(result, 31) + this.g3c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.f3c_1 === tmp0_other_with_cast.f3c_1))
      return false;
    if (!(this.g3c_1 === tmp0_other_with_cast.g3c_1))
      return false;
    return true;
  }
}
class Companion_83 {
  constructor() {
    Companion_instance_84 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.q3d_1 = new Float64Array([-0.06405689286260563, 0.06405689286260563, -0.1911188674736163, 0.1911188674736163, -0.3150426796961634, 0.3150426796961634, -0.4337935076260451, 0.4337935076260451, -0.5454214713888396, 0.5454214713888396, -0.6480936519369755, 0.6480936519369755, -0.7401241915785544, 0.7401241915785544, -0.820001985973903, 0.820001985973903, -0.8864155270044011, 0.8864155270044011, -0.9382745520027328, 0.9382745520027328, -0.9747285559713095, 0.9747285559713095, -0.9951872199970213, 0.9951872199970213]);
    var tmp_0 = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp_0.r3d_1 = new Float64Array([0.12793819534675216, 0.12793819534675216, 0.1258374563468283, 0.1258374563468283, 0.12167047292780339, 0.12167047292780339, 0.1155056680537256, 0.1155056680537256, 0.10744427011596563, 0.10744427011596563, 0.09761865210411388, 0.09761865210411388, 0.08619016153195327, 0.08619016153195327, 0.0733464814110803, 0.0733464814110803, 0.05929858491543678, 0.05929858491543678, 0.04427743881741981, 0.04427743881741981, 0.028531388628933663, 0.028531388628933663, 0.0123412297999872, 0.0123412297999872]);
    this.s3d_1 = 6.283185307179586;
    this.t3d_1 = Line2D.s37(0, 0, 1, 0);
    this.u3d_1 = new Float64Array(0);
  }
  v3d(p0, p1, p2, p3, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.cubicCalc' call
    var x0 = p0.l36_1;
    var y0 = p0.m36_1;
    var x1 = p1.l36_1;
    var y1 = p1.m36_1;
    var x2 = p2.l36_1;
    var y2 = p2.m36_1;
    var cx = 3.0 * (x1 - x0);
    var bx = 3.0 * (x2 - x1) - cx;
    var ax = p3.l36_1 - x0 - cx - bx;
    var cy = 3.0 * (y1 - y0);
    var by = 3.0 * (y2 - y1) - cy;
    var ay = p3.m36_1 - y0 - cy - by;
    var tSquared = Ratio__times_impl_ucdh7y(t, t);
    var tCubed = Ratio__times_impl_ucdh7y(tSquared, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp = ax * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_0 = tmp + bx * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var x = tmp_0 + cx * _Ratio___get_value__impl__57cli6(t) + x0;
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_1 = ay * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_2 = tmp_1 + by * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var y = tmp_2 + cy * _Ratio___get_value__impl__57cli6(t) + y0;
    out = Vector2D.h38(x, y);
    return out;
  }
  w3d(p, c, a, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.quadCalc' call
    var x0 = p.l36_1;
    var y0 = p.m36_1;
    var xc = c.l36_1;
    var yc = c.m36_1;
    var x1 = a.l36_1;
    var y1 = a.m36_1;
    var t1 = 1 - Ratio__toDouble_impl_o7epze(t);
    var a_0 = t1 * t1;
    var c_0 = Ratio__times_impl_ucdh7y(t, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var b = 2 * t1 * _Ratio___get_value__impl__57cli6(t);
    var x = a_0 * x0 + b * xc + Ratio__times_impl_ucdh7y_0(c_0, x1);
    var y = a_0 * y0 + b * yc + Ratio__times_impl_ucdh7y_0(c_0, y1);
    out = Vector2D.h38(x, y);
    return out;
  }
}
class Arc {
  constructor() {
    this.x3d_1 = 0.5522847498307933;
    this.y3d_1 = 6.283185307179586;
  }
  z3d(out, center, r, start, end, counterclockwise) {
    var x = center.jk();
    var y = center.kk();
    var startAngle = _Angle___get_normalized__impl__9s30ys(start);
    var endAngle1 = _Angle___get_normalized__impl__9s30ys(end);
    var endAngle = Angle__compareTo_impl_a0hfds(endAngle1, startAngle) < 0 ? Angle__plus_impl_26v37k(endAngle1, Companion_getInstance_69().h36_1) : endAngle1;
    // Inline function 'korlibs.math.geom.min' call
    var a = Companion_getInstance_69().h36_1;
    // Inline function 'korlibs.math.geom.abs' call
    var angle = Angle__minus_impl_xeau7k(endAngle, startAngle);
    var b = _Angle___get_absoluteValue__impl__4qoakv(angle);
    // Inline function 'kotlin.math.min' call
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var a_0 = _Angle___get_radians__impl__n00yt5(a);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var b_0 = _Angle___get_radians__impl__n00yt5(b);
    var tmp$ret$3 = Math.min(a_0, b_0);
    var remainingAngle = _Angle___init__impl__g23q1m(tmp$ret$3);
    if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_69().c36_1) < 0 && !equals(start, end))
      remainingAngle = Companion_getInstance_69().h36_1;
    var sgn1 = Angle__compareTo_impl_a0hfds(startAngle, endAngle) < 0 ? 1 : -1;
    var sgn = counterclockwise ? -sgn1 | 0 : sgn1;
    if (counterclockwise) {
      remainingAngle = Angle__minus_impl_xeau7k(Companion_getInstance_69().h36_1, remainingAngle);
      if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_69().c36_1) < 0 && !equals(start, end))
        remainingAngle = Companion_getInstance_69().h36_1;
    }
    var a1 = startAngle;
    var index = 0;
    while (Angle__compareTo_impl_a0hfds(remainingAngle, Companion_getInstance_69().c36_1) > 0) {
      var tmp = a1;
      // Inline function 'korlibs.math.geom.min' call
      var a_1 = remainingAngle;
      var b_1 = Companion_getInstance_69().e36_1;
      // Inline function 'kotlin.math.min' call
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var a_2 = _Angle___get_radians__impl__n00yt5(a_1);
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var b_2 = _Angle___get_radians__impl__n00yt5(b_1);
      var tmp$ret$7 = Math.min(a_2, b_2);
      var tmp$ret$8 = _Angle___init__impl__g23q1m(tmp$ret$7);
      var a2 = Angle__plus_impl_26v37k(tmp, Angle__times_impl_v3s9y2(tmp$ret$8, sgn));
      var a_3 = Angle__div_impl_ut2btd(Angle__minus_impl_xeau7k(a2, a1), 2.0);
      var x4 = r * _Angle___get_cosine__impl__vprvmu(a_3);
      var y4 = r * _Angle___get_sine__impl__15nmyi(a_3);
      var x1 = x4;
      var y1 = -y4;
      var f = 0.5522847498307933 * _Angle___get_tangent__impl__vushdy(a_3);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = Angle__plus_impl_26v37k(a_3, a1);
      var cos_ar = _Angle___get_cosine__impl__vprvmu(ar);
      var sin_ar = _Angle___get_sine__impl__15nmyi(ar);
      if (index === 0) {
        out.a3e(Vector2D.h38(x + r * _Angle___get_cosine__impl__vprvmu(a1), y + r * _Angle___get_sine__impl__15nmyi(a1)));
      }
      out.b3e(Vector2D.h38(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar), Vector2D.h38(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar), Vector2D.h38(x + r * _Angle___get_cosine__impl__vprvmu(a2), y + r * _Angle___get_sine__impl__15nmyi(a2)));
      index = index + 1 | 0;
      var tmp_0 = remainingAngle;
      // Inline function 'korlibs.math.geom.abs' call
      var angle_0 = Angle__minus_impl_xeau7k(a2, a1);
      var tmp$ret$9 = _Angle___get_absoluteValue__impl__4qoakv(angle_0);
      remainingAngle = Angle__minus_impl_xeau7k(tmp_0, tmp$ret$9);
      a1 = a2;
    }
    if (equals(startAngle, endAngle) && !(index === 0)) {
      out.p5();
    }
  }
}
class Companion_84 {
  c3e(width, height, algo) {
    return new BinPacker(Size2D.s3b(width, height), algo);
  }
  d3e(width, height, algo) {
    return Companion_instance_85.c3e(width, height, algo);
  }
  i1t(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.f3e(width, height) : algo;
    return $super === VOID ? this.d3e(width, height, algo) : $super.d3e.call(this, width, height, algo);
  }
}
class ImageDoNotFitException extends Error {
  static k3e(width, height, packer) {
    var $this = createThis(this);
    setPropertiesToThrowableInstance($this, "Size '" + width + 'x' + height + "' doesn't fit in '" + packer.h1j() + 'x' + packer.i1j() + "'");
    captureStack($this, $this.j3e_1);
    $this.g3e_1 = width;
    $this.h3e_1 = height;
    $this.i3e_1 = packer;
    return $this;
  }
}
class BinPacker {
  constructor(size, algo) {
    algo = algo === VOID ? MaxRects.o3e(size) : algo;
    this.l3e_1 = size;
    this.m3e_1 = algo;
    this.n3e_1 = FastArrayList.j1h();
  }
  h1j() {
    return this.l3e_1.c37_1;
  }
  i1j() {
    return this.l3e_1.d37_1;
  }
  p3e(width, height) {
    var tmp0_elvis_lhs = this.q3e(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw ImageDoNotFitException.k3e(width, height, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  q3e(width, height) {
    var tmp0_elvis_lhs = this.m3e_1.r3e(Size2D.s3b(width, height));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect = tmp;
    // Inline function 'kotlin.collections.plusAssign' call
    this.n3e_1.g(rect);
    return rect;
  }
}
class MaxRects {
  static o3e(maxSize) {
    var $this = createThis(this);
    $this.e3e_1 = fastArrayListOf([Companion_getInstance_77().f37(Companion_getInstance_82().r36_1, maxSize)]);
    return $this;
  }
  static f3e(width, height) {
    return this.o3e(Size2D.s3b(width, height));
  }
  r3e(size) {
    return this.s3e(size);
  }
  s3e(size) {
    var width = size.jk();
    var height = size.kk();
    if (width <= 0.0 && height <= 0.0)
      return Companion_getInstance_77().c2a(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode.r2b_1 === 0.0)
      return null;
    var numRectanglesToProcess = this.e3e_1.d1();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this.e3e_1.f1(i), newNode)) {
        this.e3e_1.w2(i);
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        i = i - 1 | 0;
      }
      i = i + 1 | 0;
    }
    pruneFreeList(this);
    return newNode;
  }
}
class AbstractShape2D {}
class Companion_85 {
  constructor() {
    Companion_instance_86 = this;
    this.t3e_1 = values_2();
  }
  f1(index) {
    return this.t3e_1[umod(index, 4)];
  }
}
class SliceRotation extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.w3e_1 = imul(this.j3_1, 90);
  }
}
class Companion_86 {
  constructor() {
    Companion_instance_87 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var this_0 = new Int32Array([0, 1, 2, 3]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.INDICES.<anonymous>' call
      var orientation = _SliceOrientation___init__impl__ewylib(tmp_2);
      if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
        swap(this_0, 0, 1);
        swap(this_0, 3, 2);
      }
      rotateRight(this_0, _SliceOrientation___get_rotation__impl__m65r0o(orientation).j3_1);
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.y1z_1 = tmp_1;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(8), null);
    while (tmp_4 < 8) {
      var tmp_6 = tmp_4;
      var orientation_0 = _SliceOrientation___init__impl__ewylib(tmp_6);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.i();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.NAMES.<anonymous>' call
      this_1.ab(_SliceOrientation___get_flipX__impl__lgb7bx(orientation_0) ? 'MIRROR_HORIZONTAL_ROTATE_' : 'ROTATE_');
      this_1.eg(_SliceOrientation___get_rotation__impl__m65r0o(orientation_0).w3e_1);
      tmp_5[tmp_6] = this_1.toString();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.z1z_1 = tmp_5;
    var tmp_7 = this;
    var tmp829_rotation = SliceRotation_R0_getInstance();
    tmp_7.a20_1 = _SliceOrientation___init__impl__ewylib_0(tmp829_rotation, false);
    var tmp_8 = this;
    var tmp830_rotation = SliceRotation_R90_getInstance();
    tmp_8.b20_1 = _SliceOrientation___init__impl__ewylib_0(tmp830_rotation, false);
    var tmp_9 = this;
    var tmp831_rotation = SliceRotation_R180_getInstance();
    tmp_9.c20_1 = _SliceOrientation___init__impl__ewylib_0(tmp831_rotation, false);
    var tmp_10 = this;
    var tmp832_rotation = SliceRotation_R270_getInstance();
    tmp_10.d20_1 = _SliceOrientation___init__impl__ewylib_0(tmp832_rotation, false);
    this.e20_1 = _SliceOrientation___init__impl__ewylib_0(VOID, true);
    var tmp_11 = this;
    var tmp833_rotation = SliceRotation_R90_getInstance();
    tmp_11.f20_1 = _SliceOrientation___init__impl__ewylib_0(tmp833_rotation, true);
    var tmp_12 = this;
    var tmp834_rotation = SliceRotation_R180_getInstance();
    tmp_12.g20_1 = _SliceOrientation___init__impl__ewylib_0(tmp834_rotation, true);
    var tmp_13 = this;
    var tmp835_rotation = SliceRotation_R270_getInstance();
    tmp_13.h20_1 = _SliceOrientation___init__impl__ewylib_0(tmp835_rotation, true);
    this.i20_1 = listOf_0([new SliceOrientation(this.a20_1), new SliceOrientation(this.b20_1), new SliceOrientation(this.c20_1), new SliceOrientation(this.d20_1), new SliceOrientation(this.e20_1), new SliceOrientation(this.f20_1), new SliceOrientation(this.g20_1), new SliceOrientation(this.h20_1)]);
  }
}
class SliceOrientation {
  constructor(raw) {
    Companion_getInstance_88();
    this.j2g_1 = raw;
  }
  toString() {
    return SliceOrientation__toString_impl_tdph6r(this.j2g_1);
  }
  hashCode() {
    return SliceOrientation__hashCode_impl_7mjkdw(this.j2g_1);
  }
  equals(other) {
    return SliceOrientation__equals_impl_h4gywg(this.j2g_1, other);
  }
}
class SliceCoords {}
function x(index) {
  switch (index) {
    case 0:
      return this.o3f();
    case 1:
      return this.q3f();
    case 2:
      return this.s3f();
    case 3:
      return this.u3f();
    default:
      return NaN;
  }
}
function y(index) {
  switch (index) {
    case 0:
      return this.p3f();
    case 1:
      return this.r3f();
    case 2:
      return this.t3f();
    case 3:
      return this.v3f();
    default:
      return NaN;
  }
}
class SliceCoordsWithBase {}
function get_frameOffsetX() {
  return this.g3f().o20_1;
}
function get_frameOffsetY() {
  return this.g3f().l20_1;
}
function get_frameWidth() {
  return this.h1j() + this.g3f().p20() | 0;
}
function get_frameHeight() {
  return this.i1j() + this.g3f().q20() | 0;
}
class SliceCoordsWithBaseAndRect {}
function get_left() {
  return this.f3f().o1x();
}
function get_top() {
  return this.f3f().p1x();
}
function get_right() {
  return this.f3f().q1x();
}
function get_bottom() {
  return this.f3f().r1x();
}
function get_area() {
  return this.f3f().b1w();
}
class RectSlice {
  constructor(base, rect, orientation, padding, name) {
    orientation = orientation === VOID ? Companion_getInstance_88().a20_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_72().j20_1 : padding;
    name = name === VOID ? null : name;
    this.a1u_1 = base;
    this.b1u_1 = rect;
    this.c1u_1 = orientation;
    this.d1u_1 = padding;
    this.e1u_1 = name;
    this.f1u_1 = this.a1u_1.d1().v1v_1;
    this.g1u_1 = this.a1u_1.d1().w1v_1;
    this.h1u_1 = this.b1u_1.s1v_1;
    this.i1u_1 = this.b1u_1.t1v_1;
    this.j1u_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.c1u_1) ? this.b1u_1.s1v_1 : this.b1u_1.t1v_1;
    this.k1u_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.c1u_1) ? this.b1u_1.t1v_1 : this.b1u_1.s1v_1;
    this.l1u_1 = this.j1u_1 + this.d1u_1.p20() | 0;
    this.m1u_1 = this.k1u_1 + this.d1u_1.q20() | 0;
    this.n1u_1 = this.b1u_1.o1x() / this.f1u_1;
    this.o1u_1 = this.b1u_1.q1x() / this.f1u_1;
    this.p1u_1 = this.b1u_1.p1x() / this.g1u_1;
    this.q1u_1 = this.b1u_1.r1x() / this.g1u_1;
    this.r1u_1 = new RectCoords(this.n1u_1, this.p1u_1, this.o1u_1, this.p1u_1, this.o1u_1, this.q1u_1, this.n1u_1, this.q1u_1);
    this.s1u_1 = transformed(this.r1u_1, this.c1u_1);
    this.t1u_1 = this.s1u_1.x3e_1;
    this.u1u_1 = this.s1u_1.y3e_1;
    this.v1u_1 = this.s1u_1.z3e_1;
    this.w1u_1 = this.s1u_1.a3f_1;
    this.x1u_1 = this.s1u_1.b3f_1;
    this.y1u_1 = this.s1u_1.c3f_1;
    this.z1u_1 = this.s1u_1.d3f_1;
    this.a1v_1 = this.s1u_1.e3f_1;
  }
  x1z() {
    return this.a1u_1;
  }
  f3f() {
    return this.b1u_1;
  }
  g3f() {
    return this.d1u_1;
  }
  h1j() {
    return this.j1u_1;
  }
  i1j() {
    return this.k1u_1;
  }
  h3f() {
    return this.l1u_1;
  }
  i3f() {
    return this.m1u_1;
  }
  j3f(left, top, right, bottom, name, clamped, orientation) {
    var tmp = this.b1u_1.k3c(left, top, right, bottom, clamped);
    return new RectSlice(this.a1u_1, tmp, orientation, this.d1u_1, name == null ? this.e1u_1 : name);
  }
  k3f(x, y, width, height, name, clamped, orientation) {
    return this.j3f(x, y, x + width | 0, y + height | 0, name, clamped, orientation);
  }
  l3f(x, y, width, height, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.c1u_1 : orientation;
    return $super === VOID ? this.k3f(x, y, width, height, name, clamped, orientation) : $super.k3f.call(this, x, y, width, height, name, clamped, new SliceOrientation(orientation));
  }
  m3f(rect, name, clamped, orientation) {
    return this.j3f(rect.o1x(), rect.p1x(), rect.q1x(), rect.r1x(), name, clamped, orientation);
  }
  n3f(rect, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.c1u_1 : orientation;
    return $super === VOID ? this.m3f(rect, name, clamped, orientation) : $super.m3f.call(this, rect, name, clamped, new SliceOrientation(orientation));
  }
  o3f() {
    return this.t1u_1;
  }
  p3f() {
    return this.u1u_1;
  }
  q3f() {
    return this.v1u_1;
  }
  r3f() {
    return this.w1u_1;
  }
  s3f() {
    return this.x1u_1;
  }
  t3f() {
    return this.y1u_1;
  }
  u3f() {
    return this.z1u_1;
  }
  v3f() {
    return this.a1v_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.slice.RectSlice.toString.<anonymous>' call
    this_0.ab('RectSlice(');
    this_0.ab(this.e1u_1);
    this_0.ab(':');
    this_0.za(this.b1u_1);
    if (!(this.c1u_1 === Companion_getInstance_88().a20_1)) {
      this_0.ab(':');
      this_0.za(new SliceOrientation(this.c1u_1));
    }
    if (this.d1u_1.u37()) {
      this_0.ab(':');
      this_0.za(this.d1u_1);
    }
    this_0.ab(')');
    return this_0.toString();
  }
  hashCode() {
    var result = hashCode(this.a1u_1);
    result = imul(result, 31) + this.b1u_1.hashCode() | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.c1u_1) | 0;
    result = imul(result, 31) + this.d1u_1.hashCode() | 0;
    result = imul(result, 31) + (this.e1u_1 == null ? 0 : getStringHashCode(this.e1u_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectSlice))
      return false;
    var tmp0_other_with_cast = other instanceof RectSlice ? other : THROW_CCE();
    if (!equals(this.a1u_1, tmp0_other_with_cast.a1u_1))
      return false;
    if (!this.b1u_1.equals(tmp0_other_with_cast.b1u_1))
      return false;
    if (!(this.c1u_1 === tmp0_other_with_cast.c1u_1))
      return false;
    if (!this.d1u_1.equals(tmp0_other_with_cast.d1u_1))
      return false;
    if (!(this.e1u_1 == tmp0_other_with_cast.e1u_1))
      return false;
    return true;
  }
}
class Companion_87 {
  a3g(base, coords, name, flippedWidthHeight) {
    return new SliceCoordsImpl(base, coords, name, flippedWidthHeight);
  }
  b3g(base, coords, name, flippedWidthHeight, $super) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    return $super === VOID ? this.a3g(base, coords, name, flippedWidthHeight) : $super.a3g.call(this, base, coords, name, flippedWidthHeight);
  }
}
class RectCoords {
  constructor(tlX, tlY, trX, trY, brX, brY, blX, blY) {
    this.x3e_1 = tlX;
    this.y3e_1 = tlY;
    this.z3e_1 = trX;
    this.a3f_1 = trY;
    this.b3f_1 = brX;
    this.c3f_1 = brY;
    this.d3f_1 = blX;
    this.e3f_1 = blY;
  }
  o3f() {
    return this.x3e_1;
  }
  p3f() {
    return this.y3e_1;
  }
  q3f() {
    return this.z3e_1;
  }
  r3f() {
    return this.a3f_1;
  }
  s3f() {
    return this.b3f_1;
  }
  t3f() {
    return this.c3f_1;
  }
  u3f() {
    return this.d3f_1;
  }
  v3f() {
    return this.e3f_1;
  }
  toString() {
    return 'RectCoords(tlX=' + this.x3e_1 + ', tlY=' + this.y3e_1 + ', trX=' + this.z3e_1 + ', trY=' + this.a3f_1 + ', brX=' + this.b3f_1 + ', brY=' + this.c3f_1 + ', blX=' + this.d3f_1 + ', blY=' + this.e3f_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.x3e_1);
    result = imul(result, 31) + getNumberHashCode(this.y3e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z3e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a3f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b3f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c3f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d3f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e3f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCoords))
      return false;
    var tmp0_other_with_cast = other instanceof RectCoords ? other : THROW_CCE();
    if (!equals(this.x3e_1, tmp0_other_with_cast.x3e_1))
      return false;
    if (!equals(this.y3e_1, tmp0_other_with_cast.y3e_1))
      return false;
    if (!equals(this.z3e_1, tmp0_other_with_cast.z3e_1))
      return false;
    if (!equals(this.a3f_1, tmp0_other_with_cast.a3f_1))
      return false;
    if (!equals(this.b3f_1, tmp0_other_with_cast.b3f_1))
      return false;
    if (!equals(this.c3f_1, tmp0_other_with_cast.c3f_1))
      return false;
    if (!equals(this.d3f_1, tmp0_other_with_cast.d3f_1))
      return false;
    if (!equals(this.e3f_1, tmp0_other_with_cast.e3f_1))
      return false;
    return true;
  }
}
class SliceCoordsImpl {
  constructor(base, coords, name, flippedWidthHeight) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    this.c3g_1 = base;
    this.d3g_1 = coords;
    this.e3g_1 = name;
    this.f3g_1 = flippedWidthHeight;
    this.g3g_1 = Companion_getInstance_72().j20_1;
    this.h3g_1 = !this.f3g_1 ? this.c3g_1.d1().v1v_1 : this.c3g_1.d1().w1v_1;
    this.i3g_1 = !this.f3g_1 ? this.c3g_1.d1().w1v_1 : this.c3g_1.d1().v1v_1;
    this.j3g_1 = numberToInt(Companion_getInstance_82().i3d(this.d3g_1.o3f(), this.d3g_1.p3f(), this.d3g_1.q3f(), this.d3g_1.r3f()) * this.h3g_1);
    this.k3g_1 = numberToInt(Companion_getInstance_82().i3d(this.d3g_1.o3f(), this.d3g_1.p3f(), this.d3g_1.u3f(), this.d3g_1.v3f()) * this.i3g_1);
    this.l3g_1 = this.j3g_1 + this.g3g_1.p20() | 0;
    this.m3g_1 = this.k3g_1 + this.g3g_1.q20() | 0;
  }
  x1z() {
    return this.c3g_1;
  }
  g3f() {
    return this.g3g_1;
  }
  h1j() {
    return this.j3g_1;
  }
  i1j() {
    return this.k3g_1;
  }
  h3f() {
    return this.l3g_1;
  }
  i3f() {
    return this.m3g_1;
  }
  o3f() {
    return this.d3g_1.o3f();
  }
  p3f() {
    return this.d3g_1.p3f();
  }
  q3f() {
    return this.d3g_1.q3f();
  }
  r3f() {
    return this.d3g_1.r3f();
  }
  s3f() {
    return this.d3g_1.s3f();
  }
  t3f() {
    return this.d3g_1.t3f();
  }
  u3f() {
    return this.d3g_1.u3f();
  }
  v3f() {
    return this.d3g_1.v3f();
  }
  toString() {
    return 'SliceCoordsImpl(base=' + toString(this.c3g_1) + ', coords=' + toString(this.d3g_1) + ', name=' + this.e3g_1 + ', flippedWidthHeight=' + this.f3g_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.c3g_1);
    result = imul(result, 31) + hashCode(this.d3g_1) | 0;
    result = imul(result, 31) + (this.e3g_1 == null ? 0 : getStringHashCode(this.e3g_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f3g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SliceCoordsImpl))
      return false;
    var tmp0_other_with_cast = other instanceof SliceCoordsImpl ? other : THROW_CCE();
    if (!equals(this.c3g_1, tmp0_other_with_cast.c3g_1))
      return false;
    if (!equals(this.d3g_1, tmp0_other_with_cast.d3g_1))
      return false;
    if (!(this.e3g_1 == tmp0_other_with_cast.e3g_1))
      return false;
    if (!(this.f3g_1 === tmp0_other_with_cast.f3g_1))
      return false;
    return true;
  }
}
class VectorBuilder {}
function line(p0, p1) {
  this.a3e(p0);
  this.o3g(p1);
}
function isNotEmpty() {
  return !(this.n3g() === 0);
}
function rect(rect) {
  return this.r3g(rect.o2b_1, rect.p2b_1, rect.q2b_1, rect.r2b_1);
}
function rect_0(x, y, width, height) {
  this.a3e(Vector2D.h38(x, y));
  this.o3g(Vector2D.h38(x + width, y));
  this.o3g(Vector2D.h38(x + width, y + height));
  this.o3g(Vector2D.h38(x, y + height));
  this.p5();
}
function arc(center, r, start, end, counterclockwise) {
  return Arc_instance.z3d(this, center, numberToDouble(r), start, end, counterclockwise);
}
function arc$default(center, r, start, end, counterclockwise, $super) {
  counterclockwise = counterclockwise === VOID ? false : counterclockwise;
  var tmp;
  if ($super === VOID) {
    this.s3g(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  } else {
    arc(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  }
  return tmp;
}
function circle(center, radius) {
  return this.t3g(center, radius, Companion_getInstance_69().d36_1, Companion_getInstance_69().h36_1);
}
class Companion_88 {}
class VectorPath extends AbstractShape2D {
  constructor(commands, data, winding, optimize) {
    commands = commands === VOID ? new IntArrayList() : commands;
    data = data === VOID ? new DoubleArrayList() : data;
    winding = winding === VOID ? Companion_instance_90.g3h() : winding;
    optimize = optimize === VOID ? true : optimize;
    super();
    this.v3g_1 = new Mixin();
    this.w3g_1 = commands;
    this.x3g_1 = data;
    this.y3g_1 = winding;
    this.z3g_1 = optimize;
    this.a3h_1 = false;
    this.b3h_1 = 0;
    this.c3h_1 = Vector2D.r37();
    this.d3h_1 = Vector2D.r37();
    this.e3h_1 = null;
    this.f3h_1 = null;
  }
  b1i(_set____db54di) {
    this.v3g_1.b1i(_set____db54di);
  }
  c1i() {
    return this.v3g_1.c1i();
  }
  equals(other) {
    if (this === other)
      return true;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof VectorPath) {
      tmp_1 = this.w3g_1.equals(other.w3g_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.x3g_1.equals(other.x3g_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y3g_1.equals(other.y3g_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return (this.w3g_1.hashCode() + imul(this.x3g_1.hashCode(), 13) | 0) + imul(this.y3g_1.j3_1, 111) | 0;
  }
  a3e(p) {
    if (this.w3g_1.w1j() && this.w3g_1.x1j() === 0) {
      if (this.c3h_1.equals(p))
        return Unit_instance;
    }
    this.w3g_1.u1j(0);
    this.x3g_1.a1k(p.l36_1, p.m36_1);
    this.c3h_1 = p;
    this.d3h_1 = p;
    this.b3h_1 = this.b3h_1 + 1 | 0;
  }
  o3g(p) {
    if (ensureMoveTo(this, p) && this.z3g_1)
      return Unit_instance;
    if (p.equals(this.c3h_1) && this.z3g_1)
      return Unit_instance;
    this.w3g_1.u1j(1);
    this.x3g_1.a1k(p.l36_1, p.m36_1);
    this.c3h_1 = p;
    this.b3h_1 = this.b3h_1 + 1 | 0;
  }
  b3e(c1, c2, a) {
    ensureMoveTo(this, c1);
    this.w3g_1.u1j(3);
    this.x3g_1.b1k(c1.l36_1, c1.m36_1, c2.l36_1, c2.m36_1, a.l36_1, a.m36_1);
    this.c3h_1 = a;
    this.b3h_1 = this.b3h_1 + 1 | 0;
  }
  p5() {
    this.w3g_1.u1j(4);
    this.c3h_1 = this.d3h_1;
    this.b3h_1 = this.b3h_1 + 1 | 0;
  }
  n3g() {
    return this.x3g_1.d1() / 2 | 0;
  }
  h3h() {
    // Inline function 'kotlin.text.trimEnd' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.w3g_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.y1h(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.x3g_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.h38(tmp, this.x3g_1.f1(_unary__edvuaz_1));
          var x = destruct.jk();
          var y = destruct.kk();
          this_0.ab('M' + get_niceStr(x) + ',' + get_niceStr(y) + ' ');
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.x3g_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.h38(tmp_0, this.x3g_1.f1(_unary__edvuaz_3));
          var x_0 = destruct_0.jk();
          var y_0 = destruct_0.kk();
          this_0.ab('L' + get_niceStr(x_0) + ',' + get_niceStr(y_0) + ' ');
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.x3g_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.h38(tmp_1, this.x3g_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.x3g_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.h38(tmp_2, this.x3g_1.f1(_unary__edvuaz_7));
          var x1 = destruct_1.jk();
          var y1 = destruct_1.kk();
          var x2 = destruct_2.jk();
          var y2 = destruct_2.kk();
          this_0.ab('Q' + get_niceStr(x1) + ',' + get_niceStr(y1) + ',' + get_niceStr(x2) + ',' + get_niceStr(y2) + ' ');
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.x3g_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.h38(tmp_3, this.x3g_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.x3g_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.h38(tmp_4, this.x3g_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.x3g_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.h38(tmp_5, this.x3g_1.f1(_unary__edvuaz_13));
          var x1_0 = destruct_3.jk();
          var y1_0 = destruct_3.kk();
          var x2_0 = destruct_4.jk();
          var y2_0 = destruct_4.kk();
          var x3 = destruct_5.jk();
          var y3 = destruct_5.kk();
          this_0.ab('C' + get_niceStr(x1_0) + ',' + get_niceStr(y1_0) + ',' + get_niceStr(x2_0) + ',' + get_niceStr(y2_0) + ',' + get_niceStr(x3) + ',' + get_niceStr(y3) + ' ');
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          this_0.ab('Z ');
          break;
      }
    }
    var this_2 = this_0.toString();
    return toString(trimEnd_0(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  }
  toString() {
    return 'VectorPath(' + this.h3h() + ')';
  }
}
class Companion_89 {
  g3h() {
    return Winding_NON_ZERO_getInstance();
  }
}
class Winding extends Enum {
  constructor(name, ordinal, str) {
    super(name, ordinal);
    this.k3h_1 = str;
  }
}
class Companion_90 {
  constructor() {
    Companion_instance_91 = this;
    var tmp = this;
    var tmp_0 = MMatrix$Companion$POOL$lambda;
    tmp.s3h_1 = ConcurrentPool.k1n(tmp_0, VOID, MMatrix$Companion$POOL$lambda_0);
  }
}
class MMatrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_92();
    a = a === VOID ? 1.0 : a;
    b = b === VOID ? 0.0 : b;
    c = c === VOID ? 0.0 : c;
    d = d === VOID ? 1.0 : d;
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.l3h_1 = a;
    this.m3h_1 = b;
    this.n3h_1 = c;
    this.o3h_1 = d;
    this.p3h_1 = tx;
    this.q3h_1 = ty;
  }
  t3h(a, b, c, d, tx, ty) {
    this.l3h_1 = a;
    this.m3h_1 = b;
    this.n3h_1 = c;
    this.o3h_1 = d;
    this.p3h_1 = tx;
    this.q3h_1 = ty;
    return this;
  }
  r3h() {
    return this.t3h(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  }
  toString() {
    return 'Matrix(a=' + this.l3h_1 + ', b=' + this.m3h_1 + ', c=' + this.n3h_1 + ', d=' + this.o3h_1 + ', tx=' + this.p3h_1 + ', ty=' + this.q3h_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.l3h_1);
    result = imul(result, 31) + getNumberHashCode(this.m3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q3h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MMatrix))
      return false;
    var tmp0_other_with_cast = other instanceof MMatrix ? other : THROW_CCE();
    if (!equals(this.l3h_1, tmp0_other_with_cast.l3h_1))
      return false;
    if (!equals(this.m3h_1, tmp0_other_with_cast.m3h_1))
      return false;
    if (!equals(this.n3h_1, tmp0_other_with_cast.n3h_1))
      return false;
    if (!equals(this.o3h_1, tmp0_other_with_cast.o3h_1))
      return false;
    if (!equals(this.p3h_1, tmp0_other_with_cast.p3h_1))
      return false;
    if (!equals(this.q3h_1, tmp0_other_with_cast.q3h_1))
      return false;
    return true;
  }
}
class Easings extends Enum {
  toString() {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return replace_0(super.toString(), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)).toLowerCase();
  }
}
class Easings$SMOOTH extends Easings {
  constructor() {
    super('SMOOTH', 0);
    Easings_SMOOTH_instance = this;
  }
  a35(it) {
    return it * it * (3 - 2 * it);
  }
}
class Easings$EASE_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_ELASTIC', 1);
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  a35(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp_0 = -1.0;
        // Inline function 'kotlin.math.pow' call

        var x = 10.0 * inv;
        var tmp_1 = tmp_0 * Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (inv - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_1 * Math.sin(x_0);
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_ELASTIC', 2);
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  a35(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        // Inline function 'kotlin.math.pow' call

        var x = -10.0 * it;
        var tmp_0 = Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (it - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_0 * Math.sin(x_0) + 1;
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_BOUNCE', 3);
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  a35(it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      // Inline function 'kotlin.math.pow' call
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = it - 1.5 / p;
      tmp = s * Math.pow(this_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_1 = it - 2.25 / p;
      tmp = s * Math.pow(this_1, 2.0) + 0.9375;
    } else {
      // Inline function 'kotlin.math.pow' call
      var this_2 = it - 2.625 / p;
      tmp = s * Math.pow(this_2, 2.0) + 0.984375;
    }
    return tmp;
  }
}
class Easings$LINEAR extends Easings {
  constructor() {
    super('LINEAR', 4);
    Easings_LINEAR_instance = this;
  }
  a35(it) {
    return it;
  }
}
class Easings$EASE extends Easings {
  constructor() {
    super('EASE', 5);
    Easings_EASE_instance = this;
    this.g3i_1 = new EasingCubic(0.25, 0.1, 0.25, 1.0, 'ease');
  }
  a35(it) {
    return this.g3i_1.a35(it);
  }
}
class Easings$EASE_IN extends Easings {
  constructor() {
    super('EASE_IN', 6);
    Easings_EASE_IN_instance = this;
    this.p3i_1 = new EasingCubic(0.42, 0.0, 1.0, 1.0, 'ease-in');
  }
  a35(it) {
    return this.p3i_1.a35(it);
  }
}
class Easings$EASE_OUT extends Easings {
  constructor() {
    super('EASE_OUT', 7);
    Easings_EASE_OUT_instance = this;
    this.s3i_1 = new EasingCubic(0.0, 0.0, 0.58, 1.0, 'ease-out');
  }
  a35(it) {
    return this.s3i_1.a35(it);
  }
}
class Easings$EASE_IN_OUT extends Easings {
  constructor() {
    super('EASE_IN_OUT', 8);
    Easings_EASE_IN_OUT_instance = this;
    this.v3i_1 = new EasingCubic(0.42, 0.0, 0.58, 1.0, 'ease-in-out');
  }
  a35(it) {
    return this.v3i_1.a35(it);
  }
}
class Easings$EASE_IN_OLD extends Easings {
  constructor() {
    super('EASE_IN_OLD', 9);
    Easings_EASE_IN_OLD_instance = this;
  }
  a35(it) {
    return it * it * it;
  }
}
class Easings$EASE_OUT_OLD extends Easings {
  constructor() {
    super('EASE_OUT_OLD', 10);
    Easings_EASE_OUT_OLD_instance = this;
  }
  a35(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_OLD.invoke.<anonymous>' call
    var inv = it - 1.0;
    return inv * inv * inv + 1;
  }
}
class Easings$EASE_IN_OUT_OLD extends Easings {
  constructor() {
    super('EASE_IN_OUT_OLD', 11);
    Easings_EASE_IN_OUT_OLD_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_IN_OLD_getInstance();
    var end = Easings_EASE_OUT_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_OLD extends Easings {
  constructor() {
    super('EASE_OUT_IN_OLD', 12);
    Easings_EASE_OUT_IN_OLD_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_OUT_OLD_getInstance();
    var end = Easings_EASE_IN_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BACK extends Easings {
  constructor() {
    super('EASE_IN_BACK', 13);
    Easings_EASE_IN_BACK_instance = this;
  }
  a35(it) {
    // Inline function 'kotlin.math.pow' call
    return Math.pow(it, 2.0) * ((1.70158 + 1.0) * it - 1.70158);
  }
}
class Easings$EASE_OUT_BACK extends Easings {
  constructor() {
    super('EASE_OUT_BACK', 14);
    Easings_EASE_OUT_BACK_instance = this;
  }
  a35(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_BACK.invoke.<anonymous>' call
    var inv = it - 1.0;
    // Inline function 'kotlin.math.pow' call
    return Math.pow(inv, 2.0) * ((1.70158 + 1.0) * inv + 1.70158) + 1.0;
  }
}
class Easings$EASE_IN_OUT_BACK extends Easings {
  constructor() {
    super('EASE_IN_OUT_BACK', 15);
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_IN_BACK_getInstance();
    var end = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BACK extends Easings {
  constructor() {
    super('EASE_OUT_IN_BACK', 16);
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_OUT_BACK_getInstance();
    var end = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_OUT_ELASTIC', 17);
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_IN_ELASTIC_getInstance();
    var end = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_IN_ELASTIC', 18);
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_OUT_ELASTIC_getInstance();
    var end = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_BOUNCE', 19);
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  a35(it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().a35(1.0 - it);
  }
}
class Easings$EASE_IN_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_OUT_BOUNCE', 20);
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_IN_BOUNCE_getInstance();
    var end = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_IN_BOUNCE', 21);
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  a35(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_66();
    var start = Easings_EASE_OUT_BOUNCE_getInstance();
    var end = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.a35(it * 2.0) : 0.5 * end.a35((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_QUAD extends Easings {
  constructor() {
    super('EASE_IN_QUAD', 22);
    Easings_EASE_IN_QUAD_instance = this;
  }
  a35(it) {
    return 1.0 * it * it;
  }
}
class Easings$EASE_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_OUT_QUAD', 23);
    Easings_EASE_OUT_QUAD_instance = this;
  }
  a35(it) {
    return -1.0 * it * (it - 2);
  }
}
class Easings$EASE_IN_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_IN_OUT_QUAD', 24);
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  a35(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_IN_OUT_QUAD.invoke.<anonymous>' call
    var t = it * 2.0;
    var tmp;
    if (t < 1) {
      tmp = +1.0 / 2 * t * t;
    } else {
      tmp = -1.0 / 2 * ((t - 1) * (t - 1 - 2) - 1);
    }
    return tmp;
  }
}
class Easings$EASE_SINE extends Easings {
  constructor() {
    super('EASE_SINE', 25);
    Easings_EASE_SINE_instance = this;
  }
  a35(it) {
    // Inline function 'kotlin.math.sin' call
    var x = it * 1.5707964;
    return Math.sin(x);
  }
}
class Easings$EASE_CLAMP_START extends Easings {
  constructor() {
    super('EASE_CLAMP_START', 26);
    Easings_EASE_CLAMP_START_instance = this;
  }
  a35(it) {
    return it <= 0.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_END extends Easings {
  constructor() {
    super('EASE_CLAMP_END', 27);
    Easings_EASE_CLAMP_END_instance = this;
  }
  a35(it) {
    return it < 1.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_MIDDLE extends Easings {
  constructor() {
    super('EASE_CLAMP_MIDDLE', 28);
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  a35(it) {
    return it < 0.5 ? 0.0 : 1.0;
  }
}
class P {
  static m3k(x, y) {
    var $this = createThis(this);
    $this.k3k_1 = x;
    $this.l3k_1 = y;
    return $this;
  }
  static n3k(x, y) {
    return this.m3k(x, y);
  }
  t3c(that) {
    return P.m3k(this.k3k_1 * that, this.l3k_1 * that);
  }
  o3k(that) {
    return P.m3k(this.k3k_1 + that.k3k_1, this.l3k_1 + that.l3k_1);
  }
  toString() {
    return 'P(x=' + this.k3k_1 + ', y=' + this.l3k_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.k3k_1);
    result = imul(result, 31) + getNumberHashCode(this.l3k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof P))
      return false;
    var tmp0_other_with_cast = other instanceof P ? other : THROW_CCE();
    if (!equals(this.k3k_1, tmp0_other_with_cast.k3k_1))
      return false;
    if (!equals(this.l3k_1, tmp0_other_with_cast.l3k_1))
      return false;
    return true;
  }
}
class EasingCubic {
  constructor(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    this.h3i_1 = x1;
    this.i3i_1 = y1;
    this.j3i_1 = x2;
    this.k3i_1 = y2;
    this.l3i_1 = name;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m3i_1 = [P.n3k(0.0, 0.0), P.n3k(clamp_1(this.h3i_1, 0.0, 1.0), this.i3i_1), P.n3k(clamp_1(this.j3i_1, 0.0, 1.0), this.k3i_1), P.n3k(1.0, 1.0)];
  }
  toString() {
    var tmp0_elvis_lhs = this.l3i_1;
    return tmp0_elvis_lhs == null ? 'cubic-bezier(' + this.h3i_1 + ', ' + this.i3i_1 + ', ' + this.j3i_1 + ', ' + this.k3i_1 + ')' : tmp0_elvis_lhs;
  }
  a35(it) {
    var pivotLeft = it < 0.0 ? it * 10.0 : 0.0;
    var pivotRight = it > 1.0 ? it * 10.0 : 1.0;
    var pivot = it;
    var lastX = 0.0;
    var lastY = 0.0;
    var steps = 0;
    var inductionVariable = 0;
    if (inductionVariable < 50)
      $l$loop_0: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        steps = steps + 1 | 0;
        var res = calc(this, pivot);
        lastX = res.k3k_1;
        lastY = res.l3k_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = lastX - it;
        if (Math.abs(this_0) < 0.001)
          break $l$loop_0;
        if (it < lastX) {
          pivotRight = pivot;
          pivot = (pivotLeft + pivot) * 0.5;
        } else if (it > lastX) {
          pivotLeft = pivot;
          pivot = (pivotRight + pivot) * 0.5;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable < 50);
    return lastY;
  }
}
class UByteArrayInt {
  constructor(data) {
    this.p3k_1 = data;
  }
  toString() {
    return UByteArrayInt__toString_impl_f8qdsi(this.p3k_1);
  }
  hashCode() {
    return UByteArrayInt__hashCode_impl_y17rdr(this.p3k_1);
  }
  equals(other) {
    return UByteArrayInt__equals_impl_xlvwxn(this.p3k_1, other);
  }
}
class Companion_91 {
  constructor() {
    this.d3l_1 = 2;
  }
}
class TypedBuffer {}
function get_size() {
  return this.h3l().t3k() / this.i3l() | 0;
}
class Uint16Buffer {
  constructor(buffer) {
    this.g3l_1 = buffer;
  }
  h3l() {
    return _Uint16Buffer___get_buffer__impl__rei8ax(this.g3l_1);
  }
  i3l() {
    return _Uint16Buffer___get_elementSizeInBytes__impl__tcik7m(this.g3l_1);
  }
  toString() {
    return Uint16Buffer__toString_impl_rxffha(this.g3l_1);
  }
  hashCode() {
    return Uint16Buffer__hashCode_impl_lcipoz(this.g3l_1);
  }
  equals(other) {
    return Uint16Buffer__equals_impl_u4cl2n(this.g3l_1, other);
  }
}
class SimpleBytesDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.d2n_1 = initialBits;
    this.e2n_1 = allowGrow;
    this.f2n_1 = new SimpleRingBuffer(this.d2n_1);
    this.g2n_1 = new Int8Array(1024);
    this.h2n_1 = new Long(0, 0);
    this.i2n_1 = new Long(0, 0);
  }
  k2n() {
    return this.f2n_1.q1f_1;
  }
  j2n(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.f2n_1.j2n(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.h2n_1 = this.h2n_1.q3(toLong(out));
    }
    return out;
  }
  x1f(buffer, offset, size) {
    var out = this.f2n_1.x1f(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.i2n_1 = this.i2n_1.q3(toLong(out));
    }
    return out;
  }
  hashCode() {
    return this.f2n_1.p3l();
  }
  equals(other) {
    var tmp;
    if (other instanceof SimpleBytesDeque) {
      tmp = this.f2n_1.equals(other.f2n_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class SimpleChunkedByteDeque {
  constructor() {
    this.m2n_1 = ArrayDeque.oj();
    this.n2n_1 = 0;
    this.o2n_1 = 0;
  }
  t2n(data, offset, size) {
    writeFullNoCopy(this, copyOfRange(data, offset, offset + size | 0));
  }
  x1f(data, offset, size) {
    if (offset < 0 || (offset + size | 0) > data.length)
      throw IndexOutOfBoundsException.nd();
    var coffset = offset;
    var pending = size;
    var readTotal = 0;
    $l$loop_0: while (pending > 0) {
      // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
      // Inline function 'korlibs.memory.SimpleChunkedByteDeque.read.<anonymous>' call
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.m2n_1.g1()) {
        tmp = this.m2n_1.pj();
      } else {
        tmp = null;
      }
      var tmp0_elvis_lhs = tmp;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var chunk = tmp_0;
      var availableInChunk = chunk.length - this.n2n_1 | 0;
      // Inline function 'kotlin.math.min' call
      var b = pending;
      var toCopy = Math.min(availableInChunk, b);
      if (toCopy <= 0)
        break $l$loop_0;
      arraycopy_2(chunk, this.n2n_1, data, coffset, toCopy);
      coffset = coffset + toCopy | 0;
      pending = pending - toCopy | 0;
      readTotal = readTotal + toCopy | 0;
      consumeChunkSize(chunk, this, toCopy);
    }
    return readTotal;
  }
}
class SimpleRingBuffer {
  constructor(bits) {
    this.j1f_1 = bits;
    this.k1f_1 = 1 << this.j1f_1;
    this.l1f_1 = this.k1f_1 - 1 | 0;
    this.m1f_1 = new Int8Array(this.k1f_1);
    this.n1f_1 = 0;
    this.o1f_1 = 0;
    this.p1f_1 = this.k1f_1;
    this.q1f_1 = 0;
  }
  s1f() {
    return this.m1f_1;
  }
  q3l() {
    return this.n1f_1 & this.l1f_1;
  }
  t1f() {
    return this.o1f_1 & this.l1f_1;
  }
  v1f(count) {
    if (count < 0 || count > this.p1f_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.n4(toString(message));
    }
    this.o1f_1 = this.o1f_1 + count | 0;
    this.q1f_1 = this.q1f_1 + count | 0;
    this.p1f_1 = this.p1f_1 - count | 0;
  }
  r3l(count) {
    if (count < 0 || count > this.q1f_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.n4(toString(message));
    }
    this.n1f_1 = this.n1f_1 + count | 0;
    this.q1f_1 = this.q1f_1 - count | 0;
    this.p1f_1 = this.p1f_1 + count | 0;
  }
  s3l() {
    // Inline function 'kotlin.math.min' call
    var a = this.q1f_1;
    var b = this.k1f_1 - (this.n1f_1 & this.l1f_1) | 0;
    return Math.min(a, b);
  }
  r1f() {
    // Inline function 'kotlin.math.min' call
    var a = this.p1f_1;
    var b = this.k1f_1 - (this.o1f_1 & this.l1f_1) | 0;
    return Math.min(a, b);
  }
  o3l(consume) {
    while (consume.q1f_1 > 0) {
      // Inline function 'kotlin.math.min' call
      var a = consume.s3l();
      var b = this.r1f();
      var copySize = Math.min(a, b);
      arraycopy_2(consume.s1f(), consume.q3l(), this.s1f(), this.t1f(), copySize);
      consume.r3l(copySize);
      this.v1f(copySize);
    }
  }
  j2n(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.p1f_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      // Inline function 'kotlin.math.min' call
      var a_0 = remaining;
      var b = this.r1f();
      var chunkSize = Math.min(a_0, b);
      if (chunkSize <= 0)
        break $l$loop;
      arraycopy_2(data, coffset, this.m1f_1, this.t1f(), chunkSize);
      this.v1f(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  x1f(data, offset, size) {
    return this.j31(this.t3l(data, offset, size));
  }
  j31(size) {
    // Inline function 'kotlin.math.min' call
    var a = this.q1f_1;
    var toRead = Math.min(a, size);
    this.n1f_1 = (this.n1f_1 + toRead | 0) & this.l1f_1;
    this.p1f_1 = this.p1f_1 + toRead | 0;
    this.q1f_1 = this.q1f_1 - toRead | 0;
    return toRead;
  }
  t3l(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.q1f_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.m1f_1;
    var mask = this.l1f_1;
    var coffset = offset;
    var lReadPos = this.n1f_1;
    $l$loop: while (true) {
      // Inline function 'kotlin.math.min' call
      var a_0 = toRead;
      var b = this.s3l();
      var toReadChunk = Math.min(a_0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      arraycopy_2(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  y1f() {
    if (this.q1f_1 <= 0)
      return -1;
    var out = this.m1f_1[this.n1f_1] & 255;
    this.n1f_1 = (this.n1f_1 + 1 | 0) & this.l1f_1;
    this.q1f_1 = this.q1f_1 - 1 | 0;
    this.p1f_1 = this.p1f_1 + 1 | 0;
    return out;
  }
  e31(offset) {
    return this.m1f_1[(this.n1f_1 + offset | 0) & this.l1f_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof SimpleRingBuffer) {
      tmp_0 = this.q1f_1 === other.q1f_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.memory.SimpleRingBuffer.equaler' call
        var count = this.q1f_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.memory.SimpleRingBuffer.equals.<anonymous>' call
            if (!(this.e31(n) === other.e31(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.p3l();
  }
  p3l() {
    // Inline function 'korlibs.memory.SimpleRingBuffer.hashCoder' call
    var count = this.q1f_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.memory.SimpleRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.e31(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_92 {
  constructor() {
    Companion_instance_93 = this;
    this.u3l_1 = _ByteUnits___init__impl__x795am(0.0);
  }
  v3l(bytes) {
    return _ByteUnits___init__impl__x795am(bytes);
  }
  w3l(bytes) {
    return _ByteUnits___init__impl__x795am(bytes.e4());
  }
}
class Companion_93 {
  q3k(src, srcPosBytes, dst, dstPosBytes, sizeInBytes) {
    dst.x3l(dstPosBytes, sizeInBytes).set(src.x3l(srcPosBytes, sizeInBytes), 0);
  }
  r3k(src, srcPosBytes, dst, dstPosBytes, sizeInBytes) {
    return equalsCommon_0(this, src, srcPosBytes, dst, dstPosBytes, sizeInBytes, false);
  }
}
class Buffer {
  static y3l(dataView) {
    var $this = createThis(this);
    $this.t1s_1 = dataView;
    return $this;
  }
  static b3l(size, direct) {
    direct = direct === VOID ? false : direct;
    return this.y3l(new DataView(new ArrayBuffer(checkNBufferSize(size))));
  }
  z3l() {
    return this.t1s_1.byteOffset;
  }
  t3k() {
    return this.t1s_1.byteLength;
  }
  j3l(start, end) {
    return Buffer.y3l(new DataView(get_buffer(this), this.z3l() + start | 0, end - start | 0));
  }
  x3l(offset, size) {
    return new Uint8Array(get_buffer(this), this.t1s_1.byteOffset + offset | 0, size);
  }
  s3k(bufferOffset, array, arrayOffset, len, toArray) {
    var bufferSlice = new Int8Array(this.t1s_1.buffer, this.t1s_1.byteOffset + bufferOffset | 0, len);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var arraySlice = array.subarray(arrayOffset, arrayOffset + len | 0);
    if (toArray) {
      arraySlice.set(bufferSlice, 0);
    } else {
      bufferSlice.set(arraySlice, 0);
    }
  }
  v3k(byteOffset) {
    return this.t1s_1.getInt8(byteOffset);
  }
  l3l(byteOffset) {
    return this.t1s_1.getInt16(byteOffset, true);
  }
  u3k(byteOffset) {
    return this.t1s_1.getInt32(byteOffset, true);
  }
  w3k(byteOffset) {
    var v0 = toLong(this.u3k(byteOffset)).b4(new Long(-1, 0));
    var v1 = toLong(this.u3k(byteOffset + 4 | 0)).b4(new Long(-1, 0));
    return get_isLittleEndian_0() ? v1.y3(32).c4(v0) : v0.y3(32).c4(v1);
  }
  y3k(byteOffset) {
    return this.t1s_1.getFloat32(byteOffset, true);
  }
  m3l(byteOffset) {
    return this.t1s_1.getInt16(byteOffset, false);
  }
  x3k(byteOffset) {
    return this.t1s_1.getFloat32(byteOffset, false);
  }
  n3l(byteOffset, value) {
    return this.t1s_1.setInt8(byteOffset, value);
  }
  f3l(byteOffset, value) {
    return this.t1s_1.setInt16(byteOffset, value, true);
  }
  c3l(byteOffset, value) {
    return this.t1s_1.setInt32(byteOffset, value, true);
  }
  a3l(byteOffset, value) {
    return this.t1s_1.setFloat32(byteOffset, value, true);
  }
  e3l(byteOffset, value) {
    return this.t1s_1.setInt16(byteOffset, value, false);
  }
  k3l(byteOffset, value) {
    return this.t1s_1.setInt32(byteOffset, value, false);
  }
  z3k(byteOffset, value) {
    return this.t1s_1.setFloat32(byteOffset, value, false);
  }
  hashCode() {
    return hashCodeCommon(Companion_instance_94, this);
  }
  p5() {
  }
  equals(other) {
    return equalsCommon(Companion_instance_94, this, other);
  }
  toString() {
    return NBuffer_toString(this);
  }
}
class CloseableCancellable {}
function cancel(e) {
  return this.p5();
}
class Companion_94 {}
class CancellableGroup {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.b3m_1 = ArrayList.j1();
  }
  c3m(c) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.b3m_1;
    var element = cancellable(c);
    this_0.g(element);
  }
  p5() {
    this.a3m(CancellationException.tc());
  }
  a3m(e) {
    cancel_1(this.b3m_1, e);
  }
}
class sam$korlibs_io_lang_Cancellable$0 {
  constructor(function_0) {
    this.d3m_1 = function_0;
  }
  a3m(e) {
    return this.d3m_1(e);
  }
}
class Companion_95 {
  l1i(key) {
    var tmp873_safe_receiver = customEnvironments;
    var tmp;
    if (tmp873_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = key.toUpperCase();
      tmp = tmp873_safe_receiver.f3(tmp$ret$1);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = Companion_getInstance_101().e3m();
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = key.toUpperCase();
      tmp_0 = tmp_1.f3(tmp$ret$3);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
}
class MalformedInputException extends Exception {
  static j2x(msg) {
    var $this = this.f5(msg);
    captureStack($this, $this.i2x_1);
    return $this;
  }
}
class InvalidOperationException extends Exception {
  static h3m(str) {
    str = str === VOID ? 'Invalid Operation' : str;
    var $this = this.f5(str);
    captureStack($this, $this.g3m_1);
    return $this;
  }
}
class UnreachableException extends Exception {
  static k3m(str) {
    str = str === VOID ? 'Unreachable' : str;
    var $this = this.f5(str);
    captureStack($this, $this.j3m_1);
    return $this;
  }
}
class OutOfBoundsException extends Exception {
  static w2n(index, str) {
    index = index === VOID ? -1 : index;
    str = str === VOID ? 'Out Of Bounds' : str;
    var $this = this.f5(str);
    captureStack($this, $this.v2n_1);
    return $this;
  }
}
class ByteArrayBuilder {
  static f2p(data, size, allowGrow) {
    size = size === VOID ? data.length : size;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    var $this = createThis(this);
    $this.p1d_1 = data;
    $this.q1d_1 = allowGrow;
    $this.r1d_1 = size;
    return $this;
  }
  static s1d(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.f2p(new Int8Array(initialCapacity), 0);
  }
  l2p(value) {
    var oldPosition = this.r1d_1;
    var newPosition = value;
    ensure_1(this, newPosition);
    this.r1d_1 = newPosition;
    if (newPosition > oldPosition) {
      fill_0(this.p1d_1, 0, oldPosition, newPosition);
    }
  }
  d1() {
    return this.r1d_1;
  }
  d1d(array, offset, len) {
    ensureCount(this, len);
    arraycopy_11(this, array, offset, this.p1d_1, this.r1d_1, len);
    this.r1d_1 = this.r1d_1 + len | 0;
  }
  k2j(array, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? array.length - offset | 0 : len;
    var tmp;
    if ($super === VOID) {
      this.d1d(array, offset, len);
      tmp = Unit_instance;
    } else {
      tmp = $super.d1d.call(this, array, offset, len);
    }
    return tmp;
  }
  c1d(v) {
    ensure_1(this, this.r1d_1 + 1 | 0);
    var tmp = this.p1d_1;
    var _unary__edvuaz = this.r1d_1;
    this.r1d_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v;
  }
  t1d() {
    return copyOf_2(this.p1d_1, this.r1d_1);
  }
}
class Companion_96 {
  l3m() {
    return get_currentArch();
  }
}
class Arch extends Enum {
  constructor(name, ordinal, bits, isArm, isX86OrX64, isMips, isWasm, isPowerPC) {
    isArm = isArm === VOID ? false : isArm;
    isX86OrX64 = isX86OrX64 === VOID ? false : isX86OrX64;
    isMips = isMips === VOID ? false : isMips;
    isWasm = isWasm === VOID ? false : isWasm;
    isPowerPC = isPowerPC === VOID ? false : isPowerPC;
    super(name, ordinal);
    this.b1s_1 = bits;
    this.c1s_1 = isArm;
    this.d1s_1 = isX86OrX64;
    this.e1s_1 = isMips;
    this.f1s_1 = isWasm;
    this.g1s_1 = isPowerPC;
  }
  m3m() {
    return this.b1s_1 === 32;
  }
  h1s() {
    return this.b1s_1 === 64;
  }
}
class Companion_97 {
  constructor() {
    Companion_instance_98 = this;
    this.n3m_1 = get_currentIsLittleEndian() ? Endian_LITTLE_ENDIAN_getInstance() : Endian_BIG_ENDIAN_getInstance();
  }
}
class Endian extends Enum {
  i2c() {
    return this.equals(Endian_LITTLE_ENDIAN_getInstance());
  }
}
class Companion_98 {
  constructor() {
    Companion_instance_99 = this;
    this.o3m_1 = values_4();
  }
  l3m() {
    return get_currentOs();
  }
}
class Os extends Enum {
  i1s() {
    return this.equals(Os_WINDOWS_getInstance());
  }
  r3m() {
    return this.equals(Os_LINUX_getInstance());
  }
  j1s() {
    return this.equals(Os_MACOSX_getInstance());
  }
}
class Platform {}
function get_isWindows() {
  return this.s3m().i1s();
}
function get_isLinux() {
  return this.s3m().r3m();
}
function get_isMac() {
  return this.s3m().j1s();
}
function get_isNative() {
  return this.t3m().v3m();
}
function get_isJsNodeJs() {
  return this.u3m() === 'js-node' || this.u3m() === 'wasm-node';
}
function get_isJsDenoJs() {
  return this.u3m() === 'js-deno' || this.u3m() === 'wasm-deno';
}
function get_isJsBrowser() {
  return this.u3m() === 'js-web' || this.u3m() === 'wasm-web';
}
class Companion_99 {
  constructor() {
    Companion_instance_100 = this;
    var tmp = this;
    tmp.w1r_1 = lazy(Platform$Companion$envs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.x1r_1 = lazy(Platform$Companion$envsUC$delegate$lambda);
  }
  y1r() {
    return Companion_instance_97.l3m();
  }
  s3m() {
    return Companion_getInstance_100().l3m();
  }
  t3m() {
    return Companion_instance_101.l3m();
  }
  u3m() {
    return get_currentRawPlatformName();
  }
  x34() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w1r_1;
    envs$factory();
    return this_0.h3();
  }
  e3m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x1r_1;
    envsUC$factory();
    return this_0.h3();
  }
}
class Companion_100 {
  l3m() {
    return get_currentRuntime();
  }
}
class Runtime extends Enum {
  y3m() {
    return this.equals(Runtime_JVM_getInstance());
  }
  v3m() {
    return this.equals(Runtime_NATIVE_getInstance());
  }
}
class EOFException extends IOException {
  static r2p(msg) {
    var $this = this.d2y(msg);
    captureStack($this, $this.q2p_1);
    return $this;
  }
}
class FileNotFoundException extends IOException {
  static r2u(msg) {
    var $this = this.d2y(msg);
    captureStack($this, $this.q2u_1);
    return $this;
  }
}
class Companion_101 {}
class DenoPointer {
  constructor(rawPointer) {
    this.k1s_1 = rawPointer;
  }
  toString() {
    return 'DenoPointer(rawPointer=' + toString(this.k1s_1) + ')';
  }
  hashCode() {
    return hashCode(this.k1s_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DenoPointer))
      return false;
    var tmp0_other_with_cast = other instanceof DenoPointer ? other : THROW_CCE();
    if (!equals(this.k1s_1, tmp0_other_with_cast.k1s_1))
      return false;
    return true;
  }
}
class Json {
  constructor() {
    Companion_getInstance_104();
    this.f2u_1 = false;
  }
  g2u(s) {
    return this.z3m(Companion_instance_105.l3n(s));
  }
  a3n() {
    return this.f2u_1;
  }
  b3n(capacity) {
    return ArrayList.r(capacity);
  }
  c3n(capacity, $super) {
    capacity = capacity === VOID ? 16 : capacity;
    return $super === VOID ? this.b3n(capacity) : $super.b3n.call(this, capacity);
  }
  d3n(doubles) {
    return toList_1(doubles.k3n());
  }
  z3m(s) {
    var ic = skipSpaces(s, this).f31();
    var tmp;
    if (ic === _Char___init__impl__6a9atx(123)) {
      tmp = parseObject(this, s);
    } else if (ic === _Char___init__impl__6a9atx(91)) {
      tmp = parseArray(this, s);
    } else if (ic === _Char___init__impl__6a9atx(45) || (ic === _Char___init__impl__6a9atx(43) || ic === _Char___init__impl__6a9atx(48)) || (ic === _Char___init__impl__6a9atx(49) || (ic === _Char___init__impl__6a9atx(50) || ic === _Char___init__impl__6a9atx(51))) || (ic === _Char___init__impl__6a9atx(52) || (ic === _Char___init__impl__6a9atx(53) || ic === _Char___init__impl__6a9atx(54)) || (ic === _Char___init__impl__6a9atx(55) || (ic === _Char___init__impl__6a9atx(56) || ic === _Char___init__impl__6a9atx(57))))) {
      var dres = parseNumber(this, s);
      tmp = numberToInt(dres) === dres ? numberToInt(dres) : dres;
    } else if (ic === _Char___init__impl__6a9atx(116)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'true');
      tmp = true;
    } else if (ic === _Char___init__impl__6a9atx(102)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'false');
      tmp = false;
    } else if (ic === _Char___init__impl__6a9atx(110)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'null');
      tmp = null;
    } else if (ic === _Char___init__impl__6a9atx(117)) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.serialization.json.Json.parse.<anonymous>' call
      expect(s, this, 'undefined');
      tmp = null;
    } else if (ic === _Char___init__impl__6a9atx(34)) {
      tmp = this.f3n(s).toString();
    } else {
      invalidJson(this, "Not expected '" + toString_1(ic) + "' in " + toString(s));
    }
    return tmp;
  }
  e3n(_this__u8e3s4, reportErrors, out) {
    var quotec = _this__u8e3s4.h31();
    if (quotec !== _Char___init__impl__6a9atx(34) && quotec !== _Char___init__impl__6a9atx(39))
      throw IllegalArgumentException.m('Invalid string literal');
    var closed = false;
    loop: while (_this__u8e3s4.g31()) {
      var c = _this__u8e3s4.h31();
      if (c === _Char___init__impl__6a9atx(92)) {
        var cc = _this__u8e3s4.h31();
        var tmp;
        if (cc === _Char___init__impl__6a9atx(92)) {
          tmp = _Char___init__impl__6a9atx(92);
        } else if (cc === _Char___init__impl__6a9atx(47)) {
          tmp = _Char___init__impl__6a9atx(47);
        } else if (cc === _Char___init__impl__6a9atx(39)) {
          tmp = _Char___init__impl__6a9atx(39);
        } else if (cc === _Char___init__impl__6a9atx(34)) {
          tmp = _Char___init__impl__6a9atx(34);
        } else if (cc === _Char___init__impl__6a9atx(98)) {
          tmp = _Char___init__impl__6a9atx(8);
        } else if (cc === _Char___init__impl__6a9atx(102)) {
          tmp = _Char___init__impl__6a9atx(12);
        } else if (cc === _Char___init__impl__6a9atx(110)) {
          tmp = _Char___init__impl__6a9atx(10);
        } else if (cc === _Char___init__impl__6a9atx(114)) {
          tmp = _Char___init__impl__6a9atx(13);
        } else if (cc === _Char___init__impl__6a9atx(116)) {
          tmp = _Char___init__impl__6a9atx(9);
        } else if (cc === _Char___init__impl__6a9atx(117)) {
          // Inline function 'korlibs.io.util.NumberParser.parseInt' call
          NumberParser_getInstance();
          var positive = true;
          var out_0 = 0;
          var n = 0;
          $l$loop_0: while (true) {
            // Inline function 'korlibs.io.serialization.json.Json.readStringLit.<anonymous>' call
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            var c_0 = _unary__edvuaz >= 4 ? _Char___init__impl__6a9atx(0) : _this__u8e3s4.h31();
            if (c_0 === _Char___init__impl__6a9atx(0))
              break $l$loop_0;
            if (c_0 === _Char___init__impl__6a9atx(45) || c_0 === _Char___init__impl__6a9atx(43)) {
              positive = c_0 === _Char___init__impl__6a9atx(43);
            } else {
              var value = ctypeAsInt(c_0);
              if (value < 0)
                break $l$loop_0;
              out_0 = imul(out_0, 16);
              out_0 = out_0 + value | 0;
            }
          }
          var tmp$ret$1 = positive ? out_0 : -out_0 | 0;
          tmp = numberToChar(tmp$ret$1);
        } else {
          throw IllegalArgumentException.m("Invalid char '" + toString_1(cc) + "'");
        }
        var c_1 = tmp;
        out.bb(c_1);
      } else if (c === quotec) {
        closed = true;
        break loop;
      } else
        out.bb(c);
    }
    if (!closed && reportErrors) {
      throw RuntimeException.v9("String literal not closed! '" + toString(_this__u8e3s4) + "'");
    }
    return out;
  }
  f3n(_this__u8e3s4, reportErrors, out, $super) {
    reportErrors = reportErrors === VOID ? true : reportErrors;
    out = out === VOID ? StringBuilder.i() : out;
    return $super === VOID ? this.e3n(_this__u8e3s4, reportErrors, out) : $super.e3n.call(this, _this__u8e3s4, reportErrors, out);
  }
}
class Companion_102 extends Json {
  constructor() {
    Companion_instance_103 = null;
    super();
    Companion_instance_103 = this;
  }
}
class MiniNumberArrayList {
  constructor() {
    this.g3n_1 = 0;
    this.h3n_1 = new Float64Array(16);
  }
  d1() {
    return this.g3n_1;
  }
  i3n() {
    return this.h3n_1.length;
  }
  f1(index) {
    return this.h3n_1[index];
  }
  j3n(value) {
    if (this.g3n_1 >= this.i3n()) {
      this.h3n_1 = copyOf_0(this.h3n_1, imul(this.h3n_1.length, 3));
    }
    var tmp = this.h3n_1;
    var _unary__edvuaz = this.g3n_1;
    this.g3n_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = value;
  }
  k3n() {
    return copyOf_0(this.h3n_1, this.g3n_1);
  }
  equals(other) {
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    if (!(other.d1() === this.g3n_1))
      return false;
    if (isInterface(other, DoubleList)) {
      var inductionVariable = 0;
      var last = this.g3n_1;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.f1(n) === other.f1(n)))
            return false;
        }
         while (inductionVariable < last);
      return true;
    }
    if (isInterface(other, KtList)) {
      var inductionVariable_0 = 0;
      var last_0 = this.g3n_1;
      if (inductionVariable_0 < last_0)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!equals(this.f1(n_0), other.f1(n_0)))
            return false;
        }
         while (inductionVariable_0 < last_0);
      return true;
    }
    var n_1 = 0;
    var _iterator__ex2g4s = other.a1();
    while (_iterator__ex2g4s.b1()) {
      var v = _iterator__ex2g4s.c1();
      var _unary__edvuaz = n_1;
      n_1 = _unary__edvuaz + 1 | 0;
      if (!equals(this.f1(_unary__edvuaz), v))
        return false;
    }
    return true;
  }
  hashCode() {
    return contentHashCode_4(this.h3n_1, this, 0, this.g3n_1);
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.gb(2 + imul(5, this.g3n_1) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.toString.<anonymous>' call
    this_0.bb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.g3n_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ab(', ');
        }
        var v = this.y1h(n);
        if (numberToInt(v) === v)
          this_0.eg(numberToInt(v));
        else
          this_0.hg(v);
      }
       while (inductionVariable < last);
    this_0.bb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
  q2(elements) {
    return this.z1h(elements);
  }
}
class Charset {
  constructor(name) {
    this.m3n_1 = name;
  }
  n3n(nbytes) {
    return imul(nbytes, 2);
  }
}
class BaseSingleByteCharset extends Charset {
  n3n(nbytes) {
    return nbytes;
  }
}
class SingleByteCharset extends BaseSingleByteCharset {
  constructor(name, conv) {
    super(name);
    this.q3n_1 = conv;
    var tmp = this;
    var tmp943_safe_receiver = maxOrNull(this.q3n_1);
    var tmp_0;
    var tmp_1 = tmp943_safe_receiver;
    if ((tmp_1 == null ? null : new Char(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = Char__plus_impl_qi7pgj(tmp943_safe_receiver, 1);
    }
    var tmp944_safe_receiver = tmp_0;
    var tmp_2;
    var tmp_3 = tmp944_safe_receiver;
    if ((tmp_3 == null ? null : new Char(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.code' call
      tmp_2 = Char__toInt_impl_vasixd(tmp944_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp_2;
    tmp.r3n_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_4 = this;
    // Inline function 'kotlin.also' call
    var this_0 = new Int8Array(this.r3n_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.SingleByteCharset.v.<anonymous>' call
    fill_0(this_0, 63);
    var inductionVariable = 0;
    var last = charSequenceLength(this.q3n_1) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_1 = charSequenceGet(this.q3n_1, n);
        this_0[Char__toInt_impl_vasixd(this_1)] = toByte(n);
      }
       while (inductionVariable <= last);
    tmp_4.s3n_1 = this_0;
  }
  o3n(out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.bb(charSequenceGet(this.q3n_1, src[n] & 255));
      }
       while (inductionVariable < end);
    return end - start | 0;
  }
}
class ASCII extends SingleByteCharset {
  constructor() {
    ASCII_instance = null;
    var tmp = 0;
    var tmp_0 = charArray(128);
    while (tmp < 128) {
      var tmp_1 = tmp;
      tmp_0[tmp_1] = numberToChar(tmp_1);
      tmp = tmp + 1 | 0;
    }
    super('ASCII', concatToString(tmp_0) + '\xC7\xFC\xE9\xE2\xE4\xE0\xE5\xE7\xEA\xEB\xE8\xEF\xEE\xEC\xC4\xC5\xC9\xE6\xC6\xF4\xF6\xF2\xFB\xF9\xFF\xD6\xDC\xF8\xA3\xD8\xD7\u0192\xE1\xED\xF3\xFA\xF1\xD1\xAA\xBA\xBF\xAE\xAC\xBD\xBC\xA1\xAB\xBB\u2591\u2592\u2593\u2502\u2524\xC1\xC2\xC0\xA9\u2563\u2551\u2557\u255D\xA2\xA5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xE3\xC3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xA4\xF0\xD0\xCA\xCB\xC8\u0131\xCD\xCE\xCF\u2518\u250C\u2588\u2584\xA6\xCC\u2580\xD3\xDF\xD4\xD2\xF5\xD5\xB5\xFE\xDE\xDA\xDB\xD9\xFD\xDD\xAF\xB4\xAD\xB1\u2017\xBE\xB6\xA7\xF7\xB8\xB0\xA8\xB7\xB9\xB3\xB2\u25A0\xA0');
    ASCII_instance = this;
  }
}
class Companion_103 {
  u3n(_this__u8e3s4, codePoint) {
    if ((55296 <= codePoint ? codePoint <= 57343 : false) || codePoint > 65535) {
      var U0 = codePoint - 65536 | 0;
      var hs = extract_1(U0, 10, 10);
      var ls = extract_1(U0, 0, 10);
      _this__u8e3s4.bb(numberToChar(55296 | hs));
      _this__u8e3s4.bb(numberToChar(56320 | ls));
    } else {
      _this__u8e3s4.bb(numberToChar(codePoint));
    }
  }
}
class UTF16Charset extends Charset {
  constructor(le) {
    super('UTF-16-' + (le ? 'LE' : 'BE'));
    this.w3n_1 = le;
  }
  n3n(nbytes) {
    return imul(nbytes, 2);
  }
  o3n(out, src, start, end) {
    var consumed = 0;
    var progression = step(until(start, end), 2);
    var inductionVariable = progression.u1_1;
    var last = progression.v1_1;
    var step_0 = progression.w1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var char = numberToChar(getS16(src, n, this.w3n_1));
        out.bb(char);
        consumed = consumed + 2 | 0;
      }
       while (!(n === last));
    return consumed;
  }
}
class UTC8CharsetBase extends Charset {
  n3n(nbytes) {
    return imul(nbytes, 2);
  }
  o3n(out, src, start, end) {
    if (start < 0 || start > src.length || (end < 0 || end > src.length)) {
      // Inline function 'kotlin.error' call
      var message = 'Out of bounds';
      throw IllegalStateException.n4(toString(message));
    }
    var i = start;
    loop: while (i < end) {
      var c = src[i] & 255;
      var tmp942_subject = c >> 4;
      if (0 <= tmp942_subject ? tmp942_subject <= 7 : false) {
        Companion_instance_104.u3n(out, c);
        i = i + 1 | 0;
      } else if (12 <= tmp942_subject ? tmp942_subject <= 13 : false) {
        if ((i + 1 | 0) >= end)
          break loop;
        Companion_instance_104.u3n(out, (c & 31) << 6 | src[i + 1 | 0] & 63);
        i = i + 2 | 0;
      } else if (tmp942_subject === 14) {
        if ((i + 2 | 0) >= end)
          break loop;
        Companion_instance_104.u3n(out, (c & 15) << 12 | (src[i + 1 | 0] & 63) << 6 | src[i + 2 | 0] & 63);
        i = i + 3 | 0;
      } else if (tmp942_subject === 15) {
        if ((i + 3 | 0) >= end)
          break loop;
        Companion_instance_104.u3n(out, insert_1(insert_1(insert_1(insert_1(0, extract_1(src[i + 0 | 0], 0, 3), 18, 3), extract_1(src[i + 1 | 0], 0, 6), 12, 6), extract_1(src[i + 2 | 0], 0, 6), 6, 6), extract_1(src[i + 3 | 0], 0, 6), 0, 6));
        i = i + 4 | 0;
      } else {
        out.bb(_Char___init__impl__6a9atx(65533));
        i = i + 1 | 0;
      }
    }
    return i - start | 0;
  }
}
class ISO_8859_1 extends SingleByteCharset {
  constructor() {
    ISO_8859_1_instance = null;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.lang.ISO_8859_1.<init>.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.bb(numberToChar(n));
      }
       while (inductionVariable < 256);
    super('ISO-8859-1', this_0.toString());
    ISO_8859_1_instance = this;
  }
}
class Charsets {
  y2b() {
    return get_LATIN1();
  }
}
class INDENTS_0 {
  constructor() {
    INDENTS_instance_0 = this;
    this.b30_1 = new Object();
    this.c30_1 = StringBuilder.gb(1024);
    this.d30_1 = ArrayList.r(1024);
  }
  f1(index) {
    if (this.d30_1.d1() <= index) {
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      this.b30_1;
      while (INDENTS_getInstance_0().d30_1.d1() <= index) {
        INDENTS_getInstance_0().d30_1.g(INDENTS_getInstance_0().c30_1.toString());
        INDENTS_getInstance_0().c30_1.bb(_Char___init__impl__6a9atx(9));
      }
    }
    return this.d30_1.f1(index);
  }
}
class Impl {
  constructor(str, pos) {
    this.y3n_1 = str;
    this.z3n_1 = pos;
  }
  c31() {
    return this.z3n_1;
  }
  g31() {
    return this.z3n_1 < this.y3n_1.length;
  }
  h31() {
    // Inline function 'kotlin.also' call
    var this_0 = new Char(this.f31());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.util.Impl.readChar.<anonymous>' call
    this_0.d2_1;
    this.z3n_1 = this.z3n_1 + 1 | 0;
    return this_0.d2_1;
  }
  f31() {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = this.y3n_1;
    var index = this.z3n_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, index);
    } else {
      // Inline function 'korlibs.util.Impl.peekChar.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    return tmp;
  }
  toString() {
    return "Impl(str='" + this.y3n_1 + "', pos=" + this.z3n_1 + ')';
  }
}
class Companion_104 {
  a3o(str, pos) {
    return new Impl(str, pos);
  }
  l3n(str, pos, $super) {
    pos = pos === VOID ? 0 : pos;
    return $super === VOID ? this.a3o(str, pos) : $super.a3o.call(this, str, pos);
  }
}
class Companion_105 {
  constructor() {
    Companion_instance_106 = this;
    this.n2s_1 = new Long(1, 0);
    this.o2s_1 = _DateTime___init__impl__ifgty2(0.0);
    this.p2s_1 = 6.21355968E13;
  }
  b3o(unix) {
    return _DateTime___init__impl__ifgty2(unix);
  }
  h2u(unix) {
    return this.b3o(unix.e4());
  }
  c3o() {
    return _DateTime___init__impl__ifgty2(get_CoreTime().d3o());
  }
  e3o() {
    return numberToLong(get_CoreTime().d3o());
  }
}
class DateTime {
  constructor(unixMillis) {
    Companion_getInstance_107();
    this.f3o_1 = unixMillis;
  }
  g3o(other) {
    return DateTime__compareTo_impl_geo3bs(this.f3o_1, other);
  }
  d(other) {
    return DateTime__compareTo_impl_geo3bs_0(this, other);
  }
  toString() {
    return DateTime__toString_impl_cnueje(this.f3o_1);
  }
  hashCode() {
    return DateTime__hashCode_impl_yf0bc9(this.f3o_1);
  }
  equals(other) {
    return DateTime__equals_impl_qd7s8j(this.f3o_1, other);
  }
}
class Companion_106 {
  h3o() {
    return _FastDuration___init__impl__cfl6bz(0.0);
  }
  i3o() {
    return _FastDuration___init__impl__cfl6bz(NaN);
  }
  j3o() {
    return this.i3o();
  }
}
class FastDuration {
  constructor(ms) {
    this.k3o_1 = ms;
  }
  l3o(other) {
    return FastDuration__compareTo_impl_4fhnj7(this.k3o_1, other);
  }
  d(other) {
    return FastDuration__compareTo_impl_4fhnj7_0(this, other);
  }
  toString() {
    return FastDuration__toString_impl_c9xohb(this.k3o_1);
  }
  hashCode() {
    return FastDuration__hashCode_impl_y13la6(this.k3o_1);
  }
  equals(other) {
    return FastDuration__equals_impl_unk8ke(this.k3o_1, other);
  }
}
class TimeProvider {}
class Companion_107 {
  c3o() {
    return Companion_getInstance_107().c3o();
  }
}
class ICoreTime {}
function performanceMillis() {
  return this.d3o();
}
class CoreTime$1 {
  d3o() {
    return Date.now();
  }
}
class PerformanceCounter {
  constructor() {
    PerformanceCounter_instance = this;
    this.n3o_1 = nowMillis(this);
  }
  o3o() {
    return _FastDuration___get_nanoseconds__impl__pxizcb(ellapsed(this));
  }
  p3o() {
    return _FastDuration___get_microseconds__impl__o4j93h(ellapsed(this));
  }
  q3o() {
    return get_slow(ellapsed(this));
  }
  r3o() {
    return ellapsed(this);
  }
}
class Stopwatch {
  constructor(nanosecondProvider) {
    var tmp;
    if (nanosecondProvider === VOID) {
      tmp = Stopwatch$_init_$lambda_lg3mf2;
    } else {
      tmp = nanosecondProvider;
    }
    nanosecondProvider = tmp;
    this.s3o_1 = nanosecondProvider;
    this.t3o_1 = false;
    this.u3o_1 = 0.0;
    setStart(this);
  }
  v3o() {
    return this.t3o_1 ? _get_currentNano__jndyu4(this) - this.u3o_1 : this.u3o_1;
  }
  w3o() {
    return get_fastNanoseconds(this.v3o());
  }
}
class IntTimedCache {
  constructor(ttl, timeProvider, gen) {
    timeProvider = timeProvider === VOID ? Companion_instance_108 : timeProvider;
    this.x3o_1 = ttl;
    this.y3o_1 = timeProvider;
    this.z3o_1 = gen;
    this.a3p_1 = Companion_getInstance_107().o2s_1;
    this.b3p_1 = 0;
  }
  lm(obj, property) {
    // Inline function 'korlibs.time.IntTimedCache.get' call
    var now = this.y3o_1.c3o();
    if (equals(this.a3p_1, Companion_getInstance_107().o2s_1) || Duration__compareTo_impl_pchp0f(DateTime__minus_impl_10njw8(now, this.a3p_1), this.x3o_1) >= 0) {
      this.a3p_1 = now;
      this.b3p_1 = this.z3o_1();
    }
    return this.b3p_1;
  }
}
//endregion
function get_defaultAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  // Inline function 'kotlin.getValue' call
  var this_0 = defaultAudioFormats$delegate;
  defaultAudioFormats$factory();
  return this_0.h3();
}
var defaultAudioFormats$delegate;
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function invalidate($this) {
  $this.x18_1 = null;
  return $this;
}
function standardAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  return Companion_instance_0.u18([Companion_getInstance_4(), Companion_getInstance_2()]);
}
function defaultAudioFormats$delegate$lambda() {
  _init_properties_AudioFormat_kt__9os7np();
  return standardAudioFormats();
}
function defaultAudioFormats$factory() {
  return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
    return get_defaultAudioFormats();
  }, null);
}
var properties_initialized_AudioFormat_kt_2wpbb7;
function _init_properties_AudioFormat_kt__9os7np() {
  if (!properties_initialized_AudioFormat_kt_2wpbb7) {
    properties_initialized_AudioFormat_kt_2wpbb7 = true;
    defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
  }
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
var Minimp3AudioFormat_instance;
function Minimp3AudioFormat_getInstance() {
  if (Minimp3AudioFormat_instance === VOID)
    new Minimp3AudioFormat();
  return Minimp3AudioFormat_instance;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 === VOID)
    new Companion_2();
  return Companion_instance_3;
}
var DEFAULT_MAX_SAMPLES;
function NativeSoundProvider$audioFormats$delegate$lambda() {
  return get_defaultAudioFormats();
}
var Companion_instance_4;
function Companion_getInstance_5() {
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
function get_nativeSoundProvider() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  // Inline function 'kotlin.getValue' call
  var this_0 = nativeSoundProvider$delegate;
  nativeSoundProvider$factory();
  return this_0.h3();
}
var nativeSoundProvider$delegate;
function nativeSoundProvider$delegate$lambda() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  var tmp;
  if (Companion_getInstance_101().c1a()) {
    tmp = new HtmlNativeSoundProvider();
  } else {
    tmp = Companion_getInstance_5();
  }
  return tmp;
}
function nativeSoundProvider$factory() {
  return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
    return get_nativeSoundProvider();
  }, null);
}
var properties_initialized_HtmlNativeSoundProvider_kt_uyp32m;
function _init_properties_HtmlNativeSoundProvider_kt__ocy1lg() {
  if (!properties_initialized_HtmlNativeSoundProvider_kt_uyp32m) {
    properties_initialized_HtmlNativeSoundProvider_kt_uyp32m = true;
    nativeSoundProvider$delegate = lazy(nativeSoundProvider$delegate$lambda);
  }
}
function HtmlSimpleSound$lambda$lambda($source) {
  return function () {
    $source.disconnect(0);
    HtmlSimpleSound_getInstance().y19_1 = true;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = HtmlSimpleSound_getInstance().w19_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'Web Audio was successfully unlocked';
      this_0.j1a(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    HtmlSimpleSound_getInstance().z19_1.yu(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$lambda($unlock, this$0, $_scratchBuffer) {
  return function (it) {
    var tmp = document;
    var tmp_0;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_0 = $unlock._v;
    }
    tmp.removeEventListener('keydown', tmp_0, true);
    var tmp_1 = document;
    var tmp_2;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_2 = $unlock._v;
    }
    tmp_1.removeEventListener('touchstart', tmp_2, true);
    var tmp_3 = document;
    var tmp_4;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_4 = $unlock._v;
    }
    tmp_3.removeEventListener('touchend', tmp_4, true);
    var tmp_5 = document;
    var tmp_6;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_6 = $unlock._v;
    }
    tmp_5.removeEventListener('mousedown', tmp_6, true);
    var tmp_7;
    if (!(this$0.x19_1 == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp48_safe_receiver = window.globalAudioContext;
      if (tmp48_safe_receiver == null)
        null;
      else {
        tmp48_safe_receiver.resume();
      }
      var source = this$0.x19_1.createBufferSource();
      source.buffer = $_scratchBuffer;
      source.connect(this$0.x19_1.destination);
      source.start(0.0);
      // Inline function 'kotlin.js.asDynamic' call
      if (typeof this$0.x19_1.resume === 'function') {
        // Inline function 'kotlin.js.asDynamic' call
        this$0.x19_1.resume();
      }
      source.onended = HtmlSimpleSound$lambda$lambda(source);
      tmp_7 = Unit_instance;
    }
    return Unit_instance;
  };
}
var HtmlSimpleSound_instance;
function HtmlSimpleSound_getInstance() {
  if (HtmlSimpleSound_instance === VOID)
    new HtmlSimpleSound();
  return HtmlSimpleSound_instance;
}
var Adler32_instance;
function Adler32_getInstance() {
  return Adler32_instance;
}
var CRC32_instance;
function CRC32_getInstance() {
  if (CRC32_instance === VOID)
    new CRC32();
  return CRC32_instance;
}
var Companion_instance_5;
function Companion_getInstance_6() {
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_7() {
  return Companion_instance_6;
}
function resetAlloc($this) {
  $this.i1b_1 = 0;
}
function alloc($this, value, left, right) {
  // Inline function 'kotlin.apply' call
  var _unary__edvuaz = $this.i1b_1;
  $this.i1b_1 = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.compression.deflate.HuffmanTree.alloc.<anonymous>' call
  $this.f1b_1[_unary__edvuaz] = value;
  $this.g1b_1[_unary__edvuaz] = left;
  $this.h1b_1[_unary__edvuaz] = right;
  return _unary__edvuaz;
}
function allocLeaf($this, value) {
  return alloc($this, value, 1023, 1023);
}
function allocNode($this, left, right) {
  return alloc($this, -1, left, right);
}
function computeFastLookup($this) {
  fill($this.l1b_1, -1);
  computeEncodedValues($this, $this.j1b_1, 0, 0);
}
function computeEncodedValues($this, node, encoded, encodedBits) {
  // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
  if ($this.f1b_1[node] === -1) {
    if (encodedBits < 10) {
      // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
      var tmp$ret$1 = $this.g1b_1[node];
      computeEncodedValues($this, tmp$ret$1, encoded, encodedBits + 1 | 0);
      // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
      var tmp$ret$2 = $this.h1b_1[node];
      computeEncodedValues($this, tmp$ret$2, encoded | 1 << encodedBits, encodedBits + 1 | 0);
    } else {
      writeVariants($this, encoded, encodedBits, node, -2);
    }
  } else {
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var tmp$ret$3 = $this.f1b_1[node];
    writeVariants($this, encoded, encodedBits, node, tmp$ret$3);
  }
}
function writeVariants($this, encoded, encodedBits, node, nvalue) {
  var encodedInfo = nvalue & 65535 | encodedBits << 16;
  var rangeCount = 1 << (10 - encodedBits | 0);
  var inductionVariable = 0;
  if (inductionVariable < rangeCount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = encoded | n << encodedBits;
      $this.l1b_1[i] = encodedInfo;
      $this.m1b_1[i] = node;
    }
     while (inductionVariable < rangeCount);
}
function *_generator_uncompress__ej2bxp($this, reader, out, $completion) {
  var sout = new SlidingWindowWithOutput(new SlidingWindow($this.r1b_1), out, reader.s1b(), reader.t1b());
  var lastBlock = false;
  var tempTree = new HuffmanTree();
  var tempDist = new HuffmanTree();
  var codeLenCodeLen = new Int32Array(32);
  var lengths = new Int32Array(512);
  while (!lastBlock) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
    if (false || sout.c1c()) {
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
      var tmp = sout.v1b_1.b1c(sout.y1b_1.z1b_1, 0, sout.y1b_1.a1c_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      sout.y1b_1.z2();
    }
    var tmp_0 = reader.d1c($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    lastBlock = reader.e1c();
    var blockType = reader.f1c(2);
    if (!(0 <= blockType ? blockType <= 2 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'invalid bit';
      throw IllegalStateException.n4(toString(message));
    }
    if (blockType === 0) {
      var len = reader.t1c();
      var nlen = reader.t1c();
      var nnlen = ~nlen & 65535;
      if (!(len === nnlen)) {
        // Inline function 'kotlin.error' call
        var message_0 = 'Invalid deflate stream: len(' + len + ') != ~nlen(' + nnlen + ') :: nlen=' + nlen;
        throw IllegalStateException.n4(toString(message_0));
      }
      var tmp_1 = reader.u1c(len, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var bytes = tmp_1;
      sout.v1c(bytes, 0, len);
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
      if (false || sout.c1c()) {
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
        var tmp_2 = sout.v1b_1.b1c(sout.y1b_1.z1b_1, 0, sout.y1b_1.a1c_1, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        sout.y1b_1.z2();
      }
    } else {
      var tree;
      var dist;
      if (blockType === 1) {
        tree = Companion_getInstance_8().h1c_1;
        dist = Companion_getInstance_8().i1c_1;
      } else {
        var hlit = reader.f1c(5) + 257 | 0;
        var hdist = reader.f1c(5) + 1 | 0;
        var hclen = reader.f1c(4) + 4 | 0;
        fill(codeLenCodeLen, 0);
        var inductionVariable = 0;
        if (inductionVariable < hclen)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            codeLenCodeLen[Companion_getInstance_8().n1c_1[i]] = reader.f1c(3);
          }
           while (inductionVariable < hclen);
        tempTree.o1c(codeLenCodeLen);
        var codeLen = tempTree;
        var hlithdist = hlit + hdist | 0;
        var n = 0;
        fill(lengths, 0);
        while (n < hlithdist) {
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var value = codeLen.p1c(reader);
          if (!(0 <= value ? value <= 18 : false)) {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.n4(toString('Invalid'));
          }
          var len_0;
          switch (value) {
            case 16:
              len_0 = reader.f1c(2) + 3 | 0;
              break;
            case 17:
              len_0 = reader.f1c(3) + 3 | 0;
              break;
            case 18:
              len_0 = reader.f1c(7) + 11 | 0;
              break;
            default:
              len_0 = 1;
              break;
          }
          var vv;
          switch (value) {
            case 16:
              vv = lengths[n - 1 | 0];
              break;
            case 17:
              vv = 0;
              break;
            case 18:
              vv = 0;
              break;
            default:
              vv = value;
              break;
          }
          fill(lengths, vv, n, n + len_0 | 0);
          n = n + len_0 | 0;
        }
        tempTree.q1c(lengths, 0, hlit);
        tempDist.q1c(lengths, hlit, hlithdist);
        tree = tempTree;
        dist = tempDist;
      }
      $l$loop: while (true) {
        var tmp_3 = reader.d1c($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var value_0 = tree.p1c(reader);
        if (value_0 === 256)
          break $l$loop;
        if (value_0 < 256) {
          sout.s1c(toByte(value_0));
        } else {
          var zlenof = value_0 - 257 | 0;
          var lengthExtra = reader.f1c(Companion_getInstance_8().j1c_1[zlenof]);
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var distanceData = dist.p1c(reader);
          var distanceExtra = reader.f1c(Companion_getInstance_8().l1c_1[distanceData]);
          var distance = Companion_getInstance_8().m1c_1[distanceData] + distanceExtra | 0;
          var length = Companion_getInstance_8().k1c_1[zlenof] + lengthExtra | 0;
          sout.r1c(distance, length);
        }
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
        if (false || sout.c1c()) {
          // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
          var tmp_4 = sout.v1b_1.b1c(sout.y1b_1.z1b_1, 0, sout.y1b_1.a1c_1, $completion);
          if (tmp_4 === get_COROUTINE_SUSPENDED())
            tmp_4 = yield tmp_4;
          sout.y1b_1.z2();
        }
      }
    }
  }
  // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
  if (true || sout.c1c()) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
    var tmp_5 = sout.v1b_1.b1c(sout.y1b_1.z1b_1, 0, sout.y1b_1.a1c_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    sout.y1b_1.z2();
  }
  return Unit_instance;
}
var Companion_instance_7;
function Companion_getInstance_8() {
  if (Companion_instance_7 === VOID)
    new Companion_6();
  return Companion_instance_7;
}
function get_unsigned(_this__u8e3s4) {
  return _this__u8e3s4 & 255;
}
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function uncompress_0(_this__u8e3s4, method, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(_this__u8e3s4.length, 2) : outputSizeHint;
  return uncompress_1(method, _this__u8e3s4, outputSizeHint);
}
function uncompressed(_this__u8e3s4, method, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  return uncompressStream(method, _this__u8e3s4, bufferSize, $completion);
}
function uncompress_1(_this__u8e3s4, bytes, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(bytes.length, 2) : outputSizeHint;
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.s1d(outputSizeHint);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.io.compression.uncompress.<anonymous>' call
  uncompress_2(_this__u8e3s4, openSync(bytes), s);
  return buffer.t1d();
}
function uncompressStream(_this__u8e3s4, input, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  var tmp = 'uncompress:' + toString(_this__u8e3s4);
  return asyncStreamWriter(bufferSize, tmp, false, uncompressStream$slambda_0(_this__u8e3s4, input), $completion);
}
function uncompress_2(_this__u8e3s4, i, o) {
  return runBlockingNoSuspensions(uncompress$slambda_0(_this__u8e3s4, i, o));
}
function *_generator_uncompress__ej2bxp_0(_this__u8e3s4, i, o, $completion) {
  var tmp = Companion_instance_10.w1d(i, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _this__u8e3s4.o1d(tmp, o, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function uncompress_3(_this__u8e3s4, i, o, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_0(_this__u8e3s4, i, o, $completion), $completion);
}
function *_generator_invoke__zhh2q8($this, output, $completion) {
  var tmp = uncompress_3($this.x1d_1, $this.y1d_1, output, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompressStream$slambda_0($this_uncompressStream, $input) {
  var i = new uncompressStream$slambda($this_uncompressStream, $input);
  var l = function (output, $completion) {
    return i.z1d(output, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = uncompress_3($this.a1e_1, toAsync_1($this.b1e_1), toAsync_0($this.c1e_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompress$slambda_0($this_uncompress, $i, $o) {
  var i = new uncompress$slambda($this_uncompress, $i, $o);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function get_Deflate() {
  _init_properties_Deflate_kt__jbr9mv();
  // Inline function 'kotlin.getValue' call
  var this_0 = Deflate$delegate;
  Deflate$factory();
  return this_0.h3();
}
var Deflate$delegate;
function Deflate(windowBits) {
  _init_properties_Deflate_kt__jbr9mv();
  return new Deflate$4(windowBits);
}
function toDeflater(_this__u8e3s4) {
  _init_properties_Deflate_kt__jbr9mv();
  return new toDeflater$1(_this__u8e3s4);
}
function toDeflater_0(_this__u8e3s4) {
  _init_properties_Deflate_kt__jbr9mv();
  return new toDeflater$2(_this__u8e3s4);
}
function Deflate$delegate$lambda() {
  _init_properties_Deflate_kt__jbr9mv();
  return Deflate(15);
}
function *_generator_uncompress__ej2bxp_1($this, reader, out, $completion) {
  var tmp = $this.d1e_1.h1d(toDeflater(reader), toDeflater_0(out), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_prepareBigChunkIfRequired__yhuuys($this, $completion) {
  // Inline function 'korlibs.io.compression.util.BitReader.prepareBigChunkIfRequired' call
  var this_0 = $this.e1e_1;
  if (this_0.p1e()) {
    var tmp = this_0.o1e(this_0.g1e_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function Deflate$factory() {
  return getPropertyCallableRef('Deflate', 0, KProperty0, function () {
    return get_Deflate();
  }, null);
}
var properties_initialized_Deflate_kt_5ek8zp;
function _init_properties_Deflate_kt__jbr9mv() {
  if (!properties_initialized_Deflate_kt_5ek8zp) {
    properties_initialized_Deflate_kt_5ek8zp = true;
    Deflate$delegate = lazy(Deflate$delegate$lambda);
  }
}
function GZIP$Companion$_init_$lambda_4zsoc7() {
  return get_Deflate();
}
var Companion_instance_8;
function Companion_getInstance_9() {
  if (Companion_instance_8 === VOID)
    new Companion_7();
  return Companion_instance_8;
}
function *_generator_close__nh2uv0($this, $completion) {
  var tmp = $this.u1e_1.y1e($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_write__x1694l($this, buffer, offset, len, $completion) {
  if (len > 0) {
    $this.w1e_1._v = CRC32_getInstance().s1a($this.w1e_1._v, buffer, offset, len);
    $this.x1e_1._v = $this.x1e_1._v + len | 0;
    var tmp = $this.v1e_1.b1c(buffer, offset, len, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_uncompress__ej2bxp_2($this, reader, out, $completion) {
  var r = reader;
  // Inline function 'korlibs.io.compression.util.BitReader.prepareBigChunkIfRequired' call
  if (r.p1e()) {
    var tmp = r.o1e(r.g1e_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var h0 = r.z1e();
  var h1 = r.z1e();
  if (!(h0 === 31) || !(h1 === 139)) {
    // Inline function 'kotlin.error' call
    var message = 'Not a GZIP file (h0=' + get_hex_1(toByte(h0)) + ', h1=' + get_hex_1(toByte(h1)) + ')';
    throw IllegalStateException.n4(toString(message));
  }
  var method = r.z1e();
  if (!(method === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Just supported deflate in GZIP (method=' + method + ')';
    throw IllegalStateException.n4(toString(message_0));
  }
  var ftext = r.e1c();
  var fhcrc = r.e1c();
  var fextra = r.e1c();
  var fname = r.e1c();
  var fcomment = r.e1c();
  var reserved = r.f1c(3);
  var mtime = r.a1f();
  var xfl = r.z1e();
  var os = r.z1e();
  var tmp_0;
  if (fextra) {
    var tmp_1 = r.q1e(r.t1c(), VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0 = new Int8Array([]);
  }
  var extra = tmp_0;
  var tmp_2;
  if (fname) {
    var tmp_3 = r.b1f($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = null;
  }
  var name = tmp_2;
  var tmp_4;
  if (fcomment) {
    var tmp_5 = r.b1f($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp_4 = tmp_5;
  } else {
    tmp_4 = null;
  }
  var comment = tmp_4;
  var crc16 = fhcrc ? r.t1c() : 0;
  var ccrc32 = {_v: CRC32_getInstance().t1a_1};
  var csize = {_v: 0};
  var tmp_6 = $this.t1e_1();
  var tmp_7 = tmp_6.o1d(r, new GZIPBase$uncompress$2(out, ccrc32, csize), $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  // Inline function 'korlibs.io.compression.util.BitReader.prepareBigChunkIfRequired' call
  if (r.p1e()) {
    var tmp_8 = r.o1e(r.g1e_1, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
  }
  var crc32 = r.a1f();
  var size = r.a1f();
  if ($this.s1e_1 && (!(csize._v === size) || !(ccrc32._v === crc32))) {
    invalidOp("Size doesn't match SIZE(" + get_hex(csize._v) + ' != ' + get_hex(size) + ') || CRC32(' + get_hex(ccrc32._v) + ' != ' + get_hex(crc32) + ')');
  }
  return Unit_instance;
}
function ZLib$Companion$_init_$lambda_nrgg4o(it) {
  return Deflate(it);
}
function *_generator_write__x1694l_0($this, buffer, offset, len, $completion) {
  var tmp = $this.d1f_1.b1c(buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.e1f_1._v = Adler32_instance.s1a($this.e1f_1._v, buffer, offset, len);
  return Unit_instance;
}
var Companion_instance_9;
function Companion_getInstance_10() {
  if (Companion_instance_9 === VOID)
    new Companion_8();
  return Companion_instance_9;
}
function *_generator_uncompress__ej2bxp_3($this, reader, out, $completion) {
  var r = reader;
  var o = out;
  // Inline function 'korlibs.io.compression.util.BitReader.prepareBigChunkIfRequired' call
  if (r.p1e()) {
    var tmp = r.o1e(r.g1e_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var cmf = r.z1e();
  var flg = r.z1e();
  if (!(((imul(cmf, 256) + flg | 0) % 31 | 0) === 0)) {
    // Inline function 'kotlin.error' call
    var message = 'bad zlib header';
    throw IllegalStateException.n4(toString(message));
  }
  var compressionMethod = extract_0(cmf, 0, 4);
  if (!(compressionMethod === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Invalid zlib stream compressionMethod=' + compressionMethod;
    throw IllegalStateException.n4(toString(message_0));
  }
  var windowBits = extract_0(cmf, 4, 4) + 8 | 0;
  var fcheck = extract_0(flg, 0, 5);
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  var hasDict = !(((flg >>> 5 | 0) & 1) === 0);
  var flevel = extract_0(flg, 6, 2);
  var dictid = 0;
  if (hasDict) {
    dictid = r.a1f();
    // Inline function 'kotlin.TODO' call
    var reason = 'Unsupported custom dictionaries (Provided DICTID=' + dictid + ')';
    throw NotImplementedError.cd('An operation is not implemented: ' + reason);
  }
  var chash = {_v: Adler32_instance.r1a_1};
  var tmp_0 = $this.f1f_1(windowBits);
  var tmp_1 = tmp_0.o1d(r, new ZLib$uncompress$2(o, chash), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'korlibs.io.compression.util.BitReader.prepareBigChunkIfRequired' call
  if (r.p1e()) {
    var tmp_2 = r.o1e(r.g1e_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  var adler32 = r.g1f();
  if (!(chash._v === adler32)) {
    invalidOp("Adler32 doesn't match " + get_hex(chash._v) + ' != ' + get_hex(adler32));
  }
  return Unit_instance;
}
function *_generator_forInput__mjt6c9($this, s, $completion) {
  var tmp;
  if (isInterface(s, AsyncGetLengthStream)) {
    var tmp_0 = s.h1f($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.min' call
    var tmp_1 = s.i1f($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var a = tmp_1;
    var b = new Long(8388608, 0);
    var b_0 = (a.p1(b) <= 0 ? a : b).b2();
    var bigChunkSize = Math.max(32768, b_0);
    // Inline function 'kotlin.math.max' call
    var a_0 = bigChunkSize / 2 | 0;
    var readWithSize = Math.max(a_0, 32768);
    return new BitReader(s, bigChunkSize, readWithSize);
  }
  return new BitReader(s);
}
var Companion_instance_10;
function Companion_getInstance_11() {
  return Companion_instance_10;
}
function *_generator_prepareBytesUpTo__5zpo26($this, expectedBytes, $completion) {
  $l$loop_0: while ($this.k1e_1.q1f_1 < expectedBytes) {
    // Inline function 'kotlin.math.min' call
    var b = $this.k1e_1.r1f();
    var readCount = Math.min(expectedBytes, b);
    if (readCount <= 0)
      break $l$loop_0;
    var tmp = $this.f1e_1.u1f($this.k1e_1.s1f(), $this.k1e_1.t1f(), readCount, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var transferred = tmp;
    if (transferred <= 0)
      break $l$loop_0;
    $this.k1e_1.v1f(transferred);
    $this.m1e_1 = $this.m1e_1 + transferred;
  }
  return Unit_instance;
}
function *_generator_abytes__gje57m($this, count, out, $completion) {
  var tmp = $this.o1e(count, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.w1f(count, out);
}
function *_generator_read__qih2oe($this, buffer, offset, len, $completion) {
  var tmp = $this.o1e(len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var out = $this.k1e_1.x1f(buffer, offset, len);
  $this.l1e_1 = $this.l1e_1 + out;
  return out;
}
function *_generator_close__nh2uv0_0($this, $completion) {
  var tmp = $this.f1e_1.y1e($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_strz__qhnc5d($this, $completion) {
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.s1d(4096);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.io.compression.util.BitReader.strz.<anonymous>' call
  // Inline function 'korlibs.io.compression.util.BitReader.discardBits' call
  $this.i1e_1 = 0;
  $this.j1e_1 = 0;
  $l$loop: while (true) {
    // Inline function 'korlibs.io.compression.util.BitReader.prepareBigChunkIfRequired' call
    if ($this.p1e()) {
      var tmp = $this.o1e($this.g1e_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    // Inline function 'korlibs.io.compression.util.BitReader._su8' call
    $this.l1e_1 = $this.l1e_1 + 1;
    var c = $this.k1e_1.y1f();
    if (c === 0)
      break $l$loop;
    write8(s, c);
  }
  var tmp$ret$2 = buffer.t1d();
  return toString_3(tmp$ret$2, ASCII_getInstance());
}
function *_generator_hasLength__5f5ox8($this, $completion) {
  var tmp = $this.f1e_1;
  var tmp66_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp66_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp66_safe_receiver.h1f($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function *_generator_getLength__lvva94($this, $completion) {
  var tmp = $this.f1e_1;
  var tmp67_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp67_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp67_safe_receiver.i1f($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var message = 'Length not available on Stream';
    throw IllegalStateException.n4(toString(message));
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function ilog2(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function get_nextPowerOfTwo(_this__u8e3s4) {
  var v = _this__u8e3s4;
  v = v - 1 | 0;
  v = v | v >> 1;
  v = v | v >> 2;
  v = v | v >> 4;
  v = v | v >> 8;
  v = v | v >> 16;
  v = v + 1 | 0;
  return v;
}
function DeflaterNative(windowBits) {
  return new DeflaterPortable(windowBits);
}
var Companion_instance_11;
function Companion_getInstance_12() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_13() {
  if (Companion_instance_12 === VOID)
    new Companion_11();
  return Companion_instance_12;
}
function Signal$_init_$lambda_6vimhp() {
  return Unit_instance;
}
function BaseSignal$_init_$lambda_tuu04y() {
  return Unit_instance;
}
function invoke_1(_this__u8e3s4) {
  return _this__u8e3s4.d1h(Unit_instance);
}
function *_generator_invoke__zhh2q8_1($this, value, $completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
    if ($this.y1g_1.g1()) {
      break $l$block;
    }
    try {
      $this.a1h_1 = $this.a1h_1 + 1 | 0;
      // Inline function 'korlibs.io.async.fastIterateRemove' call
      var this_0 = $this.y1g_1;
      var n = 0;
      var m = 0;
      while (n < this_0.d1()) {
        if (m >= 0 && !(m === n)) {
          this_0.v2(m, this_0.f1(n));
        }
        // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
        var node = this_0.f1(n);
        var remove = node.e1h_1;
        // Inline function 'korlibs.io.async.AsyncSignal.invoke.<anonymous>' call
        var tmp = node.f1h_1(value, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if (remove) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.d1() > m) {
        this_0.w2(this_0.d1() - 1 | 0);
      }
    }finally {
      $this.a1h_1 = $this.a1h_1 - 1 | 0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this.z1g_1.g1()) {
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_1 = $this.z1g_1;
        var n_0 = 0;
        var m_0 = 0;
        while (n_0 < this_1.d1()) {
          if (m_0 >= 0 && !(m_0 === n_0)) {
            this_1.v2(m_0, this_1.f1(n_0));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var it = this_1.f1(n_0);
          $this.y1g_1.u2(it);
          if (true) {
            m_0 = m_0 - 1 | 0;
          }
          n_0 = n_0 + 1 | 0;
          m_0 = m_0 + 1 | 0;
        }
        while (this_1.d1() > m_0) {
          this_1.w2(this_1.d1() - 1 | 0);
        }
      }
    }
  }
  return Unit_instance;
}
function AsyncSignal$_init_$lambda_rsv6fb() {
  return Unit_instance;
}
function runBlockingNoSuspensions(callback) {
  var completed = {_v: false};
  var rresult = {_v: null};
  var resultEx = {_v: null};
  var suspendCount = {_v: 0};
  startCoroutineUndispatched(callback, new runBlockingNoSuspensions$1(suspendCount, resultEx, completed, rresult));
  if (!completed._v)
    throw IllegalStateException.n4('runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
  if (!(resultEx._v == null))
    throw ensureNotNull(resultEx._v);
  var tmp;
  if (rresult._v == null) {
    throwUninitializedPropertyAccessException('rresult');
  } else {
    tmp = rresult._v;
  }
  return tmp;
}
function startCoroutineUndispatched(_this__u8e3s4, completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.startDirect' call
    var tmp;
    try {
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>' call
      // Inline function 'korlibs.io.async.withCoroutineContext' call
      completion.zb();
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>.<anonymous>' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(e));
        completion.bc(tmp$ret$3);
        break $l$block;
      } else {
        throw $p;
      }
    }
    var value = tmp;
    if (!(value === get_COROUTINE_SUSPENDED())) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
      var tmp$ret$6 = _Result___init__impl__xyqfz8(value_0);
      completion.bc(tmp$ret$6);
    }
  }
}
function _get_unitInstance__yoa8mq($this) {
  return Unit_instance;
}
function NativeThread$Companion$warnSleep$delegate$lambda() {
  println('!!! Sync sleeping on JS');
  return Unit_instance;
}
var Companion_instance_13;
function Companion_getInstance_14() {
  if (Companion_instance_13 === VOID)
    new Companion_12();
  return Companion_instance_13;
}
function DoubleList$subList$lambda(this$0) {
  return function (it) {
    return this$0.f1(it);
  };
}
function Extra$PropertyThis$transform$lambda(_this__u8e3s4, it) {
  return it;
}
function hasExtra(_this__u8e3s4, name) {
  var tmp103_safe_receiver = _this__u8e3s4.c1i();
  return (tmp103_safe_receiver == null ? null : tmp103_safe_receiver.n1i(name)) === true;
}
function setExtra(_this__u8e3s4, name, value) {
  if (_this__u8e3s4.c1i() == null) {
    if (value == null)
      return Unit_instance;
    _this__u8e3s4.b1i(ExtraTypeCreate());
  }
  var tmp105_safe_receiver = _this__u8e3s4.c1i();
  if (tmp105_safe_receiver == null)
    null;
  else {
    tmp105_safe_receiver.m1i(name, value);
  }
}
function getExtraTyped(_this__u8e3s4, name) {
  var tmp = _this__u8e3s4.c1i();
  var tmp102_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
  return tmp102_safe_receiver == null ? null : tmp102_safe_receiver.f3(name);
}
function ExtraTypeCreate() {
  return new ExtraObject();
}
function getExtra(_this__u8e3s4, name) {
  var tmp104_safe_receiver = _this__u8e3s4.c1i();
  return tmp104_safe_receiver == null ? null : tmp104_safe_receiver.l1i(name);
}
function fastArrayListOf(values) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.q1i(values.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.fastArrayListOf.<anonymous>' call
  addAll_0(this_0, values);
  return this_0;
}
function toFastList(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.q1i(_this__u8e3s4.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
  // Inline function 'korlibs.datastructure.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.length) {
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = _this__u8e3s4[_unary__edvuaz];
    this_0.g(it);
  }
  return this_0;
}
function toFastList_0(_this__u8e3s4, out) {
  out = out === VOID ? FastArrayList.j1h() : out;
  out.v1i(0, _this__u8e3s4);
  out.w1i(_this__u8e3s4.d1());
  return out;
}
function SimpleSubList(fromIndex, toIndex, get) {
  return SimpleSubList$1.a1j(toIndex, fromIndex, get);
}
function containsAllCheck(collection, elements) {
  var elementsMap = toMutableSet(elements);
  var _iterator__ex2g4s = collection.a1();
  while (_iterator__ex2g4s.b1()) {
    var v = _iterator__ex2g4s.c1();
    elementsMap.u2(v);
  }
  return elementsMap.g1();
}
function Resourceable(value) {
  return new Fixed(value);
}
function _addAll($this, elements) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (elements.length === 0)
    return false;
  // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = $this.i1h_1;
  (function () {
    var $externalVarargReceiverTmp = tmp$ret$3;
    return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
  }.call(this));
  $this.y5_1 = $this.y5_1 + 1 | 0;
  return true;
}
function rangeCheck($this, index) {
  if (index < 0 || index >= $this.d1())
    throw IndexOutOfBoundsException.od('index: ' + index + ', size: ' + $this.d1());
  return index;
}
function insertionRangeCheck($this, index) {
  if (index < 0 || index > $this.d1())
    throw IndexOutOfBoundsException.od('index: ' + index + ', size: ' + $this.d1());
  return index;
}
var Companion_instance_14;
function Companion_getInstance_15() {
  return Companion_instance_14;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var size = _this__u8e3s4.length;
    var offset_0 = umod(offset, size);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= offset_0 ? offset_0 < size : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.n4(toString(message));
    }
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, size);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, offset_0);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, offset_0, size);
  }
  return tmp$ret$0;
}
var Companion_instance_15;
function Companion_getInstance_16() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_17() {
  return Companion_instance_16;
}
function ensure($this, count) {
  if (($this.z1j_1 + count | 0) > $this.y1j_1.length) {
    var tmp = $this;
    var tmp_0 = $this.y1j_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.z1j_1 + count | 0;
    var b = imul($this.y1j_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
    tmp.y1j_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.f1k_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.f1k_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.d1() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.f1k_1;
    var istart = $this.d1k_1;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.f1k_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.d1() + count | 0;
    var b = imul($this.f1k_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var size = Math.max(a, b_0);
    var _o = fillArrayVal(Array(size), null);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.e1k_1);
    $this.f1k_1 = o;
    $this.d1k_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.g1k(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.g1k(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.f1k_1[($this.d1k_1 + $this.e1k_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.e1k_1 = $this.e1k_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function internalIndex($this, index) {
  return umod($this.d1k_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.w1k_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.w1k_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.d1() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.w1k_1;
    var istart = $this.u1k_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.w1k_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.d1() + count | 0;
    var b = imul($this.w1k_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var tmp$ret$1 = Math.max(a, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.v1k_1);
    $this.w1k_1 = o;
    $this.u1k_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.x1k(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.x1k(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.w1k_1[($this.u1k_1 + $this.v1k_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.v1k_1 = $this.v1k_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.u1k_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_4(_this__u8e3s4, key);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
  remove(_this__u8e3s4, key);
  return this_0;
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
var Companion_instance_17;
function Companion_getInstance_18() {
  return Companion_instance_17;
}
function IArray2$asString$lambda(this$0) {
  return function (y) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.h1j());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
      var tmp$ret$0 = this$0.p1j(item, y);
      destination.g(tmp$ret$0);
    }
    return joinToString_0(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.h1j() : false) || !(0 <= y ? y < _this__u8e3s4.i1j() : false))
    return invalid;
  return imul(y, _this__u8e3s4.h1j()) + x | 0;
}
function currentKey($this) {
  switch ($this.q1l_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.p1l_1.z1l_1[$this.q1l_1];
  }
}
function currentValue($this) {
  switch ($this.q1l_1) {
    case 2147483647:
      return $this.p1l_1.w1l_1;
    case 2147483646:
      return null;
    default:
      return $this.p1l_1.a1m_1[$this.q1l_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.q1l_1 === 2147483646))
    $this.q1l_1 = nextNonEmptyIndex($this, $this.p1l_1.z1l_1, $this.q1l_1 === 2147483647 ? 0 : $this.q1l_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return function () {
    return $it.d1m();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return function () {
    return $it.e1m();
  };
}
var Companion_instance_18;
function Companion_getInstance_19() {
  return Companion_instance_18;
}
function _get_stashStart__3psegu($this) {
  return $this.z1l_1.length - $this.y1l_1 | 0;
}
function grow($this) {
  var inc = $this.s1l_1 < 20 ? 3 : 1;
  var newnbits = $this.s1l_1 + inc | 0;
  var new_0 = IntMap.i1m(newnbits, $this.t1l_1, true);
  var inductionVariable = 0;
  var last = $this.z1l_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.z1l_1[n];
      if (!(k === 0)) {
        new_0.j1m(k, $this.a1m_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.s1l_1 = new_0.s1l_1;
  $this.u1l_1 = new_0.u1l_1;
  $this.x1l_1 = new_0.x1l_1;
  $this.y1l_1 = new_0.y1l_1;
  $this.z1l_1 = new_0.z1l_1;
  $this.a1m_1 = new_0.a1m_1;
  $this.b1m_1 = new_0.b1m_1;
}
function growStash($this) {
  $this.y1l_1 = imul($this.y1l_1, 2);
  $this.z1l_1 = copyOf($this.z1l_1, $this.k1m());
  $this.a1m_1 = copyOf_1($this.a1m_1, $this.k1m());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.v1l_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.z1l_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.z1l_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.z1l_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.z1l_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.z1l_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.z1l_1[index] === 0))
    throw IllegalStateException.uc();
  $this.z1l_1[index] = key;
  $this.a1m_1[index] = value;
  $this.c1m_1 = $this.c1m_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.x1l_1);
}
function hash2($this, key) {
  return _hash2(key, $this.x1l_1);
}
function hash3($this, key) {
  return _hash3(key, $this.x1l_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.p1m(numberToInt(_this__u8e3s4.d1() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.c3().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.g3();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.h3();
    out.j1m(k, v);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_19;
function Companion_getInstance_20() {
  return Companion_instance_19;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return function (it) {
    this$0.l1n_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return function (it) {
    return this$0.m1n_1(it);
  };
}
var Companion_instance_20;
function Companion_getInstance_21() {
  return Companion_instance_20;
}
function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
  $this.v1n_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
}
function _get_value__a43j40(_this__u8e3s4, $this) {
  return $this.v1n_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
}
function _get_isRoot__1006zj(_this__u8e3s4, $this) {
  return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
}
function _get_parent__oo9xup(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
}
function _get_right__bvz45n(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.w1n_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.w1n_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.v1n_1.length;
}
function ensure_0($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_1($this.v1n_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.v1n_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0(i, $this);
    var right = _get_right__bvz45n(i, $this);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.x1n_1 && lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.x1n_1 && lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40(r, $this);
  _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
  _set_value__lx0xdg(l, $this, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
  this_0.i1o(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$2();
}
function Ref_1(prop) {
  return new Ref$3(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.j1h() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).d1();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_21;
function Companion_getInstance_22() {
  return Companion_instance_21;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).g(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).w2(_get_items__fzd5gv($this).d1() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).z2();
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).q2(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.l1o_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).a1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.l1o_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function contentHashCode_2(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_2(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.ob();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.jk();
    var value = _destruct__k2r9zo.kk();
    // Inline function 'kotlin.collections.set' call
    this_0.x2(key, value);
  }
  return this_0;
}
function toLinkedMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.ob();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var key = _destruct__k2r9zo.jk();
    var value = _destruct__k2r9zo.kk();
    // Inline function 'kotlin.collections.set' call
    this_0.x2(key, value);
  }
  return this_0;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_4(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function set_0(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function contains_2(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$2);
}
function Array_from(value) {
  return Array.from(value);
}
function _Dyn___init__impl__6cuxxc(value) {
  return value;
}
function _Dyn___get_value__impl__bemnlg($this) {
  return $this;
}
function Dyn__toComparable_impl_pfql3z($this) {
  var tmp158_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (tmp158_subject == null) {
    tmp = isComparable(0) ? 0 : THROW_CCE();
  } else {
    if (!(tmp158_subject == null) ? isComparable(tmp158_subject) : false) {
      var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
      tmp = isComparable(tmp_0) ? tmp_0 : THROW_CCE();
    } else {
      var tmp_1 = toString(_Dyn___get_value__impl__bemnlg($this));
      tmp = isComparable(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  return tmp;
}
function Dyn__compareTo_impl_7znl52($this, other) {
  var l = $this;
  var r = other;
  var tmp;
  var tmp_0 = _Dyn___get_value__impl__bemnlg(l);
  if (isNumber(tmp_0)) {
    var tmp_1 = _Dyn___get_value__impl__bemnlg(r);
    tmp = isNumber(tmp_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    return compareTo(numberToDouble(_Dyn___get_value__impl__bemnlg(l)), numberToDouble(_Dyn___get_value__impl__bemnlg(r)));
  }
  var lc = Dyn__toComparable_impl_pfql3z(l);
  var rc = Dyn__toComparable_impl_pfql3z(r);
  return getKClassFromExpression(lc).me(rc) ? compareTo(lc, rc) : -1;
}
function Dyn__compareTo_impl_7znl52_0($this, other) {
  return Dyn__compareTo_impl_7znl52($this.o1o_1, other instanceof Dyn ? other.o1o_1 : THROW_CCE());
}
function Dyn__toString_impl_9l0v3s($this) {
  return toString_2($this, _Dyn___get_value__impl__bemnlg($this));
}
var Companion_instance_22;
function Companion_getInstance_23() {
  return Companion_instance_22;
}
function Dyn__set_impl_2ozvx8($this, key, value) {
  var tmp165_subject = _Dyn___get_value__impl__bemnlg($this);
  if (!(tmp165_subject == null) ? isInterface(tmp165_subject, KtMutableMap) : false) {
    // Inline function 'kotlin.collections.set' call
    var tmp = _Dyn___get_value__impl__bemnlg($this);
    (isInterface(tmp, KtMutableMap) ? tmp : THROW_CCE()).x2(key, value);
  } else {
    if (!(tmp165_subject == null) ? isInterface(tmp165_subject, KtMutableList) : false) {
      var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
      (isInterface(tmp_0, KtMutableList) ? tmp_0 : THROW_CCE()).v2(Dyn__toInt_impl_nu3u6q(get_dyn(key)), value);
    } else {
      get_dynApi().r1o(_Dyn___get_value__impl__bemnlg($this), toString_0(key), value);
    }
  }
}
function Dyn__get_impl_6l2p80($this, key) {
  return Dyn__get_impl_6l2p80_0($this, _Dyn___get_value__impl__bemnlg(key));
}
function Dyn__get_impl_6l2p80_0($this, key) {
  return _getOrThrow($this, key, false);
}
function _getOrThrow($this, key, doThrow) {
  var tmp166_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (tmp166_subject == null) {
    var tmp_0;
    if (doThrow) {
      throw NullPointerException.zd("Trying to access '" + toString_0(key) + "'");
    } else {
      tmp_0 = get_dyn(null);
    }
    tmp = tmp_0;
  } else {
    if (!(tmp166_subject == null) ? isInterface(tmp166_subject, KtMap) : false) {
      var tmp_1 = _Dyn___get_value__impl__bemnlg($this);
      tmp = get_dyn((isInterface(tmp_1, KtMap) ? tmp_1 : THROW_CCE()).f3(key));
    } else {
      if (!(tmp166_subject == null) ? isInterface(tmp166_subject, KtList) : false) {
        tmp = get_dyn(getOrNull(_Dyn___get_value__impl__bemnlg($this), Dyn__toInt_impl_nu3u6q(get_dyn(key))));
      } else {
        tmp = get_dyn(get_dynApi().s1o(_Dyn___get_value__impl__bemnlg($this), toString_0(key)));
      }
    }
  }
  return tmp;
}
function _Dyn___get_listAny__impl__vrilgp($this) {
  var tmp;
  if (_Dyn___get_value__impl__bemnlg($this) == null) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
    if (!(tmp_0 == null) ? isInterface(tmp_0, KtList) : false) {
      tmp = _Dyn___get_value__impl__bemnlg($this);
    } else {
      var tmp_1 = _Dyn___get_value__impl__bemnlg($this);
      if (!(tmp_1 == null) ? isInterface(tmp_1, Iterable) : false) {
        tmp = toList(_Dyn___get_value__impl__bemnlg($this));
      } else {
        tmp = listOf(_Dyn___get_value__impl__bemnlg($this));
      }
    }
  }
  return tmp;
}
function _Dyn___get_keysAny__impl__whx5cj($this) {
  var tmp;
  var tmp_0 = _Dyn___get_value__impl__bemnlg($this);
  if (!(tmp_0 == null) ? isInterface(tmp_0, KtMap) : false) {
    tmp = toList(_Dyn___get_value__impl__bemnlg($this).a3());
  } else {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  }
  return tmp;
}
function _Dyn___get_list__impl__qpwjp($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _Dyn___get_listAny__impl__vrilgp($this);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.io.dynamic.Dyn.<get-list>.<anonymous>' call
    var tmp$ret$0 = new Dyn(get_dyn(item));
    destination.g(tmp$ret$0);
  }
  return destination;
}
function _Dyn___get_keys__impl__o4xmor($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _Dyn___get_keysAny__impl__whx5cj($this);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.io.dynamic.Dyn.<get-keys>.<anonymous>' call
    var tmp$ret$0 = new Dyn(get_dyn(item));
    destination.g(tmp$ret$0);
  }
  return destination;
}
function Dyn__toNumber_impl_rlhtn4($this, $receiver) {
  var tmp = toIntOrNull($receiver);
  var tmp0_elvis_lhs = (tmp == null ? true : isNumber(tmp)) ? tmp : null;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? toDoubleOrNull($receiver) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? NaN : tmp1_elvis_lhs;
}
function Dyn__toNumber_impl_rlhtn4_0($this) {
  var tmp173_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (tmp173_subject == null) {
    tmp = 0;
  } else {
    if (isNumber(tmp173_subject)) {
      tmp = _Dyn___get_value__impl__bemnlg($this);
    } else {
      if (!(tmp173_subject == null) ? typeof tmp173_subject === 'boolean' : false) {
        tmp = _Dyn___get_value__impl__bemnlg($this) ? 1 : 0;
      } else {
        if (!(tmp173_subject == null) ? typeof tmp173_subject === 'string' : false) {
          var tmp0_elvis_lhs = toIntSafe(_Dyn___get_value__impl__bemnlg($this));
          var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? toDoubleSafe(_Dyn___get_value__impl__bemnlg($this)) : tmp0_elvis_lhs;
          tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        } else {
          tmp = Dyn__toNumber_impl_rlhtn4($this, toString(_Dyn___get_value__impl__bemnlg($this)));
        }
      }
    }
  }
  return tmp;
}
function toString_2($this, value) {
  var tmp;
  if (value == null) {
    tmp = '';
  } else {
    if (!(value == null) ? typeof value === 'string' : false) {
      tmp = value;
    } else {
      if (!(value == null) ? typeof value === 'number' : false) {
        var tmp_0;
        if (value === numberToInt(value)) {
          tmp_0 = numberToInt(value).toString();
        } else {
          tmp_0 = value.toString();
        }
        tmp = tmp_0;
      } else {
        if (!(value == null) ? isInterface(value, Iterable) : false) {
          tmp = '[' + joinToString_0(value, ', ', VOID, VOID, VOID, VOID, Dyn$toString$lambda($this)) + ']';
        } else {
          if (!(value == null) ? isInterface(value, KtMap) : false) {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList.r(value.d1());
            // Inline function 'kotlin.collections.iterator' call
            var tmp0_iterator = value.c3().a1();
            while (tmp0_iterator.b1()) {
              var item = tmp0_iterator.c1();
              // Inline function 'korlibs.io.dynamic.Dyn.toString.<anonymous>' call
              var tmp$ret$1 = quote(toString_2($this, item.g3())) + ': ' + toString_2($this, item.h3());
              destination.g(tmp$ret$1);
            }
            tmp = '{' + joinToString_0(destination, ', ') + '}';
          } else {
            tmp = toString(value);
          }
        }
      }
    }
  }
  return tmp;
}
function Dyn__toInt_impl_nu3u6q($this) {
  return numberToInt(Dyn__toNumber_impl_rlhtn4_0($this));
}
function Dyn__toLong_impl_mq8zcz($this) {
  return numberToLong(Dyn__toNumber_impl_rlhtn4_0($this));
}
function Dyn__toBoolOrNull_impl_2dk92d($this) {
  var tmp175_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (!(tmp175_subject == null) ? typeof tmp175_subject === 'boolean' : false) {
    tmp = _Dyn___get_value__impl__bemnlg($this);
  } else {
    if (!(tmp175_subject == null) ? typeof tmp175_subject === 'string' : false) {
      tmp = equals(_Dyn___get_value__impl__bemnlg($this), '1') || equals(_Dyn___get_value__impl__bemnlg($this), 'true') || equals(_Dyn___get_value__impl__bemnlg($this), 'on');
    } else {
      if (isNumber(tmp175_subject)) {
        tmp = !(Dyn__toInt_impl_nu3u6q($this) === 0);
      } else {
        tmp = null;
      }
    }
  }
  return tmp;
}
function Dyn__toLongOrNull_impl_ws7y8j($this) {
  var tmp177_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (isNumber(tmp177_subject)) {
    tmp = Dyn__toLong_impl_mq8zcz($this);
  } else {
    if (!(tmp177_subject == null) ? typeof tmp177_subject === 'string' : false) {
      tmp = toLongSafe(_Dyn___get_value__impl__bemnlg($this));
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function Dyn__toLongDefault_impl_auunl0($this, default_0) {
  var tmp180_subject = _Dyn___get_value__impl__bemnlg($this);
  var tmp;
  if (isNumber(tmp180_subject)) {
    tmp = Dyn__toLong_impl_mq8zcz($this);
  } else {
    if (!(tmp180_subject == null) ? typeof tmp180_subject === 'string' : false) {
      var tmp0_elvis_lhs = toLongSafe(_Dyn___get_value__impl__bemnlg($this), 10);
      tmp = tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
    } else {
      tmp = default_0;
    }
  }
  return tmp;
}
function Dyn__toLongDefault$default_impl_w5acm9($this, default_0, $super) {
  default_0 = default_0 === VOID ? new Long(0, 0) : default_0;
  return $super === VOID ? Dyn__toLongDefault_impl_auunl0($this, default_0) : $super.t1o.call(new Dyn($this), default_0);
}
function _Dyn___get_str__impl__dup4cs($this) {
  return Dyn__toString_impl_9l0v3s($this);
}
function _Dyn___get_bool__impl__nv3iun($this) {
  var tmp0_elvis_lhs = Dyn__toBoolOrNull_impl_2dk92d($this);
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function _Dyn___get_long__impl__wdxl7n($this) {
  return Dyn__toLongDefault$default_impl_w5acm9($this);
}
function Dyn__hashCode_impl_vc6rwn($this) {
  return $this == null ? 0 : hashCode($this);
}
function Dyn__equals_impl_sp125n($this, other) {
  if (!(other instanceof Dyn))
    return false;
  var tmp0_other_with_cast = other instanceof Dyn ? other.o1o_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function Dyn$toString$lambda(this$0) {
  return function (it) {
    return toString_2(this$0, it);
  };
}
function get_dyn(_this__u8e3s4) {
  return _Dyn___init__impl__6cuxxc(_this__u8e3s4);
}
function toIntSafe(_this__u8e3s4, radix) {
  radix = radix === VOID ? 10 : radix;
  return toIntOrNull_0(_this__u8e3s4, radix);
}
function toDoubleSafe(_this__u8e3s4) {
  return toDoubleOrNull(_this__u8e3s4);
}
function quote(_this__u8e3s4) {
  return '"' + escape(_this__u8e3s4) + '"';
}
function toLongSafe(_this__u8e3s4, radix) {
  radix = radix === VOID ? 10 : radix;
  return toLongOrNull(_this__u8e3s4, radix);
}
function escape(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  var capacity = _this__u8e3s4.length;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.gb(capacity);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.dynamic.escape.<anonymous>' call
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(_this__u8e3s4, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (c === _Char___init__impl__6a9atx(10))
      this_0.ab('\\n');
    else if (c === _Char___init__impl__6a9atx(13))
      this_0.ab('\\r');
    else if (c === _Char___init__impl__6a9atx(9))
      this_0.ab('\\t');
    else if (c === _Char___init__impl__6a9atx(92))
      this_0.ab('\\\\');
    else
      this_0.bb(c);
  }
  return this_0.toString();
}
function get_dynApi() {
  _init_properties_DynApi_kt__g2fyyp();
  return dynApi;
}
var dynApi;
var properties_initialized_DynApi_kt_kcoydf;
function _init_properties_DynApi_kt__g2fyyp() {
  if (!properties_initialized_DynApi_kt_kcoydf) {
    properties_initialized_DynApi_kt_kcoydf = true;
    dynApi = DynamicInternal_instance;
  }
}
var DynamicInternal_instance;
function DynamicInternal_getInstance() {
  return DynamicInternal_instance;
}
function fromBase64(_this__u8e3s4, ignoreSpaces, url) {
  ignoreSpaces = ignoreSpaces === VOID ? false : ignoreSpaces;
  url = url === VOID ? false : url;
  return Base64_getInstance().z1o(ignoreSpaces, _this__u8e3s4, url);
}
function readU8(_this__u8e3s4, $this, index) {
  return _this__u8e3s4[index] & 255;
}
var Base64_instance;
function Base64_getInstance() {
  if (Base64_instance === VOID)
    new Base64();
  return Base64_instance;
}
function toDecodeArray(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = new Int32Array(256);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.encoding.toDecodeArray.<anonymous>' call
  var inductionVariable = 0;
  if (inductionVariable <= 255)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this_0[n] = -1;
    }
     while (inductionVariable <= 255);
  var inductionVariable_0 = 0;
  var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
  if (inductionVariable_0 <= last)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = charSequenceGet(_this__u8e3s4, n_0);
      this_0[Char__toInt_impl_vasixd(this_1)] = n_0;
    }
     while (inductionVariable_0 <= last);
  return this_0;
}
function get_shex(_this__u8e3s4) {
  return Hex_instance.d1p(_this__u8e3s4);
}
function appendHexByte(_this__u8e3s4, value) {
  return Hex_instance.e1p(_this__u8e3s4, value);
}
function get_hex(_this__u8e3s4) {
  return '0x' + get_shex(_this__u8e3s4);
}
var Hex_instance;
function Hex_getInstance() {
  return Hex_instance;
}
function get_hex_0(_this__u8e3s4) {
  return Hex_instance.h1p(_this__u8e3s4);
}
function get_hex_1(_this__u8e3s4) {
  return '0x' + get_shex_0(_this__u8e3s4);
}
function get_shex_0(_this__u8e3s4) {
  return Hex_instance.i1p(_this__u8e3s4);
}
var Companion_instance_23;
function Companion_getInstance_24() {
  if (Companion_instance_23 === VOID)
    new Companion_22();
  return Companion_instance_23;
}
function FFILib$resolvedPath$delegate$lambda(this$0) {
  return function () {
    var tmp = Companion_getInstance_27();
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this$0.a1q_1;
    var tmp$ret$0 = copyToArray(this_0);
    return tmp.p1q(tmp$ret$0.slice());
  };
}
var Companion_instance_24;
function Companion_getInstance_25() {
  if (Companion_instance_24 === VOID)
    new Companion_23();
  return Companion_instance_24;
}
function setFFIPointer(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  if (get_FFI_POINTER_SIZE() === 8) {
    set64(_this__u8e3s4, get_address(value), byteOffset);
  } else {
    set32(_this__u8e3s4, get_address(value).b2(), byteOffset);
  }
}
function _get_vlist__9y3qo3($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, $this.d1());
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.ffi.FFIPointerArray.<get-vlist>.<anonymous>' call
    var tmp$ret$0 = $this.f1(item);
    destination.g(tmp$ret$0);
  }
  return destination;
}
function resolvedPath$factory() {
  return getPropertyCallableRef('resolvedPath', 1, KProperty1, function (receiver) {
    return receiver.r1q();
  }, null);
}
function file(_this__u8e3s4, fullPath) {
  return new FFISyncIOFile(_this__u8e3s4, fullPath);
}
var Companion_instance_25;
function Companion_getInstance_26() {
  if (Companion_instance_25 === VOID)
    new Companion_24();
  return Companion_instance_25;
}
function _get_libFoldersInitializeOnce__sla0ii($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.r1r_1;
  libFoldersInitializeOnce$factory();
  return this_0.h3();
}
function loadConfFile($this, file_0) {
  if ($this.q1r_1.p2(file_0))
    return Unit_instance;
  $this.q1r_1.g(file_0);
  var _iterator__ex2g4s = lines(file_0.k1r()).a1();
  $l$loop: while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.takeIf' call
    // Inline function 'kotlin.text.trim' call
    var tmp$ret$0 = toString(trim(isCharSequence(line) ? line : THROW_CCE()));
    var this_0 = substringBefore(tmp$ret$0, _Char___init__impl__6a9atx(35));
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.ffi.LDLibraries.loadConfFile.<anonymous>' call
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_0) > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tline = tmp_0;
    if (startsWith(tline, 'include ')) {
      var glob = removePrefix(tline, 'include ');
      var fullFile = file($this.o1r_1, glob);
      var globFolder = fullFile.f1r();
      var globPattern = Regex.wg('^' + replace(replace(replace(fullFile.k3(), '.', '\\.'), '*', '.*'), '?', '.') + '$');
      if (globFolder.i1r()) {
        var _iterator__ex2g4s_0 = globFolder.m1r().a1();
        while (_iterator__ex2g4s_0.b1()) {
          var item = _iterator__ex2g4s_0.c1();
          if (globPattern.xg(item.k3())) {
            loadConfFile($this, item);
          }
        }
      }
    } else {
      $this.t1r(tline);
    }
  }
}
function LDLibraries$libFoldersInitializeOnce$delegate$lambda(this$0) {
  return function () {
    var tmp;
    try {
      this$0.t1r('/lib');
      this$0.t1r('/usr/lib');
      loadConfFile(this$0, file(this$0.o1r_1, '/etc/ld.so.conf'));
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return this$0.p1r_1;
  };
}
function libFoldersInitializeOnce$factory() {
  return getPropertyCallableRef('libFoldersInitializeOnce', 1, KProperty1, function (receiver) {
    return _get_libFoldersInitializeOnce__sla0ii(receiver);
  }, null);
}
var Companion_instance_26;
function Companion_getInstance_27() {
  if (Companion_instance_26 === VOID)
    new Companion_25();
  return Companion_instance_26;
}
function LibraryResolver$ldLibraries$delegate$lambda(this$0) {
  return function () {
    return new LDLibraries(this$0.m1q_1);
  };
}
function LibraryResolver$resolve$lambda($name) {
  return function (folder) {
    var tries = listOf_0(['lib' + $name + '.so', $name]);
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var tmp0_iterator = tries.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.takeIf' call
        var this_0 = folder.l1i(element);
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>.<anonymous>.<anonymous>' call
        if (this_0.g1r()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var result = tmp;
        if (!(result == null)) {
          tmp$ret$3 = result;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp195_safe_receiver = tmp$ret$3;
    return tmp195_safe_receiver == null ? null : tmp195_safe_receiver.d1r_1;
  };
}
function LibraryResolver$resolve$lambda_0($name) {
  return function (folder) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = folder.m1r().a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>.<anonymous>' call
        if (startsWith(element.k3(), 'lib' + $name) || startsWith(element.k3(), $name)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp196_safe_receiver = tmp$ret$1;
    return tmp196_safe_receiver == null ? null : tmp196_safe_receiver.d1r_1;
  };
}
function ldLibraries$factory() {
  return getPropertyCallableRef('ldLibraries', 1, KProperty1, function (receiver) {
    return receiver.u1r();
  }, null);
}
function get_FFI_POINTER_SIZE() {
  _init_properties_FFILib_js_kt__tqmrqh();
  return FFI_POINTER_SIZE;
}
var FFI_POINTER_SIZE;
function get_FFI_SUPPORTED() {
  _init_properties_FFILib_js_kt__tqmrqh();
  return FFI_SUPPORTED;
}
var FFI_SUPPORTED;
function FFILibSym_0(lib) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new FFILibSymJS(lib);
}
function set32(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  return getDataView(_this__u8e3s4, byteOffset, 4).setInt32(0, value, true);
}
function getS32(_this__u8e3s4, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  return (new Deno.UnsafePointerView(_this__u8e3s4.k1s_1)).getInt32(byteOffset);
}
function CreateFFIPointer(ptr) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return ptr.equals(new Long(0, 0)) ? null : get_pointer_0(Deno.UnsafePointer.create(toJsBigInt(ptr)));
}
function set64(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  set32(_this__u8e3s4, get__low(value), byteOffset);
  set32(_this__u8e3s4, get__high(value), byteOffset + 4 | 0);
}
function get_address(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var tmp = Deno.UnsafePointer;
  var res = tmp.value(_this__u8e3s4 == null ? null : _this__u8e3s4.k1s_1);
  var tmp_0;
  if (isNumber(res)) {
    tmp_0 = numberToLong(res);
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp_0 = toLong_0(res);
  }
  return tmp_0;
}
function getDataView(_this__u8e3s4, offset, size) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new DataView((new Deno.UnsafePointerView(_this__u8e3s4.k1s_1)).getArrayBuffer(size, offset));
}
function FFILibSymJS$symbolsByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.l1s_1.d1q_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.pb(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.FFILibSymJS.symbolsByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.m1p_1;
      destination.x2(tmp$ret$0, element);
    }
    return destination;
  };
}
function FFILibSymJS$dylib$delegate$lambda(this$0) {
  return function () {
    var tmp = this$0.l1s_1;
    if (!(tmp instanceof FFILib))
      THROW_CCE();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$5;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var tmp0_iterator = plus_1(listOfNotNull(this$0.l1s_1.r1q()), this$0.l1s_1.a1q_1).a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.ffi.FFILibSymJS.dylib$delegate.<anonymous>.<anonymous>' call
        var tmp_0;
        try {
          var tmp_1 = Deno;
          // Inline function 'kotlin.collections.toTypedArray' call
          // Inline function 'kotlin.collections.map' call
          var this_0 = this$0.l1s_1.d1q_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
          var tmp0_iterator_0 = this_0.a1();
          while (tmp0_iterator_0.b1()) {
            var item = tmp0_iterator_0.c1();
            // Inline function 'korlibs.ffi.FFILibSymJS.dylib$delegate.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$0 = to(item.m1p_1, funcToDenoDef(item.o1p_1));
            destination.g(tmp$ret$0);
          }
          var tmp$ret$3 = copyToArray(destination);
          tmp_0 = tmp_1.dlopen(element, jsObject(tmp$ret$3.slice()));
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_2;
        }
        var result = tmp_0;
        if (!(result == null)) {
          tmp$ret$5 = result;
          break $l$block;
        }
      }
      tmp$ret$5 = null;
    }
    // Inline function 'kotlin.js.asDynamic' call
    var this_1 = tmp$ret$5;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.ffi.FFILibSymJS.dylib$delegate.<anonymous>.<anonymous>' call
    if (this_1 == null) {
      println("Couldn't load library: dymlib=" + toString_0(this_1) + ' : ' + this$0.l1s_1.r1q());
    }
    return this_1;
  };
}
function FFILibSymJS$syms$delegate$lambda(this$0) {
  return function () {
    var tmp57_safe_receiver = this$0.q1s();
    return tmp57_safe_receiver == null ? null : tmp57_safe_receiver.symbols;
  };
}
function funcToDenoDef(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var ftype = Companion_getInstance_24().k1p(_this__u8e3s4);
  var tmp50_safe_receiver = ftype.w1p_1;
  var tmp = tmp50_safe_receiver == null ? null : toDenoFFI(tmp50_safe_receiver, true);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = ftype.v1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.ffi.funcToDenoDef.<anonymous>' call
    var tmp$ret$0 = item == null ? null : toDenoFFI(item, false);
    destination.g(tmp$ret$0);
  }
  var tmp$ret$3 = copyToArray(destination);
  return def(tmp, tmp$ret$3.slice(), equals(ftype.y1p_1, getKClass(Deferred)));
}
function preprocessFunc(type, func, name, config) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var ftype = Companion_getInstance_24().k1p(type);
  var convertToString = equals(ftype.y1p_1, PrimitiveClasses_getInstance().nf());
  var retPointer = equals(ftype.y1p_1, getKClass(DenoPointer));
  return preprocessFunc$lambda(ftype, func, convertToString, retPointer, name, type);
}
function def(result, params, nonblocking) {
  nonblocking = nonblocking === VOID ? false : nonblocking;
  _init_properties_FFILib_js_kt__tqmrqh();
  return jsObject([to('parameters', params), to('result', result), to('nonblocking', nonblocking)]);
}
function toDenoFFI(_this__u8e3s4, ret) {
  _init_properties_FFILib_js_kt__tqmrqh();
  if (equals(_this__u8e3s4.bf(), getKClass(Deferred))) {
    var tmp52_safe_receiver = first(_this__u8e3s4.cf()).gn_1;
    var tmp53_safe_receiver = tmp52_safe_receiver == null ? null : tmp52_safe_receiver.bf();
    return tmp53_safe_receiver == null ? null : toDenoFFI_0(tmp53_safe_receiver, ret);
  } else {
    var tmp55_safe_receiver = _this__u8e3s4 == null ? null : _this__u8e3s4.bf();
    return tmp55_safe_receiver == null ? null : toDenoFFI_0(tmp55_safe_receiver, ret);
  }
}
function getCString(ptr) {
  _init_properties_FFILib_js_kt__tqmrqh();
  if (ptr == null)
    return null;
  return Deno.UnsafePointerView.getCString(ptr.k1s_1);
}
function toDenoFFI_0(_this__u8e3s4, ret) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var tmp;
  if (equals(_this__u8e3s4, getKClass(Long))) {
    tmp = 'usize';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().jf())) {
    tmp = 'i32';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().kf())) {
    tmp = 'f32';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().lf())) {
    tmp = 'f64';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().gf())) {
    tmp = 'i8';
  } else if (equals(_this__u8e3s4, getKClass(NativeImageRef))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().rf())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().sf())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().qf())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().tf())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().vf())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().wf())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().pf())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(FFIPointerArray))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(Buffer))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(DenoPointer))) {
    tmp = 'pointer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().nf())) {
    tmp = ret ? 'pointer' : 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(Unit))) {
    tmp = 'void';
  } else {
    var reason = toString(_this__u8e3s4);
    throw NotImplementedError.cd('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function CreateFFIMemory(size) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new Uint8Array(size);
}
function get_pointer(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return get_pointer_0(Deno.UnsafePointer.of(new Int8Array(_this__u8e3s4.t1s_1.buffer, _this__u8e3s4.t1s_1.byteOffset, _this__u8e3s4.t1s_1.byteLength)));
}
function CreateFFIMemory_0(bytes) {
  _init_properties_FFILib_js_kt__tqmrqh();
  // Inline function 'kotlin.js.asDynamic' call
  return bytes;
}
function preprocessFunc$lambda($ftype, $func, $convertToString, $retPointer, $name, $type) {
  return function () {
    var arguments_0 = arguments;
    var params = $ftype.x1p_1;
    var inductionVariable = 0;
    var last = params.d1();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var param = params.f1(n);
        var v = arguments_0[n];
        if (equals(param, PrimitiveClasses_getInstance().nf())) {
          v = encodeToByteArray(toString(v) + '\x00');
        }
        if (v instanceof FFIPointerArray)
          v = v.a1r_1;
        if (v instanceof DenoPointer)
          v = v.k1s_1;
        if (v instanceof Buffer)
          v = v.t1s_1;
        if (!(v == null) ? typeof v === 'boolean' : false)
          v = v ? 1 : 0;
        if (v instanceof Long) {
          v = toJsBigInt(v instanceof Long ? v : THROW_CCE());
        }
        arguments_0[n] = v;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    var tmp_0;
    try {
      var result = $func.apply(null, arguments_0);
      var tmp_1;
      if (result == null) {
        tmp_1 = null;
      } else if ($convertToString) {
        // Inline function 'kotlin.js.unsafeCast' call
        var ptr = result;
        tmp_1 = getCString(get_pointer_0(ptr));
      } else if ($retPointer) {
        // Inline function 'kotlin.js.unsafeCast' call
        tmp_1 = get_pointer_0(result);
      } else {
        tmp_1 = result;
      }
      var res2 = tmp_1;
      var tmp_2;
      if (res2 instanceof Promise) {
        // Inline function 'kotlin.js.unsafeCast' call
        tmp_2 = asDeferred(res2);
      } else {
        tmp_2 = res2;
      }
      tmp_0 = tmp_2;
    } catch ($p) {
      var tmp_3;
      var e = $p;
      println('ERROR calling[' + $name + ']: ' + toString($type) + ' : ' + toString(toList_0(Array.from(arguments_0))));
      throw e;
    }
    return tmp_0;
  };
}
function symbolsByName$factory() {
  return getPropertyCallableRef('symbolsByName', 1, KProperty1, function (receiver) {
    return receiver.r1s();
  }, null);
}
function dylib$factory() {
  return getPropertyCallableRef('dylib', 1, KProperty1, function (receiver) {
    return receiver.q1s();
  }, null);
}
function syms$factory() {
  return getPropertyCallableRef('syms', 1, KProperty1, function (receiver) {
    return receiver.s1s();
  }, null);
}
var properties_initialized_FFILib_js_kt_88mj2t;
function _init_properties_FFILib_js_kt__tqmrqh() {
  if (!properties_initialized_FFILib_js_kt_88mj2t) {
    properties_initialized_FFILib_js_kt_88mj2t = true;
    FFI_POINTER_SIZE = 8;
    FFI_SUPPORTED = get_Deno_isDeno();
  }
}
function get_FFIPlatformSyncIO() {
  _init_properties_FFIPlatformSyncIO_js_kt__byepuc();
  return FFIPlatformSyncIO;
}
var FFIPlatformSyncIO;
var properties_initialized_FFIPlatformSyncIO_js_kt_sxp582;
function _init_properties_FFIPlatformSyncIO_js_kt__byepuc() {
  if (!properties_initialized_FFIPlatformSyncIO_js_kt_sxp582) {
    properties_initialized_FFIPlatformSyncIO_js_kt_sxp582 = true;
    var tmp;
    if (get_Deno_isDeno()) {
      tmp = new FFIPlatformSyncIO$1();
    } else {
      throw NotImplementedError.cd();
    }
    FFIPlatformSyncIO = tmp;
  }
}
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.u1s() <= 0.25;
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.f1t_1);
  $this.x1s_1 = Companion_instance_85.i1t(width, height);
  $this.d1t_1 = Bitmap32.z1t(width, height, VOID, $this.z1s_1);
  $this.e1t_1.z2();
  $this.e1t_1.g($this.d1t_1);
  $this.g1t_1.z2();
  $this.f1t_1.z2();
  var _iterator__ex2g4s = slices.a1();
  while (_iterator__ex2g4s.b1()) {
    var entry = _iterator__ex2g4s.c1();
    $this.b1v(entry.v1s_1, entry.w1s_1, entry.v1s_1.e1u_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.b1t_1.j3_1) {
    case 0:
      reconstructWithSize($this, imul($this.h1j(), 2), imul($this.i1j(), 2));
      break;
    case 1:
      if (bmp.j1u_1 > $this.h1j() || bmp.k1u_1 > $this.i1j()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.h1j() + 'x' + $this.i1j() + ') to hold a slice of (' + bmp.j1u_1 + 'x' + bmp.k1u_1 + ')';
        throw IllegalStateException.n4(toString(message));
      }

      $this.x1s_1 = Companion_instance_85.i1t($this.h1j(), $this.i1j());
      $this.d1t_1 = Bitmap32.z1t($this.h1j(), $this.i1j(), VOID, $this.z1s_1);
      $this.e1t_1.g($this.d1t_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.d1i_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.c1i();
    var tmp101_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp101_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.d1i_1;
      tmp_0 = tmp101_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.e1i_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.d1i_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.d1i_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.d1i_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.c1i();
    var tmp101_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp101_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.d1i_1;
      tmp_0 = tmp101_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.e1i_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.d1i_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.d1i_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.d1v_1, 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.g1w(x, y, width, height, out, 0);
  return out;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.j1v_1 = true;
  _this__u8e3s4.k1v_1 = true;
  return _this__u8e3s4;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.y1v();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8_2($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.c1x_1.b1w();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.pk(new RGBA($this.c1x_1.d1x(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_27;
function Companion_getInstance_28() {
  if (Companion_instance_27 === VOID)
    new Companion_26();
  return Companion_instance_27;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.h1x($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).w1t_1);
  var width = _this__u8e3s4.q1x() - _this__u8e3s4.o1x() | 0;
  var inductionVariable = _this__u8e3s4.p1x();
  var last = _this__u8e3s4.r1x();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.c1w(_this__u8e3s4.o1x(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.o1x() + ', top=' + _this__u8e3s4.p1x() + ', right=' + _this__u8e3s4.q1x() + ', bottom=' + _this__u8e3s4.r1x();
        throw IllegalStateException.n4(toString(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.p1x(), area.o1x(), area.r1x(), area.q1x(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.w1t_1;
  var x0Index = _this__u8e3s4.c1w(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.c1w(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.d1v_1 | 0;
      x1Index = x1Index + _this__u8e3s4.d1v_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy_1(data, _this__u8e3s4.c1w(x, areaTop), data, _this__u8e3s4.c1w(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy_1(data, _this__u8e3s4.c1w(x, areaBottom - 1 | 0), data, _this__u8e3s4.c1w(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_28;
function Companion_getInstance_29() {
  return Companion_instance_28;
}
function get_bounds(_this__u8e3s4) {
  return _this__u8e3s4.b1u_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.x1z();
}
function slice(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.u1v(0, 0, _this__u8e3s4.d1v_1, _this__u8e3s4.e1v_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_88().a20_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_72().j20_1 : padding;
  var left = clamp(bounds.o1x(), 0, _this__u8e3s4.d1v_1);
  var top = clamp(bounds.p1x(), 0, _this__u8e3s4.e1v_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_77.k20(left, top, clamp(bounds.q1x(), left, _this__u8e3s4.d1v_1), clamp(bounds.r1x(), top, _this__u8e3s4.e1v_1)), orientation, padding, name);
}
function extract(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.c1u_1) ? _this__u8e3s4.b1u_1.s1v_1 : _this__u8e3s4.b1u_1.t1v_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.c1u_1) ? _this__u8e3s4.b1u_1.t1v_1 : _this__u8e3s4.b1u_1.s1v_1;
  var tmp = get_container(_this__u8e3s4).z1w(w + _this__u8e3s4.d1u_1.p20() | 0, h + _this__u8e3s4.d1u_1.q20() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).y1w(_this__u8e3s4.c1u_1);
  raw.q1w(0, 0, out, _this__u8e3s4.d1u_1.o20_1, _this__u8e3s4.d1u_1.l20_1, raw.d1v_1, raw.e1v_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_88().a20_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_72().j20_1 : padding;
  return slice(_this__u8e3s4, RectangleInt.u1v(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).z1w(_this__u8e3s4.b1u_1.s1v_1, _this__u8e3s4.b1u_1.t1v_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).n1w(_this__u8e3s4.b1u_1.q1v_1, _this__u8e3s4.b1u_1.r1v_1, out, 0, 0, _this__u8e3s4.b1u_1.s1v_1, _this__u8e3s4.b1u_1.t1v_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice(Companion_getInstance_28().f1x(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().w20_1)), VOID, 'transparent');
    Bitmaps_white = slice(Companion_getInstance_28().f1x(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().r20_1)), VOID, 'white');
  }
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().y26(width, height, premultiplied);
}
var Companion_instance_29;
function Companion_getInstance_30() {
  if (Companion_instance_29 === VOID)
    Companion_28.n27();
  return Companion_instance_29;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.c28()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.m('Unsupported bpp ' + _this__u8e3s4.c28());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_33().m28(_this__u8e3s4.d28(c), _this__u8e3s4.e28(c), _this__u8e3s4.f28(c), _this__u8e3s4.g28(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.c28() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE_0(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE_0(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var Companion_instance_30;
function Companion_getInstance_31() {
  if (Companion_instance_30 === VOID)
    new Companion_29();
  return Companion_instance_30;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_31;
function Companion_getInstance_32() {
  return Companion_instance_31;
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.gb(9);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.bb(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.i29_1, other instanceof RGBA ? other.i29_1 : THROW_CCE());
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
var Companion_instance_32;
function Companion_getInstance_33() {
  if (Companion_instance_32 === VOID)
    new Companion_31();
  return Companion_instance_32;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.i29_1 : THROW_CCE())))
    return false;
  return true;
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().w20_1;
  } else {
    var ialpha = 255.0 / alpha;
    tmp = Companion_getInstance_33().m28(numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha), numberToInt(_RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha), numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha), alpha);
  }
  return tmp;
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  var outA = numberToInt(_RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf);
  var outR = numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf);
  var outG = numberToInt(_RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf);
  var outB = numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
var Companion_instance_33;
function Companion_getInstance_34() {
  return Companion_instance_33;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract(this$0.t29_1).a1x();
  };
}
var Companion_instance_34;
function Companion_getInstance_35() {
  return Companion_instance_34;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.k2a_1;
    var baseline = 0.0;
    var tmp = -this$0.p2a_1;
    var tmp_0 = -this$0.p2a_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.l2a_1.b3().a1();
    while (_iterator__ex2g4s.b1()) {
      var glyph = _iterator__ex2g4s.c1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.t29_1.j1u_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.i2a_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.l2a_1.f1(this$0.l2a_1.a3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.u2a() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.i2a_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.f2a();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.u2a();
  }, null);
}
var DefaultTtfFontOrNull;
var SystemFontRegistryOrNull;
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_35;
function Companion_getInstance_36() {
  DataFormat_initEntries();
  if (Companion_instance_35 === VOID)
    new Companion_34();
  return Companion_instance_35;
}
function values() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_36();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString(s, 2, Charsets_instance.y2b(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.n4(toString(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.z2b_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.k1a(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.j1a(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.c2c_1.b2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_36();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.f1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.z2b_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.k1a(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.w2b_1(nComponent);
          this_1.j1a(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact(s, dataFormat.w2b_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.z2b_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.k1a(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.j1a(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_88().a20_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_88().e20_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_88().c20_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_88().g20_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_88().h20_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_88().b20_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_88().f20_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_88().d20_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_88().a20_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.i2c());
}
function readExifBase$readInt(data, endian, index) {
  return getS32_0(data, imul(index, 4), endian.i2c());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.m2c_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.m2c_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
var Companion_instance_36;
function Companion_getInstance_37() {
  return Companion_instance_36;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.o2d()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.n2d().d1v_1, b.n2d().e1v_1), imul(b.n2d().f1v_1, b.n2d().f1v_1));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.o2d()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.n2d().d1v_1, a.n2d().e1v_1), imul(a.n2d().f1v_1, a.n2d().f1v_1));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
var tilesetBorder$delegate;
var Companion_instance_37;
function Companion_getInstance_38() {
  if (Companion_instance_37 === VOID)
    new Companion_36();
  return Companion_instance_37;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.z2e(tmp, props.v2e(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_38().c2e_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.u2e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.r2e();
  }, null);
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
    var s = openSync(data);
    var _iterator__ex2g4s = $this.o2f().a1();
    while (_iterator__ex2g4s.b1()) {
      var format = _iterator__ex2g4s.c1();
      if (format.h2f(sliceStart_0(s), props)) {
        // Inline function 'korlibs.image.format.ImageFormats.decodeSuspend.<anonymous>' call
        sliceStart_0(s);
        var tmp = format.j2f(data, props, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        tmp$ret$1 = tmp;
        break $l$block;
      }
    }
    throw UnsupportedOperationException.k9('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes_1(sliceStart_0(s), 4)) + ') (' + toString_3(readBytes_1(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
  }
  return tmp$ret$1;
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.j1();
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.o2f();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.s2f();
  }, function (receiver, value) {
    return receiver.r2f(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.s2f();
  }, function (receiver, value) {
    return receiver.r2f(value);
  });
}
var Companion_instance_38;
function Companion_getInstance_39() {
  return Companion_instance_38;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_39;
function Companion_getInstance_40() {
  Type_initEntries();
  if (Companion_instance_39 === VOID)
    new Companion_38();
  return Companion_instance_39;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_40();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.d1i_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.c1i();
    var tmp101_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp101_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.d1i_1;
      tmp_0 = tmp101_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.e1i_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.d1i_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.d1i_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.j2g_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.j2g_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.j2g_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.j2g_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_38().c2e_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_38().c2e_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.r2e(), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.k2g(result.b1x(), Unit_instance, name).v1s_1 : slice(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_38().c2e_1 : props;
  var prop = !(file == null) ? props.v2e(file) : props;
  var rformats = !prop.n2e_1 ? listOf(prop.o2e_1) : prop.o2e_1 == null ? listOf(null) : prop.m2e_1 ? listOf_0([prop.o2e_1, null]) : listOf_0([null, prop.o2e_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.a1();
  while (_iterator__ex2g4s.b1()) {
    var format = _iterator__ex2g4s.c1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.j2f(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.k2f(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.cd();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.j2e_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.k1a(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.j1a(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_38().c2e_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g(file, bytes, props, $completion), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.r2e(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_65().p1a('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, vfs, path, props, $completion) {
  var tmp = vfs.l2h(path).r2h($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.l2g(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme_0($this, data, props, $completion) {
  var tmp = $this.l2g(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.h2h_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.f2h(file.t2h(), file.e1r(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.h2h_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.g2h(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_40;
function Companion_getInstance_41() {
  Colorspace_initEntries();
  if (Companion_instance_40 === VOID)
    new Companion_39();
  return Companion_instance_40;
}
function values_0() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_41();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE_0(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.m('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE_0(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.s1d();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.m('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.g2i_1;
  var height = header.h2i_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.n2i_1);
  var databb = uncompress_0(pngdata.t1d(), Companion_getInstance_10());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.p2i_1.n2i_1;
  var row32 = context.s2i_1;
  var tmp_2;
  if (header.n2i_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
      var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_33().m28(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, item)));
      destination.g(tmp$ret$1);
    }
    tmp_2 = Bitmap8.t1y(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray(destination)));
  } else {
    tmp_2 = Bitmap32.z1t(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.m2i_1 === 1 ? $this.x2i_1 : $this.y2i_1;
  var _iterator__ex2g4s = passes.a1();
  while (_iterator__ex2g4s.b1()) {
    var pass = _iterator__ex2g4s.c1();
    var progression = step(until(pass.z2h_1, height), pass.b2i_1);
    var inductionVariable = progression.u1_1;
    var last = progression.v1_1;
    var step_0 = progression.w1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var col = pass.a2i_1;
        var colIncrement = pass.c2i_1;
        var pixelsInThisRow = width >>> pass.f2i_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.n2i_1), header.i2i_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.r2i_1;
        var lastRow = context.q2i_1;
        arraycopy_2(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.a2j(filter, lastRow, currentRow, header.n2i_1);
          switch (header.i2i_1) {
            case 1:
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < width)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract_0(UByteArrayInt__get_impl_px6q8a(currentRow, n / 8 | 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.l1w(x, y, color);
                }
                 while (inductionVariable_0 < width);
              break;
            case 2:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract_0(UByteArrayInt__get_impl_px6q8a(currentRow, n_0 / 4 | 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.l1w(x_0, y_0, color_0);
                }
                 while (inductionVariable_1 < width);
              break;
            case 4:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract_0(UByteArrayInt__get_impl_px6q8a(currentRow, n_1 / 2 | 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.l1w(x_1, y_1, color_1);
                }
                 while (inductionVariable_2 < width);
              break;
            case 8:
              bmp8.w1z(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.i2i_1;
              throw IllegalStateException.n4(toString(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.i2i_1 === 8) {
            $this.z2i(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_31(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_33(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.cd('An operation is not implemented: ' + reason);
            }
            bmp32.y1x(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.i2i_1;
            throw IllegalStateException.n4(toString(message_0));
          }
        }
        context.b2j();
      }
       while (!(row === last));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE_0(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream(_this__u8e3s4, toLong(length));
  var crc = readS32BE_0(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE_0(data);
      var tmp_0 = readS32BE_0(data);
      var tmp_1 = readU8_0(data);
      var tmp0_elvis_lhs = Companion_getInstance_41().y2h_1.f3(readU8_0(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8_0(data), readU8_0(data), readU8_0(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.e2f_1 = this_0.g2i_1;
      $info.f2f_1 = this_0.h2i_1;
      $info.g2f_1 = imul(this_0.i2i_1, this_0.j2i_1.x2h_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().b2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.x1f(asByteArray(rgbPalette), 0, data.a().b2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().b2();
      paletteCount._v = Math.max(a_0, b_0);
      data.x1f(asByteArray(aPalette), 0, data.a().b2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.k2j(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.n2j();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.a2g([PNG_getInstance()]);
  }
}
function f2i(v) {
  return toIntRound_0(clamp01(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.l2k(HtmlImage_instance.r2j(_this__u8e3s4.a1x()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_tempB() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return tempB;
}
var tempB;
function get_tempI() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return tempI;
}
var tempI;
function get_temp8() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return temp8;
}
var temp8;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  // Inline function 'kotlin.getValue' call
  var this_0 = isLittleEndian$delegate;
  isLittleEndian$factory();
  return this_0.h3();
}
var isLittleEndian$delegate;
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  var tmp = BrowserImage_instance.p2k(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.l2k(tmp));
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.v2k(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.w2k(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.u2k(path);
      var tmp_1 = BrowserImage_instance.v2k(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.w2k(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.l1i(path).q2k($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.p2k(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.l2k(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.h2k_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.h2k_1;
      tmp = tmp_0.x2k(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.h2k_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.h2k_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.y2k().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_101().q2j()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.n4(toString(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.d2l(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.e2l(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.f2l(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.bc(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.v9('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.bc(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function isLittleEndian$delegate$lambda() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  get_tempI()[0] = 1;
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  return get_temp8()[0] === 1;
}
function isLittleEndian$factory() {
  return getPropertyCallableRef('isLittleEndian', 0, KProperty0, function () {
    return get_isLittleEndian();
  }, null);
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.y2k();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.a2l();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_101().g2l() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_101().q2j() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    tempB = new ArrayBuffer(4);
    tempI = new Int32Array(get_tempB());
    temp8 = new Uint8Array(get_tempB());
    isLittleEndian$delegate = lazy(isLittleEndian$delegate$lambda);
  }
}
var Companion_instance_41;
function Companion_getInstance_42() {
  return Companion_instance_41;
}
var Companion_instance_42;
function Companion_getInstance_43() {
  return Companion_instance_42;
}
function injector($completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp618_safe_receiver = $completion.zb().mc(Companion_instance_42);
  var tmp0_elvis_lhs = tmp618_safe_receiver == null ? null : tmp618_safe_receiver.n2m_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Injector not in the context, please call withInjector function';
    throw IllegalStateException.n4(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_NullSystemFS() {
  _init_properties_SystemFS_kt__ntwqsk();
  return NullSystemFS;
}
var NullSystemFS;
var Companion_instance_43;
function Companion_getInstance_44() {
  if (Companion_instance_43 === VOID)
    new Companion_42();
  return Companion_instance_43;
}
function toAsync(_this__u8e3s4, ioDispatcher) {
  _init_properties_SystemFS_kt__ntwqsk();
  var sync = _this__u8e3s4;
  return new toAsync$1(ioDispatcher, sync);
}
var NullSyncSystemFS_instance;
function NullSyncSystemFS_getInstance() {
  return NullSyncSystemFS_instance;
}
var properties_initialized_SystemFS_kt_k4cs8u;
function _init_properties_SystemFS_kt__ntwqsk() {
  if (!properties_initialized_SystemFS_kt_k4cs8u) {
    properties_initialized_SystemFS_kt_k4cs8u = true;
    NullSystemFS = toAsync(NullSyncSystemFS_instance, Dispatchers_getInstance().lv_1);
  }
}
var defaultSyncSystemFS;
function get_defaultSystemFS() {
  _init_properties_SystemFS_js_kt__9f6y2x();
  return defaultSystemFS;
}
var defaultSystemFS;
var properties_initialized_SystemFS_js_kt_5tdsz9;
function _init_properties_SystemFS_js_kt__9f6y2x() {
  if (!properties_initialized_SystemFS_js_kt_5tdsz9) {
    properties_initialized_SystemFS_js_kt_5tdsz9 = true;
    defaultSyncSystemFS = NullSyncSystemFS_instance;
    defaultSystemFS = get_NullSystemFS();
  }
}
var Companion_instance_44;
function Companion_getInstance_45() {
  if (Companion_instance_44 === VOID)
    new Companion_43();
  return Companion_instance_44;
}
function get_defaultHttpFetch() {
  _init_properties_HttpRawFetch_js_kt__twfcvf();
  return defaultHttpFetch;
}
var defaultHttpFetch;
function *_generator_fetch__osg116($this, method, host, port, path, secure, headers, body, $completion) {
  var scheme = secure ? 'https' : 'http';
  var headersJsObj = {};
  var _iterator__ex2g4s = headers.a1();
  $l$loop_0: while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var key = _destruct__k2r9zo.jk();
    var value = _destruct__k2r9zo.kk();
    if (equals_0(key, 'connection', true))
      continue $l$loop_0;
    if (equals_0(key, 'content-length', true))
      continue $l$loop_0;
    headersJsObj[key] = value;
  }
  var url = scheme + '://' + host + ':' + port + path;
  var tmp = get_jsGlobalThis();
  // Inline function 'org.w3c.fetch.RequestInit' call
  var tmp_0;
  if (body == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = readAll(body, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var body_0 = tmp_0;
  var referrer = undefined;
  var referrerPolicy = undefined;
  var mode = undefined;
  var credentials = undefined;
  var cache = undefined;
  var redirect = undefined;
  var integrity = undefined;
  var keepalive = undefined;
  var window_0 = undefined;
  var o = {};
  o['method'] = method;
  o['headers'] = headersJsObj;
  o['body'] = body_0;
  o['referrer'] = referrer;
  o['referrerPolicy'] = referrerPolicy;
  o['mode'] = mode;
  o['credentials'] = credentials;
  o['cache'] = cache;
  o['redirect'] = redirect;
  o['integrity'] = integrity;
  o['keepalive'] = keepalive;
  o['window'] = window_0;
  var tmp_2 = await_0(tmp.fetch(url, o), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var result = tmp_2;
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp_3 = await_0(result.arrayBuffer(), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'kotlin.js.asDynamic' call
  var body_1 = asInt8Array(tmp_3);
  var rheaders = result.headers;
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp_4 = Array;
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var keys = tmp_4.from(rheaders.keys());
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.r(keys.length);
  var inductionVariable = 0;
  var last = keys.length;
  while (inductionVariable < last) {
    var item = keys[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.io.http.core.<no name provided>.fetch.<anonymous>' call
    var tmp$ret$6 = to(item, rheaders.get(item));
    destination.g(tmp$ret$6);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = toMutableList(destination);
  var destination_0 = ArrayList.j1();
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.io.http.core.<no name provided>.fetch.<anonymous>' call
    if (!equals_0(element.hk_1, 'content-encoding', true) && !equals_0(element.hk_1, 'transfer-encoding', true)) {
      destination_0.g(element);
    }
  }
  var outHeaders = destination_0;
  var tmp_5 = result.status;
  var tmp_6 = result.statusText;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return new HttpFetchResult(tmp_5, tmp_6, outHeaders, openAsync(body_1));
}
var properties_initialized_HttpRawFetch_js_kt_h8nx03;
function _init_properties_HttpRawFetch_js_kt__twfcvf() {
  if (!properties_initialized_HttpRawFetch_js_kt_h8nx03) {
    properties_initialized_HttpRawFetch_js_kt_h8nx03 = true;
    defaultHttpFetch = new defaultHttpFetch$1();
  }
}
function *_generator_write__x1694l_1($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return Unit_instance;
  if ($this.c2n_1) {
    // Inline function 'kotlin.error' call
    var message = 'Trying to write to a completed ' + $this.toString();
    throw IllegalStateException.n4(toString(message));
  }
  var tmp = $this.z2m_1.m13($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.b2n_1.j2n(buffer, offset, len);
  var tmp_0 = $this.a2n_1.i13(Unit_instance, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_read__qih2oe_0($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return len;
  if ($this.b2n_1.k2n() > 0) {
    return $this.b2n_1.x1f(buffer, offset, len);
  }
  var tmp = $this.z2m_1.i13(Unit_instance, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  while (!$this.c2n_1 && $this.b2n_1.k2n() === 0) {
    var tmp_0 = $this.a2n_1.m13($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  if ($this.c2n_1 && $this.b2n_1.k2n() === 0)
    return -1;
  return $this.b2n_1.x1f(buffer, offset, len);
}
function *_generator_close__nh2uv0_1($this, $completion) {
  $this.c2n_1 = true;
  var tmp = $this.a2n_1.i13(Unit_instance, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_45;
function Companion_getInstance_46() {
  return Companion_instance_45;
}
function *_generator_waitToWriteMore__u7wb0w($this, len, $completion) {
  if ($this.r2n_1.o2n_1 > $this.p2n_1) {
    while ($this.r2n_1.o2n_1 > (1 + ($this.p2n_1 / 2 | 0) | 0)) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance_0();
      var tmp$ret$0 = toDuration_0(1, DurationUnit_MILLISECONDS_getInstance());
      var tmp = delay(tmp$ret$0, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  }
  return Unit_instance;
}
function waitToWriteMore($this, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_waitToWriteMore__u7wb0w($this, len, $completion), $completion);
}
function *_generator_write__x1694l_2($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return Unit_instance;
  if ($this.s2n_1) {
    // Inline function 'kotlin.error' call
    var message = 'Trying to write to a completed ' + $this.toString();
    throw IllegalStateException.n4(toString(message));
  }
  var tmp = waitToWriteMore($this, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.r2n_1.t2n(buffer, offset, len);
  return Unit_instance;
}
function *_generator_read__qih2oe_1($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return 0;
  if (offset < 0 || (offset + len | 0) > buffer.length)
    throw OutOfBoundsException.w2n();
  $l$loop: while (true) {
    var out = $this.r2n_1.x1f(buffer, offset, len);
    if (out <= 0 && !$this.s2n_1) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance_0();
      var tmp$ret$0 = toDuration_0(1, DurationUnit_MILLISECONDS_getInstance());
      var tmp = delay(tmp$ret$0, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      continue $l$loop;
    }
    return out;
  }
}
var EMPTY_BYTE_ARRAY;
function toAsync_0(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$1_0(_this__u8e3s4, dispatcher);
}
function toAsync_1(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$2(_this__u8e3s4, dispatcher);
}
function *_generator_write__x1694l_3($this, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.y2n_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$write$slambda_0($this, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    $this.x2n_1.t2n(buffer, offset, len);
    tmp = Unit_instance;
  }
  return Unit_instance;
}
function toAsync$o$write$slambda_0(this$0, $buffer, $offset, $len) {
  var i = new toAsync$o$write$slambda(this$0, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.r17($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$close$slambda_1(this$0) {
  var i = new toAsync$o$close$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.r17($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_read__qih2oe_2($this, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.f2o_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$read$slambda_0($this, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
    tmp = $this.e2o_1.x1f(buffer, offset, len);
  }
  return tmp;
}
function *_generator_getPosition__nbsewl($this, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.f2o_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$getPosition$slambda_0($this), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.getPosition.<anonymous>' call
    var tmp_1 = $this.e2o_1;
    var tmp632_safe_receiver = isInterface(tmp_1, SyncPositionStream) ? tmp_1 : null;
    tmp = tmp632_safe_receiver == null ? null : tmp632_safe_receiver.g2o();
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var tmp_3 = getPosition.call($this, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function *_generator_getLength__lvva94_0($this, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.f2o_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$getLength$slambda_0($this), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.getLength.<anonymous>' call
    var tmp_1 = $this.e2o_1;
    var tmp633_safe_receiver = isInterface(tmp_1, SyncLengthStream) ? tmp_1 : null;
    tmp = tmp633_safe_receiver == null ? null : tmp633_safe_receiver.a();
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var tmp_3 = getLength.call($this, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function toAsync$o$read$slambda_0(this$0, $buffer, $offset, $len) {
  var i = new toAsync$o$read$slambda(this$0, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.r17($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$close$slambda_2(this$0) {
  var i = new toAsync$o$close$slambda_0(this$0);
  var l = function ($this$launch, $completion) {
    return i.r17($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$getPosition$slambda_0(this$0) {
  var i = new toAsync$o$getPosition$slambda(this$0);
  var l = function ($this$withContext, $completion) {
    return i.r17($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$getLength$slambda_0(this$0) {
  var i = new toAsync$o$getLength$slambda(this$0);
  var l = function ($this$withContext, $completion) {
    return i.r17($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_SyncAsync_ext_kt_cwobuk;
function _init_properties_SyncAsync_ext_kt__inwu1q() {
  if (!properties_initialized_SyncAsync_ext_kt_cwobuk) {
    properties_initialized_SyncAsync_ext_kt_cwobuk = true;
    EMPTY_BYTE_ARRAY = new Int8Array(0);
  }
}
function *_generator_readS32LE__lo1d8f(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var tmp = _this__u8e3s4.u1f(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.n4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readS32LE.<anonymous>' call
  return getS32LE(it, 0);
}
function readS32LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32LE__lo1d8f(_this__u8e3s4, $completion), $completion);
}
function *_generator_readString__6uahun(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  var tmp = readBytesExact(_this__u8e3s4, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_3(tmp, charset);
}
function readString(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readString__6uahun(_this__u8e3s4, len, charset, $completion), $completion);
}
function *_generator_readLine__gnpvha(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion) {
  eol = eol === VOID ? _Char___init__impl__6a9atx(10) : eol;
  charset = charset === VOID ? get_UTF8() : charset;
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(eol);
  var tmp = readUntil(_this__u8e3s4, toByte(tmp$ret$0), limit, initialCapacity, includeEnd, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_3(tmp, charset);
}
function readLine(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion) {
  eol = eol === VOID ? _Char___init__impl__6a9atx(10) : eol;
  charset = charset === VOID ? get_UTF8() : charset;
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readLine__gnpvha(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion), $completion);
}
function *_generator_readU16BE__ml3dd9(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var tmp = _this__u8e3s4.u1f(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.n4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readU16BE.<anonymous>' call
  return getU16BE_0(it, 0);
}
function readU16BE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16BE__ml3dd9(_this__u8e3s4, $completion), $completion);
}
function *_generator_readS32BE__lo15th(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var tmp = _this__u8e3s4.u1f(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.n4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readS32BE.<anonymous>' call
  return getS32BE(it, 0);
}
function readS32BE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32BE__lo15th(_this__u8e3s4, $completion), $completion);
}
function *_generator_readU16__9pf7bk(_this__u8e3s4, endian, $completion) {
  var tmp;
  if (endian.equals(Endian_LITTLE_ENDIAN_getInstance())) {
    var tmp_0 = readU16LE(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = readU16BE(_this__u8e3s4, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function readU16(_this__u8e3s4, endian, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16__9pf7bk(_this__u8e3s4, endian, $completion), $completion);
}
function *_generator_readS32__9pdyqg(_this__u8e3s4, endian, $completion) {
  var tmp;
  if (endian.equals(Endian_LITTLE_ENDIAN_getInstance())) {
    var tmp_0 = readS32LE(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = readS32BE(_this__u8e3s4, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function readS32(_this__u8e3s4, endian, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32__9pdyqg(_this__u8e3s4, endian, $completion), $completion);
}
function *_generator_readStringz__10au0x(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  var tmp = readBytesExact(_this__u8e3s4, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var res = tmp;
  var index = indexOf(res, 0);
  return toString_3(copyOf_2(res, index < 0 ? len : index), charset);
}
function readStringz(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readStringz__10au0x(_this__u8e3s4, len, charset, $completion), $completion);
}
function *_generator_readUntil__njr8lo(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion) {
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  temp = temp === VOID ? new Int8Array(1) : temp;
  var out = ByteArrayBuilder.s1d(initialCapacity);
  try {
    $l$loop_0: while (true) {
      var tmp = readExact(_this__u8e3s4, temp, 0, 1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var c = temp[0];
      if (c === endByte) {
        if (includeEnd) {
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          out.c1d(c);
        }
        break $l$loop_0;
      }
      // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
      out.c1d(c);
      if (out.d1() >= limit)
        break $l$loop_0;
    }
  } catch ($p) {
    if ($p instanceof EOFException) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return out.t1d();
}
function readUntil(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion) {
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  temp = temp === VOID ? new Int8Array(1) : temp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readUntil__njr8lo(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion), $completion);
}
function *_generator_readU16LE__ml3ks7(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var tmp = _this__u8e3s4.u1f(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.n4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readU16LE.<anonymous>' call
  return getU16LE_0(it, 0);
}
function readU16LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16LE__ml3ks7(_this__u8e3s4, $completion), $completion);
}
function skipToAlign(_this__u8e3s4, alignment, offset) {
  var tmp = _this__u8e3s4;
  // Inline function 'kotlin.Long.minus' call
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = _this__u8e3s4.c2c_1.q3(toLong(offset));
  tmp.c2c_1 = nextAlignedTo_0(tmp$ret$0, toLong(alignment)).q1(toLong(offset));
}
function *_generator_readBytes__epy2u7(_this__u8e3s4, position, count, $completion) {
  var out = new Int8Array(count);
  var tmp = _this__u8e3s4.o2o(position, out, 0, out.length, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var readLen = tmp;
  return copyOf_2(out, readLen);
}
function readBytes_0(_this__u8e3s4, position, count, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytes__epy2u7(_this__u8e3s4, position, count, $completion), $completion);
}
function sliceWithSize_0(_this__u8e3s4, start, length, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return sliceWithBounds(_this__u8e3s4, start, start.q3(length), closeParent, $completion);
}
function *_generator_sliceWithBounds__ahw9dz(_this__u8e3s4, start, end, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp;
  var tmp_0 = _this__u8e3s4.h1f($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = _this__u8e3s4.i1f($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  } else {
    tmp = end;
  }
  var rlen = tmp;
  var len = rlen.p1(new Long(0, 0)) >= 0 ? rlen : end;
  var clampedStart = coerceIn(start, new Long(0, 0), len);
  var clampedEnd = coerceIn(end, new Long(0, 0), len);
  var base = _this__u8e3s4.b2c_1;
  var tmp_2;
  if (base instanceof SliceAsyncStreamBase) {
    tmp_2 = SliceAsyncStreamBase.u2o(base.p2o_1, base.q2o_1.q3(clampedStart), base.q2o_1.q3(clampedEnd), closeParent);
  } else {
    tmp_2 = SliceAsyncStreamBase.u2o(_this__u8e3s4.b2c_1, clampedStart, clampedEnd, closeParent);
  }
  return toAsyncStream(tmp_2);
}
function sliceWithBounds(_this__u8e3s4, start, end, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceWithBounds__ahw9dz(_this__u8e3s4, start, end, closeParent, $completion), $completion);
}
function clampPosition($this, position) {
  return coerceIn(position, $this.q2o_1, $this.r2o_1);
}
function clampPositionLen($this, position, len) {
  if (position.p1(new Long(0, 0)) < 0)
    throw IllegalArgumentException.m('Invalid position');
  var targetStartPosition = clampPosition($this, $this.q2o_1.q3(position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = targetStartPosition.q3(toLong(len));
  var targetEndPosition = clampPosition($this, tmp$ret$0);
  var targetLen = targetEndPosition.q1(targetStartPosition).b2();
  return new Pair(targetStartPosition, targetLen);
}
function *_generator_close__nh2uv0_2($this, $completion) {
  if ($this.s2o_1) {
    var tmp = $this.p2o_1.y1e($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_sliceStart__7mxlrc(_this__u8e3s4, start, closeParent, $completion) {
  start = start === VOID ? new Long(0, 0) : start;
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp = _this__u8e3s4.i1f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = sliceWithBounds(_this__u8e3s4, start, tmp, closeParent, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function sliceStart(_this__u8e3s4, start, closeParent, $completion) {
  start = start === VOID ? new Long(0, 0) : start;
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceStart__7mxlrc(_this__u8e3s4, start, closeParent, $completion), $completion);
}
function *_generator_sliceHere__xy500i(_this__u8e3s4, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp = _this__u8e3s4.c2c_1;
  var tmp_0 = _this__u8e3s4.i1f($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = sliceWithSize_0(_this__u8e3s4, tmp, tmp_0, closeParent, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function sliceHere(_this__u8e3s4, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceHere__xy500i(_this__u8e3s4, closeParent, $completion), $completion);
}
function buffered(_this__u8e3s4, blockSize, blocksToRead) {
  blockSize = blockSize === VOID ? 2048 : blockSize;
  blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
  return toAsyncStream(BufferedStreamBase.d2p(_this__u8e3s4.b2c_1, blockSize, blocksToRead), _this__u8e3s4.c2c_1);
}
function *_generator__read__lo0dlr($this, position, buffer, offset, len, $completion) {
  var tmp;
  var tmp_0 = $this.x2o_1.h1f($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = $this.x2o_1.i1f($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = position.p1(tmp_1) >= 0;
  } else {
    tmp = false;
  }
  if (tmp)
    return -1;
  // Inline function 'kotlin.Long.div' call
  var other = $this.a2p_1;
  var sector = position.s3(toLong(other));
  if (!$this.c2p_1.equals(sector)) {
    // Inline function 'kotlin.Long.times' call
    var other_0 = $this.a2p_1;
    var pos = sector.r3(toLong(other_0));
    var tmp_2;
    var tmp_3 = $this.x2o_1.h1f($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    if (tmp_3) {
      // Inline function 'kotlin.comparisons.minOf' call
      var a = toLong($this.a2p_1);
      var tmp_4 = $this.x2o_1.i1f($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var b = tmp_4.q1(pos);
      tmp_2 = (a.p1(b) <= 0 ? a : b).b2();
    } else {
      tmp_2 = $this.a2p_1;
    }
    var len_0 = tmp_2;
    var tmp_5 = $this;
    var tmp_6 = readBytes_0($this.x2o_1, pos, len_0, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    tmp_5.b2p_1 = tmp_6;
    $this.c2p_1 = sector;
  }
  // Inline function 'kotlin.Long.rem' call
  var other_1 = $this.a2p_1;
  var soffset = position.t3(toLong(other_1)).b2();
  var available = $this.b2p_1.length - soffset | 0;
  // Inline function 'kotlin.math.min' call
  var toRead = Math.min(available, len);
  arraycopy_2($this.b2p_1, soffset, buffer, offset, toRead);
  return toRead;
}
function *_generator_write__x1694l_4($this, position, buffer, offset, len, $completion) {
  var tmp = $this.x2o_1.w2o(position, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function openAsync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return toAsyncStream(MemoryAsyncStreamBase.h2p(ByteArrayBuilder.f2p(_this__u8e3s4, VOID, true)), new Long(0, 0));
}
function *_generator_read__qih2oe_3($this, buffer, offset, len, $completion) {
  var tmp;
  if ($this.d2c_1) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = $this.e2c_1;
    var tmp_0 = this_0.f16(null, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1;
    try {
      // Inline function 'korlibs.io.stream.AsyncStream.read.<anonymous>' call
      var tmp_2 = readInternal($this, buffer, offset, len, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1 = tmp_2;
    }finally {
      this_0.q15(null);
    }
    tmp = tmp_1;
  } else {
    var tmp_3 = readInternal($this, buffer, offset, len, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  }
  return tmp;
}
function *_generator_write__x1694l_5($this, buffer, offset, len, $completion) {
  if ($this.d2c_1) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = $this.f2c_1;
    var tmp = this_0.f16(null, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0;
    try {
      var tmp_1 = writeInternal($this, buffer, offset, len, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = Unit_instance;
    }finally {
      this_0.q15(null);
    }
  } else {
    var tmp_2 = writeInternal($this, buffer, offset, len, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function *_generator_readInternal__sbpouj($this, buffer, offset, len, $completion) {
  var tmp = $this.b2c_1.o2o($this.c2c_1, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (read >= 0) {
    var tmp_0 = $this;
    // Inline function 'kotlin.Long.plus' call
    tmp_0.c2c_1 = $this.c2c_1.q3(toLong(read));
  }
  return read;
}
function readInternal($this, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readInternal__sbpouj($this, buffer, offset, len, $completion), $completion);
}
function *_generator_writeInternal__u35gg8($this, buffer, offset, len, $completion) {
  var tmp = $this.b2c_1.w2o($this.c2c_1, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this;
  // Inline function 'kotlin.Long.plus' call
  tmp_0.c2c_1 = $this.c2c_1.q3(toLong(len));
  return Unit_instance;
}
function writeInternal($this, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_writeInternal__u35gg8($this, buffer, offset, len, $completion), $completion);
}
function *_generator_readBytesUpTo__nh3xxl(_this__u8e3s4, len, $completion) {
  var BYTES_TEMP_SIZE = 4096;
  if (len <= BYTES_TEMP_SIZE) {
    var tmp = readBytesUpToCopy(_this__u8e3s4, new Int8Array(len), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    return tmp;
  }
  if (isInterface(_this__u8e3s4, AsyncPositionLengthStream)) {
    // Inline function 'kotlin.math.min' call
    var tmp_0 = _this__u8e3s4.n2p($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var b = toIntClamp(tmp_0);
    var tmp$ret$0 = Math.min(len, b);
    var tmp_1 = readBytesUpToCopy(_this__u8e3s4, new Int8Array(tmp$ret$0), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    return tmp_1;
  }
  var pending = len;
  var temp = new Int8Array(BYTES_TEMP_SIZE);
  var bout = ByteArrayBuilder.s1d();
  $l$loop: while (pending > 0) {
    // Inline function 'kotlin.math.min' call
    var a = temp.length;
    var b_0 = pending;
    var tmp$ret$1 = Math.min(a, b_0);
    var tmp_2 = _this__u8e3s4.u1f(temp, 0, tmp$ret$1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var read = tmp_2;
    if (read <= 0)
      break $l$loop;
    bout.d1d(temp, 0, read);
    pending = pending - read | 0;
  }
  return bout.t1d();
}
function readBytesUpTo(_this__u8e3s4, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpTo__nh3xxl(_this__u8e3s4, len, $completion), $completion);
}
function *_generator_readBytesExact__9z65vi(_this__u8e3s4, len, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = new Int8Array(len);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.readBytesExact.<anonymous>' call
  var tmp = readExact(_this__u8e3s4, this_0, 0, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function readBytesExact(_this__u8e3s4, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesExact__9z65vi(_this__u8e3s4, len, $completion), $completion);
}
function *_generator_hasLength__5f5ox8_0($this, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.i1f($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0.p1(new Long(0, 0)) >= 0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof UnsupportedOperationException) {
      var t = $p;
      tmp_1 = false;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_readAll__9p3omh(_this__u8e3s4, $completion) {
  var tmp;
  try {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (isInterface(_this__u8e3s4, AsyncGetPositionStream)) {
      tmp_2 = isInterface(_this__u8e3s4, AsyncGetLengthStream);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp_3 = _this__u8e3s4.h1f($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      tmp_1 = tmp_3;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp_4 = _this__u8e3s4.i1f($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var tmp_5 = _this__u8e3s4.b1g($completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      var available = tmp_4.q1(tmp_5);
      var tmp_6 = readBytesExact(_this__u8e3s4, available.b2(), $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      tmp_0 = tmp_6;
    } else {
      var tmp_7;
      if (_this__u8e3s4 instanceof AsyncStream) {
        var tmp_8 = _this__u8e3s4.m2p($completion);
        if (tmp_8 === get_COROUTINE_SUSPENDED())
          tmp_8 = yield tmp_8;
        tmp_7 = tmp_8;
      } else {
        tmp_7 = false;
      }
      if (tmp_7) {
        var tmp_9 = _this__u8e3s4.n2p($completion);
        if (tmp_9 === get_COROUTINE_SUSPENDED())
          tmp_9 = yield tmp_9;
        var available_0 = tmp_9.b2();
        var tmp_10 = readBytesExact(_this__u8e3s4, available_0, $completion);
        if (tmp_10 === get_COROUTINE_SUSPENDED())
          tmp_10 = yield tmp_10;
        tmp_0 = tmp_10;
      } else {
        var out = ByteArrayBuilder.s1d();
        // Inline function 'korlibs.io.stream.readChunks' call
        var temp = new Int8Array(1024);
        $l$loop: while (true) {
          var tmp_11 = _this__u8e3s4.u1f(temp, 0, temp.length, $completion);
          if (tmp_11 === get_COROUTINE_SUSPENDED())
            tmp_11 = yield tmp_11;
          var r = tmp_11;
          if (r <= 0)
            break $l$loop;
          // Inline function 'korlibs.io.stream.readAll.<anonymous>' call
          out.d1d(temp, 0, r);
        }
        tmp_0 = out.t1d();
      }
    }
    tmp = tmp_0;
  }finally {
    var tmp_12 = _this__u8e3s4.y1e($completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
  }
  return tmp;
}
function readAll(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAll__9p3omh(_this__u8e3s4, $completion), $completion);
}
function toAsyncStream(_this__u8e3s4, position) {
  position = position === VOID ? new Long(0, 0) : position;
  return new AsyncStream(_this__u8e3s4, position);
}
function *_generator_getAvailable__v3o1wr($this, $completion) {
  var tmp = $this.i1f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.b1g($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp.q1(tmp_0);
}
function *_generator_readBytesUpToCopy__bi3svg(_this__u8e3s4, out, $completion) {
  var tmp = readBytesUpTo_0(_this__u8e3s4, out, 0, out.length, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var pos = tmp;
  return out.length === pos ? out : copyOf_2(out, pos);
}
function readBytesUpToCopy(_this__u8e3s4, out, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpToCopy__bi3svg(_this__u8e3s4, out, $completion), $completion);
}
function *_generator_readExact__g46z7v(_this__u8e3s4, buffer, offset, len, $completion) {
  var remaining = len;
  var coffset = offset;
  var reader = _this__u8e3s4;
  $l$loop: while (remaining > 0) {
    var tmp = reader.u1f(buffer, coffset, remaining, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var read = tmp;
    if (read < 0)
      break $l$loop;
    if (read === 0)
      throw EOFException.r2p('Not enough data. Expected=' + len + ', Read=' + (len - remaining | 0) + ', Remaining=' + remaining);
    coffset = coffset + read | 0;
    remaining = remaining - read | 0;
  }
  return Unit_instance;
}
function readExact(_this__u8e3s4, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readExact__g46z7v(_this__u8e3s4, buffer, offset, len, $completion), $completion);
}
function *_generator_readBytesUpTo__nh3xxl_0(_this__u8e3s4, out, offset, len, $completion) {
  var total = 0;
  var pending = len;
  var offset_0 = offset;
  $l$loop: while (true) {
    var tmp = _this__u8e3s4.u1f(out, offset_0, pending, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var result = tmp;
    if (result <= 0)
      break $l$loop;
    offset_0 = offset_0 + result | 0;
    pending = pending - result | 0;
    total = total + result | 0;
  }
  return total;
}
function readBytesUpTo_0(_this__u8e3s4, out, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpTo__nh3xxl_0(_this__u8e3s4, out, offset, len, $completion), $completion);
}
function asyncStreamWriter(bufferSize, name, lazy, process, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  name = name === VOID ? null : name;
  lazy = lazy === VOID ? false : lazy;
  return new asyncStreamWriter$1(lazy, bufferSize, name, process);
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  try {
    var tmp = $this.s2p_1(new asyncStreamWriter$1$ensureJob$2$1($this.t2p_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      $this.t2p_1.v2p_1 = e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
    var tmp_0 = $this.t2p_1.u2p_1.y1e($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function checkException($this) {
  if (!($this.v2p_1 == null))
    throw RuntimeException.pd('Error in asyncStreamWriter', ensureNotNull($this.v2p_1));
}
function ensureJob($this, $completion) {
  if (!($this.w2p_1 == null))
    return Unit_instance;
  var tmp = $this;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.zb();
  var tmp_0 = CoroutineScope_0(tmp$ret$0);
  tmp.w2p_1 = launch(tmp_0, VOID, VOID, asyncStreamWriter$o$ensureJob$slambda_0($this.y2p_1, $this));
}
function *_generator_read__qih2oe_4($this, buffer, offset, len, $completion) {
  var tmp = ensureJob($this, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  checkException($this);
  // Inline function 'kotlin.also' call
  var tmp_0 = $this.u2p_1.u1f(buffer, offset, len, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
  return tmp_0;
}
function asyncStreamWriter$o$ensureJob$slambda_0($process, this$0) {
  var i = new asyncStreamWriter$o$ensureJob$slambda($process, this$0);
  var l = function ($this$launch, $completion) {
    return i.r17($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function openSync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return MemorySyncStreamBase.c2q(ByteArrayBuilder.f2p(_this__u8e3s4)).e2q(new Long(0, 0));
}
function MemorySyncStream(data) {
  return MemorySyncStreamBase.c2q(data).k2q();
}
function readS32BE_0(_this__u8e3s4) {
  return readU8_0(_this__u8e3s4) << 24 | readU8_0(_this__u8e3s4) << 16 | readU8_0(_this__u8e3s4) << 8 | readU8_0(_this__u8e3s4);
}
function readStringz_0(_this__u8e3s4, len) {
  var res = readBytes_1(_this__u8e3s4, len);
  var index = indexOf(res, 0);
  return decodeToString(copyOf_2(res, index < 0 ? len : index));
}
function readU8_0(_this__u8e3s4) {
  return _this__u8e3s4.q2q();
}
function readBytes_1(_this__u8e3s4, len) {
  var bytes = new Int8Array(len);
  var out = _this__u8e3s4.x1f(bytes, 0, len);
  return !(out === len) ? copyOf_2(bytes, out) : bytes;
}
function readString_0(_this__u8e3s4, len, charset) {
  charset = charset === VOID ? get_UTF8() : charset;
  return toString_3(readBytes_1(_this__u8e3s4, len), charset);
}
function write8(_this__u8e3s4, v) {
  return _this__u8e3s4.r2q(v);
}
function get_eof(_this__u8e3s4) {
  return _this__u8e3s4.s2q().p1(new Long(0, 0)) <= 0;
}
function readAll_0(_this__u8e3s4) {
  return readBytes_1(_this__u8e3s4, _this__u8e3s4.s2q().b2());
}
function readStream(_this__u8e3s4, length) {
  return readSlice(_this__u8e3s4, length);
}
function sliceWithBounds_0(_this__u8e3s4, start, end) {
  var len = _this__u8e3s4.a();
  var clampedStart = coerceIn(start, new Long(0, 0), len);
  var clampedEnd = coerceIn(end, new Long(0, 0), len);
  var base = _this__u8e3s4.d2j_1;
  if (base instanceof SliceSyncStreamBase) {
    return SliceSyncStreamBase.y2q(base.u2q_1, base.v2q_1.q3(clampedStart), base.v2q_1.q3(clampedEnd)).k2q();
  } else {
    return SliceSyncStreamBase.y2q(base, clampedStart, clampedEnd).k2q();
  }
}
function readSlice(_this__u8e3s4, length) {
  // Inline function 'kotlin.apply' call
  var this_0 = sliceWithSize_1(_this__u8e3s4, _this__u8e3s4.g2o(), length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.readSlice.<anonymous>' call
  _this__u8e3s4.m2q(_this__u8e3s4.g2o().q3(length));
  return this_0;
}
function clampPosition_0($this, position) {
  return coerceIn(position, $this.v2q_1, $this.w2q_1);
}
function clampPositionLen_0($this, position, len) {
  if (position.p1(new Long(0, 0)) < 0)
    throw IllegalArgumentException.m('Invalid position');
  var targetStartPosition = clampPosition_0($this, $this.v2q_1.q3(position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = targetStartPosition.q3(toLong(len));
  var targetEndPosition = clampPosition_0($this, tmp$ret$0);
  var targetLen = targetEndPosition.q1(targetStartPosition).b2();
  return new Pair(targetStartPosition, targetLen);
}
function sliceWithSize_1(_this__u8e3s4, position, length) {
  return sliceWithBounds_0(_this__u8e3s4, position, position.q3(length));
}
function sliceStart_0(_this__u8e3s4, start) {
  start = start === VOID ? new Long(0, 0) : start;
  return sliceWithBounds_0(_this__u8e3s4, start, _this__u8e3s4.a());
}
function getUnderlyingUnscapedFile(_this__u8e3s4, $completion) {
  return _this__u8e3s4.o2h_1.b2r(_this__u8e3s4.p2h_1, $completion);
}
function get_extensionLC(_this__u8e3s4) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return get_extension(_this__u8e3s4).toLowerCase();
}
function _PathInfo___init__impl__vpw96a(fullPath) {
  return fullPath;
}
function _PathInfo___get_fullPath__impl__21fx6x($this) {
  return $this;
}
function get_baseName(_this__u8e3s4) {
  return get_baseName_0(_this__u8e3s4.c2r());
}
function get_pathInfo(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(_this__u8e3s4);
}
function get_extension(_this__u8e3s4) {
  return substringAfterLast(get_baseName_0(_this__u8e3s4), _Char___init__impl__6a9atx(46), '');
}
function get_baseName_0(_this__u8e3s4) {
  return substringAfterLast(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
}
function get_fullPathNormalized(_this__u8e3s4) {
  return replace_0(_PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
}
function lightCombine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(base) > 0) {
    tmp = trimEnd(base, charArrayOf([_Char___init__impl__6a9atx(47)])) + '/' + trim_0(access_0, charArrayOf([_Char___init__impl__6a9atx(47)]));
  } else {
    tmp = access_0;
  }
  var res = tmp;
  return get_pathInfo(res);
}
function get_parent(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(get_folder(_this__u8e3s4));
}
function combine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  return get_pathInfo(isAbsolute(get_pathInfo(access_0)) ? normalize(get_pathInfo(access_0)) : normalize(get_pathInfo(base + '/' + access_0)));
}
function normalize(_this__u8e3s4, removeEndSlash) {
  removeEndSlash = removeEndSlash === VOID ? true : removeEndSlash;
  var path = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var schemeIndex = indexOf_0(path, ':');
  var tmp;
  if (schemeIndex >= 0) {
    var tmp_0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = path.substring(schemeIndex);
    if (startsWith(tmp$ret$1, '://')) {
      tmp_0 = 3;
    } else {
      tmp_0 = 1;
    }
    var take = tmp_0;
    // Inline function 'kotlin.text.substring' call
    var endIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = path.substring(0, endIndex);
    // Inline function 'kotlin.text.substring' call
    var startIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = path.substring(startIndex);
    tmp = tmp_1 + normalize(get_pathInfo(tmp$ret$5), removeEndSlash);
  } else {
    var path2 = replace_0(path, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
    var out = ArrayList.j1();
    var path2PathLength;
    // Inline function 'korlibs.io.file.fastForEachWithIndex' call
    // Inline function 'kotlin.also' call
    var this_0 = split(path2, ['/']);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.normalize.<anonymous>' call
    path2PathLength = this_0.d1();
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.io.file.normalize.<anonymous>' call
      var index = n;
      var part = this_0.f1(n);
      switch (part) {
        case '':
          if (out.g1() || !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.g('');
          }

          break;
        case '.':
          if (index === (path2PathLength - 1 | 0) && !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.g('');
          }

          break;
        case '..':
          var tmp_2;
          // Inline function 'kotlin.collections.isNotEmpty' call

          if (!out.g1()) {
            tmp_2 = !(index === 1);
          } else {
            tmp_2 = false;
          }

          if (tmp_2) {
            out.w2(out.d1() - 1 | 0);
          }

          break;
        default:
          // Inline function 'kotlin.collections.plusAssign' call

          out.g(part);
          break;
      }
      n = n + 1 | 0;
    }
    tmp = joinToString_0(out, '/');
  }
  return tmp;
}
function get_folder(_this__u8e3s4) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var tmp0_elvis_lhs = lastIndexOfOrNull(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
  var endIndex = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  // Inline function 'kotlin.js.asDynamic' call
  return this_0.substring(0, endIndex);
}
function get_extensionLC_0(_this__u8e3s4) {
  return get_extensionLC(_this__u8e3s4.c2r());
}
function isAbsolute(_this__u8e3s4) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(base) === 0)
    return false;
  var b = substringBefore(replace_0(base, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(47));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(b) === 0)
    return true;
  if (contains_1(b, _Char___init__impl__6a9atx(58)))
    return true;
  return false;
}
function lastIndexOfOrNull(_this__u8e3s4, char, startIndex) {
  startIndex = startIndex === VOID ? get_lastIndex_0(_this__u8e3s4) : startIndex;
  // Inline function 'kotlin.takeIf' call
  var this_0 = lastIndexOf(_this__u8e3s4, char, startIndex);
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.io.file.lastIndexOfOrNull.<anonymous>' call
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function *_generator_invoke__zhh2q8_4($this, $this$async, $completion) {
  try {
    var tmp = $this.e2r_1.g2r($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_getUnderlyingUnscapedFile__y1cdv2($this, path, $completion) {
  var tmp = $this.h2r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.i2r(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = getUnderlyingUnscapedFile(tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_initOnce__uuyf07($this, $completion) {
  if ($this.f2r_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.zb();
    var tmp_0 = CoroutineScope_0(tmp$ret$0);
    tmp.f2r_1 = async(tmp_0, VOID, VOID, Vfs$Proxy$initOnce$slambda_0($this));
  }
  var tmp_1 = ensureNotNull($this.f2r_1).hr($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return $this;
}
function *_generator_open__qjxcea($this, path, mode, $completion) {
  var tmp = $this.h2r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.i2r(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.j2r(mode, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_readRange__lxd64t($this, path, range, $completion) {
  var tmp = $this.h2r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.i2r(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.k2r(range, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_stat__qhnowc($this, path, $completion) {
  var tmp = $this.h2r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.i2r(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.l2r($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1.c2s($this.l2h(path));
}
function Vfs$Proxy$initOnce$slambda_0(this$0) {
  var i = new Vfs$Proxy$initOnce$slambda(this$0);
  var l = function ($this$async, $completion) {
    return i.r17($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_readRange__lxd64t_0($this, path, range, $completion) {
  // Inline function 'korlibs.io.async.useIt' call
  var tmp = $this.d2s(path, VfsOpenMode_READ_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.io.async.use' call
  var this_0 = tmp;
  var error = null;
  var tmp_0;
  try {
    // Inline function 'korlibs.io.file.Vfs.readRange.<anonymous>' call
    this_0.c2c_1 = range.a2();
    // Inline function 'kotlin.math.min' call
    // Inline function 'kotlin.Long.minus' call
    var a = (new Long(2147483647, 0)).q1(toLong(1));
    var b = range.y1().q1(range.a2());
    var tmp$ret$1 = a.p1(b) <= 0 ? a : b;
    var tmp_1 = readBytesUpTo(this_0, tmp$ret$1.b2() + 1 | 0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      error = e;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var result = tmp_0;
  if (this_0 == null)
    null;
  else {
    var tmp_3 = this_0.y1e($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  if (!(error == null))
    throw error;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function unsupported($this) {
  throw UnsupportedOperationException.k9('unsupported for ' + toString(getKClassFromExpression($this)) + ' : ' + $this.toString());
}
var VfsOpenMode_READ_instance;
var VfsOpenMode_WRITE_instance;
var VfsOpenMode_APPEND_instance;
var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
var VfsOpenMode_CREATE_instance;
var VfsOpenMode_CREATE_NEW_instance;
var VfsOpenMode_entriesInitialized;
function VfsOpenMode_initEntries() {
  if (VfsOpenMode_entriesInitialized)
    return Unit_instance;
  VfsOpenMode_entriesInitialized = true;
  VfsOpenMode_READ_instance = new VfsOpenMode('READ', 0, 'rb', false);
  VfsOpenMode_WRITE_instance = new VfsOpenMode('WRITE', 1, 'r+b', true, true);
  VfsOpenMode_APPEND_instance = new VfsOpenMode('APPEND', 2, 'a+b', true, true, VOID, VOID, true);
  VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
  VfsOpenMode_CREATE_instance = new VfsOpenMode('CREATE', 4, 'w+b', true, true);
  VfsOpenMode_CREATE_NEW_instance = new VfsOpenMode('CREATE_NEW', 5, 'w+b', true);
}
var Companion_instance_46;
function Companion_getInstance_47() {
  return Companion_instance_46;
}
function VfsOpenMode_READ_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_READ_instance;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_VfsFile_kt__9wj0sz();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
function *_generator_readString__6uahun_0($this, charset, $completion) {
  var tmp = $this.c2t($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_3(tmp, charset);
}
function *_generator_stat__qhnowc_0($this, $completion) {
  var tmp0_elvis_lhs = $this.q2h_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0 = $this.o2h_1.f2s($this.p2h_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function *_generator_readAsSyncStream__xvjwgr(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.c2t($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return openSync(tmp);
}
function readAsSyncStream(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAsSyncStream__xvjwgr(_this__u8e3s4, $completion), $completion);
}
var properties_initialized_VfsFile_kt_lqx1ld;
function _init_properties_VfsFile_kt__9wj0sz() {
  if (!properties_initialized_VfsFile_kt_lqx1ld) {
    properties_initialized_VfsFile_kt_lqx1ld = true;
    LONG_ZERO_TO_MAX_RANGE = (new Long(0, 0)).s1(new Long(-1, 2147483647));
  }
}
var Companion_instance_47;
function Companion_getInstance_48() {
  return Companion_instance_47;
}
var Companion_instance_48;
function Companion_getInstance_49() {
  return Companion_instance_48;
}
function get_logger() {
  _init_properties_AsyncExt_kt__ahev1h();
  return logger;
}
var logger;
var DEFAULT_SUSPEND_TEST_TIMEOUT;
var DEFAULT_TEST_SYNC_IO;
function get_DEBUG_ASYNC_LAUNCH_ERRORS() {
  _init_properties_AsyncExt_kt__ahev1h();
  // Inline function 'kotlin.getValue' call
  var this_0 = DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
  DEBUG_ASYNC_LAUNCH_ERRORS$factory();
  return this_0.h3();
}
var DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
function launchImmediately(context, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return launchImmediately_0(CoroutineScope_0(context), callback);
}
function launchImmediately_0(_this__u8e3s4, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return _launch(_this__u8e3s4, CoroutineStart_UNDISPATCHED_getInstance(), callback);
}
function _launch(_this__u8e3s4, start, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  var tmp = _this__u8e3s4.qo();
  return launch(_this__u8e3s4, tmp, start, _launch$slambda_0(callback));
}
function launchUnscopedAndWait(_this__u8e3s4, block, $completion) {
  var deferred = CompletableDeferred();
  startCoroutine(block, new launchUnscopedAndWait$1(_this__u8e3s4, deferred));
  return deferred.hr($completion);
}
function launchUnscoped(_this__u8e3s4, block) {
  _init_properties_AsyncExt_kt__ahev1h();
  return launchUnscoped_0(_this__u8e3s4.qo(), block);
}
function launchUnscoped_0(_this__u8e3s4, block) {
  _init_properties_AsyncExt_kt__ahev1h();
  startCoroutine(block, new launchUnscoped$1(_this__u8e3s4));
}
function DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda() {
  _init_properties_AsyncExt_kt__ahev1h();
  return Companion_instance_96.l1i('DEBUG_ASYNC_LAUNCH_ERRORS') === 'true';
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  try {
    var tmp = $this.l2t_1($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        if (get_DEBUG_ASYNC_LAUNCH_ERRORS()) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_0 = get_logger();
          var level = Level_ERROR_getInstance();
          var tmp_0;
          if (this_0.k1a(level)) {
            // Inline function 'korlibs.io.async._launch.<anonymous>.<anonymous>' call
            var tmp$ret$0 = 'CoroutineScope._launch.catch:';
            this_0.j1a(level, tmp$ret$0);
            tmp_0 = Unit_instance;
          }
          printStackTrace(e_0);
        }
        throw e_0;
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function _launch$slambda_0($callback) {
  var i = new _launch$slambda($callback);
  var l = function ($this$launch, $completion) {
    return i.r17($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function DEBUG_ASYNC_LAUNCH_ERRORS$factory() {
  return getPropertyCallableRef('DEBUG_ASYNC_LAUNCH_ERRORS', 0, KProperty0, function () {
    return get_DEBUG_ASYNC_LAUNCH_ERRORS();
  }, null);
}
var properties_initialized_AsyncExt_kt_7k2grr;
function _init_properties_AsyncExt_kt__ahev1h() {
  if (!properties_initialized_AsyncExt_kt_7k2grr) {
    properties_initialized_AsyncExt_kt_7k2grr = true;
    logger = Companion_getInstance_65().p1a('AsyncExt');
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_SUSPEND_TEST_TIMEOUT = toDuration(20, DurationUnit_SECONDS_getInstance());
    DEFAULT_TEST_SYNC_IO = false;
    DEBUG_ASYNC_LAUNCH_ERRORS$delegate = lazy(DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8_6($this, $this$withContext, $completion) {
  var tmp = protoOf(Proxy).d2s.call($this.p2t_1, $this.q2t_1, $this.r2t_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.b2c_1;
}
function *_generator_write__x1694l_6($this, position, buffer, offset, len, $completion) {
  var tmp = $this.t2t_1.w2o(position, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.comparisons.maxOf' call
  var a = $this.u2t_1._v;
  // Inline function 'kotlin.Long.plus' call
  var b = position.q3(toLong(len));
  var tmp$ret$1 = a.p1(b) >= 0 ? a : b;
  $this.u2t_1._v = tmp$ret$1;
  return Unit_instance;
}
function *_generator_open__qjxcea_0($this, path, mode, $completion) {
  var tmp = $this.b2u(path, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var fstat = tmp;
  if (!(fstat == null) && mode.equals(VfsOpenMode_READ_getInstance()) && fstat.p2r_1.p1($this.x2t_1) <= 0) {
    var tmp_0 = $this.e2s(path, get_LONG_ZERO_TO_MAX_RANGE_0(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return openAsync(tmp_0);
  }
  var tmp_1 = new VfsCachedStatContext(fstat);
  var tmp_2 = withContext(tmp_1, CatalogVfs$open$slambda_0($this, path, mode), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var base = tmp_2;
  var tmp_3;
  if ((fstat == null ? null : fstat.n2r_1) === true) {
    tmp_3 = fstat.p2r_1;
  } else {
    var tmp_4 = base.i1f($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp_3 = tmp_4;
  }
  var maxSize = {_v: tmp_3};
  return buffered(toAsyncStream(CatalogVfs$open$2.c2u($this, base, maxSize)));
}
function *_generator_stat__qhnowc_1($this, path, $completion) {
  var tmp = $this.b2u(path, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? $this.m2s(normalize(_PathInfo___init__impl__vpw96a(path)), VOID, true) : tmp0_elvis_lhs;
}
function *_generator_statOrNull__vj5496($this, path, $completion) {
  var normalizedPath = normalize(_PathInfo___init__impl__vpw96a(path));
  if (normalizedPath === '/' || normalizedPath === '') {
    return $this.k2s('/', true, new Long(0, 0), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  var baseName = get_baseName_0(_PathInfo___init__impl__vpw96a(normalizedPath));
  var tmp = $this.d2u(_PathInfo___get_fullPath__impl__21fx6x(get_parent(_PathInfo___init__impl__vpw96a(normalizedPath))), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.z2t_1;
    var value = this_0.f3(path);
    var tmp_1;
    if (value == null) {
      // Inline function 'korlibs.io.file.std.CatalogVfs.statOrNull.<anonymous>' call
      var tmp_2 = $this.w2t_1.l1i(path).l2r($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      var answer = tmp_2;
      this_0.x2(path, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    return tmp_1;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var info = tmp_0;
  var tmp1_elvis_lhs = info.f3(baseName);
  return tmp1_elvis_lhs == null ? $this.m2s(normalizedPath, VOID, true) : tmp1_elvis_lhs;
}
function *_generator_cachedListSimpleStatsOrNull__bbx84j($this, path, $completion) {
  var key = normalize(_PathInfo___init__impl__vpw96a(path));
  var tmp$ret$2;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.a2u_1;
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var res = this_0.get(key);
    if (!(res == null)) {
      tmp$ret$2 = res;
      break $l$block;
    }
    // Inline function 'korlibs.io.file.std.CatalogVfs.cachedListSimpleStatsOrNull.<anonymous>' call
    var tmp = $this.e2u(key, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var out = tmp;
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, out);
    tmp$ret$2 = out;
  }
  return tmp$ret$2;
}
function *_generator_listSimpleStatsOrNull__lelcpx($this, path, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.w2t_1.l1i(path).l1i('$catalog.json').e2t(VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      if (!(e instanceof FileNotFoundException)) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_0 = $this.y2t_1;
        var level = Level_ERROR_getInstance();
        var tmp_2;
        if (this_0.k1a(level)) {
          // Inline function 'korlibs.io.file.std.CatalogVfs.listSimpleStatsOrNull.<anonymous>' call
          this_0.j1a(level, e);
          tmp_2 = Unit_instance;
        }
      }
      return null;
    } else {
      throw $p;
    }
  }
  var catalogJsonString = tmp;
  var data = get_dyn(Companion_getInstance_104().g2u(catalogJsonString));
  var tmp678_subject = _Dyn___get_value__impl__bemnlg(data);
  if (!(tmp678_subject == null) ? isInterface(tmp678_subject, KtList) : false) {
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = _Dyn___get_list__impl__qpwjp(data);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.r(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.file.std.CatalogVfs.listSimpleStatsOrNull.<anonymous>' call
      var it = item.o1o_1;
      var localName = get_baseName_0(_PathInfo___init__impl__vpw96a(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80_0(it, 'name'))));
      var tmp$ret$2 = $this.k2s(path + '/' + localName, _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80_0(it, 'isDirectory')), _Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'size')), VOID, VOID, VOID, VOID, VOID, Companion_getInstance_107().h2u(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'createTime'))), Companion_getInstance_107().h2u(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'modifiedTime'))), VOID, VOID, VOID, true);
      destination.g(tmp$ret$2);
    }
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.pb(capacity);
    var tmp0_iterator_0 = destination.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'korlibs.io.file.std.CatalogVfs.listSimpleStatsOrNull.<anonymous>' call
      var tmp$ret$5 = get_baseName(element);
      destination_0.x2(tmp$ret$5, element);
    }
    return destination_0;
  } else {
    var out = LinkedHashMap.ob();
    var _iterator__ex2g4s = _Dyn___get_keys__impl__o4xmor(data).a1();
    while (_iterator__ex2g4s.b1()) {
      var key = _iterator__ex2g4s.c1().o1o_1;
      var fileName = _Dyn___get_str__impl__dup4cs(key);
      var info = Dyn__get_impl_6l2p80(data, key);
      var tmp0_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 0));
      var size = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 1));
      var creationTime = tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 2));
      var modifiedTime = tmp2_elvis_lhs == null ? creationTime : tmp2_elvis_lhs;
      var isDirectory = endsWith(fileName, '/');
      var baseName = trimEnd(fileName, charArrayOf([_Char___init__impl__6a9atx(47)]));
      // Inline function 'kotlin.collections.set' call
      var value = $this.k2s(path + '/' + baseName, isDirectory, size, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_107().h2u(creationTime), Companion_getInstance_107().h2u(modifiedTime), VOID, VOID, VOID, true);
      out.x2(baseName, value);
    }
    return out;
  }
}
function CatalogVfs$open$slambda_0(this$0, $path, $mode) {
  var i = new CatalogVfs$open$slambda(this$0, $path, $mode);
  var l = function ($this$withContext, $completion) {
    return i.r17($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var resourcesVfsDebug;
function get_resourcesVfs() {
  return get_standardVfs().i2u();
}
function get_localCurrentDirVfs() {
  return get_applicationVfs();
}
function *_generator_close__nh2uv0_3($this, $completion) {
  if ($this.k2u_1) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = $this.l2u_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.io.file.std.MountableVfs.close.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp = this_0.f1(_unary__edvuaz).ik_1.o2h_1.y1e($completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  }
  return Unit_instance;
}
function unmountInternal($this, folder) {
  removeAll($this.l2u_1, MountableVfs$unmountInternal$lambda(folder));
}
function resort($this) {
  // Inline function 'kotlin.collections.sortByDescending' call
  var this_0 = $this.l2u_1;
  if (this_0.d1() > 1) {
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = MountableVfs$resort$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_2(tmp);
    sortWith(this_0, tmp$ret$0);
  }
}
function MountableVfs$unmountInternal$lambda($folder) {
  return function (it) {
    return it.hk_1 === normalize(get_pathInfo($folder));
  };
}
function MountableVfs$resort$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.io.file.std.MountableVfs.resort.<anonymous>' call
  var tmp = b.hk_1.length;
  // Inline function 'korlibs.io.file.std.MountableVfs.resort.<anonymous>' call
  var tmp$ret$1 = a.hk_1.length;
  return compareValues(tmp, tmp$ret$1);
}
function UrlVfs_0(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return UrlVfs_1(url.f2v(VOID, VOID, VOID, VOID, VOID, '', null).g2v(), Unit_instance, client, failFromStatus).l1i(url.y2u_1);
}
function *_generator_read__qih2oe_5($this, position, buffer, offset, len, $completion) {
  if (len === 0)
    return 0;
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = position.q3(toLong(len));
  var tmp = _readRangeBase($this.h2v_1, $this.k2v_1, until_0(position, tmp$ret$0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var res = tmp;
  var s = res.q2v_1;
  var coffset = offset;
  var pending = len;
  var totalRead = 0;
  $l$loop: while (pending > 0) {
    var tmp_0 = s.u1f(buffer, coffset, pending, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var read = tmp_0;
    if (read < 0 && totalRead === 0)
      return read;
    if (read <= 0)
      break $l$loop;
    pending = pending - read | 0;
    totalRead = totalRead + read | 0;
    coffset = coffset + read | 0;
  }
  return totalRead;
}
function *_generator_getLength__lvva94_1($this, $completion) {
  var tmp;
  var tmp_0 = $this.h1f($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    tmp = $this.l2v_1.p2r_1;
  } else {
    unsupported_0();
  }
  return tmp;
}
function *_generator_open__qjxcea_1($this, path, mode, $completion) {
  try {
    var fullUrl = $this.u2k(path);
    if (startsWith(fullUrl, 'file:')) {
      var tmp = $this.x2v_1.z2v(fullUrl, VOID, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      return openAsync(tmp);
    }
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp688_safe_receiver = $completion.zb().mc(Companion_instance_46);
    var tmp0_elvis_lhs = tmp688_safe_receiver == null ? null : tmp688_safe_receiver.b2t_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = $this.f2s(path, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var stat = tmp_0;
    var tmp_2 = stat.y2r_1;
    var response = tmp_2 instanceof Response ? tmp_2 : null;
    if (!stat.n2r_1) {
      throw FileNotFoundException.r2u('Unexistant ' + fullUrl + ' : ' + toString_0(response));
    }
    return buffered(toAsyncStream(FinalUrlVfs$open$2.a2w($this, path, mode, fullUrl, stat)));
  } catch ($p) {
    if ($p instanceof RuntimeException) {
      var e = $p;
      var tmp1_elvis_lhs = e.message;
      throw FileNotFoundException.r2u(tmp1_elvis_lhs == null ? 'error' : tmp1_elvis_lhs);
    } else {
      throw $p;
    }
  }
}
function *_generator__readRangeBase__z0wzdd($this, fullUrl, range, $completion) {
  // Inline function 'kotlin.also' call
  var tmp = $this.x2v_1.o2w(Companion_getInstance_51().c2w_1, fullUrl, Headers.n2w(range.equals(get_LONG_ZERO_TO_MAX_RANGE_0()) ? LinkedHashMap.ob() : linkedHashMapOf([to('range', 'bytes=' + range.a2().toString() + '-' + range.y1().toString())])), VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.file.std.FinalUrlVfs._readRangeBase.<anonymous>' call
  if ($this.s2k_1) {
    if (this_0.m2v_1 === 404)
      throw FileNotFoundException.r2u(fullUrl + ' not found');
    var tmp_0 = this_0.p2w($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return this_0;
}
function _readRangeBase($this, fullUrl, range, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readRangeBase__z0wzdd($this, fullUrl, range, $completion), $completion);
}
function *_generator_readRange__lxd64t_1($this, path, range, $completion) {
  var tmp = _readRangeBase($this, $this.u2k(path), range, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = readAll(tmp.q2v_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_stat__qhnowc_2($this, path, $completion) {
  var fullUrl = $this.u2k(path);
  var tmp;
  if (startsWith(fullUrl, 'file:')) {
    var tmp_0;
    try {
      var tmp_1 = $this.x2v_1.z2v(fullUrl, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var size = toLong(tmp_1.length);
      tmp_0 = $this.k2s(path, false, size, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_2 = $this.m2s(path);
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp = tmp_0;
  } else {
    var tmp_3 = $this.x2v_1.o2w(Companion_getInstance_51().d2w_1, fullUrl, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var result = tmp_3;
    var tmp_4;
    if (result.r2v_1) {
      var tmp690_safe_receiver = result.o2v_1.l1i(Companion_instance_52.q2w_1);
      var tmp0_elvis_lhs = tmp690_safe_receiver == null ? null : toLongOrNull_0(tmp690_safe_receiver);
      tmp_4 = $this.k2s(path, false, tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, result);
    } else {
      tmp_4 = $this.m2s(path, result);
    }
    tmp = tmp_4;
  }
  return tmp;
}
function UrlVfs_1(url, dummy, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return new FinalUrlVfs(url, dummy, client, failFromStatus);
}
function UrlVfs_2(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return UrlVfs_0(Companion_getInstance_50().p1a(url), client, failFromStatus);
}
function currentStackTrace(msg) {
  msg = msg === VOID ? 'printStackTrace' : msg;
  return stackTraceToString(Exception.f5(msg));
}
var Companion_instance_49;
function Companion_getInstance_50() {
  if (Companion_instance_49 === VOID)
    new Companion_48();
  return Companion_instance_49;
}
function URL$fullUrl$delegate$lambda(this$0) {
  return function () {
    return this$0.k2x().toString();
  };
}
function URL$fullUrlWithoutScheme$delegate$lambda(this$0) {
  return function () {
    return this$0.k2x(false).toString();
  };
}
function URL$pathWithQuery$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (!(this$0.z2u_1 == null)) {
      tmp = this$0.y2u_1 + '?' + this$0.z2u_1;
    } else {
      tmp = this$0.y2u_1;
    }
    return tmp;
  };
}
function normalizeUrl(_this__u8e3s4) {
  // Inline function 'kotlin.text.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.firstOrNull' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
      var element = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.io.net.normalizeUrl.<anonymous>' call
      if (element === _Char___init__impl__6a9atx(63) || element === _Char___init__impl__6a9atx(35)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
    tmp = _Char___init__impl__6a9atx(63);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paramFlag = tmp;
  var pathParts = toMutableList(split_0(_this__u8e3s4, charArrayOf([paramFlag])));
  pathParts.v2(0, normalize(get_pathInfo(pathParts.f1(0)), false));
  return joinToString_0(pathParts, toString_1(paramFlag));
}
function fullUrl$factory() {
  return getPropertyCallableRef('fullUrl', 1, KProperty1, function (receiver) {
    return receiver.g2v();
  }, null);
}
var Methods_ALL_instance;
var Methods_OPTIONS_instance;
var Methods_GET_instance;
var Methods_HEAD_instance;
var Methods_POST_instance;
var Methods_PUT_instance;
var Methods_DELETE_instance;
var Methods_TRACE_instance;
var Methods_CONNECT_instance;
var Methods_PATCH_instance;
var Methods_entriesInitialized;
function Methods_initEntries() {
  if (Methods_entriesInitialized)
    return Unit_instance;
  Methods_entriesInitialized = true;
  Methods_ALL_instance = new Methods('ALL', 0);
  Methods_OPTIONS_instance = new Methods('OPTIONS', 1);
  Methods_GET_instance = new Methods('GET', 2);
  Methods_HEAD_instance = new Methods('HEAD', 3);
  Methods_POST_instance = new Methods('POST', 4);
  Methods_PUT_instance = new Methods('PUT', 5);
  Methods_DELETE_instance = new Methods('DELETE', 6);
  Methods_TRACE_instance = new Methods('TRACE', 7);
  Methods_CONNECT_instance = new Methods('CONNECT', 8);
  Methods_PATCH_instance = new Methods('PATCH', 9);
}
var Companion_instance_50;
function Companion_getInstance_51() {
  if (Companion_instance_50 === VOID)
    new Companion_49();
  return Companion_instance_50;
}
var Companion_instance_51;
function Companion_getInstance_52() {
  return Companion_instance_51;
}
var Companion_instance_52;
function Companion_getInstance_53() {
  return Companion_instance_52;
}
function Http$Headers$toListGrouped$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = a.hk_1.toLowerCase();
  // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = b.hk_1.toLowerCase();
  return compareValues(tmp, tmp$ret$5);
}
function Methods_OPTIONS_getInstance() {
  Methods_initEntries();
  return Methods_OPTIONS_instance;
}
function Methods_GET_getInstance() {
  Methods_initEntries();
  return Methods_GET_instance;
}
function Methods_HEAD_getInstance() {
  Methods_initEntries();
  return Methods_HEAD_instance;
}
function Methods_POST_getInstance() {
  Methods_initEntries();
  return Methods_POST_instance;
}
function Methods_PUT_getInstance() {
  Methods_initEntries();
  return Methods_PUT_instance;
}
function Methods_DELETE_getInstance() {
  Methods_initEntries();
  return Methods_DELETE_instance;
}
function Methods_TRACE_getInstance() {
  Methods_initEntries();
  return Methods_TRACE_instance;
}
function Methods_CONNECT_getInstance() {
  Methods_initEntries();
  return Methods_CONNECT_instance;
}
function Methods_PATCH_getInstance() {
  Methods_initEntries();
  return Methods_PATCH_instance;
}
function get__defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  // Inline function 'kotlin.getValue' call
  var this_0 = _defaultHttpFactory$delegate;
  _defaultHttpFactory$factory();
  return this_0.h3();
}
var _defaultHttpFactory$delegate;
function *_generator_invoke__zhh2q8_7($this, status, statusText, headers, rawContent, $completion) {
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  var tmp0_elvis_lhs = headers.l1i('Transfer-Encoding');
  // Inline function 'kotlin.js.asDynamic' call
  var this_0 = (tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs).toLowerCase();
  var transferEncoding = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  var tmp1_elvis_lhs = headers.l1i('Content-Encoding');
  // Inline function 'kotlin.js.asDynamic' call
  var this_1 = (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs).toLowerCase();
  var contentEncoding = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  var tmp = withTransferEncoding(rawContent, transferEncoding, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = withContentEncoding(tmp, contentEncoding, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return new Response(status, statusText, headers, rawContent, tmp_0);
}
var Companion_instance_53;
function Companion_getInstance_54() {
  return Companion_instance_53;
}
function *_generator_readAllBytes__ja4yyw($this, $completion) {
  var tmp = readAll($this.q2v_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var allContent = tmp;
  return allContent;
}
function *_generator_readAllString__7ikxrc($this, charset, $completion) {
  var tmp = $this.l2y($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bytes = tmp;
  return toString_3(bytes, charset);
}
function *_generator_checkErrors__u7iznj($this, $completion) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.net.http.Response.checkErrors.<anonymous>' call
  if (!$this.r2v_1) {
    var tmp = $this.m2y(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    throw HttpException.y2x($this.m2v_1, tmp, $this.n2v_1);
  }
  return $this;
}
function HttpClient$Response$responseCharset$delegate$lambda() {
  return get_UTF8();
}
var Companion_instance_54;
function Companion_getInstance_55() {
  if (Companion_instance_54 === VOID)
    new Companion_53();
  return Companion_instance_54;
}
function mergeUrls($this, base, append) {
  return Companion_getInstance_50().g2x(base, append);
}
function *_generator_request__hjt9xh($this, method, url, headers, content, config, $completion) {
  var tmp;
  if (content == null) {
    tmp = null;
  } else {
    var tmp_0 = content.i1f($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  }
  var tmp0_elvis_lhs = tmp;
  var contentLength = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  var actualHeaders = headers;
  var tmp_1;
  if (!(content == null)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_2;
      if (isInterface(headers, Collection)) {
        tmp_2 = headers.g1();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = headers.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.io.net.http.HttpClient.request.<anonymous>' call
        if (equals_0(element.hk_1, Companion_instance_52.q2w_1, true)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_1 = !tmp$ret$0;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    actualHeaders = actualHeaders.i2y([to(Companion_instance_52.q2w_1, contentLength.toString())]);
  }
  if (config.a2z_1) {
    actualHeaders = Companion_getInstance_56().j2z(actualHeaders, null);
  }
  // Inline function 'kotlin.apply' call
  var tmp_3 = $this.k2z(method, url, actualHeaders, content, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var this_0 = tmp_3;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.net.http.HttpClient.request.<anonymous>' call
  if (config.x2y_1) {
    var tmp_4 = this_0.p2w($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  var response = this_0;
  if (config.w2y_1 && config.y2y_1 >= 0) {
    var redirectLocation = response.o2v_1.l1i('location');
    if (!(redirectLocation == null)) {
      var tmp_5 = $this.l2z(method, mergeUrls($this, url, redirectLocation), headers.i2y([to('Referer', url)]), content, config.c2z(VOID, VOID, config.y2y_1 - 1 | 0), $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      return tmp_5;
    }
  }
  return response;
}
function *_generator_requestAsBytes__v4smbm($this, method, url, headers, content, config, $completion) {
  var tmp = $this.l2z(method, url, headers, content, config, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var res = tmp;
  var tmp_0 = res.l2y($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return res.q2y(tmp_0);
}
function *_generator_readBytes__epy2u7_0($this, url, config, $completion) {
  var tmp = $this.m2z(Companion_getInstance_51().c2w_1, url, VOID, VOID, config.c2z(VOID, true), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.u2y_1;
}
var Companion_instance_55;
function Companion_getInstance_56() {
  if (Companion_instance_55 === VOID)
    new Companion_54();
  return Companion_instance_55;
}
function createHttpClient() {
  _init_properties_HttpClient_kt__huy6s3();
  return get_defaultHttpFactory().p2z();
}
var HttpStatusMessage_instance;
function HttpStatusMessage_getInstance() {
  if (HttpStatusMessage_instance === VOID)
    new HttpStatusMessage();
  return HttpStatusMessage_instance;
}
function *_generator_withContentEncoding__x3c14e(_this__u8e3s4, contentEncoding, $completion) {
  var input = _this__u8e3s4;
  var tmp;
  switch (contentEncoding) {
    case '':
    case 'plain':
      tmp = input;
      break;
    case 'gzip':
      var tmp_0 = uncompressed(input, Companion_getInstance_9(), VOID, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
      break;
    case 'deflate':
      var tmp_1 = uncompressed(input, get_Deflate(), VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = tmp_1;
      break;
    default:
      var message = "Unsupported Content-Encoding '" + contentEncoding + "'";
      throw IllegalStateException.n4(toString(message));
  }
  return tmp;
}
function withContentEncoding(_this__u8e3s4, contentEncoding, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withContentEncoding__x3c14e(_this__u8e3s4, contentEncoding, $completion), $completion);
}
function *_generator_withTransferEncoding__5yv4cc(_this__u8e3s4, transferEncoding, $completion) {
  var input = _this__u8e3s4;
  var tmp;
  switch (transferEncoding) {
    case '':
    case 'identity':
      tmp = input;
      break;
    case 'chunked':
      var tmp_0 = asyncStreamWriter(VOID, 'chunked', VOID, withTransferEncoding$slambda_0(input), $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
      break;
    default:
      var message = "Unsupported Transfer-Encoding '" + transferEncoding + "'";
      throw IllegalStateException.n4(toString(message));
  }
  return tmp;
}
function withTransferEncoding(_this__u8e3s4, transferEncoding, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTransferEncoding__5yv4cc(_this__u8e3s4, transferEncoding, $completion), $completion);
}
function createHttpClientFromFetch(fetch) {
  fetch = fetch === VOID ? Companion_getInstance_45() : fetch;
  _init_properties_HttpClient_kt__huy6s3();
  return new createHttpClientFromFetch$1(fetch);
}
function get_defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  return get__defaultHttpFactory();
}
function createHttpClientFromFetch$accessor$36sicd(fetch) {
  fetch = fetch === VOID ? Companion_getInstance_45() : fetch;
  _init_properties_HttpClient_kt__huy6s3();
  return createHttpClientFromFetch(fetch);
}
function _defaultHttpFactory$delegate$lambda() {
  _init_properties_HttpClient_kt__huy6s3();
  return new ProxiedHttpFactory(get_httpFactory());
}
function *_generator_invoke__zhh2q8_8($this, out, $completion) {
  do {
    // Inline function 'kotlin.text.trim' call
    var tmp = readLine($this.s2z_1, VOID, VOID, VOID, 16, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var this_0 = tmp;
    var nbytesString = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var tmp0_elvis_lhs = toIntOrNull_0(nbytesString, 16);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't convert '" + nbytesString + "' into int for chunked encoding";
      throw IllegalStateException.n4(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var nbytes = tmp_0;
    if (nbytes > 0) {
      var tmp_1 = readBytesExact($this.s2z_1, nbytes, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var bytes = tmp_1;
      var tmp_2 = out.c1f(bytes, VOID, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      var tmp_3 = readLine($this.s2z_1, VOID, VOID, VOID, 2, VOID, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
   while (nbytes > 0);
  return Unit_instance;
}
function withTransferEncoding$slambda_0($input) {
  var i = new withTransferEncoding$slambda($input);
  var l = function (out, $completion) {
    return i.z1d(out, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_requestInternal__facax4($this, method, url, headers, content, $completion) {
  var url_0 = Companion_getInstance_50().p1a(url);
  var tmp = method.k3();
  var tmp0_elvis_lhs = url_0.x2u_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var message = 'Missing host';
    throw IllegalStateException.n4(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var tmp_1 = $this.u2z_1.s2m(tmp, tmp_0, url_0.n2x(), url_0.y2u_1, url_0.l2x(), toList(headers), content, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var result = tmp_1;
  var tmp_2 = Companion_instance_53.k2y(result.t2m_1, result.u2m_1, Headers.e2y(result.v2m_1), result.w2m_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
function _defaultHttpFactory$factory() {
  return getPropertyCallableRef('_defaultHttpFactory', 0, KProperty0, function () {
    return get__defaultHttpFactory();
  }, null);
}
function responseCharset$factory() {
  return getPropertyCallableRef('responseCharset', 1, KProperty1, function (receiver) {
    return receiver.o2y();
  }, null);
}
var properties_initialized_HttpClient_kt_t7kzvv;
function _init_properties_HttpClient_kt__huy6s3() {
  if (!properties_initialized_HttpClient_kt_t7kzvv) {
    properties_initialized_HttpClient_kt_t7kzvv = true;
    _defaultHttpFactory$delegate = lazy(_defaultHttpFactory$delegate$lambda);
  }
}
var EmptyLineOnce_instance;
function EmptyLineOnce_getInstance() {
  return EmptyLineOnce_instance;
}
var Indent_instance;
function Indent_getInstance() {
  return Indent_instance;
}
var Unindent_instance;
function Unindent_getInstance() {
  return Unindent_instance;
}
var INDENTS_instance;
function INDENTS_getInstance() {
  return INDENTS_instance;
}
var Companion_instance_56;
function Companion_getInstance_57() {
  if (Companion_instance_56 === VOID)
    new Companion_55();
  return Companion_instance_56;
}
function get_LONG_ZERO_TO_MAX_RANGE_0() {
  _init_properties_RangeExt_kt__vz0y4k();
  return LONG_ZERO_TO_MAX_RANGE_0;
}
var LONG_ZERO_TO_MAX_RANGE_0;
var properties_initialized_RangeExt_kt_dqkq5i;
function _init_properties_RangeExt_kt__vz0y4k() {
  if (!properties_initialized_RangeExt_kt_dqkq5i) {
    properties_initialized_RangeExt_kt_dqkq5i = true;
    LONG_ZERO_TO_MAX_RANGE_0 = (new Long(0, 0)).s1(new Long(-1, 2147483647));
  }
}
var Companion_instance_57;
function Companion_getInstance_58() {
  return Companion_instance_57;
}
function posSkip($this, count) {
  var out = $this.z2w_1;
  $this.z2w_1 = $this.z2w_1 + count | 0;
  return out;
}
function substr($this, pos, length) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = $this.x2w_1;
  // Inline function 'kotlin.math.min' call
  var b = $this.b2x_1;
  var startIndex = Math.min(pos, b);
  // Inline function 'kotlin.math.min' call
  var a = pos + length | 0;
  var b_0 = $this.b2x_1;
  var endIndex = Math.min(a, b_0);
  // Inline function 'kotlin.js.asDynamic' call
  return this_0.substring(startIndex, endIndex);
}
function get_DEBUG_WORKER() {
  _init_properties_Worker_kt__eidt7m();
  return DEBUG_WORKER;
}
var DEBUG_WORKER;
function DemoWorkerTask$execute$slambda_0() {
  var i = new DemoWorkerTask$execute$slambda();
  var l = function (params, $completion) {
    return i.m31(params, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'kotlin.runCatching' call
  var this_0 = $this.f32_1;
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    // Inline function 'korlibs.io.worker.WorkerTask.runSuspend.<anonymous>.<anonymous>' call
    var tmp_0 = $this.g32_1(this_0.a32(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var value = tmp_0;
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  var tmp$ret$3 = tmp;
  completeWith($this.e32_1, tmp$ret$3);
  return Unit_instance;
}
function WorkerTask$runSuspend$slambda_0($deferred, this$0, $block) {
  var i = new WorkerTask$runSuspend$slambda($deferred, this$0, $block);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
var Companion_instance_58;
function Companion_getInstance_59() {
  return Companion_instance_58;
}
var properties_initialized_Worker_kt_gr88g0;
function _init_properties_Worker_kt__eidt7m() {
  if (!properties_initialized_Worker_kt_gr88g0) {
    properties_initialized_Worker_kt_gr88g0 = true;
    DEBUG_WORKER = Companion_instance_96.l1i('DEBUG_WORKER') === 'true';
  }
}
function *_generator_delay__nu7n9t(time, $completion) {
  var tmp = delay_0(numberToLong(_FastDuration___get_milliseconds__impl__ffr17u(time)), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function delay_1(time, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_delay__nu7n9t(time, $completion), $completion);
}
function get_jsGlobalDynamic() {
  _init_properties_KorioNativeJs_kt__151su();
  return jsGlobalDynamic;
}
var jsGlobalDynamic;
var jsGlobal;
function get_isDenoJs() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isDenoJs$delegate;
  isDenoJs$factory();
  return this_0.h3();
}
var isDenoJs$delegate;
function get_isWeb() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWeb$delegate;
  isWeb$factory();
  return this_0.h3();
}
var isWeb$delegate;
function get_isWorker() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWorker$delegate;
  isWorker$factory();
  return this_0.h3();
}
var isWorker$delegate;
function get_isNodeJs() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isNodeJs$delegate;
  isNodeJs$factory();
  return this_0.h3();
}
var isNodeJs$delegate;
function set__jsRuntime(_set____db54di) {
  _init_properties_KorioNativeJs_kt__151su();
  _jsRuntime = _set____db54di;
}
function get__jsRuntime() {
  _init_properties_KorioNativeJs_kt__151su();
  return _jsRuntime;
}
var _jsRuntime;
function get_jsRuntime() {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp0_elvis_lhs = get__jsRuntime();
  set__jsRuntime(tmp0_elvis_lhs == null ? get_isDenoJs() ? Companion_getInstance_62() : Companion_getInstance_61() : tmp0_elvis_lhs);
  return ensureNotNull(get__jsRuntime());
}
function get_isShell() {
  _init_properties_KorioNativeJs_kt__151su();
  return !get_isWeb() && !get_isNodeJs() && !get_isWorker();
}
function isDenoJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof Deno === 'object' && Deno.statSync !== undefined;
}
function isWeb$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof window === 'object';
}
function isWorker$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof importScripts === 'function';
}
function isNodeJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
}
function isDenoJs$factory() {
  return getPropertyCallableRef('isDenoJs', 0, KProperty0, function () {
    return get_isDenoJs();
  }, null);
}
function isWeb$factory() {
  return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
    return get_isWeb();
  }, null);
}
function isWorker$factory() {
  return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
    return get_isWorker();
  }, null);
}
function isNodeJs$factory() {
  return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
    return get_isNodeJs();
  }, null);
}
var properties_initialized_KorioNativeJs_kt_y4p8os;
function _init_properties_KorioNativeJs_kt__151su() {
  if (!properties_initialized_KorioNativeJs_kt_y4p8os) {
    properties_initialized_KorioNativeJs_kt_y4p8os = true;
    jsGlobalDynamic = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
    jsGlobal = get_jsGlobalDynamic();
    isDenoJs$delegate = lazy(isDenoJs$delegate$lambda);
    isWeb$delegate = lazy(isWeb$delegate$lambda);
    isWorker$delegate = lazy(isWorker$delegate$lambda);
    isNodeJs$delegate = lazy(isNodeJs$delegate$lambda);
    _jsRuntime = null;
  }
}
function toVfs(_this__u8e3s4) {
  var file = _this__u8e3s4;
  return (new toVfs$1(file)).l1i(file.name);
}
function openAsync_0(_this__u8e3s4) {
  return buffered(toAsyncStream(BlobAsyncBaseStream.k32(_this__u8e3s4)), 65536, 16);
}
function BlobAsyncBaseStream$read$lambda($reader, $len, $buffer, $offset, $deferred) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    var ab = $reader.result;
    // Inline function 'kotlin.math.min' call
    var a = ab.byteLength;
    var b = $len;
    var minLen = Math.min(a, b);
    arraycopy_2(toByteArray(new Int8Array(ab)), 0, $buffer, $offset, minLen);
    return $deferred.yu(minLen);
  };
}
function BlobAsyncBaseStream$read$lambda_0($deferred, $reader) {
  return function (it) {
    return $deferred.xu(newThrowable('' + $reader.error));
  };
}
function get_standardVfs() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return standardVfs;
}
var standardVfs;
function get_applicationVfs() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  // Inline function 'kotlin.getValue' call
  var this_0 = applicationVfs$delegate;
  applicationVfs$factory();
  return this_0.h3();
}
var applicationVfs$delegate;
var applicationDataVfsOrNull;
var cacheVfsOrNull;
var externalStorageVfs$delegate;
var userHomeVfs$delegate;
var tempVfsOrNull;
function localVfs(path, async) {
  async = async === VOID ? true : async;
  _init_properties_LocalVfsJs_kt__kywvdr();
  return get_jsRuntime().p32(path);
}
function standardVfs$o$resourcesVfs$delegate$lambda() {
  return get_applicationVfs().f2t();
}
function standardVfs$o$rootLocalVfs$delegate$lambda() {
  return localVfs('.');
}
function applicationVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function externalStorageVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function userHomeVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function applicationVfs$factory() {
  return getPropertyCallableRef('applicationVfs', 0, KProperty0, function () {
    return get_applicationVfs();
  }, null);
}
function resourcesVfs$factory() {
  return getPropertyCallableRef('resourcesVfs', 1, KProperty1, function (receiver) {
    return receiver.i2u();
  }, null);
}
var properties_initialized_LocalVfsJs_kt_51m659;
function _init_properties_LocalVfsJs_kt__kywvdr() {
  if (!properties_initialized_LocalVfsJs_kt_51m659) {
    properties_initialized_LocalVfsJs_kt_51m659 = true;
    standardVfs = new standardVfs$1();
    applicationVfs$delegate = lazy(applicationVfs$delegate$lambda);
    applicationDataVfsOrNull = null;
    cacheVfsOrNull = null;
    externalStorageVfs$delegate = lazy(externalStorageVfs$delegate$lambda);
    userHomeVfs$delegate = lazy(userHomeVfs$delegate$lambda);
    tempVfsOrNull = null;
  }
}
var StandardPaths_instance;
function StandardPaths_getInstance() {
  return StandardPaths_instance;
}
function get_httpFactory() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  // Inline function 'kotlin.getValue' call
  var this_0 = httpFactory$delegate;
  httpFactory$factory();
  return this_0.h3();
}
var httpFactory$delegate;
function httpFactory$delegate$lambda() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  return new httpFactory$2$1();
}
function httpFactory$factory() {
  return getPropertyCallableRef('httpFactory', 0, KProperty0, function () {
    return get_httpFactory();
  }, null);
}
var properties_initialized_HttpFactoryJs_kt_on1x9h;
function _init_properties_HttpFactoryJs_kt__a3ro2v() {
  if (!properties_initialized_HttpFactoryJs_kt_on1x9h) {
    properties_initialized_HttpFactoryJs_kt_on1x9h = true;
    httpFactory$delegate = lazy(httpFactory$delegate$lambda);
  }
}
var Companion_instance_59;
function Companion_getInstance_60() {
  if (Companion_instance_59 === VOID)
    new Companion_58();
  return Companion_instance_59;
}
var Companion_instance_60;
function Companion_getInstance_61() {
  if (Companion_instance_60 === VOID)
    new Companion_59();
  return Companion_instance_60;
}
function JsRuntimeBrowser$href$delegate$lambda() {
  var tmp86_safe_receiver = document.location;
  var tmp0_elvis_lhs = tmp86_safe_receiver == null ? null : tmp86_safe_receiver.href;
  return tmp0_elvis_lhs == null ? '.' : tmp0_elvis_lhs;
}
function JsRuntimeBrowser$baseUrl$delegate$lambda(this$0) {
  return function () {
    return endsWith(this$0.z32(), '/') ? this$0.z32() : substringBeforeLast(this$0.z32(), _Char___init__impl__6a9atx(47));
  };
}
function href$factory() {
  return getPropertyCallableRef('href', 1, KProperty1, function (receiver) {
    return receiver.z32();
  }, null);
}
function baseUrl$factory() {
  return getPropertyCallableRef('baseUrl', 1, KProperty1, function (receiver) {
    return receiver.a33();
  }, null);
}
var Companion_instance_61;
function Companion_getInstance_62() {
  if (Companion_instance_61 === VOID)
    new Companion_60();
  return Companion_instance_61;
}
function getFullPath($this, path) {
  return normalize(get_pathInfo(path));
}
function *_generator_open__qjxcea_2($this, path, mode, $completion) {
  var options = jsObject([to('read', mode.y2s_1), to('write', mode.v2s_1), to('append', mode.z2s_1), to('truncate', mode.x2s_1), to('create', mode.v2s_1), to('mode', toInt('666', 8))]);
  var fullPath = getFullPath($this, path);
  try {
    var tmp = await_0(Deno.open(fullPath, options), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var file = tmp;
    return toAsyncStream(DenoAsyncStreamBase.j33(file));
  } catch ($p) {
    var e = $p;
    if (e && e.code == 'ENOENT')
      throw FileNotFoundException.r2u("Can't open file " + fullPath);
    throw e;
  }
}
function *_generator_stat__qhnowc_3($this, path, $completion) {
  var tmp;
  try {
    // Inline function 'kotlin.let' call
    var tmp_0 = await_0(Deno.stat(getFullPath($this, path)), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.runtime.DenoLocalVfs.stat.<anonymous>' call
    var it = tmp_0;
    var tmp_1 = it.isDirectory;
    var tmp_2 = numberToLong(it.size);
    var tmp_3 = numberToLong(it.dev);
    var tmp87_safe_receiver = it.ino;
    var tmp0_elvis_lhs = tmp87_safe_receiver == null ? null : numberToLong(tmp87_safe_receiver);
    var tmp_4 = tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs;
    var tmp88_safe_receiver = it.mode;
    var tmp1_elvis_lhs = tmp88_safe_receiver == null ? null : numberToInt(tmp88_safe_receiver);
    tmp = $this.k2s(path, tmp_1, tmp_2, tmp_3, tmp_4, tmp1_elvis_lhs == null ? toInt('777', 8) : tmp1_elvis_lhs);
  } catch ($p) {
    var tmp_5;
    if ($p instanceof Error) {
      var e = $p;
      tmp_5 = $this.m2s(path);
    } else {
      throw $p;
    }
    tmp = tmp_5;
  }
  return tmp;
}
function *_generator_read__qih2oe_6($this, position, buffer, offset, len, $completion) {
  var tmp = await_0($this.h33_1.seek(position.e4(), Deno.SeekMode.Start), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = await_0($this.h33_1.read(new Uint8Array(buffer.buffer, offset, len)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var read = tmp_0;
  var tmp0_elvis_lhs = read == null ? null : numberToInt(read);
  return tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
}
function *_generator_write__x1694l_7($this, position, buffer, offset, len, $completion) {
  var tmp = await_0($this.h33_1.seek(position.e4(), Deno.SeekMode.Start), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = await_0($this.h33_1.write(new Uint8Array(buffer.buffer, offset, len)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_getLength__lvva94_2($this, $completion) {
  var tmp = await_0($this.h33_1.stat(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return numberToLong(tmp.size);
}
function toByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tout = _this__u8e3s4;
  var tmp;
  if (!(tout == null) ? isByteArray(tout) : false) {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = tout;
  } else {
    var out = new Int8Array(_this__u8e3s4.length);
    var inductionVariable = 0;
    var last = out.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        out[n] = _this__u8e3s4[n];
      }
       while (inductionVariable <= last);
    tmp = out;
  }
  return tmp;
}
function set_workerUrl(_set____db54di) {
  _init_properties_Worker_js_kt__6mcbpj();
  workerUrl = _set____db54di;
}
function get_workerUrl() {
  _init_properties_Worker_js_kt__6mcbpj();
  return workerUrl;
}
var workerUrl;
function get_workerImpl() {
  _init_properties_Worker_js_kt__6mcbpj();
  return workerImpl;
}
var workerImpl;
function get_isWorker_0() {
  _init_properties_Worker_js_kt__6mcbpj();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof DedicatedWorkerGlobalScope === 'function';
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  try {
    $this.l33_1.s31();
    var result = $this.l33_1.w31_1;
    if (!(result == null) ? isInterface(result, Deferred) : false) {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = get_jsGlobalThis();
      // Inline function 'kotlin.arrayOf' call
      var tmp = result.hr($completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [$this.m33_1, 'ok', tmp];
      tmp$ret$0.postMessage(tmp$ret$3);
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = get_jsGlobalThis();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$7 = [$this.m33_1, 'ok', result];
      tmp$ret$4.postMessage(tmp$ret$7);
    }
  } catch ($p) {
    var e = $p;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = get_jsGlobalThis();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$11 = [$this.m33_1, 'error', e.stack];
    tmp$ret$8.postMessage(tmp$ret$11);
  }
  return Unit_instance;
}
function workerImpl$o$insideWorker$lambda(evt) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var input = evt.data;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var id = input[0];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = input[1];
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? get_workerUrl() : tmp0_elvis_lhs;
  var moduleUrl = tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var clazzName = input[2];
  var params = drop(input, 3);
  var tmp = import(moduleUrl);
  var tmp_0 = tmp instanceof Promise ? tmp : THROW_CCE();
  var imported = tmp_0.then(workerImpl$o$insideWorker$lambda$lambda(clazzName, params, id));
  return Unit_instance;
}
function workerImpl$o$insideWorker$lambda$lambda$slambda_0($workerTask, $id) {
  var i = new workerImpl$o$insideWorker$lambda$lambda$slambda($workerTask, $id);
  var l = function ($completion) {
    return i.dd($completion);
  };
  l.$arity = 0;
  return l;
}
function workerImpl$o$insideWorker$lambda$lambda($clazzName, $params, $id) {
  return function (imported) {
    // Inline function 'kotlin.js.asDynamic' call
    var taskClass = imported[$clazzName];
    // Inline function 'kotlin.js.unsafeCast' call
    var workerTask = jsNew(taskClass);
    workerTask.v31_1 = toList($params);
    var tmp = EmptyCoroutineContext_getInstance();
    return launchImmediately(tmp, workerImpl$o$insideWorker$lambda$lambda$slambda_0(workerTask, $id));
  };
}
var properties_initialized_Worker_js_kt_gnq77b;
function _init_properties_Worker_js_kt__6mcbpj() {
  if (!properties_initialized_Worker_js_kt_gnq77b) {
    properties_initialized_Worker_js_kt_gnq77b = true;
    var tmp0_elvis_lhs = globalThis.location;
    workerUrl = tmp0_elvis_lhs == null ? get_isDenoJs() ? Deno.mainModule : '.' : tmp0_elvis_lhs;
    workerImpl = new workerImpl$1();
  }
}
function JSStackTrace$Companion$parse$lambda($numParts) {
  return function (it) {
    var tmp0_elvis_lhs = toIntOrNull(it.xh().f1(2));
    $numParts.k6(0, tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs);
    return it.xh().f1(1);
  };
}
var Companion_instance_62;
function Companion_getInstance_63() {
  return Companion_instance_62;
}
var Color_BLACK_instance;
var Color_RED_instance;
var Color_GREEN_instance;
var Color_YELLOW_instance;
var Color_BLUE_instance;
var Color_PURPLE_instance;
var Color_CYAN_instance;
var Color_WHITE_instance;
var Color_entriesInitialized;
function Color_initEntries() {
  if (Color_entriesInitialized)
    return Unit_instance;
  Color_entriesInitialized = true;
  Color_BLACK_instance = new Color('BLACK', 0, 0);
  Color_RED_instance = new Color('RED', 1, 1);
  Color_GREEN_instance = new Color('GREEN', 2, 2);
  Color_YELLOW_instance = new Color('YELLOW', 3, 3);
  Color_BLUE_instance = new Color('BLUE', 4, 4);
  Color_PURPLE_instance = new Color('PURPLE', 5, 5);
  Color_CYAN_instance = new Color('CYAN', 6, 6);
  Color_WHITE_instance = new Color('WHITE', 7, 7);
}
function Color_RED_getInstance() {
  Color_initEntries();
  return Color_RED_instance;
}
function Color_GREEN_getInstance() {
  Color_initEntries();
  return Color_GREEN_instance;
}
function Color_YELLOW_getInstance() {
  Color_initEntries();
  return Color_YELLOW_instance;
}
function Color_BLUE_getInstance() {
  Color_initEntries();
  return Color_BLUE_instance;
}
function Color_CYAN_getInstance() {
  Color_initEntries();
  return Color_CYAN_instance;
}
var baseConsoleHook;
var Kind_ERROR_instance;
var Kind_WARN_instance;
var Kind_INFO_instance;
var Kind_DEBUG_instance;
var Kind_TRACE_instance;
var Kind_LOG_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_ERROR_instance = new Kind('ERROR', 0, 0, Color_RED_getInstance());
  Kind_WARN_instance = new Kind('WARN', 1, 1, Color_YELLOW_getInstance());
  Kind_INFO_instance = new Kind('INFO', 2, 2, Color_BLUE_getInstance());
  Kind_DEBUG_instance = new Kind('DEBUG', 3, 3, Color_CYAN_getInstance());
  Kind_TRACE_instance = new Kind('TRACE', 4, 4, Color_GREEN_getInstance());
  Kind_LOG_instance = new Kind('LOG', 5, 5, null);
}
function BaseConsole$logInternal$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.k34(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'logInternal';
  return l;
}
function Kind_ERROR_getInstance() {
  Kind_initEntries();
  return Kind_ERROR_instance;
}
function Kind_WARN_getInstance() {
  Kind_initEntries();
  return Kind_WARN_instance;
}
function Kind_LOG_getInstance() {
  Kind_initEntries();
  return Kind_LOG_instance;
}
var _miniEnvironmentVariablesUC;
function normalizeName($this, name) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return replace_0(replace_0(name, _Char___init__impl__6a9atx(46), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(95)).toUpperCase();
}
var Level_NONE_instance;
var Level_FATAL_instance;
var Level_ERROR_instance;
var Level_WARN_instance;
var Level_INFO_instance;
var Level_DEBUG_instance;
var Level_TRACE_instance;
var Companion_instance_63;
function Companion_getInstance_64() {
  Level_initEntries();
  if (Companion_instance_63 === VOID)
    new Companion_62();
  return Companion_instance_63;
}
function values_1() {
  return [Level_NONE_getInstance(), Level_FATAL_getInstance(), Level_ERROR_getInstance(), Level_WARN_getInstance(), Level_INFO_getInstance(), Level_DEBUG_getInstance(), Level_TRACE_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'NONE':
      return Level_NONE_getInstance();
    case 'FATAL':
      return Level_FATAL_getInstance();
    case 'ERROR':
      return Level_ERROR_getInstance();
    case 'WARN':
      return Level_WARN_getInstance();
    case 'INFO':
      return Level_INFO_getInstance();
    case 'DEBUG':
      return Level_DEBUG_getInstance();
    case 'TRACE':
      return Level_TRACE_getInstance();
    default:
      Level_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var Level_entriesInitialized;
function Level_initEntries() {
  if (Level_entriesInitialized)
    return Unit_instance;
  Level_entriesInitialized = true;
  Level_NONE_instance = new Level('NONE', 0, 0);
  Level_FATAL_instance = new Level('FATAL', 1, 1);
  Level_ERROR_instance = new Level('ERROR', 2, 2);
  Level_WARN_instance = new Level('WARN', 3, 3);
  Level_INFO_instance = new Level('INFO', 4, 4);
  Level_DEBUG_instance = new Level('DEBUG', 5, 5);
  Level_TRACE_instance = new Level('TRACE', 6, 6);
  Companion_getInstance_64();
}
var Companion_instance_64;
function Companion_getInstance_65() {
  if (Companion_instance_64 === VOID)
    new Companion_63();
  return Companion_instance_64;
}
var ConsoleLogOutput_instance;
function ConsoleLogOutput_getInstance() {
  return ConsoleLogOutput_instance;
}
function Level_NONE_getInstance() {
  Level_initEntries();
  return Level_NONE_instance;
}
function Level_FATAL_getInstance() {
  Level_initEntries();
  return Level_FATAL_instance;
}
function Level_ERROR_getInstance() {
  Level_initEntries();
  return Level_ERROR_instance;
}
function Level_WARN_getInstance() {
  Level_initEntries();
  return Level_WARN_instance;
}
function Level_INFO_getInstance() {
  Level_initEntries();
  return Level_INFO_instance;
}
function Level_DEBUG_getInstance() {
  Level_initEntries();
  return Level_DEBUG_instance;
}
function Level_TRACE_getInstance() {
  Level_initEntries();
  return Level_TRACE_instance;
}
function get_miniEnvironmentVariablesUC() {
  if (_miniEnvironmentVariablesUC == null) {
    // Inline function 'kotlin.collections.mapKeys' call
    var this_0 = get_miniEnvironmentVariables();
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination = LinkedHashMap.pb(mapCapacity(this_0.d1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator = this_0.c3().a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.logger.<get-miniEnvironmentVariablesUC>.<anonymous>' call
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = element.g3().toUpperCase();
      // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
      var tmp$ret$3 = element.h3();
      destination.x2(tmp, tmp$ret$3);
    }
    _miniEnvironmentVariablesUC = destination;
  }
  return ensureNotNull(_miniEnvironmentVariablesUC);
}
function get_miniEnvironmentVariables() {
  return Companion_getInstance_101().x34();
}
var DefaultLogOutput_instance;
function DefaultLogOutput_getInstance() {
  return DefaultLogOutput_instance;
}
var Console_instance;
function Console_getInstance() {
  if (Console_instance === VOID)
    new Console();
  return Console_instance;
}
function get_MINUS_ZERO_D() {
  _init_properties_NumberExt_kt__gxb31i();
  return MINUS_ZERO_D;
}
var MINUS_ZERO_D;
function toStringDecimal(_this__u8e3s4, decimalPlaces, skipTrailingZeros) {
  skipTrailingZeros = skipTrailingZeros === VOID ? false : skipTrailingZeros;
  _init_properties_NumberExt_kt__gxb31i();
  if (isNanOrInfinite(_this__u8e3s4))
    return _this__u8e3s4.toString();
  var res = normalizeZero(roundDecimalPlaces(_this__u8e3s4, decimalPlaces)).toString();
  var eup = indexOf_1(res, _Char___init__impl__6a9atx(69));
  var elo = indexOf_1(res, _Char___init__impl__6a9atx(101));
  var eIndex = eup >= 0 ? eup : elo;
  var tmp;
  if (eIndex >= 0) {
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var base = res.substring(0, eIndex);
    // Inline function 'kotlin.text.substring' call
    var startIndex = eIndex + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = res.substring(startIndex);
    var exp = toInt_0(tmp$ret$3);
    var rbase = contains(base, '.') ? base : base + '.0';
    // Inline function 'kotlin.math.absoluteValue' call
    var tmp$ret$4 = abs(exp);
    var zeros = repeat('0', tmp$ret$4 + 2 | 0);
    var part = exp > 0 ? rbase + zeros : zeros + rbase;
    var pointIndex2 = indexOf_0(part, '.');
    var pointIndex = pointIndex2 < 0 ? part.length : pointIndex2;
    var outIndex = pointIndex + exp | 0;
    var part2 = replace(part, '.', '');
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>' call
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_1 = until(0, outIndex);
      var tmp_0;
      if (isInterface(this_1, Collection)) {
        tmp_0 = this_1.g1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator = this_1.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>.<anonymous>' call
        if (!(charSequenceGet(part2, element) === _Char___init__impl__6a9atx(48))) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    if (tmp$ret$5) {
      this_0.bb(_Char___init__impl__6a9atx(48));
    } else {
      this_0.cg(part2, 0, outIndex);
    }
    this_0.bb(_Char___init__impl__6a9atx(46));
    this_0.cg(part2, outIndex, part2.length);
    tmp = this_0.toString();
  } else {
    tmp = res;
  }
  var rez = tmp;
  var pointIndex_0 = indexOf_1(rez, _Char___init__impl__6a9atx(46));
  var tmp_1;
  if (pointIndex_0 >= 0) {
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = rez.substring(0, pointIndex_0);
  } else {
    tmp_1 = rez;
  }
  var integral = tmp_1;
  if (decimalPlaces === 0)
    return integral;
  var tmp_2;
  if (pointIndex_0 >= 0) {
    // Inline function 'kotlin.text.substring' call
    var startIndex_0 = pointIndex_0 + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = rez.substring(startIndex_0);
    tmp_2 = trimEnd(tmp$ret$12, charArrayOf([_Char___init__impl__6a9atx(48)]));
  } else {
    tmp_2 = '';
  }
  var decimal = tmp_2;
  // Inline function 'kotlin.text.buildString' call
  var capacity = (2 + integral.length | 0) + decimalPlaces | 0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_2 = StringBuilder.gb(capacity);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>' call
  this_2.ab(integral);
  var tmp_3;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(decimal) > 0) {
    tmp_3 = true;
  } else {
    tmp_3 = !skipTrailingZeros;
  }
  if (tmp_3) {
    // Inline function 'kotlin.math.min' call
    var a = decimal.length;
    var decimalCount = Math.min(a, decimalPlaces);
    var tmp$ret$15;
    $l$block_2: {
      // Inline function 'kotlin.collections.all' call
      var this_3 = until(0, decimalCount);
      var tmp_4;
      if (isInterface(this_3, Collection)) {
        tmp_4 = this_3.g1();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$15 = true;
        break $l$block_2;
      }
      var tmp0_iterator_0 = this_3.a1();
      while (tmp0_iterator_0.b1()) {
        var element_0 = tmp0_iterator_0.c1();
        // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>.<anonymous>' call
        if (!(charSequenceGet(decimal, element_0) === _Char___init__impl__6a9atx(48))) {
          tmp$ret$15 = false;
          break $l$block_2;
        }
      }
      tmp$ret$15 = true;
    }
    var allZeros = tmp$ret$15;
    if (!skipTrailingZeros || !allZeros) {
      this_2.bb(_Char___init__impl__6a9atx(46));
      this_2.cg(decimal, 0, decimalCount);
      if (!skipTrailingZeros) {
        // Inline function 'kotlin.repeat' call
        var times = decimalPlaces - decimalCount | 0;
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.io.util.toStringDecimal.<anonymous>.<anonymous>' call
            this_2.bb(_Char___init__impl__6a9atx(48));
          }
           while (inductionVariable < times);
      }
    }
  }
  return this_2.toString();
}
function isNanOrInfinite(_this__u8e3s4) {
  _init_properties_NumberExt_kt__gxb31i();
  return isNaN_0(_this__u8e3s4) || isInfinite(_this__u8e3s4);
}
function normalizeZero(_this__u8e3s4) {
  _init_properties_NumberExt_kt__gxb31i();
  return _this__u8e3s4 === get_MINUS_ZERO_D() ? 0.0 : _this__u8e3s4;
}
function roundDecimalPlaces(_this__u8e3s4, places) {
  _init_properties_NumberExt_kt__gxb31i();
  if (places < 0)
    return _this__u8e3s4;
  // Inline function 'kotlin.math.pow' call
  var placesFactor = Math.pow(10.0, places);
  return round(_this__u8e3s4 * placesFactor) / placesFactor;
}
var properties_initialized_NumberExt_kt_qjkgco;
function _init_properties_NumberExt_kt__gxb31i() {
  if (!properties_initialized_NumberExt_kt_qjkgco) {
    properties_initialized_NumberExt_kt_qjkgco = true;
    MINUS_ZERO_D = -0.0;
  }
}
var NumberParser_instance;
function NumberParser_getInstance() {
  if (NumberParser_instance === VOID)
    new NumberParser();
  return NumberParser_instance;
}
function ctypeAsInt(_this__u8e3s4) {
  return Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(57)) <= 0 ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(48)) : Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(97)) >= 0 && Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(122)) <= 0 ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(97)) + 10 | 0 : Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(65)) >= 0 && Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(90)) <= 0 ? Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65)) + 10 | 0 : -1;
}
function nextAlignedTo(_this__u8e3s4, align) {
  return isAlignedTo(_this__u8e3s4, align) ? _this__u8e3s4 : imul((_this__u8e3s4 / align | 0) + 1 | 0, align);
}
function isAlignedTo(_this__u8e3s4, alignment) {
  return alignment === 0 || (_this__u8e3s4 % alignment | 0) === 0;
}
function nextAlignedTo_0(_this__u8e3s4, align) {
  var tmp;
  if (isAlignedTo_0(_this__u8e3s4, align)) {
    tmp = _this__u8e3s4;
  } else {
    // Inline function 'kotlin.Long.plus' call
    tmp = _this__u8e3s4.s3(align).q3(toLong(1)).r3(align);
  }
  return tmp;
}
function isAlignedTo_0(_this__u8e3s4, alignment) {
  return alignment.equals(new Long(0, 0)) || _this__u8e3s4.t3(alignment).equals(new Long(0, 0));
}
function clamp01(_this__u8e3s4) {
  return clamp_1(_this__u8e3s4, 0.0, 1.0);
}
function clamp(_this__u8e3s4, min, max) {
  return _this__u8e3s4 < min ? min : _this__u8e3s4 > max ? max : _this__u8e3s4;
}
function clampUByte(_this__u8e3s4) {
  var n = _this__u8e3s4 & (-(_this__u8e3s4 >= 0 ? 1 : 0) | 0);
  return (n | (255 - n | 0) >> 31) & 255;
}
function clamp_0(_this__u8e3s4, min, max) {
  return _this__u8e3s4 < min ? min : _this__u8e3s4 > max ? max : _this__u8e3s4;
}
function toIntClamp(_this__u8e3s4, min, max) {
  min = min === VOID ? -2147483648 : min;
  max = max === VOID ? 2147483647 : max;
  if (_this__u8e3s4.p1(toLong(min)) < 0)
    return min;
  if (_this__u8e3s4.p1(toLong(max)) > 0)
    return max;
  return _this__u8e3s4.b2();
}
function clamp_1(_this__u8e3s4, min, max) {
  return _this__u8e3s4 < min ? min : _this__u8e3s4 > max ? max : _this__u8e3s4;
}
function toShortClamped(_this__u8e3s4) {
  return toShort(clamp(_this__u8e3s4, -32768, 32767));
}
function convertRange(_this__u8e3s4, srcMin, srcMax, dstMin, dstMax) {
  return dstMin + (dstMax - dstMin) * ((_this__u8e3s4 - srcMin) / (srcMax - srcMin));
}
function convertRange_0(_this__u8e3s4, srcMin, srcMax, dstMin, dstMax) {
  return numberToInt(dstMin + (dstMax - dstMin | 0) * ((_this__u8e3s4 - srcMin | 0) / (srcMax - srcMin | 0)));
}
function ilog2_0(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function ilog2Ceil(v) {
  // Inline function 'kotlin.math.ceil' call
  // Inline function 'kotlin.math.log2' call
  var x = log2(v);
  var tmp$ret$1 = Math.ceil(x);
  return numberToInt(tmp$ret$1);
}
function isAlmostEquals(_this__u8e3s4, other, epsilon) {
  epsilon = epsilon === VOID ? 1.0E-6 : epsilon;
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _this__u8e3s4 - other;
  return Math.abs(this_0) < epsilon;
}
function isAlmostEquals_0(_this__u8e3s4, other, epsilon) {
  epsilon = epsilon === VOID ? 1.0E-6 : epsilon;
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = _this__u8e3s4 - other;
  return Math.abs(this_0) < epsilon;
}
function nextMultipleOf(_this__u8e3s4, multiple) {
  return isMultipleOf(_this__u8e3s4, multiple) ? _this__u8e3s4 : imul((_this__u8e3s4 / multiple | 0) + 1 | 0, multiple);
}
function isMultipleOf(_this__u8e3s4, multiple) {
  return multiple === 0 || (_this__u8e3s4 % multiple | 0) === 0;
}
function get_nextPowerOfTwo_0(_this__u8e3s4) {
  var v = _this__u8e3s4;
  v = v - 1 | 0;
  v = v | v >> 1;
  v = v | v >> 2;
  v = v | v >> 4;
  v = v | v >> 8;
  v = v | v >> 16;
  v = v + 1 | 0;
  return v;
}
function get_isPowerOfTwo(_this__u8e3s4) {
  return get_nextPowerOfTwo_0(_this__u8e3s4) === _this__u8e3s4;
}
function roundDecimalPlaces_0(_this__u8e3s4, places) {
  if (places < 0)
    return _this__u8e3s4;
  // Inline function 'kotlin.math.pow' call
  var placesFactor = Math.pow(10.0, places);
  return round(_this__u8e3s4 * placesFactor) / placesFactor;
}
function roundDecimalPlaces_1(_this__u8e3s4, places) {
  if (places < 0)
    return _this__u8e3s4;
  // Inline function 'kotlin.math.pow' call
  var placesFactor = Math.pow(10.0, places);
  // Inline function 'kotlin.math.round' call
  var x = _this__u8e3s4 * placesFactor;
  return round(x) / placesFactor;
}
function toIntRound(_this__u8e3s4) {
  return numberToInt(round(_this__u8e3s4));
}
function toIntCeil(_this__u8e3s4) {
  // Inline function 'kotlin.math.ceil' call
  var tmp$ret$0 = Math.ceil(_this__u8e3s4);
  return numberToInt(tmp$ret$0);
}
function toIntRound_0(_this__u8e3s4) {
  // Inline function 'kotlin.math.round' call
  var tmp$ret$0 = round(_this__u8e3s4);
  return numberToInt(tmp$ret$0);
}
function toLongRound(_this__u8e3s4) {
  return numberToLong(round(_this__u8e3s4));
}
var MINUS_ZERO_F;
function umod(_this__u8e3s4, other) {
  _init_properties_Umod_kt__kqwjv1();
  var rm = _this__u8e3s4 % other | 0;
  var remainder = rm === 0 ? 0 : rm;
  return remainder < 0 ? remainder + other | 0 : remainder;
}
function umod_0(_this__u8e3s4, other) {
  _init_properties_Umod_kt__kqwjv1();
  var rm = _this__u8e3s4 % other;
  var remainder = rm === -0.0 ? 0.0 : rm;
  return remainder < 0.0 ? remainder + other : remainder;
}
var properties_initialized_Umod_kt_24uvkf;
function _init_properties_Umod_kt__kqwjv1() {
  if (!properties_initialized_Umod_kt_24uvkf) {
    properties_initialized_Umod_kt_24uvkf = true;
    MINUS_ZERO_F = -0.0;
  }
}
function Easing$Companion$LINEAR$lambda(it) {
  return it;
}
function Easing$Companion$SMOOTH$lambda(it) {
  return it * it * (3 - 2 * it);
}
var Companion_instance_65;
function Companion_getInstance_66() {
  if (Companion_instance_65 === VOID)
    new Companion_64();
  return Companion_instance_65;
}
function interpolate(_this__u8e3s4, l, r) {
  return l + (r - l) * Ratio__toDouble_impl_o7epze(_this__u8e3s4);
}
function interpolate_0(_this__u8e3s4, l, r) {
  return Ratio__plus_impl_pm43pk(l, Ratio__times_impl_ucdh7y(Ratio__minus_impl_s1uwyg(r, l), _this__u8e3s4));
}
function _Ratio___init__impl__9mwvn2(value) {
  return value;
}
function _Ratio___get_value__impl__57cli6($this) {
  return $this;
}
function _Ratio___init__impl__9mwvn2_0(ratio) {
  return _Ratio___init__impl__9mwvn2(ratio);
}
function Ratio__toFloat_impl_1ftup5($this) {
  return _Ratio___get_value__impl__57cli6($this);
}
function Ratio__toDouble_impl_o7epze($this) {
  return _Ratio___get_value__impl__57cli6($this);
}
function Ratio__plus_impl_pm43pk($this, that) {
  return _Ratio___init__impl__9mwvn2(_Ratio___get_value__impl__57cli6($this) + _Ratio___get_value__impl__57cli6(that));
}
function Ratio__minus_impl_s1uwyg($this, that) {
  return _Ratio___init__impl__9mwvn2(_Ratio___get_value__impl__57cli6($this) - _Ratio___get_value__impl__57cli6(that));
}
function Ratio__times_impl_ucdh7y($this, that) {
  return _Ratio___init__impl__9mwvn2(_Ratio___get_value__impl__57cli6($this) * _Ratio___get_value__impl__57cli6(that));
}
function Ratio__times_impl_ucdh7y_0($this, that) {
  return _Ratio___get_value__impl__57cli6($this) * that;
}
function Ratio__compareTo_impl_z2ienc($this, other) {
  return compareTo(_Ratio___get_value__impl__57cli6($this), _Ratio___get_value__impl__57cli6(other));
}
function Ratio__compareTo_impl_z2ienc_0($this, other) {
  return Ratio__compareTo_impl_z2ienc($this.g35_1, other instanceof Ratio ? other.g35_1 : THROW_CCE());
}
function Ratio__toString_impl_mfgt3e($this) {
  return '' + _Ratio___get_value__impl__57cli6($this);
}
var Companion_instance_66;
function Companion_getInstance_67() {
  if (Companion_instance_66 === VOID)
    new Companion_65();
  return Companion_instance_66;
}
function Ratio__hashCode_impl_quhc2v($this) {
  return getNumberHashCode($this);
}
function Ratio__equals_impl_mfc2gt($this, other) {
  if (!(other instanceof Ratio))
    return false;
  var tmp0_other_with_cast = other instanceof Ratio ? other.g35_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function toRatio(_this__u8e3s4) {
  return _Ratio___init__impl__9mwvn2_0(_this__u8e3s4);
}
function toRatio_0(_this__u8e3s4) {
  return _Ratio___init__impl__9mwvn2(_this__u8e3s4);
}
function get__low(_this__u8e3s4) {
  return _this__u8e3s4.b2();
}
function get__high(_this__u8e3s4) {
  return _this__u8e3s4.a4(32).b2();
}
function extract_0(_this__u8e3s4, offset, count) {
  return (_this__u8e3s4 >>> offset | 0) & mask(count);
}
function insert(_this__u8e3s4, value, offset, count) {
  var mask_0 = mask(count) << offset;
  var ovalue = value << offset & mask_0;
  return _this__u8e3s4 & ~mask_0 | ovalue;
}
function insert_0(_this__u8e3s4, value, offset) {
  var bits = 1 << offset;
  return value ? _this__u8e3s4 | bits : _this__u8e3s4 & ~bits;
}
function mask(_this__u8e3s4) {
  return (1 << _this__u8e3s4) - 1 | 0;
}
function insert8(_this__u8e3s4, value, offset) {
  // Inline function 'korlibs.memory.insertMask' call
  return _this__u8e3s4 & ~(255 << offset) | (value & 255) << offset;
}
function get_low(_this__u8e3s4) {
  return _this__u8e3s4.b2();
}
function get_high(_this__u8e3s4) {
  return _this__u8e3s4.a4(32).b2();
}
function setBits(_this__u8e3s4, bits, set) {
  return set ? setBits_0(_this__u8e3s4, bits) : unsetBits(_this__u8e3s4, bits);
}
function insert5(_this__u8e3s4, value, offset) {
  // Inline function 'korlibs.memory.insertMask' call
  return _this__u8e3s4 & ~(31 << offset) | (value & 31) << offset;
}
function insert2(_this__u8e3s4, value, offset) {
  // Inline function 'korlibs.memory.insertMask' call
  return _this__u8e3s4 & ~(3 << offset) | (value & 3) << offset;
}
function insert4(_this__u8e3s4, value, offset) {
  // Inline function 'korlibs.memory.insertMask' call
  return _this__u8e3s4 & ~(15 << offset) | (value & 15) << offset;
}
function insert14(_this__u8e3s4, value, offset) {
  // Inline function 'korlibs.memory.insertMask' call
  return _this__u8e3s4 & ~(16383 << offset) | (value & 16383) << offset;
}
function insert3(_this__u8e3s4, value, offset) {
  // Inline function 'korlibs.memory.insertMask' call
  return _this__u8e3s4 & ~(7 << offset) | (value & 7) << offset;
}
function extractScaledf01(_this__u8e3s4, offset, count) {
  return extract_0(_this__u8e3s4, offset, count) / mask(count);
}
function insertScaledf01(_this__u8e3s4, value, offset, count) {
  return insert(_this__u8e3s4, numberToInt(coerceIn_0(value, 0.0, 1.0) * mask(offset)), offset, count);
}
function setBits_0(_this__u8e3s4, bits) {
  return _this__u8e3s4 | bits;
}
function unsetBits(_this__u8e3s4, bits) {
  return _this__u8e3s4 & ~bits;
}
function get_niceStr(_this__u8e3s4) {
  return niceStr(_this__u8e3s4, -1, false);
}
function get_niceStr_0(_this__u8e3s4) {
  return niceStr_0(_this__u8e3s4, -1, false);
}
function niceStr(_this__u8e3s4, decimalPlaces, zeroSuffix) {
  zeroSuffix = zeroSuffix === VOID ? false : zeroSuffix;
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.i();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.number.niceStr.<anonymous>' call
  appendNice(this_0, roundDecimalPlaces_0(_this__u8e3s4, decimalPlaces), zeroSuffix && decimalPlaces > 0);
  return this_0.toString();
}
function niceStr_0(_this__u8e3s4, decimalPlaces, zeroSuffix) {
  zeroSuffix = zeroSuffix === VOID ? false : zeroSuffix;
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.i();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.number.niceStr.<anonymous>' call
  appendNice_0(this_0, roundDecimalPlaces_1(_this__u8e3s4, decimalPlaces), zeroSuffix && decimalPlaces > 0);
  return this_0.toString();
}
function appendNice(_this__u8e3s4, value, zeroSuffix) {
  zeroSuffix = zeroSuffix === VOID ? false : zeroSuffix;
  if (isAlmostEquals(round(value), value))
    if (value >= -2147483648 && value <= 2147483647)
      _this__u8e3s4.eg(numberToInt(round(value)));
    else
      _this__u8e3s4.fg(numberToLong(round(value)));
  else {
    _this__u8e3s4.hg(value);
    return Unit_instance;
  }
  if (zeroSuffix) {
    _this__u8e3s4.ab('.0');
  }
}
function appendNice_0(_this__u8e3s4, value, zeroSuffix) {
  zeroSuffix = zeroSuffix === VOID ? false : zeroSuffix;
  // Inline function 'kotlin.math.round' call
  var tmp$ret$0 = round(value);
  if (isAlmostEquals_0(tmp$ret$0, value))
    if (value >= -2147483648 && value <= 2147483647)
      _this__u8e3s4.eg(numberToInt(value));
    else
      _this__u8e3s4.fg(numberToLong(value));
  else {
    _this__u8e3s4.gg(value);
    return Unit_instance;
  }
  if (zeroSuffix) {
    _this__u8e3s4.ab('.0');
  }
}
var Companion_instance_67;
function Companion_getInstance_68() {
  if (Companion_instance_67 === VOID)
    new Companion_66();
  return Companion_instance_67;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_69();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_69();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_69();
  var ratio = umod_0(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio_0(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y_0(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.b36_1, other instanceof Angle ? other.b36_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces_0(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_68;
function Companion_getInstance_69() {
  if (Companion_instance_68 === VOID)
    new Companion_67();
  return Companion_instance_68;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.b36_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_69();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_69();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_75.k36(up);
  return up.m36_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_69();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_69();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate_0(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$0 = Ratio__times_impl_ucdh7y_0(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$0);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_69().f36_1) <= 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_69();
    var radians = interpolate(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_69();
    var radians_0 = interpolate(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_69().h36_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_69();
    var radians_1 = interpolate(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_69().h36_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function interpolateAngleNormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, true);
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
var Companion_instance_69;
function Companion_getInstance_70() {
  if (Companion_instance_69 === VOID)
    new Companion_68();
  return Companion_instance_69;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).g37())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_77().f37(p, Size2D.e37(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_77().b37(Companion_getInstance_82().i37(_BoundsBuilder___get_bounds__impl__s1l1gx($this).h37(), p), Companion_getInstance_82().k37(_BoundsBuilder___get_bounds__impl__s1l1gx($this).j37(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.g37())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.h37()), rect.j37());
}
var Companion_instance_70;
function Companion_getInstance_71() {
  if (Companion_instance_70 === VOID)
    new Companion_69();
  return Companion_instance_70;
}
var Companion_instance_71;
function Companion_getInstance_72() {
  if (Companion_instance_71 === VOID)
    new Companion_70();
  return Companion_instance_71;
}
var Companion_instance_72;
function Companion_getInstance_73() {
  if (Companion_instance_72 === VOID)
    new Companion_71();
  return Companion_instance_72;
}
var Companion_instance_73;
function Companion_getInstance_74() {
  if (Companion_instance_73 === VOID)
    new Companion_72();
  return Companion_instance_73;
}
var Companion_instance_74;
function Companion_getInstance_75() {
  if (Companion_instance_74 === VOID)
    new Companion_73();
  return Companion_instance_74;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_75().d3b(rect.o1x(), rect.q1x(), rect.r1x(), rect.p1x(), near, far);
}
function get_scale(_this__u8e3s4) {
  return Scale.j3b(_this__u8e3s4.e39_1, _this__u8e3s4.f39_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_75;
function Companion_getInstance_76() {
  return Companion_instance_75;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_76;
function Companion_getInstance_77() {
  if (Companion_instance_76 === VOID)
    new Companion_75();
  return Companion_instance_76;
}
var Companion_instance_77;
function Companion_getInstance_78() {
  return Companion_instance_77;
}
var Companion_instance_78;
function Companion_getInstance_79() {
  if (Companion_instance_78 === VOID)
    new Companion_77();
  return Companion_instance_78;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.h38(_this__u8e3s4.h3b_1, _this__u8e3s4.i3b_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.t3c(toVector2(c.r3c(i)).s3c());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.t3c(toVector2(c.r3c(i)).u3c());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_79;
function Companion_getInstance_80() {
  if (Companion_instance_79 === VOID)
    new Companion_78();
  return Companion_instance_79;
}
var Companion_instance_80;
function Companion_getInstance_81() {
  if (Companion_instance_80 === VOID)
    new Companion_79();
  return Companion_instance_80;
}
function toFloat(_this__u8e3s4) {
  return Size2D.p3b(_this__u8e3s4.v1v_1, _this__u8e3s4.w1v_1);
}
function toSize(_this__u8e3s4) {
  return Size2D.s3b(_this__u8e3s4.l36_1, _this__u8e3s4.m36_1);
}
function toInt_1(_this__u8e3s4) {
  return SizeInt.x1v(numberToInt(_this__u8e3s4.c37_1), numberToInt(_this__u8e3s4.d37_1));
}
var Companion_instance_81;
function Companion_getInstance_82() {
  if (Companion_instance_81 === VOID)
    new Companion_80();
  return Companion_instance_81;
}
var Companion_instance_82;
function Companion_getInstance_83() {
  if (Companion_instance_82 === VOID)
    new Companion_81();
  return Companion_instance_82;
}
var Companion_instance_83;
function Companion_getInstance_84() {
  if (Companion_instance_83 === VOID)
    new Companion_82();
  return Companion_instance_83;
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.h38(interpolate(_this__u8e3s4, l.l36_1, r.l36_1), interpolate(_this__u8e3s4, l.m36_1, r.m36_1));
}
var Companion_instance_84;
function Companion_getInstance_85() {
  if (Companion_instance_84 === VOID)
    new Companion_83();
  return Companion_instance_84;
}
var Arc_instance;
function Arc_getInstance() {
  return Arc_instance;
}
var Companion_instance_85;
function Companion_getInstance_86() {
  return Companion_instance_85;
}
function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
  var score = 1.7976931348623157E308;
  var areaFit;
  var bestNode = Companion_getInstance_77().v2a();
  var _iterator__ex2g4s = $this.e3e_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var r = _iterator__ex2g4s.c1();
    if (r.q2b_1 >= width && r.r2b_1 >= height) {
      areaFit = r.q2b_1 * r.r2b_1 - width * height;
      if (areaFit < score) {
        bestNode = new Rectangle(r.o2b_1, r.p2b_1, width, height);
        score = areaFit;
      }
    }
  }
  return bestNode;
}
function splitFreeNode($this, freeNode, usedNode) {
  var newNode;
  if (usedNode.o1x() >= freeNode.q1x() || usedNode.q1x() <= freeNode.o2b_1 || usedNode.p1x() >= freeNode.r1x() || usedNode.r1x() <= freeNode.p1x()) {
    return false;
  }
  if (usedNode.o2b_1 < freeNode.q1x() && usedNode.q1x() > freeNode.o2b_1) {
    if (usedNode.p2b_1 > freeNode.p2b_1 && usedNode.p2b_1 < freeNode.r1x()) {
      newNode = freeNode.a3c(VOID, VOID, VOID, usedNode.p2b_1 - freeNode.p2b_1);
      $this.e3e_1.g(newNode);
    }
    if (usedNode.r1x() < freeNode.r1x()) {
      newNode = freeNode.a3c(VOID, usedNode.r1x(), VOID, freeNode.r1x() - usedNode.r1x());
      $this.e3e_1.g(newNode);
    }
  }
  if (usedNode.p2b_1 < freeNode.r1x() && usedNode.r1x() > freeNode.p2b_1) {
    if (usedNode.o2b_1 > freeNode.o2b_1 && usedNode.o2b_1 < freeNode.q1x()) {
      newNode = freeNode.a3c(VOID, VOID, usedNode.o2b_1 - freeNode.o2b_1);
      $this.e3e_1.g(newNode);
    }
    if (usedNode.q1x() < freeNode.q1x()) {
      newNode = freeNode.a3c(usedNode.q1x(), VOID, freeNode.q1x() - usedNode.q1x());
      $this.e3e_1.g(newNode);
    }
  }
  return true;
}
function pruneFreeList($this) {
  var len = $this.e3e_1.d1();
  var i = 0;
  while (i < len) {
    var j = i + 1 | 0;
    var tmpRect = $this.e3e_1.f1(i);
    $l$loop: while (j < len) {
      var tmpRect2 = $this.e3e_1.f1(j);
      if (Companion_getInstance_77().r3b(tmpRect, tmpRect2)) {
        $this.e3e_1.w2(i);
        i = i - 1 | 0;
        len = len - 1 | 0;
        break $l$loop;
      }
      if (Companion_getInstance_77().r3b(tmpRect2, tmpRect)) {
        $this.e3e_1.w2(j);
        len = len - 1 | 0;
        j = j - 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
}
var SliceRotation_R0_instance;
var SliceRotation_R90_instance;
var SliceRotation_R180_instance;
var SliceRotation_R270_instance;
var Companion_instance_86;
function Companion_getInstance_87() {
  SliceRotation_initEntries();
  if (Companion_instance_86 === VOID)
    new Companion_85();
  return Companion_instance_86;
}
function values_2() {
  return [SliceRotation_R0_getInstance(), SliceRotation_R90_getInstance(), SliceRotation_R180_getInstance(), SliceRotation_R270_getInstance()];
}
var SliceRotation_entriesInitialized;
function SliceRotation_initEntries() {
  if (SliceRotation_entriesInitialized)
    return Unit_instance;
  SliceRotation_entriesInitialized = true;
  SliceRotation_R0_instance = new SliceRotation('R0', 0);
  SliceRotation_R90_instance = new SliceRotation('R90', 1);
  SliceRotation_R180_instance = new SliceRotation('R180', 2);
  SliceRotation_R270_instance = new SliceRotation('R270', 3);
  Companion_getInstance_87();
}
function _SliceOrientation___init__impl__ewylib(raw) {
  return raw;
}
function _SliceOrientation___get_raw__impl__tj3u8w($this) {
  return $this;
}
function _SliceOrientation___get_rotation__impl__m65r0o($this) {
  return Companion_getInstance_87().f1(extract_0(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 2));
}
function _SliceOrientation___get_flipX__impl__lgb7bx($this) {
  return !(extract_0(_SliceOrientation___get_raw__impl__tj3u8w($this), 2, 1) === 0);
}
function _SliceOrientation___init__impl__ewylib_0(rotation, flipX) {
  rotation = rotation === VOID ? SliceRotation_R0_getInstance() : rotation;
  flipX = flipX === VOID ? false : flipX;
  return _SliceOrientation___init__impl__ewylib(insert_0(insert(0, rotation.j3_1, 0, 2), flipX, 2));
}
function _SliceOrientation___get_indices__impl__km5on3($this) {
  return Companion_getInstance_88().y1z_1[extract_0(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
function _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) {
  return _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R90_getInstance()) || _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R270_getInstance());
}
function SliceOrientation__toString_impl_tdph6r($this) {
  return Companion_getInstance_88().z1z_1[extract_0(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
var Companion_instance_87;
function Companion_getInstance_88() {
  if (Companion_instance_87 === VOID)
    new Companion_86();
  return Companion_instance_87;
}
function SliceOrientation__hashCode_impl_7mjkdw($this) {
  return $this;
}
function SliceOrientation__equals_impl_h4gywg($this, other) {
  if (!(other instanceof SliceOrientation))
    return false;
  if (!($this === (other instanceof SliceOrientation ? other.j2g_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_88;
function Companion_getInstance_89() {
  return Companion_instance_88;
}
function transformed(_this__u8e3s4, orientation) {
  var i = _SliceOrientation___get_indices__impl__km5on3(orientation);
  return new RectCoords(_this__u8e3s4.y3f(i[0]), _this__u8e3s4.z3f(i[0]), _this__u8e3s4.y3f(i[1]), _this__u8e3s4.z3f(i[1]), _this__u8e3s4.y3f(i[2]), _this__u8e3s4.z3f(i[2]), _this__u8e3s4.y3f(i[3]), _this__u8e3s4.z3f(i[3]));
}
function SliceRotation_R0_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R0_instance;
}
function SliceRotation_R90_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R90_instance;
}
function SliceRotation_R180_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R180_instance;
}
function SliceRotation_R270_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R270_instance;
}
var Companion_instance_89;
function Companion_getInstance_90() {
  return Companion_instance_89;
}
function ensureMoveTo($this, p) {
  if ($this.w1j())
    return false;
  $this.a3e(p);
  return true;
}
var Winding_EVEN_ODD_instance;
var Winding_NON_ZERO_instance;
var Companion_instance_90;
function Companion_getInstance_91() {
  return Companion_instance_90;
}
var Winding_entriesInitialized;
function Winding_initEntries() {
  if (Winding_entriesInitialized)
    return Unit_instance;
  Winding_entriesInitialized = true;
  Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
  Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
}
function Winding_NON_ZERO_getInstance() {
  Winding_initEntries();
  return Winding_NON_ZERO_instance;
}
function get_immutable(_this__u8e3s4) {
  return _this__u8e3s4;
}
function MMatrix$Companion$POOL$lambda(it) {
  it.r3h();
  return Unit_instance;
}
function MMatrix$Companion$POOL$lambda_0(it) {
  return new MMatrix();
}
var Companion_instance_91;
function Companion_getInstance_92() {
  if (Companion_instance_91 === VOID)
    new Companion_90();
  return Companion_instance_91;
}
function toMatrix4(_this__u8e3s4) {
  if (_this__u8e3s4.g37())
    return Companion_getInstance_75().g3a_1;
  return Companion_getInstance_75().j3a(_this__u8e3s4.z37_1, _this__u8e3s4.b38_1, 0.0, _this__u8e3s4.d38_1, _this__u8e3s4.a38_1, _this__u8e3s4.c38_1, 0.0, _this__u8e3s4.e38_1, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
}
function get__ALL_LIST() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL_LIST$delegate;
  _ALL_LIST$factory();
  return this_0.h3();
}
var _ALL_LIST$delegate;
var _ALL$delegate;
var Easings_SMOOTH_instance;
var Easings_EASE_IN_ELASTIC_instance;
var Easings_EASE_OUT_ELASTIC_instance;
var Easings_EASE_OUT_BOUNCE_instance;
var Easings_LINEAR_instance;
var Easings_EASE_instance;
var Easings_EASE_IN_instance;
var Easings_EASE_OUT_instance;
var Easings_EASE_IN_OUT_instance;
var Easings_EASE_IN_OLD_instance;
var Easings_EASE_OUT_OLD_instance;
var Easings_EASE_IN_OUT_OLD_instance;
var Easings_EASE_OUT_IN_OLD_instance;
var Easings_EASE_IN_BACK_instance;
var Easings_EASE_OUT_BACK_instance;
var Easings_EASE_IN_OUT_BACK_instance;
var Easings_EASE_OUT_IN_BACK_instance;
var Easings_EASE_IN_OUT_ELASTIC_instance;
var Easings_EASE_OUT_IN_ELASTIC_instance;
var Easings_EASE_IN_BOUNCE_instance;
var Easings_EASE_IN_OUT_BOUNCE_instance;
var Easings_EASE_OUT_IN_BOUNCE_instance;
var Easings_EASE_IN_QUAD_instance;
var Easings_EASE_OUT_QUAD_instance;
var Easings_EASE_IN_OUT_QUAD_instance;
var Easings_EASE_SINE_instance;
var Easings_EASE_CLAMP_START_instance;
var Easings_EASE_CLAMP_END_instance;
var Easings_EASE_CLAMP_MIDDLE_instance;
function values_3() {
  return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_IN_OLD_getInstance(), Easings_EASE_OUT_OLD_getInstance(), Easings_EASE_IN_OUT_OLD_getInstance(), Easings_EASE_OUT_IN_OLD_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_3());
  return $ENTRIES;
}
var Easings_entriesInitialized;
function Easings_initEntries() {
  if (Easings_entriesInitialized)
    return Unit_instance;
  Easings_entriesInitialized = true;
  Easings_SMOOTH_instance = new Easings$SMOOTH();
  Easings_EASE_IN_ELASTIC_instance = new Easings$EASE_IN_ELASTIC();
  Easings_EASE_OUT_ELASTIC_instance = new Easings$EASE_OUT_ELASTIC();
  Easings_EASE_OUT_BOUNCE_instance = new Easings$EASE_OUT_BOUNCE();
  Easings_LINEAR_instance = new Easings$LINEAR();
  Easings_EASE_instance = new Easings$EASE();
  Easings_EASE_IN_instance = new Easings$EASE_IN();
  Easings_EASE_OUT_instance = new Easings$EASE_OUT();
  Easings_EASE_IN_OUT_instance = new Easings$EASE_IN_OUT();
  Easings_EASE_IN_OLD_instance = new Easings$EASE_IN_OLD();
  Easings_EASE_OUT_OLD_instance = new Easings$EASE_OUT_OLD();
  Easings_EASE_IN_OUT_OLD_instance = new Easings$EASE_IN_OUT_OLD();
  Easings_EASE_OUT_IN_OLD_instance = new Easings$EASE_OUT_IN_OLD();
  Easings_EASE_IN_BACK_instance = new Easings$EASE_IN_BACK();
  Easings_EASE_OUT_BACK_instance = new Easings$EASE_OUT_BACK();
  Easings_EASE_IN_OUT_BACK_instance = new Easings$EASE_IN_OUT_BACK();
  Easings_EASE_OUT_IN_BACK_instance = new Easings$EASE_OUT_IN_BACK();
  Easings_EASE_IN_OUT_ELASTIC_instance = new Easings$EASE_IN_OUT_ELASTIC();
  Easings_EASE_OUT_IN_ELASTIC_instance = new Easings$EASE_OUT_IN_ELASTIC();
  Easings_EASE_IN_BOUNCE_instance = new Easings$EASE_IN_BOUNCE();
  Easings_EASE_IN_OUT_BOUNCE_instance = new Easings$EASE_IN_OUT_BOUNCE();
  Easings_EASE_OUT_IN_BOUNCE_instance = new Easings$EASE_OUT_IN_BOUNCE();
  Easings_EASE_IN_QUAD_instance = new Easings$EASE_IN_QUAD();
  Easings_EASE_OUT_QUAD_instance = new Easings$EASE_OUT_QUAD();
  Easings_EASE_IN_OUT_QUAD_instance = new Easings$EASE_IN_OUT_QUAD();
  Easings_EASE_SINE_instance = new Easings$EASE_SINE();
  Easings_EASE_CLAMP_START_instance = new Easings$EASE_CLAMP_START();
  Easings_EASE_CLAMP_END_instance = new Easings$EASE_CLAMP_END();
  Easings_EASE_CLAMP_MIDDLE_instance = new Easings$EASE_CLAMP_MIDDLE();
}
var $ENTRIES;
function calc($this, it) {
  var t = toRatio(it);
  var p = $this.m3i_1;
  var order = p.length - 1 | 0;
  if (equals(t, Companion_getInstance_67().h35_1))
    return p[0];
  if (equals(t, Companion_getInstance_67().k35_1))
    return p[order];
  if (order === 0)
    return p[0];
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_67().k35_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y(t, t));
  var a = mt2 * mt;
  // Inline function 'korlibs.math.interpolation.times' call
  var b = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
  var c = mt * t2 * 3;
  var d = Ratio__times_impl_ucdh7y_0(t, t2);
  return p[0].t3c(a).o3k(p[1].t3c(b)).o3k(p[2].t3c(c)).o3k(p[3].t3c(d));
}
function get_EASE_IN_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_QUAD_getInstance();
}
function get_EASE_IN_OUT(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_getInstance();
}
function _ALL_LIST$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  return get_entries();
}
function _ALL$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get__ALL_LIST();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.pb(capacity);
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.math.interpolation._ALL$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.i3_1;
    destination.x2(tmp$ret$0, element);
  }
  return destination;
}
function Easings_SMOOTH_getInstance() {
  Easings_initEntries();
  return Easings_SMOOTH_instance;
}
function Easings_EASE_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_ELASTIC_instance;
}
function Easings_EASE_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BOUNCE_instance;
}
function Easings_LINEAR_getInstance() {
  Easings_initEntries();
  return Easings_LINEAR_instance;
}
function Easings_EASE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_instance;
}
function Easings_EASE_IN_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_instance;
}
function Easings_EASE_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_instance;
}
function Easings_EASE_IN_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_instance;
}
function Easings_EASE_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OLD_instance;
}
function Easings_EASE_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_OLD_instance;
}
function Easings_EASE_IN_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_OLD_instance;
}
function Easings_EASE_OUT_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_OLD_instance;
}
function Easings_EASE_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BACK_instance;
}
function Easings_EASE_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BACK_instance;
}
function Easings_EASE_IN_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BACK_instance;
}
function Easings_EASE_OUT_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BACK_instance;
}
function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_ELASTIC_instance;
}
function Easings_EASE_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BOUNCE_instance;
}
function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BOUNCE_instance;
}
function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BOUNCE_instance;
}
function Easings_EASE_IN_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_QUAD_instance;
}
function Easings_EASE_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_QUAD_instance;
}
function Easings_EASE_IN_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_QUAD_instance;
}
function Easings_EASE_SINE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_SINE_instance;
}
function Easings_EASE_CLAMP_START_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_START_instance;
}
function Easings_EASE_CLAMP_END_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_END_instance;
}
function Easings_EASE_CLAMP_MIDDLE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_MIDDLE_instance;
}
function _ALL_LIST$factory() {
  return getPropertyCallableRef('_ALL_LIST', 0, KProperty0, function () {
    return get__ALL_LIST();
  }, null);
}
var properties_initialized_Easings_kt_w5y1uw;
function _init_properties_Easings_kt__swvzhy() {
  if (!properties_initialized_Easings_kt_w5y1uw) {
    properties_initialized_Easings_kt_w5y1uw = true;
    var tmp = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL_LIST$delegate = lazy_0(tmp, _ALL_LIST$delegate$lambda);
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL$delegate = lazy_0(tmp_0, _ALL$delegate$lambda);
  }
}
function _UByteArrayInt___init__impl__xif7bu(data) {
  return data;
}
function _UByteArrayInt___get_data__impl__l2b913($this) {
  return $this;
}
function _UByteArrayInt___init__impl__xif7bu_0(size) {
  return _UByteArrayInt___init__impl__xif7bu(new Int8Array(size));
}
function _UByteArrayInt___get_size__impl__bcjnte($this) {
  return _UByteArrayInt___get_data__impl__l2b913($this).length;
}
function UByteArrayInt__get_impl_px6q8a($this, index) {
  return _UByteArrayInt___get_data__impl__l2b913($this)[index] & 255;
}
function UByteArrayInt__set_impl_gn4532($this, index, value) {
  _UByteArrayInt___get_data__impl__l2b913($this)[index] = toByte(value);
}
function UByteArrayInt__toString_impl_f8qdsi($this) {
  return 'UByteArrayInt(data=' + toString($this) + ')';
}
function UByteArrayInt__hashCode_impl_y17rdr($this) {
  return hashCode($this);
}
function UByteArrayInt__equals_impl_xlvwxn($this, other) {
  if (!(other instanceof UByteArrayInt))
    return false;
  var tmp0_other_with_cast = other instanceof UByteArrayInt ? other.p3k_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function arraycopy_0(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_1(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_2(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function asByteArray(_this__u8e3s4) {
  return _UByteArrayInt___get_data__impl__l2b913(_this__u8e3s4);
}
function _UShortArrayInt___init__impl__kdofb8(data) {
  return data;
}
function _UShortArrayInt___get_data__impl__l4stnv($this) {
  return $this;
}
function arraycopy_3(src, srcPos, dst, dstPos, size) {
  Companion_instance_94.q3k(src, srcPos, dst, dstPos, size);
}
function arrayfill(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? get_size_1(array) : end;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      setUInt8(array, n, value);
    }
     while (inductionVariable < end);
}
function arrayequal(src, srcPos, dst, dstPos, size) {
  return Companion_instance_94.r3k(src, srcPos, dst, dstPos, size);
}
function arraycopy_4(src, srcPos, dst, dstPos, size) {
  return arraycopy_3(_Int32Buffer___get_buffer__impl__dnrimm(src), imul(srcPos, 4), _Int32Buffer___get_buffer__impl__dnrimm(dst), imul(dstPos, 4), imul(size, 4));
}
function arraycopy_5(src, srcPos, dst, dstPos, size) {
  Uint16Buffer__setArray_impl_x4uzt(dst, dstPos, src, srcPos, size);
}
function asUShortArrayInt(_this__u8e3s4) {
  return _UShortArrayInt___init__impl__kdofb8(_this__u8e3s4);
}
function arrayadd(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? (new Uint16Buffer(array)).d1() : end;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      Uint16Buffer__set_impl_g0kliu(array, n, Uint16Buffer__get_impl_6qi0dm(array, n) + value | 0);
    }
     while (inductionVariable < end);
}
function arrayfill_0(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? array.length : end;
  return fill_0(array, value, start, end);
}
function arraycopy_6(src, srcPos, dst, dstPos, size) {
  dst.s3k(dstPos, src, srcPos, size, false);
}
function arraycopy_7(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_8(src, srcPos, dst, dstPos, size) {
  Int8Buffer__setArray_impl_oimleb(dst, dstPos, src, srcPos, size);
}
function arraycopy_9(src, srcPos, dst, dstPos, size) {
  Float32Buffer__setArray_impl_eosj51(dst, dstPos, src, srcPos, size);
}
function arraycopy_10(src, srcPos, dst, dstPos, size) {
  Int32Buffer__setArray_impl_eeeiw8(dst, dstPos, src, srcPos, size);
}
function checkNBufferSize(size) {
  if (size < 0)
    throw IllegalArgumentException.m('invalid size ' + size);
  return size;
}
function hashCodeCommon(_this__u8e3s4, buffer) {
  var h = 1;
  var len = buffer.t3k();
  var inductionVariable = 0;
  var last = len / 4 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      h = imul(31, h) + buffer.u3k(imul(n, 4)) | 0;
    }
     while (inductionVariable < last);
  var offset = imul(len / 4 | 0, 4);
  var inductionVariable_0 = 0;
  var last_0 = len % 4 | 0;
  if (inductionVariable_0 < last_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      h = imul(31, h) + buffer.v3k(offset + n_0 | 0) | 0;
    }
     while (inductionVariable_0 < last_0);
  return h;
}
function equalsCommon(_this__u8e3s4, that, other) {
  var tmp;
  if (!(other instanceof Buffer)) {
    tmp = true;
  } else {
    tmp = !(get_size_1(that) === get_size_1(other));
  }
  if (tmp)
    return false;
  return Companion_instance_94.r3k(that, 0, other, 0, that.t3k());
}
function NBuffer_toString(buffer) {
  return 'Buffer(size=' + get_size_1(buffer) + ')';
}
function equalsCommon_0(_this__u8e3s4, src, srcPosBytes, dst, dstPosBytes, sizeInBytes, use64) {
  use64 = use64 === VOID ? true : use64;
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!((srcPosBytes + sizeInBytes | 0) <= src.t3k())) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.n4(toString(message));
  }
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!((dstPosBytes + sizeInBytes | 0) <= dst.t3k())) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message_0 = 'Check failed.';
    throw IllegalStateException.n4(toString(message_0));
  }
  var offset = 0;
  var remaining = sizeInBytes;
  if (use64) {
    var WORD = 8;
    var words = remaining / WORD | 0;
    remaining = remaining % WORD | 0;
    var inductionVariable = 0;
    if (inductionVariable < words)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v0 = src.w3k((srcPosBytes + offset | 0) + imul(n, WORD) | 0);
        var v1 = dst.w3k((dstPosBytes + offset | 0) + imul(n, WORD) | 0);
        if (!v0.equals(v1)) {
          return false;
        }
      }
       while (inductionVariable < words);
    offset = offset + imul(words, WORD) | 0;
  }
  var WORD_0 = 4;
  var words_0 = remaining / WORD_0 | 0;
  remaining = remaining % WORD_0 | 0;
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < words_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var v0_0 = src.u3k((srcPosBytes + offset | 0) + imul(n_0, WORD_0) | 0);
      var v1_0 = dst.u3k((dstPosBytes + offset | 0) + imul(n_0, WORD_0) | 0);
      if (!(v0_0 === v1_0)) {
        return false;
      }
    }
     while (inductionVariable_0 < words_0);
  offset = offset + imul(words_0, WORD_0) | 0;
  var inductionVariable_1 = 0;
  var last = remaining;
  if (inductionVariable_1 < last)
    do {
      var n_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var v0_1 = src.v3k((srcPosBytes + offset | 0) + n_1 | 0);
      var v1_1 = dst.v3k((dstPosBytes + offset | 0) + n_1 | 0);
      if (!(v0_1 === v1_1)) {
        return false;
      }
    }
     while (inductionVariable_1 < last);
  return true;
}
function get_size_1(_this__u8e3s4) {
  return _this__u8e3s4.t3k();
}
function _Float32Buffer___init__impl__403k2m(buffer) {
  return buffer;
}
function _Float32Buffer___get_buffer__impl__x5nu9x($this) {
  return $this;
}
function Float32Buffer__get_impl_659lhu($this, index) {
  // Inline function 'korlibs.memory.getF32' call
  var this_0 = _Float32Buffer___get_buffer__impl__x5nu9x($this);
  var byteOffset = imul(index, 4);
  return true ? this_0.y3k(byteOffset) : this_0.x3k(byteOffset);
}
function Float32Buffer__set_impl_34szne($this, index, value) {
  // Inline function 'korlibs.memory.setF32' call
  var this_0 = _Float32Buffer___get_buffer__impl__x5nu9x($this);
  var byteOffset = imul(index, 4);
  var tmp;
  if (true) {
    this_0.a3l(byteOffset, value);
    tmp = Unit_instance;
  } else {
    this_0.z3k(byteOffset, value);
    tmp = Unit_instance;
  }
  return tmp;
}
function Float32Buffer__setArray_impl_eosj51($this, index, inp, offset, size) {
  return setArray(_Float32Buffer___get_buffer__impl__x5nu9x($this), imul(index, 4), inp, offset, size);
}
function asFloat32(_this__u8e3s4) {
  return _Float32Buffer___init__impl__403k2m(_this__u8e3s4);
}
function copyOf_3(_this__u8e3s4, newSize) {
  var out = Buffer.b3l(newSize);
  // Inline function 'kotlin.math.min' call
  var a = _this__u8e3s4.t3k();
  var tmp$ret$0 = Math.min(a, newSize);
  arraycopy_3(_this__u8e3s4, 0, out, 0, tmp$ret$0);
  return out;
}
function setInt32(_this__u8e3s4, index, value) {
  return _this__u8e3s4.c3l(imul(index, 4), value);
}
function getInt32(_this__u8e3s4, index) {
  return _this__u8e3s4.u3k(imul(index, 4));
}
function allocDirect(_this__u8e3s4, size) {
  return Buffer.b3l(size, true);
}
function setFloat32(_this__u8e3s4, index, value) {
  return _this__u8e3s4.a3l(imul(index, 4), value);
}
function allocNoDirect(_this__u8e3s4, size) {
  return Buffer.b3l(size, false);
}
function _Int32Buffer___init__impl__o98lxn(buffer) {
  return buffer;
}
function _Int32Buffer___get_buffer__impl__dnrimm($this) {
  return $this;
}
function Int32Buffer__setArray_impl_eeeiw8($this, index, inp, offset, size) {
  return setArray_0(_Int32Buffer___get_buffer__impl__dnrimm($this), imul(index, 4), inp, offset, size);
}
function get_i32(_this__u8e3s4) {
  return asInt32(_this__u8e3s4);
}
function _Int8Buffer___init__impl__e20lvc(buffer) {
  return buffer;
}
function _Int8Buffer___get_buffer__impl__q0gulb($this) {
  return $this;
}
function _Int8Buffer___init__impl__e20lvc_0(data, offset, size) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? data.length - offset | 0 : size;
  // Inline function 'kotlin.also' call
  var this_0 = Buffer.b3l(imul(size, 1));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.Int8Buffer.<init>.<anonymous>' call
  setArray_1(this_0, 0, data, offset, size);
  return _Int8Buffer___init__impl__e20lvc(this_0);
}
function Int8Buffer__setArray_impl_oimleb($this, index, inp, offset, size) {
  return setArray_1(_Int8Buffer___get_buffer__impl__q0gulb($this), imul(index, 1), inp, offset, size);
}
function sliceWithSize_2(_this__u8e3s4, start, size) {
  return sliceBuffer(_this__u8e3s4, start, start + size | 0);
}
function clone(_this__u8e3s4, direct) {
  direct = direct === VOID ? false : direct;
  var out = Buffer.b3l(get_size_1(_this__u8e3s4), direct);
  arraycopy_3(_this__u8e3s4, 0, out, 0, get_size_1(_this__u8e3s4));
  return out;
}
function _Uint16Buffer___init__impl__4401ya(buffer) {
  return buffer;
}
function _Uint16Buffer___get_buffer__impl__rei8ax($this) {
  return $this;
}
var Companion_instance_92;
function Companion_getInstance_93() {
  return Companion_instance_92;
}
function _Uint16Buffer___get_elementSizeInBytes__impl__tcik7m($this) {
  return 2;
}
function Uint16Buffer__get_impl_6qi0dm($this, index) {
  // Inline function 'korlibs.memory.getU16' call
  var this_0 = _Uint16Buffer___get_buffer__impl__rei8ax($this);
  var byteOffset = imul(index, 2);
  return true ? getU16LE(this_0, byteOffset) : getU16BE(this_0, byteOffset);
}
function Uint16Buffer__set_impl_g0kliu($this, index, value) {
  // Inline function 'korlibs.memory.set16' call
  var this_0 = _Uint16Buffer___get_buffer__impl__rei8ax($this);
  var byteOffset = imul(index, 2);
  var value_0 = toShort(value);
  var tmp;
  if (true) {
    this_0.f3l(byteOffset, value_0);
    tmp = Unit_instance;
  } else {
    this_0.e3l(byteOffset, value_0);
    tmp = Unit_instance;
  }
  return tmp;
}
function Uint16Buffer__setArray_impl_x4uzt($this, index, inp, offset, size) {
  return setArray_2(_Uint16Buffer___get_buffer__impl__rei8ax($this), imul(index, 2), _UShortArrayInt___get_data__impl__l4stnv(inp), offset, size);
}
function Uint16Buffer__toString_impl_rxffha($this) {
  return 'Uint16Buffer(buffer=' + $this.toString() + ')';
}
function Uint16Buffer__hashCode_impl_lcipoz($this) {
  return $this.hashCode();
}
function Uint16Buffer__equals_impl_u4cl2n($this, other) {
  if (!(other instanceof Uint16Buffer))
    return false;
  var tmp0_other_with_cast = other instanceof Uint16Buffer ? other.g3l_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function get_u16(_this__u8e3s4) {
  return asUInt16(_this__u8e3s4);
}
function get_f32(_this__u8e3s4) {
  return asFloat32(_this__u8e3s4);
}
function setArray(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function sliceBuffer(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.t3k() : end;
  if (start > end || !(0 <= start ? start <= _this__u8e3s4.t3k() : false) || !(0 <= end ? end <= _this__u8e3s4.t3k() : false)) {
    throw IllegalArgumentException.m('invalid slice start:' + start + ', end:' + end + ' not in 0..' + _this__u8e3s4.t3k());
  }
  return _this__u8e3s4.j3l(start, end);
}
function setArray_0(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE_0(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE_0(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function asInt32(_this__u8e3s4) {
  return _Int32Buffer___init__impl__o98lxn(_this__u8e3s4);
}
function setArray_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  arraycopy_6(data, start, _this__u8e3s4, byteOffset, size);
}
function setArray_2(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE_1(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE_1(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function asUInt16(_this__u8e3s4) {
  return _Uint16Buffer___init__impl__4401ya(_this__u8e3s4);
}
function setArrayLE(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayLE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.a3l(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayBE(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayBE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.z3k(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayLE_0(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayLE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.c3l(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayBE_0(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayBE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.k3l(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayLE_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayLE.<anonymous>' call
      var offset = byteOffset + imul(n, 2) | 0;
      var index = start + n | 0;
      _this__u8e3s4.f3l(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayBE_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayBE.<anonymous>' call
      var offset = byteOffset + imul(n, 2) | 0;
      var index = start + n | 0;
      _this__u8e3s4.e3l(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function getU16LE(_this__u8e3s4, byteOffset) {
  // Inline function 'korlibs.math.unsigned' call
  return _this__u8e3s4.l3l(byteOffset) & 65535;
}
function getU16BE(_this__u8e3s4, byteOffset) {
  // Inline function 'korlibs.math.unsigned' call
  return _this__u8e3s4.m3l(byteOffset) & 65535;
}
function setUInt8(_this__u8e3s4, index, value) {
  return _this__u8e3s4.n3l(index, toByte(value));
}
function get_i8(_this__u8e3s4) {
  return asInt8(_this__u8e3s4);
}
function asInt8(_this__u8e3s4) {
  return _Int8Buffer___init__impl__e20lvc(_this__u8e3s4);
}
function getU16LE_0(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16LE' call
  return u8$accessor$sdhsi0(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 1 | 0) << 8;
}
function getS32LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32LE' call
  return u8$accessor$sdhsi0(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 2 | 0) << 16 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 3 | 0) << 24;
}
function getS32BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32BE' call
  return u8$accessor$sdhsi0(_this__u8e3s4, offset + 3 | 0) << 0 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 2 | 0) << 8 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 1 | 0) << 16 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 0 | 0) << 24;
}
function getU16BE_0(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16BE' call
  return u8$accessor$sdhsi0(_this__u8e3s4, offset + 1 | 0) << 0 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 0 | 0) << 8;
}
function getU24LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24LE' call
  return u8$accessor$sdhsi0(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 2 | 0) << 16;
}
function getU24BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24BE' call
  return u8$accessor$sdhsi0(_this__u8e3s4, offset + 2 | 0) << 0 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$sdhsi0(_this__u8e3s4, offset + 0 | 0) << 16;
}
function u8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function getU16(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getU16LE_0(_this__u8e3s4, offset) : getU16BE_0(_this__u8e3s4, offset);
}
function getS32_0(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getS32LE(_this__u8e3s4, offset) : getS32BE(_this__u8e3s4, offset);
}
function u8$accessor$sdhsi0(_this__u8e3s4, offset) {
  return u8(_this__u8e3s4, offset);
}
function ensureWrite($this, count) {
  if (count <= $this.f2n_1.p1f_1)
    return Unit_instance;
  if (!$this.e2n_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.f2n_1.p1f_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.n4(toString(message));
  }
  var minNewSize = $this.f2n_1.q1f_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new SimpleRingBuffer(ilog2_0(minNewSize) + 2 | 0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.SimpleBytesDeque.ensureWrite.<anonymous>' call
  this_0.o3l($this.f2n_1);
  tmp.f2n_1 = this_0;
}
function writeFullNoCopy($this, data) {
  // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
  $this.m2n_1.g(data);
  $this.o2n_1 = $this.o2n_1 + data.length | 0;
}
function consumeChunkSize(_this__u8e3s4, $this, size) {
  var chunk = _this__u8e3s4;
  // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
  $this.n2n_1 = $this.n2n_1 + size | 0;
  $this.o2n_1 = $this.o2n_1 - size | 0;
  if ($this.n2n_1 >= chunk.length) {
    $this.m2n_1.sj();
    $this.n2n_1 = 0;
  }
}
function _ByteUnits___init__impl__x795am(bytes) {
  return bytes;
}
function _ByteUnits___get_bytes__impl__leukoc($this) {
  return $this;
}
function _ByteUnits___get_bytesLong__impl__1lc1w0($this) {
  return numberToLong(_ByteUnits___get_bytes__impl__leukoc($this));
}
function _ByteUnits___get_kiloBytes__impl__jnym6r($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / 1024.0;
}
function _ByteUnits___get_megaBytes__impl__qjjio2($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / (1024.0 * 1024.0);
}
function _ByteUnits___get_gigaBytes__impl__i7s8s8($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / (1024.0 * 1024.0 * 1024.0);
}
var Companion_instance_93;
function Companion_getInstance_94() {
  if (Companion_instance_93 === VOID)
    new Companion_92();
  return Companion_instance_93;
}
function roundToDigits(_this__u8e3s4, $this, digits) {
  // Inline function 'kotlin.math.pow' call
  var num = Math.pow(10.0, digits);
  return roundToInt(_this__u8e3s4 * num) / num;
}
function ByteUnits__toString_impl_ox2ku2($this) {
  return _ByteUnits___get_gigaBytes__impl__i7s8s8($this) >= 1.0 ? '' + roundToDigits(_ByteUnits___get_gigaBytes__impl__i7s8s8($this), $this, 1) + ' GB' : _ByteUnits___get_megaBytes__impl__qjjio2($this) >= 1.0 ? '' + roundToDigits(_ByteUnits___get_megaBytes__impl__qjjio2($this), $this, 1) + ' MB' : _ByteUnits___get_kiloBytes__impl__jnym6r($this) >= 1.0 ? '' + roundToDigits(_ByteUnits___get_kiloBytes__impl__jnym6r($this), $this, 1) + ' KB' : _ByteUnits___get_bytesLong__impl__1lc1w0($this).toString() + ' B';
}
function get_isLittleEndian_0() {
  _init_properties_Buffer_js_kt__30np2z();
  return isLittleEndian;
}
var isLittleEndian;
var Companion_instance_94;
function Companion_getInstance_95() {
  return Companion_instance_94;
}
function asInt32Array(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int32Array(_this__u8e3s4);
}
function asInt8Array(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int8Array(_this__u8e3s4);
}
function get_buffer(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return _this__u8e3s4.t1s_1.buffer;
}
function get_arrayUByte(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Uint8Array(get_buffer(_this__u8e3s4), _this__u8e3s4.z3l(), _this__u8e3s4.t3k());
}
function get_arrayInt(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int32Array(get_buffer(_this__u8e3s4), _this__u8e3s4.z3l(), _this__u8e3s4.t3k() / 4 | 0);
}
function get_arrayFloat(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Float32Array(get_buffer(_this__u8e3s4), _this__u8e3s4.z3l(), _this__u8e3s4.t3k() / 4 | 0);
}
var properties_initialized_Buffer_js_kt_i0s0qv;
function _init_properties_Buffer_js_kt__30np2z() {
  if (!properties_initialized_Buffer_js_kt_i0s0qv) {
    properties_initialized_Buffer_js_kt_i0s0qv = true;
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.also' call
    var this_0 = new Uint32Array(1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.memory.isLittleEndian.<anonymous>' call
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0[0] = 287454020;
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array(this_0.buffer))[0] === 68;
  }
}
function cancel_0(_this__u8e3s4) {
  return _this__u8e3s4.a3m(CancellationException.vc(''));
}
var Companion_instance_95;
function Companion_getInstance_96() {
  return Companion_instance_95;
}
function cancellable(_this__u8e3s4) {
  var tmp = cancellable$lambda(_this__u8e3s4);
  return new sam$korlibs_io_lang_Cancellable$0(tmp);
}
function cancel_1(_this__u8e3s4, e) {
  e = e === VOID ? CancellationException.vc('') : e;
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var c = _iterator__ex2g4s.c1();
    c.a3m(e);
  }
  return Unit_instance;
}
function cancellable$lambda($this_cancellable) {
  return function (it) {
    $this_cancellable.p5();
    return Unit_instance;
  };
}
var customEnvironments;
var Companion_instance_96;
function Companion_getInstance_97() {
  return Companion_instance_96;
}
function unsupported_0(msg) {
  msg = msg === VOID ? 'unsupported' : msg;
  throw UnsupportedOperationException.k9(msg);
}
function invalidOp(msg) {
  throw InvalidOperationException.h3m(msg);
}
function get_invalidOp() {
  throw InvalidOperationException.h3m();
}
function get_unreachable() {
  throw UnreachableException.k3m();
}
function ensure_1($this, expected) {
  if ($this.p1d_1.length < expected) {
    if (!$this.q1d_1)
      throw RuntimeException.v9('ByteArrayBuffer configured to not grow!');
    var newSize = imul($this.p1d_1.length + 7 | 0, 5);
    var realNewSize = newSize < 0 ? 1073741823 : newSize;
    if (newSize < 0 && expected > realNewSize) {
      // Inline function 'kotlin.error' call
      var message = "ByteArrayBuffer can't grow that much";
      throw IllegalStateException.n4(toString(message));
    }
    var tmp = $this;
    var tmp_0 = $this.p1d_1;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(expected, realNewSize);
    tmp.p1d_1 = copyOf_2(tmp_0, tmp$ret$0);
  }
}
function ensureCount($this, count) {
  ensure_1($this, $this.r1d_1 + count | 0);
}
function arraycopy_11($this, src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
var Arch_UNKNOWN_instance;
var Arch_X86_instance;
var Arch_X64_instance;
var Arch_ARM32_instance;
var Arch_ARM64_instance;
var Arch_MIPS32_instance;
var Arch_MIPSEL32_instance;
var Arch_MIPS64_instance;
var Arch_MIPSEL64_instance;
var Arch_WASM32_instance;
var Arch_POWERPC64_instance;
var Companion_instance_97;
function Companion_getInstance_98() {
  return Companion_instance_97;
}
var Arch_entriesInitialized;
function Arch_initEntries() {
  if (Arch_entriesInitialized)
    return Unit_instance;
  Arch_entriesInitialized = true;
  Arch_UNKNOWN_instance = new Arch('UNKNOWN', 0, -1);
  Arch_X86_instance = new Arch('X86', 1, 32, VOID, true);
  Arch_X64_instance = new Arch('X64', 2, 64, VOID, true);
  Arch_ARM32_instance = new Arch('ARM32', 3, 32, true);
  Arch_ARM64_instance = new Arch('ARM64', 4, 64, true);
  Arch_MIPS32_instance = new Arch('MIPS32', 5, 32, VOID, VOID, true);
  Arch_MIPSEL32_instance = new Arch('MIPSEL32', 6, 32, VOID, VOID, true);
  Arch_MIPS64_instance = new Arch('MIPS64', 7, 64, VOID, VOID, true);
  Arch_MIPSEL64_instance = new Arch('MIPSEL64', 8, 64, VOID, VOID, true);
  Arch_WASM32_instance = new Arch('WASM32', 9, 32, VOID, VOID, VOID, true);
  Arch_POWERPC64_instance = new Arch('POWERPC64', 10, 64, VOID, VOID, VOID, VOID, true);
}
function Arch_UNKNOWN_getInstance() {
  Arch_initEntries();
  return Arch_UNKNOWN_instance;
}
var Endian_LITTLE_ENDIAN_instance;
var Endian_BIG_ENDIAN_instance;
var Companion_instance_98;
function Companion_getInstance_99() {
  Endian_initEntries();
  if (Companion_instance_98 === VOID)
    new Companion_97();
  return Companion_instance_98;
}
var Endian_entriesInitialized;
function Endian_initEntries() {
  if (Endian_entriesInitialized)
    return Unit_instance;
  Endian_entriesInitialized = true;
  Endian_LITTLE_ENDIAN_instance = new Endian('LITTLE_ENDIAN', 0);
  Endian_BIG_ENDIAN_instance = new Endian('BIG_ENDIAN', 1);
  Companion_getInstance_99();
}
function Endian_LITTLE_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_LITTLE_ENDIAN_instance;
}
function Endian_BIG_ENDIAN_getInstance() {
  Endian_initEntries();
  return Endian_BIG_ENDIAN_instance;
}
var Os_UNKNOWN_instance;
var Os_MACOSX_instance;
var Os_IOS_instance;
var Os_LINUX_instance;
var Os_WINDOWS_instance;
var Os_ANDROID_instance;
var Os_WASM_instance;
var Os_TVOS_instance;
var Os_WATCHOS_instance;
var Companion_instance_99;
function Companion_getInstance_100() {
  Os_initEntries();
  if (Companion_instance_99 === VOID)
    new Companion_98();
  return Companion_instance_99;
}
function values_4() {
  return [Os_UNKNOWN_getInstance(), Os_MACOSX_getInstance(), Os_IOS_getInstance(), Os_LINUX_getInstance(), Os_WINDOWS_getInstance(), Os_ANDROID_getInstance(), Os_WASM_getInstance(), Os_TVOS_getInstance(), Os_WATCHOS_getInstance()];
}
var Os_entriesInitialized;
function Os_initEntries() {
  if (Os_entriesInitialized)
    return Unit_instance;
  Os_entriesInitialized = true;
  Os_UNKNOWN_instance = new Os('UNKNOWN', 0);
  Os_MACOSX_instance = new Os('MACOSX', 1);
  Os_IOS_instance = new Os('IOS', 2);
  Os_LINUX_instance = new Os('LINUX', 3);
  Os_WINDOWS_instance = new Os('WINDOWS', 4);
  Os_ANDROID_instance = new Os('ANDROID', 5);
  Os_WASM_instance = new Os('WASM', 6);
  Os_TVOS_instance = new Os('TVOS', 7);
  Os_WATCHOS_instance = new Os('WATCHOS', 8);
  Companion_getInstance_100();
}
function Os_UNKNOWN_getInstance() {
  Os_initEntries();
  return Os_UNKNOWN_instance;
}
function Os_MACOSX_getInstance() {
  Os_initEntries();
  return Os_MACOSX_instance;
}
function Os_IOS_getInstance() {
  Os_initEntries();
  return Os_IOS_instance;
}
function Os_LINUX_getInstance() {
  Os_initEntries();
  return Os_LINUX_instance;
}
function Os_WINDOWS_getInstance() {
  Os_initEntries();
  return Os_WINDOWS_instance;
}
function Os_ANDROID_getInstance() {
  Os_initEntries();
  return Os_ANDROID_instance;
}
function Os_WASM_getInstance() {
  Os_initEntries();
  return Os_WASM_instance;
}
function Os_TVOS_getInstance() {
  Os_initEntries();
  return Os_TVOS_instance;
}
function Os_WATCHOS_getInstance() {
  Os_initEntries();
  return Os_WATCHOS_instance;
}
function Platform$Companion$envs$delegate$lambda() {
  return get_envs();
}
function Platform$Companion$envsUC$delegate$lambda() {
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = Companion_getInstance_101().x34();
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap.pb(mapCapacity(this_0.d1()));
  // Inline function 'kotlin.collections.associateByTo' call
  var tmp0_iterator = this_0.c3().a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.platform.Companion.envsUC$delegate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = element.g3().toUpperCase();
    // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
    var tmp$ret$3 = element.h3();
    destination.x2(tmp, tmp$ret$3);
  }
  return destination;
}
var Companion_instance_100;
function Companion_getInstance_101() {
  if (Companion_instance_100 === VOID)
    new Companion_99();
  return Companion_instance_100;
}
function envs$factory() {
  return getPropertyCallableRef('envs', 1, KProperty1, function (receiver) {
    return receiver.x34();
  }, null);
}
function envsUC$factory() {
  return getPropertyCallableRef('envsUC', 1, KProperty1, function (receiver) {
    return receiver.e3m();
  }, null);
}
var Runtime_JS_instance;
var Runtime_JVM_instance;
var Runtime_ANDROID_instance;
var Runtime_NATIVE_instance;
var Runtime_WASM_instance;
var Companion_instance_101;
function Companion_getInstance_102() {
  return Companion_instance_101;
}
var Runtime_entriesInitialized;
function Runtime_initEntries() {
  if (Runtime_entriesInitialized)
    return Unit_instance;
  Runtime_entriesInitialized = true;
  Runtime_JS_instance = new Runtime('JS', 0);
  Runtime_JVM_instance = new Runtime('JVM', 1);
  Runtime_ANDROID_instance = new Runtime('ANDROID', 2);
  Runtime_NATIVE_instance = new Runtime('NATIVE', 3);
  Runtime_WASM_instance = new Runtime('WASM', 4);
}
function Runtime_JS_getInstance() {
  Runtime_initEntries();
  return Runtime_JS_instance;
}
function Runtime_JVM_getInstance() {
  Runtime_initEntries();
  return Runtime_JVM_instance;
}
function Runtime_NATIVE_getInstance() {
  Runtime_initEntries();
  return Runtime_NATIVE_instance;
}
function get_portableSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.le();
  return tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
}
var Companion_instance_102;
function Companion_getInstance_103() {
  return Companion_instance_102;
}
function get_Deno_isDeno() {
  // Inline function 'kotlin.js.unsafeCast' call
  return 'Deno' in window;
}
function get_pointer_0(_this__u8e3s4) {
  return new DenoPointer(_this__u8e3s4);
}
function toArray(_this__u8e3s4) {
  return Array.from(_this__u8e3s4);
}
function jsObject(pairs) {
  var out = jsEmptyObj();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var pair = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    out[pair.hk_1] = pair.ik_1;
  }
  return out;
}
function jsNew(clazz) {
  return (new clazz())();
}
function jsEmptyObj() {
  return {};
}
function toJsBigInt(_this__u8e3s4) {
  var bi64 = new BigInt64Array(1);
  var i32 = new Int32Array(bi64.buffer);
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  i32[0] = _this__u8e3s4.a4(0).b2();
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  i32[1] = _this__u8e3s4.a4(32).b2();
  return get_5(bi64, 0);
}
function toLong_0(_this__u8e3s4) {
  var bi64 = new BigInt64Array(1);
  var i32 = new Int32Array(bi64.buffer);
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = i32[0];
  var low = toLong(tmp$ret$1).b4(new Long(-1, 0));
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = i32[1];
  var high = toLong(tmp$ret$3).b4(new Long(-1, 0));
  return low.c4(high.y3(32));
}
function get_5(_this__u8e3s4, index) {
  // Inline function 'kotlin.js.asDynamic' call
  return BigInt(_this__u8e3s4[index]);
}
function get_isDenoJs_0() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isDenoJs$delegate_0;
  isDenoJs$factory_0();
  return this_0.h3();
}
var isDenoJs$delegate_0;
function get_isWeb_0() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWeb$delegate_0;
  isWeb$factory_0();
  return this_0.h3();
}
var isWeb$delegate_0;
function get_isWorker_1() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWorker$delegate_0;
  isWorker$factory_0();
  return this_0.h3();
}
var isWorker$delegate_0;
function get_isNodeJs_0() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = isNodeJs$delegate_0;
  isNodeJs$factory_0();
  return this_0.h3();
}
var isNodeJs$delegate_0;
function get_currentArch() {
  _init_properties_Current_js_kt__w11d1e();
  return currentArch;
}
var currentArch;
function get_currentRuntime() {
  _init_properties_Current_js_kt__w11d1e();
  return currentRuntime;
}
var currentRuntime;
var currentIsDebug;
function get_currentIsLittleEndian() {
  _init_properties_Current_js_kt__w11d1e();
  return currentIsLittleEndian;
}
var currentIsLittleEndian;
var multithreadedSharedHeap;
function get_currentRawPlatformName() {
  _init_properties_Current_js_kt__w11d1e();
  return currentRawPlatformName;
}
var currentRawPlatformName;
var currentRawOsName;
function get_envs() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.getValue' call
  var this_0 = envs$delegate;
  envs$factory_0();
  return this_0.h3();
}
var envs$delegate;
function get_jsGlobalThis() {
  _init_properties_Current_js_kt__w11d1e();
  return globalThis;
}
function get_isShell_0() {
  _init_properties_Current_js_kt__w11d1e();
  return !get_isWeb_0() && !get_isNodeJs_0() && !get_isWorker_1();
}
function get_process() {
  _init_properties_Current_js_kt__w11d1e();
  if (typeof process === 'undefined') {
    try {
      // Inline function 'kotlin.error' call
      var message = "Not in NodeJS. Can't access process";
      throw IllegalStateException.n4(toString(message));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        throw e;
      } else {
        throw $p;
      }
    }
  }
  return process;
}
function jsObjectToMap(obj) {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.collections.associate' call
  var this_0 = jsObjectKeysArray(obj);
  var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap.pb(capacity);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'korlibs.platform.jsObjectToMap.<anonymous>' call
    var pair = to(element, obj[element]);
    destination.x2(pair.hk_1, pair.ik_1);
  }
  return destination;
}
function jsObjectKeysArray(obj) {
  _init_properties_Current_js_kt__w11d1e();
  var tmp = jsToArray(jsObjectKeys(obj));
  return isArray(tmp) ? tmp : THROW_CCE();
}
function jsToArray(obj) {
  _init_properties_Current_js_kt__w11d1e();
  var tmp = 0;
  var tmp_0 = obj.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = fillArrayVal(Array(tmp_0), null);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = obj[tmp_2];
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function jsObjectKeys(obj) {
  _init_properties_Current_js_kt__w11d1e();
  return Object.keys(obj);
}
function get_currentOs() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp;
  if (get_isDenoJs_0()) {
    switch (Deno.build.os) {
      case 'darwin':
        tmp = Os_MACOSX_getInstance();
        break;
      case 'linux':
        tmp = Os_LINUX_getInstance();
        break;
      case 'windows':
        tmp = Os_WINDOWS_getInstance();
        break;
      default:
        tmp = Os_UNKNOWN_getInstance();
        break;
    }
  } else {
    tmp = Os_UNKNOWN_getInstance();
  }
  return tmp;
}
function isDenoJs$delegate$lambda_0() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof Deno === 'object' && Deno.statSync !== undefined;
}
function isWeb$delegate$lambda_0() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof window === 'object';
}
function isWorker$delegate$lambda_0() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof importScripts === 'function';
}
function isNodeJs$delegate$lambda_0() {
  _init_properties_Current_js_kt__w11d1e();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
}
function envs$delegate$lambda() {
  _init_properties_Current_js_kt__w11d1e();
  var tmp;
  if (get_isDenoJs_0()) {
    tmp = jsObjectToMap(Deno.env.toObject());
  } else if (get_isNodeJs_0()) {
    tmp = jsObjectToMap(get_process().env);
  } else {
    // Inline function 'kotlin.also' call
    var this_0 = LinkedHashMap.ob();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.platform.envs$delegate.<anonymous>.<anonymous>' call
    var tmp95_safe_receiver = document.location;
    var tmp0_elvis_lhs = tmp95_safe_receiver == null ? null : tmp95_safe_receiver.search;
    var hash = trimStart(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, charArrayOf([_Char___init__impl__6a9atx(63)]));
    var _iterator__ex2g4s = split(hash, ['&']).a1();
    while (_iterator__ex2g4s.b1()) {
      var part = _iterator__ex2g4s.c1();
      var parts = split(part, ['=']);
      var key = decodeURIComponent(parts.f1(0));
      var tmp1_elvis_lhs = getOrNull(parts, 1);
      var value = decodeURIComponent(tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs);
      // Inline function 'kotlin.collections.set' call
      this_0.x2(key, value);
    }
    tmp = this_0;
  }
  return tmp;
}
function isDenoJs$factory_0() {
  return getPropertyCallableRef('isDenoJs', 0, KProperty0, function () {
    return get_isDenoJs_0();
  }, null);
}
function isWeb$factory_0() {
  return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
    return get_isWeb_0();
  }, null);
}
function isWorker$factory_0() {
  return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
    return get_isWorker_1();
  }, null);
}
function isNodeJs$factory_0() {
  return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
    return get_isNodeJs_0();
  }, null);
}
function envs$factory_0() {
  return getPropertyCallableRef('envs', 0, KProperty0, function () {
    return get_envs();
  }, null);
}
var properties_initialized_Current_js_kt_4h6d9c;
function _init_properties_Current_js_kt__w11d1e() {
  if (!properties_initialized_Current_js_kt_4h6d9c) {
    properties_initialized_Current_js_kt_4h6d9c = true;
    isDenoJs$delegate_0 = lazy(isDenoJs$delegate$lambda_0);
    isWeb$delegate_0 = lazy(isWeb$delegate$lambda_0);
    isWorker$delegate_0 = lazy(isWorker$delegate$lambda_0);
    isNodeJs$delegate_0 = lazy(isNodeJs$delegate$lambda_0);
    currentArch = Arch_UNKNOWN_getInstance();
    currentRuntime = Runtime_JS_getInstance();
    currentIsDebug = false;
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [287454020];
    // Inline function 'kotlin.js.asDynamic' call
    currentIsLittleEndian = (new Uint8Array((new Uint32Array(tmp$ret$2)).buffer))[0] === 68;
    multithreadedSharedHeap = false;
    currentRawPlatformName = get_isDenoJs_0() ? 'js-deno' : get_isWeb_0() ? 'js-web' : get_isNodeJs_0() ? 'js-node' : get_isWorker_1() ? 'js-worker' : get_isShell_0() ? 'js-shell' : 'js';
    var tmp;
    if (get_isDenoJs_0()) {
      tmp = 'deno';
    } else if (get_isWeb_0() || get_isWorker_1()) {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = navigator.userAgent;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = get_process().platform;
    }
    currentRawOsName = tmp;
    envs$delegate = lazy(envs$delegate$lambda);
  }
}
function contentHashCode_4(_this__u8e3s4, $this, src, dst) {
  // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
var Companion_instance_103;
function Companion_getInstance_104() {
  if (Companion_instance_103 === VOID)
    new Companion_102();
  return Companion_instance_103;
}
function parseObject($this, s) {
  skipExpect(s, $this, _Char___init__impl__6a9atx(123));
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap.ob();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.serialization.json.Json.parseObject.<anonymous>' call
  obj: while (true) {
    var tmp882_subject = skipSpaces(s, $this).f31();
    if (tmp882_subject === _Char___init__impl__6a9atx(125)) {
      s.h31();
      break obj;
    } else if (tmp882_subject === _Char___init__impl__6a9atx(44)) {
      s.h31();
      continue obj;
    }
    var tmp = $this.z3m(s);
    var key = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    skipExpect(skipSpaces(s, $this), $this, _Char___init__impl__6a9atx(58));
    var value = $this.z3m(s);
    // Inline function 'kotlin.collections.set' call
    this_0.x2(key, value);
  }
  return this_0;
}
function parseArray($this, s) {
  var out = null;
  var outNumber = null;
  skipExpect(s, $this, _Char___init__impl__6a9atx(91));
  array: while (true) {
    var tmp883_subject = skipSpaces(s, $this).f31();
    if (tmp883_subject === _Char___init__impl__6a9atx(93)) {
      s.h31();
      break array;
    } else if (tmp883_subject === _Char___init__impl__6a9atx(44)) {
      s.h31();
      continue array;
    }
    var v = s.f31();
    if (out == null && $this.a3n() && ((_Char___init__impl__6a9atx(48) <= v ? v <= _Char___init__impl__6a9atx(57) : false) || v === _Char___init__impl__6a9atx(45))) {
      if (outNumber == null) {
        outNumber = new MiniNumberArrayList();
      }
      outNumber.j3n(parseNumber($this, s));
    } else {
      if (out == null) {
        var tmp884_safe_receiver = outNumber;
        var tmp0_elvis_lhs = tmp884_safe_receiver == null ? null : tmp884_safe_receiver.g3n_1;
        out = $this.b3n(tmp0_elvis_lhs == null ? 16 : tmp0_elvis_lhs);
      }
      if (!(outNumber == null)) {
        // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.fastForEach' call
        var this_0 = outNumber;
        var inductionVariable = 0;
        var last = this_0.g3n_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.io.serialization.json.Json.parseArray.<anonymous>' call
            var it = this_0.h3n_1[n];
            out.g(it);
          }
           while (inductionVariable < last);
        outNumber = null;
      }
      out.g($this.z3m(s));
    }
  }
  var tmp;
  if (outNumber == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.serialization.json.Json.parseArray.<anonymous>' call
    tmp = $this.d3n(outNumber);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? out : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? $this.c3n() : tmp2_elvis_lhs;
}
function parseNumber($this, s) {
  // Inline function 'korlibs.io.util.NumberParser.parseDouble' call
  NumberParser_getInstance();
  var out = 0.0;
  var frac = 1.0;
  var pointSeen = false;
  var eSeen = false;
  var negate = false;
  var negateExponent = false;
  var exponent = 0;
  var n = 0;
  $l$loop: while (true) {
    // Inline function 'korlibs.io.serialization.json.Json.parseNumber.<anonymous>' call
    n = n + 1 | 0;
    var c = s.f31();
    var isC = Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(57)) <= 0 || c === _Char___init__impl__6a9atx(46) || c === _Char___init__impl__6a9atx(101) || c === _Char___init__impl__6a9atx(69) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(43);
    if (isC) {
      s.h31();
    }
    var c_0 = isC ? c : _Char___init__impl__6a9atx(0);
    if (c_0 === _Char___init__impl__6a9atx(0))
      break $l$loop;
    if (c_0 === _Char___init__impl__6a9atx(101) || c_0 === _Char___init__impl__6a9atx(69))
      eSeen = true;
    else if (c_0 === _Char___init__impl__6a9atx(45)) {
      if (eSeen)
        negateExponent = true;
      else
        negate = true;
    } else if (c_0 === _Char___init__impl__6a9atx(46))
      pointSeen = true;
    else {
      if (eSeen) {
        exponent = imul(exponent, 10);
        exponent = exponent + ctypeAsInt(c_0) | 0;
      } else {
        if (pointSeen)
          frac = frac / 10;
        out = out * 10;
        out = out + ctypeAsInt(c_0);
      }
    }
  }
  var tmp = out * frac;
  // Inline function 'kotlin.math.pow' call
  var n_0 = negateExponent ? -exponent | 0 : exponent;
  var res = tmp * Math.pow(10.0, n_0);
  return negate ? -res : res;
}
function invalidJson($this, msg) {
  throw IllegalArgumentException.m(msg);
}
function expect(_this__u8e3s4, $this, str) {
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = _this__u8e3s4.h31();
      if (!(c === charSequenceGet(str, n)))
        throw IllegalStateException.n4("Expected '" + str + "' but found '" + toString_1(c) + "' at " + n);
    }
     while (inductionVariable <= last);
}
function skipSpaces(_this__u8e3s4, $this) {
  // Inline function 'korlibs.io.serialization.json.Json.skipWhile' call
  $l$loop: while (true) {
    var tmp;
    if (_this__u8e3s4.g31()) {
      // Inline function 'korlibs.io.serialization.json.Json.skipSpaces.<anonymous>' call
      var it = _this__u8e3s4.f31();
      tmp = isWhitespaceFast(it, $this);
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop;
    }
    _this__u8e3s4.h31();
  }
  return _this__u8e3s4;
}
function skipExpect(_this__u8e3s4, $this, expected) {
  var readed = _this__u8e3s4.h31();
  if (!(readed === expected))
    throw IllegalArgumentException.m("Expected '" + toString_1(expected) + "' but found '" + toString_1(readed) + "' at " + _this__u8e3s4.c31());
}
function isWhitespaceFast(_this__u8e3s4, $this) {
  return _this__u8e3s4 === _Char___init__impl__6a9atx(32) || _this__u8e3s4 === _Char___init__impl__6a9atx(9) || _this__u8e3s4 === _Char___init__impl__6a9atx(13) || _this__u8e3s4 === _Char___init__impl__6a9atx(10);
}
var CHARSET_PROVIDERS;
var CHARSET_PROVIDERS_LOCK;
function get_UTF8() {
  _init_properties_Charset_kt__c47y1m();
  return UTF8;
}
var UTF8;
function get_LATIN1() {
  _init_properties_Charset_kt__c47y1m();
  return LATIN1;
}
var LATIN1;
var UTF16_LE;
var UTF16_BE;
function toString_3(_this__u8e3s4, charset, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.length : end;
  _init_properties_Charset_kt__c47y1m();
  var out = StringBuilder.gb(charset.n3n(end - start | 0));
  charset.o3n(out, _this__u8e3s4, start, end);
  return out.toString();
}
var ASCII_instance;
function ASCII_getInstance() {
  if (ASCII_instance === VOID)
    new ASCII();
  return ASCII_instance;
}
var Companion_instance_104;
function Companion_getInstance_105() {
  return Companion_instance_104;
}
var ISO_8859_1_instance;
function ISO_8859_1_getInstance() {
  if (ISO_8859_1_instance === VOID)
    new ISO_8859_1();
  return ISO_8859_1_instance;
}
var Charsets_instance;
function Charsets_getInstance() {
  return Charsets_instance;
}
var properties_initialized_Charset_kt_dajgec;
function _init_properties_Charset_kt__c47y1m() {
  if (!properties_initialized_Charset_kt_dajgec) {
    properties_initialized_Charset_kt_dajgec = true;
    // Inline function 'kotlin.collections.arrayListOf' call
    CHARSET_PROVIDERS = ArrayList.j1();
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    CHARSET_PROVIDERS_LOCK = get_atomicfu$reentrantLock();
    UTF8 = new UTC8CharsetBase('UTF-8');
    LATIN1 = ISO_8859_1_getInstance();
    UTF16_LE = new UTF16Charset(true);
    UTF16_BE = new UTF16Charset(false);
  }
}
var replaceNonPrintableCharactersRegex$delegate;
function substr_0(_this__u8e3s4, start) {
  _init_properties_StringExt_kt__eg42u6();
  return substr_1(_this__u8e3s4, start, _this__u8e3s4.length);
}
function substr_1(_this__u8e3s4, start, length) {
  _init_properties_StringExt_kt__eg42u6();
  var low = coerceIn_1(start >= 0 ? start : _this__u8e3s4.length + start | 0, 0, _this__u8e3s4.length);
  var high = coerceIn_1(length >= 0 ? low + length | 0 : _this__u8e3s4.length + length | 0, 0, _this__u8e3s4.length);
  var tmp;
  if (high >= low) {
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = _this__u8e3s4.substring(low, high);
  } else {
    tmp = '';
  }
  return tmp;
}
function substringEquals(_this__u8e3s4, a, aIndex, b, bIndex, count) {
  _init_properties_StringExt_kt__eg42u6();
  if (count === 0)
    return true;
  if (aIndex < 0 || bIndex < 0)
    return false;
  if ((aIndex + count | 0) > a.length)
    return false;
  if ((bIndex + count | 0) > b.length)
    return false;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charSequenceGet(a, aIndex + n | 0) === charSequenceGet(b, bIndex + n | 0)))
        return false;
    }
     while (inductionVariable < count);
  return true;
}
function replaceNonPrintableCharactersRegex$delegate$lambda() {
  _init_properties_StringExt_kt__eg42u6();
  return Regex.wg('[^ -~]');
}
var properties_initialized_StringExt_kt_sd962o;
function _init_properties_StringExt_kt__eg42u6() {
  if (!properties_initialized_StringExt_kt_sd962o) {
    properties_initialized_StringExt_kt_sd962o = true;
    replaceNonPrintableCharactersRegex$delegate = lazy(replaceNonPrintableCharactersRegex$delegate$lambda);
  }
}
function extract_1(_this__u8e3s4, offset, count) {
  return (_this__u8e3s4 >>> offset | 0) & mask_0(count);
}
function getS16(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getS16LE(_this__u8e3s4, offset) : getS16BE(_this__u8e3s4, offset);
}
function insert_1(_this__u8e3s4, value, offset, count) {
  var mask = mask_0(count) << offset;
  var ovalue = value << offset & mask;
  return _this__u8e3s4 & ~mask | ovalue;
}
function mask_0(_this__u8e3s4) {
  return (1 << _this__u8e3s4) - 1 | 0;
}
function getS16LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.io.lang.internal.get16LE' call
  var tmp$ret$0 = u8_0(_this__u8e3s4, offset + 0 | 0) << 0 | u8_0(_this__u8e3s4, offset + 1 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function getS16BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.io.lang.internal.get16BE' call
  var tmp$ret$0 = u8_0(_this__u8e3s4, offset + 1 | 0) << 0 | u8_0(_this__u8e3s4, offset + 0 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function signExtend(_this__u8e3s4, bits) {
  return _this__u8e3s4 << (32 - bits | 0) >> (32 - bits | 0);
}
function u8_0(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function substringAfterOrNull(_this__u8e3s4, delimiter) {
  return contains_1(_this__u8e3s4, delimiter) ? substringAfter(_this__u8e3s4, delimiter) : null;
}
function substringBeforeOrNull(_this__u8e3s4, delimiter) {
  return contains_1(_this__u8e3s4, delimiter) ? substringBefore(_this__u8e3s4, delimiter) : null;
}
var INDENTS_instance_0;
function INDENTS_getInstance_0() {
  if (INDENTS_instance_0 === VOID)
    new INDENTS_0();
  return INDENTS_instance_0;
}
var Companion_instance_105;
function Companion_getInstance_106() {
  return Companion_instance_105;
}
function _DateTime___init__impl__ifgty2(unixMillis) {
  return unixMillis;
}
function _DateTime___get_unixMillis__impl__ofxkzp($this) {
  return $this;
}
var Companion_instance_106;
function Companion_getInstance_107() {
  if (Companion_instance_106 === VOID)
    new Companion_105();
  return Companion_instance_106;
}
function _DateTime___get_unixMillisDouble__impl__3dzlsc($this) {
  return _DateTime___get_unixMillis__impl__ofxkzp($this);
}
function _DateTime___get_unixMillisLong__impl__sdx9bd($this) {
  return numberToLong(_DateTime___get_unixMillisDouble__impl__3dzlsc($this));
}
function DateTime__minus_impl_10njw8($this, other) {
  // Inline function 'korlibs.time.milliseconds' call
  var this_0 = _DateTime___get_unixMillisDouble__impl__3dzlsc($this) - _DateTime___get_unixMillisDouble__impl__3dzlsc(other);
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
function DateTime__compareTo_impl_geo3bs($this, other) {
  return compareTo(_DateTime___get_unixMillis__impl__ofxkzp($this), _DateTime___get_unixMillis__impl__ofxkzp(other));
}
function DateTime__compareTo_impl_geo3bs_0($this, other) {
  return DateTime__compareTo_impl_geo3bs($this.f3o_1, other instanceof DateTime ? other.f3o_1 : THROW_CCE());
}
function DateTime__toString_impl_cnueje($this) {
  return 'DateTime(' + _DateTime___get_unixMillisLong__impl__sdx9bd($this).toString() + ')';
}
function DateTime__hashCode_impl_yf0bc9($this) {
  return getNumberHashCode($this);
}
function DateTime__equals_impl_qd7s8j($this, other) {
  if (!(other instanceof DateTime))
    return false;
  var tmp0_other_with_cast = other instanceof DateTime ? other.f3o_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _FastDuration___init__impl__cfl6bz(ms) {
  return ms;
}
function _get_ms__ndc6g5($this) {
  return $this;
}
var Companion_instance_107;
function Companion_getInstance_108() {
  return Companion_instance_107;
}
function _FastDuration___get_isNil__impl__n4fw9d($this) {
  return equals($this, Companion_instance_107.j3o());
}
function _FastDuration___get_seconds__impl__4kvvav($this) {
  return _get_ms__ndc6g5($this) / 1000;
}
function _FastDuration___get_milliseconds__impl__ffr17u($this) {
  return _get_ms__ndc6g5($this);
}
function _FastDuration___get_microseconds__impl__o4j93h($this) {
  return _get_ms__ndc6g5($this) * 1000;
}
function _FastDuration___get_nanoseconds__impl__pxizcb($this) {
  return _get_ms__ndc6g5($this) * 1000000;
}
function _FastDuration___get_fastMilliseconds__impl__pe68va($this) {
  return _FastDuration___get_milliseconds__impl__ffr17u($this);
}
function _FastDuration___get_fastMicroseconds__impl__e641g1($this) {
  return _FastDuration___get_microseconds__impl__o4j93h($this);
}
function _FastDuration___get_fastNanoseconds__impl__9kjwbr($this) {
  return _FastDuration___get_nanoseconds__impl__pxizcb($this);
}
function FastDuration__plus_impl_q1enab($this, that) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) + _get_ms__ndc6g5(that));
}
function FastDuration__minus_impl_evs237($this, that) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) - _get_ms__ndc6g5(that));
}
function FastDuration__div_impl_rlslck($this, other) {
  return _get_ms__ndc6g5($this) / _get_ms__ndc6g5(other);
}
function FastDuration__times_impl_h6amcp($this, scale) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) * scale);
}
function FastDuration__div_impl_rlslck_0($this, scale) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) / scale);
}
function FastDuration__plus_impl_q1enab_0($this, other) {
  return _FastDuration___init__impl__cfl6bz(_FastDuration___get_milliseconds__impl__ffr17u($this) + get_milliseconds(other));
}
function FastDuration__minus_impl_evs237_0($this, other) {
  return _FastDuration___init__impl__cfl6bz(_FastDuration___get_milliseconds__impl__ffr17u($this) - get_milliseconds(other));
}
function FastDuration__compareTo_impl_4fhnj7($this, other) {
  return compareTo(_get_ms__ndc6g5($this), _get_ms__ndc6g5(other));
}
function FastDuration__compareTo_impl_4fhnj7_0($this, other) {
  return FastDuration__compareTo_impl_4fhnj7($this.k3o_1, other instanceof FastDuration ? other.k3o_1 : THROW_CCE());
}
function FastDuration__compareTo_impl_4fhnj7_1($this, other) {
  return compareTo(_get_ms__ndc6g5($this), get_milliseconds(other));
}
function FastDuration__toString_impl_c9xohb($this) {
  return 'FastDuration(ms=' + $this + ')';
}
function FastDuration__hashCode_impl_y13la6($this) {
  return getNumberHashCode($this);
}
function FastDuration__equals_impl_unk8ke($this, other) {
  if (!(other instanceof FastDuration))
    return false;
  var tmp0_other_with_cast = other instanceof FastDuration ? other.k3o_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_fast(_this__u8e3s4) {
  var tmp;
  // Inline function 'korlibs.time.isNil' call
  if (equals(_this__u8e3s4, get_DURATION_NIL())) {
    tmp = Companion_instance_107.j3o();
  } else {
    tmp = get_fastMilliseconds(get_milliseconds(_this__u8e3s4));
  }
  return tmp;
}
function get_fastSeconds(_this__u8e3s4) {
  return get_fastSeconds_0(_this__u8e3s4);
}
function toDuration_2(_this__u8e3s4) {
  return get_slow(_this__u8e3s4);
}
function get_fastMilliseconds(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4);
}
function get_fastSeconds_0(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 * 1000);
}
function get_slow(_this__u8e3s4) {
  var tmp;
  if (_FastDuration___get_isNil__impl__n4fw9d(_this__u8e3s4)) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance_0();
    tmp = get_DURATION_NIL();
  } else {
    // Inline function 'korlibs.time.seconds' call
    var this_0 = _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4);
    tmp = toDuration(this_0, DurationUnit_SECONDS_getInstance());
  }
  return tmp;
}
function get_fastMicroseconds(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 / 1000);
}
function minus_0(_this__u8e3s4, other) {
  return _FastDuration___init__impl__cfl6bz(get_milliseconds(_this__u8e3s4) - _FastDuration___get_milliseconds__impl__ffr17u(other));
}
function get_fastMilliseconds_0(_this__u8e3s4) {
  return get_fastMilliseconds(_this__u8e3s4);
}
function roundMilliseconds(_this__u8e3s4) {
  return get_fastMilliseconds(round(_FastDuration___get_milliseconds__impl__ffr17u(_this__u8e3s4)));
}
function get_fastMicroseconds_0(_this__u8e3s4) {
  return get_fastMilliseconds(_this__u8e3s4);
}
function div(_this__u8e3s4, other) {
  return get_milliseconds(_this__u8e3s4) / _FastDuration___get_milliseconds__impl__ffr17u(other);
}
function get_fastNanoseconds(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 / 1000000);
}
function get_fastNanoseconds_0(_this__u8e3s4) {
  return get_fastMilliseconds(_this__u8e3s4);
}
var Companion_instance_108;
function Companion_getInstance_109() {
  return Companion_instance_108;
}
function get_DURATION_NIL() {
  _init_properties_TimeSpan_kt__xworpz();
  return DURATION_NIL;
}
var DURATION_NIL;
function get_milliseconds(_this__u8e3s4) {
  _init_properties_TimeSpan_kt__xworpz();
  return _Duration___get_inWholeNanoseconds__impl__r5x4mr(_this__u8e3s4).e4() / 1000000.0;
}
function max(a, b) {
  _init_properties_TimeSpan_kt__xworpz();
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_0();
  // Inline function 'kotlin.math.max' call
  var a_0 = get_milliseconds(a);
  var b_0 = get_milliseconds(b);
  var this_0 = Math.max(a_0, b_0);
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
var properties_initialized_TimeSpan_kt_fytdnd;
function _init_properties_TimeSpan_kt__xworpz() {
  if (!properties_initialized_TimeSpan_kt_fytdnd) {
    properties_initialized_TimeSpan_kt_fytdnd = true;
    DURATION_NIL = toDuration_1(new Long(13, -2097152), DurationUnit_NANOSECONDS_getInstance());
  }
}
function get_CoreTime() {
  _init_properties_CoreTime_js_kt__zee7g9();
  return CoreTime;
}
var CoreTime;
var properties_initialized_CoreTime_js_kt_73dge3;
function _init_properties_CoreTime_js_kt__zee7g9() {
  if (!properties_initialized_CoreTime_js_kt_73dge3) {
    properties_initialized_CoreTime_js_kt_73dge3 = true;
    CoreTime = new CoreTime$1();
  }
}
function _Frequency___init__impl__upasnx(hertz) {
  return hertz;
}
function _Frequency___get_hertz__impl__9m7k6x($this) {
  return $this;
}
function toFrequency(_this__u8e3s4) {
  return get_timesPerSecond(_this__u8e3s4);
}
function get_timesPerSecond(_this__u8e3s4) {
  return _Frequency___init__impl__upasnx(1.0 / _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4));
}
var KlockLocale_default;
function nowMillis($this) {
  return get_CoreTime().m3o();
}
function ellapsed($this) {
  return get_fastMilliseconds(nowMillis($this) - $this.n3o_1);
}
var PerformanceCounter_instance;
function PerformanceCounter_getInstance() {
  if (PerformanceCounter_instance === VOID)
    new PerformanceCounter();
  return PerformanceCounter_instance;
}
function _get_currentNano__jndyu4($this) {
  return $this.s3o_1();
}
function setStart($this) {
  $this.u3o_1 = _get_currentNano__jndyu4($this);
}
function Stopwatch$_init_$lambda_lg3mf2() {
  return PerformanceCounter_getInstance().o3o();
}
var ExtendedTimezoneNamesOrNull;
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioFormat, 'AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(AudioFormats, 'AudioFormats', AudioFormats, VOID, VOID, [2, 4]);
initMetadataForClass(MP3Decoder, 'MP3Decoder', MP3Decoder, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_0, VOID, VOID, [2, 4]);
initMetadataForClass(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', VOID, VOID, VOID, [2, 3, 4]);
initMetadataForObject(Minimp3AudioFormat, 'Minimp3AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(WAV, 'WAV', WAV, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_2, VOID, VOID, [2, 4]);
initMetadataForClass(NativeSoundProvider, 'NativeSoundProvider', NativeSoundProvider, VOID, [AutoCloseable], [1, 3, 4, 2]);
initMetadataForClass(NativeSoundProviderNew, 'NativeSoundProviderNew', NativeSoundProviderNew, VOID, VOID, [1, 3, 4, 2]);
initMetadataForClass(DummyNativeSoundProvider, 'DummyNativeSoundProvider', DummyNativeSoundProvider, VOID, VOID, [1, 3, 4, 2]);
initMetadataForCompanion(Companion_3, VOID, VOID, [1, 3, 4, 2]);
initMetadataForClass(HtmlNativeSoundProvider, 'HtmlNativeSoundProvider', HtmlNativeSoundProvider, VOID, VOID, [4, 1, 3, 2]);
initMetadataForObject(HtmlSimpleSound, 'HtmlSimpleSound', VOID, VOID, VOID, [0, 2, 1]);
initMetadataForObject(Adler32, 'Adler32');
initMetadataForObject(CRC32, 'CRC32');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(SlidingWindowWithOutput, 'SlidingWindowWithOutput', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(DeflaterPortable, 'DeflaterPortable', VOID, VOID, VOID, [3, 2]);
initMetadataForCompanion(Companion_6, VOID, VOID, [3, 2]);
initMetadataForClass(HuffmanTree, 'HuffmanTree', HuffmanTree);
initMetadataForClass(SlidingWindow, 'SlidingWindow');
initMetadataForClass(FixedSizeByteArrayBuilder, 'FixedSizeByteArrayBuilder');
initMetadataForInterface(CompressionMethod, 'CompressionMethod', VOID, VOID, VOID, [2, 3]);
initMetadataForLambda(uncompressStream$slambda, VOID, VOID, [1]);
initMetadataForLambda(uncompress$slambda, VOID, VOID, [0]);
initMetadataForClass(Deflate$4, VOID, VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForClass(toDeflater$1, VOID, VOID, VOID, VOID, [0, 1, 3]);
initMetadataForClass(toDeflater$2, VOID, VOID, VOID, VOID, [3, 1]);
initMetadataForClass(GZIPBase, 'GZIPBase', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForClass(GZIP, 'GZIP', VOID, VOID, VOID, [2, 3]);
initMetadataForCompanion(Companion_7, VOID, VOID, [2, 3]);
initMetadataForInterface(AsyncOutputStream, 'AsyncOutputStream', VOID, VOID, VOID, [3, 1, 0]);
protoOf(GZIPBase$uncompress$2).c1f = write$default;
initMetadataForClass(GZIPBase$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [1, 0, 3]);
initMetadataForClass(ZLib, 'ZLib', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForCompanion(Companion_8, VOID, VOID, [2, 3]);
protoOf(ZLib$uncompress$2).c1f = write$default;
initMetadataForClass(ZLib$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [0, 3, 1]);
initMetadataForCompanion(Companion_9, VOID, VOID, [1]);
initMetadataForInterface(AsyncGetLengthStream, 'AsyncGetLengthStream', VOID, VOID, VOID, [0]);
initMetadataForInterface(AsyncGetPositionStream, 'AsyncGetPositionStream', VOID, VOID, VOID, [0]);
initMetadataForClass(BitReader, 'BitReader', VOID, VOID, [AsyncGetLengthStream, AsyncGetPositionStream], [0, 1, 2, 3]);
initMetadataForClass(BaseLock, 'BaseLock');
initMetadataForClass(NonRecursiveLock, 'NonRecursiveLock', NonRecursiveLock);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Lock, 'Lock', Lock);
initMetadataForCompanion(Companion_11);
protoOf(PreferSyncIo).mc = get;
protoOf(PreferSyncIo).yl = fold;
protoOf(PreferSyncIo).xl = minusKey;
protoOf(PreferSyncIo).zl = plus;
initMetadataForClass(PreferSyncIo, 'PreferSyncIo', VOID, VOID, [Element]);
initMetadataForClass(BaseSignal, 'BaseSignal', VOID, VOID, VOID, [0]);
initMetadataForClass(Signal, 'Signal', Signal, VOID, VOID, [0]);
initMetadataForClass(Node, 'Node', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AsyncSignal, 'AsyncSignal', AsyncSignal, VOID, VOID, [1, 0]);
protoOf(runBlockingNoSuspensions$1$context$1).mc = get_0;
protoOf(runBlockingNoSuspensions$1$context$1).xl = minusKey_0;
protoOf(runBlockingNoSuspensions$1$context$1).oc = releaseInterceptedContinuation;
protoOf(runBlockingNoSuspensions$1$context$1).qv = invokeOnTimeout;
initMetadataForClass(runBlockingNoSuspensions$1$context$1, VOID, VOID, VOID, [AbstractCoroutineContextElement, ContinuationInterceptor, Delay], [1]);
initMetadataForClass(runBlockingNoSuspensions$1);
initMetadataForCompanion(Companion_12);
initMetadataForInterface(DoubleList, 'DoubleList', VOID, VOID, [Collection]);
initMetadataForClass(Mixin, 'Mixin', Mixin);
initMetadataForClass(Property, 'Property');
initMetadataForClass(PropertyThis, 'PropertyThis');
initMetadataForClass(ExtraObject, 'ExtraObject', ExtraObject, VOID, [KtMutableMap]);
initMetadataForInterface(MutableListEx, 'MutableListEx', VOID, VOID, [KtMutableList]);
initMetadataForClass(SimpleSubList$1);
initMetadataForClass(Fixed, 'Fixed', VOID, VOID, VOID, [0]);
protoOf(FastArrayList).u1i = addAll_1;
protoOf(FastArrayList).s1i = setAddAll;
protoOf(FastArrayList).v1i = setAddAll$default;
protoOf(FastArrayList).t1i = setAll;
protoOf(FastArrayList).w1i = removeToSize;
initMetadataForClass(FastArrayList, 'FastArrayList', FastArrayList.j1h, VOID, [AbstractMutableList, MutableListEx, RandomAccess]);
initMetadataForCompanion(Companion_13);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).n1j = get_1;
protoOf(IntArray2).o1j = set;
protoOf(IntArray2).y1h = getAt_1;
protoOf(IntArray2).p1j = getAt_0;
protoOf(IntArray2).q1j = inside;
protoOf(IntArray2).m1j = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList, VOID, [Collection]);
initMetadataForCompanion(Companion_15);
protoOf(DoubleArrayList).r2 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList, VOID, [DoubleList]);
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.l1k, VOID, [Collection, MutableIterable]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.c1l, VOID, [Collection, MutableIterable]);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.m1l);
initMetadataForCompanion(Companion_16);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.p1m);
initMetadataForClass(Iterator$1);
initMetadataForCompanion(Companion_18);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForCompanion(Companion_19);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [Collection, MutableIterable]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$2);
initMetadataForClass(Ref$3);
initMetadataForCompanion(Companion_20);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
initMetadataForCompanion(Companion_21);
initMetadataForClass(Dyn, 'Dyn', VOID, VOID, [Comparable], [2, 1]);
initMetadataForInterface(DynApi, 'DynApi', VOID, VOID, VOID, [2, 3]);
initMetadataForObject(DynamicInternal, 'DynamicInternal', VOID, VOID, [DynApi], [2, 3]);
initMetadataForObject(Base64, 'Base64');
initMetadataForObject(Hex, 'Hex');
initMetadataForCompanion(Companion_22);
initMetadataForClass(FuncDelegate, 'FuncDelegate');
initMetadataForClass(FuncInfo, 'FuncInfo');
initMetadataForClass(FFILib, 'FFILib', VOID, VOID, [AutoCloseable]);
initMetadataForInterface(FFILibSym, 'FFILibSym', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FuncType, 'FuncType');
initMetadataForCompanion(Companion_23);
initMetadataForClass(FFIFuncConfig, 'FFIFuncConfig', FFIFuncConfig);
initMetadataForClass(FFIPointerArray, 'FFIPointerArray', VOID, VOID, [KtList]);
initMetadataForClass(FFISyncIOFile, 'FFISyncIOFile');
initMetadataForClass(LDLibraries, 'LDLibraries');
initMetadataForCompanion(Companion_24);
initMetadataForClass(LibraryResolver, 'LibraryResolver');
initMetadataForCompanion(Companion_25);
initMetadataForClass(FFILibSymJS, 'FFILibSymJS', VOID, VOID, [FFILibSym]);
initMetadataForClass(FFIPlatformSyncIO$1);
initMetadataForClass(Entry_0, 'Entry');
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion_26, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_27);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForInterface(NativeImageRef, 'NativeImageRef');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [Bitmap, NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_28);
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_29);
initMetadataForCompanion(Companion_30);
initMetadataForCompanion(Companion_31);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_32);
initMetadataForCompanion(Companion_33);
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, VOID, [0]);
protoOf(BitmapFontImpl).f1 = get_3;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForCompanion(Companion_34);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_35);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForCompanion(Companion_36);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.z2f, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_37);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_38);
initMetadataForClass(Type, 'Type');
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [2, 1, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_39);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_40);
initMetadataForClass(RequestContext, 'RequestContext');
initMetadataForClass(NotMappedException, 'NotMappedException');
initMetadataForClass(Injector, 'Injector', Injector);
initMetadataForInterface(InjectorDependency, 'InjectorDependency');
initMetadataForInterface(ObjectProvider, 'ObjectProvider');
initMetadataForClass(InstanceObjectProvider, 'InstanceObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(SingletonObjectProvider, 'SingletonObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(PrototypeObjectProvider, 'PrototypeObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForInterface(InjectorDestructor, 'InjectorDestructor');
initMetadataForCompanion(Companion_41);
protoOf(InjectorContext).mc = get;
protoOf(InjectorContext).yl = fold;
protoOf(InjectorContext).xl = minusKey;
protoOf(InjectorContext).zl = plus;
initMetadataForClass(InjectorContext, 'InjectorContext', VOID, VOID, [Element]);
initMetadataForCompanion(Companion_42, VOID, VOID, [2, 1, 3]);
initMetadataForObject(NullSyncSystemFS, 'NullSyncSystemFS');
initMetadataForClass(toAsync$1, VOID, VOID, VOID, VOID, [1, 2, 3]);
initMetadataForCompanion(Companion_43, VOID, VOID, [7]);
initMetadataForClass(HttpFetchResult, 'HttpFetchResult');
initMetadataForClass(defaultHttpFetch$1, VOID, VOID, VOID, VOID, [7]);
protoOf(AsyncRingBuffer).c1f = write$default;
initMetadataForClass(AsyncRingBuffer, 'AsyncRingBuffer', AsyncRingBuffer, VOID, [AsyncOutputStream], [3, 0, 1]);
initMetadataForCompanion(Companion_44);
protoOf(AsyncRingBufferChunked).c1f = write$default;
initMetadataForClass(AsyncRingBufferChunked, 'AsyncRingBufferChunked', AsyncRingBufferChunked, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForLambda(toAsync$o$write$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$close$slambda, VOID, VOID, [1]);
protoOf(toAsync$1_0).c1f = write$default;
initMetadataForClass(toAsync$1_0, VOID, VOID, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForLambda(toAsync$o$read$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$close$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$getPosition$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$getLength$slambda, VOID, VOID, [1]);
protoOf(toAsync$2).h1f = hasLength;
initMetadataForClass(toAsync$2, VOID, VOID, VOID, [AsyncGetLengthStream, AsyncGetPositionStream], [1, 3, 0]);
protoOf(AsyncStreamBase).h1f = hasLength;
initMetadataForClass(AsyncStreamBase, 'AsyncStreamBase', AsyncStreamBase.v2o, VOID, [AsyncGetLengthStream], [4, 1, 0]);
initMetadataForClass(SliceAsyncStreamBase, 'SliceAsyncStreamBase', VOID, VOID, VOID, [4, 0, 1]);
initMetadataForClass(BufferedStreamBase, 'BufferedStreamBase', VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(MemoryAsyncStreamBase, 'MemoryAsyncStreamBase', MemoryAsyncStreamBase.i2p, VOID, VOID, [1, 0, 4]);
initMetadataForInterface(AsyncPositionLengthStream, 'AsyncPositionLengthStream', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1]);
protoOf(AsyncStream).c1f = write$default;
protoOf(AsyncStream).m2p = hasAvailable;
protoOf(AsyncStream).n2p = getAvailable;
initMetadataForClass(AsyncStream, 'AsyncStream', VOID, VOID, [AsyncGetLengthStream, AsyncGetPositionStream, AsyncOutputStream, AsyncPositionLengthStream], [3, 0, 1]);
protoOf(asyncStreamWriter$1$ensureJob$2$1).c1f = write$default;
initMetadataForClass(asyncStreamWriter$1$ensureJob$2$1, VOID, VOID, VOID, [AsyncOutputStream], [3, 1, 0]);
initMetadataForLambda(asyncStreamWriter$o$ensureJob$slambda, VOID, VOID, [1]);
initMetadataForClass(asyncStreamWriter$1, VOID, VOID, VOID, VOID, [0, 3]);
initMetadataForInterface(SyncLengthStream, 'SyncLengthStream');
initMetadataForClass(SyncStreamBase, 'SyncStreamBase', SyncStreamBase.f2q, VOID, [AutoCloseable, SyncLengthStream]);
initMetadataForClass(MemorySyncStreamBase, 'MemorySyncStreamBase', MemorySyncStreamBase.g2q);
initMetadataForInterface(SyncInputStream, 'SyncInputStream', VOID, VOID, [AutoCloseable]);
initMetadataForInterface(SyncPositionStream, 'SyncPositionStream');
initMetadataForInterface(SyncOutputStream, 'SyncOutputStream', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncStream, 'SyncStream', VOID, VOID, [AutoCloseable, SyncInputStream, SyncPositionStream, SyncOutputStream, SyncLengthStream]);
initMetadataForClass(SliceSyncStreamBase, 'SliceSyncStreamBase');
initMetadataForClass(FinalVfsFile, 'FinalVfsFile');
initMetadataForClass(VfsNamed, 'VfsNamed');
initMetadataForLambda(Vfs$Proxy$initOnce$slambda, VOID, VOID, [1]);
initMetadataForClass(Vfs, 'Vfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
initMetadataForClass(Proxy, 'Proxy', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForClass(VfsStat, 'VfsStat');
initMetadataForClass(VfsOpenMode, 'VfsOpenMode');
initMetadataForCompanion(Companion_45);
protoOf(VfsCachedStatContext).mc = get;
protoOf(VfsCachedStatContext).yl = fold;
protoOf(VfsCachedStatContext).xl = minusKey;
protoOf(VfsCachedStatContext).zl = plus;
initMetadataForClass(VfsCachedStatContext, 'VfsCachedStatContext', VOID, VOID, [Element]);
initMetadataForClass(VfsFile, 'VfsFile', VOID, VOID, VOID, [0, 2, 3, 1, 4, 5]);
initMetadataForCompanion(Companion_46);
initMetadataForClass(JailVfs, 'JailVfs', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(LocalVfs, 'LocalVfs', VOID, VOID, VOID, [1, 4, 0, 2, 3]);
initMetadataForClass(UrlVfs, 'UrlVfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
initMetadataForLambda(_launch$slambda, VOID, VOID, [1]);
initMetadataForClass(launchUnscopedAndWait$1);
initMetadataForClass(launchUnscoped$1);
initMetadataForLambda(CatalogVfs$open$slambda, VOID, VOID, [1]);
initMetadataForClass(CatalogVfs$open$2, VOID, VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(CatalogVfs, 'CatalogVfs', VOID, VOID, VOID, [2, 1, 0, 4, 3]);
initMetadataForClass(StandardVfs, 'StandardVfs', StandardVfs);
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(MountableVfs, 'MountableVfs', VOID, VOID, VOID, [0, 1, 4, 2, 3]);
initMetadataForInterface(StandardPathsBase, 'StandardPathsBase');
initMetadataForClass(FinalUrlVfs$open$2, VOID, VOID, VOID, VOID, [4, 0, 1]);
initMetadataForClass(FinalUrlVfs, 'FinalUrlVfs', VOID, VOID, VOID, [2, 1, 3, 0, 4]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(URL_0, 'URL');
initMetadataForCompanion(Companion_49);
initMetadataForCompanion(Companion_50);
initMetadataForCompanion(Companion_51);
initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(Methods, 'Methods');
initMetadataForClass(IOException, 'IOException');
initMetadataForClass(HttpException, 'HttpException');
initMetadataForClass(Headers, 'Headers', VOID, VOID, [Iterable]);
initMetadataForCompanion(Companion_52, VOID, VOID, [4]);
initMetadataForCompanion(Companion_53);
initMetadataForClass(Response, 'Response', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(CompletedResponse, 'CompletedResponse');
initMetadataForClass(RequestConfig, 'RequestConfig', RequestConfig);
initMetadataForInterface(HttpClient, 'HttpClient', VOID, VOID, VOID, [4, 5, 2]);
protoOf(Companion_54).o2w = request$default;
protoOf(Companion_54).m2z = requestAsBytes$default;
protoOf(Companion_54).z2v = readBytes$default;
initMetadataForCompanion(Companion_54, VOID, [HttpClient], [4, 5, 2]);
initMetadataForObject(HttpStatusMessage, 'HttpStatusMessage');
initMetadataForClass(ProxiedHttpFactory, 'ProxiedHttpFactory');
initMetadataForLambda(withTransferEncoding$slambda, VOID, VOID, [1]);
protoOf(createHttpClientFromFetch$1).l2z = request;
protoOf(createHttpClientFromFetch$1).o2w = request$default;
protoOf(createHttpClientFromFetch$1).n2z = requestAsBytes;
protoOf(createHttpClientFromFetch$1).m2z = requestAsBytes$default;
protoOf(createHttpClientFromFetch$1).o2z = readBytes;
protoOf(createHttpClientFromFetch$1).z2v = readBytes$default;
initMetadataForClass(createHttpClientFromFetch$1, VOID, VOID, VOID, [HttpClient], [4, 5, 2]);
initMetadataForClass(Resources, 'Resources');
initMetadataForInterface(Text, 'Text');
initMetadataForClass(Marker, 'Marker');
initMetadataForClass(Line, 'Line', VOID, VOID, [Text]);
initMetadataForClass(LineDeferred, 'LineDeferred');
initMetadataForObject(EmptyLineOnce, 'EmptyLineOnce');
initMetadataForObject(Indent, 'Indent');
initMetadataForObject(Unindent, 'Unindent');
initMetadataForObject(INDENTS, 'INDENTS');
initMetadataForCompanion(Companion_55);
initMetadataForClass(IndenterEvaluator, 'IndenterEvaluator');
initMetadataForClass(Indenter, 'Indenter', Indenter);
initMetadataForCompanion(Companion_56);
initMetadataForClass(BaseStrReader, 'BaseStrReader');
initMetadataForClass(StrReader, 'StrReader');
initMetadataForLambda(DemoWorkerTask$execute$slambda, VOID, VOID, [1]);
initMetadataForClass(WorkerTask, 'WorkerTask', WorkerTask);
initMetadataForClass(DemoWorkerTask, 'DemoWorkerTask', DemoWorkerTask);
initMetadataForLambda(WorkerTask$runSuspend$slambda, VOID, VOID, [0]);
initMetadataForClass(_WorkerImpl, '_WorkerImpl', _WorkerImpl, VOID, VOID, [4]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(BlobAsyncBaseStream, 'BlobAsyncBaseStream', VOID, VOID, VOID, [0, 4, 1]);
initMetadataForClass(toVfs$1, VOID, VOID, VOID, VOID, [2, 1, 0, 4, 3]);
initMetadataForClass(standardVfs$1);
protoOf(StandardPaths).s2u = appPreferencesFolder;
initMetadataForObject(StandardPaths, 'StandardPaths', VOID, VOID, [StandardPathsBase]);
initMetadataForClass(httpFactory$2$1);
initMetadataForCompanion(Companion_58);
initMetadataForClass(JsRuntime, 'JsRuntime', VOID, VOID, VOID, [1, 4]);
initMetadataForClass(JsRuntimeBrowser, 'JsRuntimeBrowser', JsRuntimeBrowser, VOID, VOID, [1, 4]);
initMetadataForCompanion(Companion_59, VOID, VOID, [1, 4]);
initMetadataForClass(JsRuntimeDeno, 'JsRuntimeDeno', JsRuntimeDeno, VOID, VOID, [1, 4]);
initMetadataForCompanion(Companion_60, VOID, VOID, [1, 4]);
initMetadataForClass(DenoLocalVfs, 'DenoLocalVfs', DenoLocalVfs, VOID, VOID, [2, 1, 4, 0, 3]);
initMetadataForClass(DenoAsyncStreamBase, 'DenoAsyncStreamBase', VOID, VOID, VOID, [4, 1, 0]);
initMetadataForLambda(workerImpl$o$insideWorker$lambda$lambda$slambda, VOID, VOID, [0]);
initMetadataForClass(workerImpl$1, VOID, VOID, VOID, VOID, [4]);
initMetadataForClass(Entry_1, 'Entry');
initMetadataForCompanion(Companion_61);
initMetadataForClass(JSStackTrace, 'JSStackTrace');
initMetadataForClass(Color, 'Color');
initMetadataForInterface(AnsiEscape, 'AnsiEscape');
initMetadataForClass(Kind, 'Kind');
protoOf(BaseConsole).b34 = appendAnsiScape;
protoOf(BaseConsole).c34 = appendAnsiScape$default;
protoOf(BaseConsole).d34 = appendReset;
protoOf(BaseConsole).e34 = appendFgColor;
protoOf(BaseConsole).f34 = appendFgColor$default;
initMetadataForClass(BaseConsole, 'BaseConsole', BaseConsole, VOID, [AnsiEscape]);
initMetadataForCompanion(Companion_62);
initMetadataForCompanion(Companion_63);
initMetadataForClass(Level, 'Level');
initMetadataForObject(ConsoleLogOutput, 'ConsoleLogOutput');
initMetadataForClass(Logger, 'Logger');
initMetadataForObject(DefaultLogOutput, 'DefaultLogOutput');
initMetadataForObject(Console, 'Console');
initMetadataForObject(NumberParser, 'NumberParser');
initMetadataForInterface(Easing, 'Easing');
protoOf(sam$korlibs_math_interpolation_Easing$0).b35 = invoke;
protoOf(sam$korlibs_math_interpolation_Easing$0).c35 = invoke_0;
initMetadataForClass(sam$korlibs_math_interpolation_Easing$0, 'sam$korlibs_math_interpolation_Easing$0', VOID, VOID, [Easing]);
protoOf(sam$korlibs_math_interpolation_Easing$0_0).b35 = invoke;
protoOf(sam$korlibs_math_interpolation_Easing$0_0).c35 = invoke_0;
initMetadataForClass(sam$korlibs_math_interpolation_Easing$0_0, 'sam$korlibs_math_interpolation_Easing$0', VOID, VOID, [Easing]);
initMetadataForCompanion(Companion_64);
initMetadataForCompanion(Companion_65);
initMetadataForClass(Ratio, 'Ratio', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_66);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_67);
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_68);
initMetadataForCompanion(Companion_69);
initMetadataForClass(Line2D, 'Line2D', Line2D.q37);
initMetadataForCompanion(Companion_70);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_71);
initMetadataForClass(Matrix, 'Matrix');
initMetadataForCompanion(Companion_72);
initMetadataForClass(MatrixTransform, 'MatrixTransform');
initMetadataForCompanion(Companion_73);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.i3a);
initMetadataForCompanion(Companion_74);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_75);
initMetadataForClass(Rectangle, 'Rectangle');
initMetadataForCompanion(Companion_76);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.j3c);
initMetadataForCompanion(Companion_77);
initMetadataForClass(Scale, 'Scale', Scale.o3c);
initMetadataForCompanion(Companion_78);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.d3d);
initMetadataForCompanion(Companion_79);
initMetadataForClass(Size2D, 'Size2D', Size2D.f3d);
initMetadataForCompanion(Companion_80);
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.r37);
initMetadataForCompanion(Companion_81);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_82);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.p3d);
initMetadataForCompanion(Companion_83);
initMetadataForObject(Arc, 'Arc');
initMetadataForCompanion(Companion_84);
initMetadataForClass(ImageDoNotFitException, 'ImageDoNotFitException');
initMetadataForClass(BinPacker, 'BinPacker');
initMetadataForClass(MaxRects, 'MaxRects');
initMetadataForClass(AbstractShape2D, 'AbstractShape2D');
initMetadataForCompanion(Companion_85);
initMetadataForClass(SliceRotation, 'SliceRotation');
initMetadataForCompanion(Companion_86);
initMetadataForClass(SliceOrientation, 'SliceOrientation');
initMetadataForInterface(SliceCoords, 'SliceCoords');
initMetadataForInterface(SliceCoordsWithBase, 'SliceCoordsWithBase', VOID, VOID, [SliceCoords]);
initMetadataForInterface(SliceCoordsWithBaseAndRect, 'SliceCoordsWithBaseAndRect', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectSlice).o1x = get_left;
protoOf(RectSlice).p1x = get_top;
protoOf(RectSlice).q1x = get_right;
protoOf(RectSlice).r1x = get_bottom;
protoOf(RectSlice).b1w = get_area;
protoOf(RectSlice).w3f = get_frameOffsetX;
protoOf(RectSlice).x3f = get_frameOffsetY;
protoOf(RectSlice).y3f = x;
protoOf(RectSlice).z3f = y;
initMetadataForClass(RectSlice, 'RectSlice', VOID, VOID, [SliceCoordsWithBaseAndRect]);
initMetadataForCompanion(Companion_87);
protoOf(RectCoords).y3f = x;
protoOf(RectCoords).z3f = y;
initMetadataForClass(RectCoords, 'RectCoords', VOID, VOID, [SliceCoords]);
protoOf(SliceCoordsImpl).w3f = get_frameOffsetX;
protoOf(SliceCoordsImpl).x3f = get_frameOffsetY;
protoOf(SliceCoordsImpl).y3f = x;
protoOf(SliceCoordsImpl).z3f = y;
initMetadataForClass(SliceCoordsImpl, 'SliceCoordsImpl', VOID, VOID, [SliceCoordsWithBase]);
initMetadataForInterface(VectorBuilder, 'VectorBuilder');
initMetadataForCompanion(Companion_88);
protoOf(VectorPath).p3g = line;
protoOf(VectorPath).w1j = isNotEmpty;
protoOf(VectorPath).q3g = rect;
protoOf(VectorPath).r3g = rect_0;
protoOf(VectorPath).s3g = arc;
protoOf(VectorPath).t3g = arc$default;
protoOf(VectorPath).u3g = circle;
initMetadataForClass(VectorPath, 'VectorPath', VectorPath, VOID, [AbstractShape2D, VectorBuilder]);
initMetadataForCompanion(Companion_89);
initMetadataForClass(Winding, 'Winding');
initMetadataForCompanion(Companion_90);
initMetadataForClass(MMatrix, 'MMatrix', MMatrix);
protoOf(Easings).b35 = invoke;
protoOf(Easings).c35 = invoke_0;
initMetadataForClass(Easings, 'Easings', VOID, VOID, [Easing, Enum]);
initMetadataForClass(Easings$SMOOTH, 'SMOOTH');
initMetadataForClass(Easings$EASE_IN_ELASTIC, 'EASE_IN_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_ELASTIC, 'EASE_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_BOUNCE, 'EASE_OUT_BOUNCE');
initMetadataForClass(Easings$LINEAR, 'LINEAR');
initMetadataForClass(Easings$EASE, 'EASE');
initMetadataForClass(Easings$EASE_IN, 'EASE_IN');
initMetadataForClass(Easings$EASE_OUT, 'EASE_OUT');
initMetadataForClass(Easings$EASE_IN_OUT, 'EASE_IN_OUT');
initMetadataForClass(Easings$EASE_IN_OLD, 'EASE_IN_OLD');
initMetadataForClass(Easings$EASE_OUT_OLD, 'EASE_OUT_OLD');
initMetadataForClass(Easings$EASE_IN_OUT_OLD, 'EASE_IN_OUT_OLD');
initMetadataForClass(Easings$EASE_OUT_IN_OLD, 'EASE_OUT_IN_OLD');
initMetadataForClass(Easings$EASE_IN_BACK, 'EASE_IN_BACK');
initMetadataForClass(Easings$EASE_OUT_BACK, 'EASE_OUT_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_BACK, 'EASE_IN_OUT_BACK');
initMetadataForClass(Easings$EASE_OUT_IN_BACK, 'EASE_OUT_IN_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_ELASTIC, 'EASE_IN_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_IN_ELASTIC, 'EASE_OUT_IN_ELASTIC');
initMetadataForClass(Easings$EASE_IN_BOUNCE, 'EASE_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_OUT_BOUNCE, 'EASE_IN_OUT_BOUNCE');
initMetadataForClass(Easings$EASE_OUT_IN_BOUNCE, 'EASE_OUT_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_QUAD, 'EASE_IN_QUAD');
initMetadataForClass(Easings$EASE_OUT_QUAD, 'EASE_OUT_QUAD');
initMetadataForClass(Easings$EASE_IN_OUT_QUAD, 'EASE_IN_OUT_QUAD');
initMetadataForClass(Easings$EASE_SINE, 'EASE_SINE');
initMetadataForClass(Easings$EASE_CLAMP_START, 'EASE_CLAMP_START');
initMetadataForClass(Easings$EASE_CLAMP_END, 'EASE_CLAMP_END');
initMetadataForClass(Easings$EASE_CLAMP_MIDDLE, 'EASE_CLAMP_MIDDLE');
initMetadataForClass(P, 'P');
protoOf(EasingCubic).b35 = invoke;
protoOf(EasingCubic).c35 = invoke_0;
initMetadataForClass(EasingCubic, 'EasingCubic', VOID, VOID, [Easing]);
initMetadataForClass(UByteArrayInt, 'UByteArrayInt');
initMetadataForCompanion(Companion_91);
initMetadataForInterface(TypedBuffer, 'TypedBuffer');
protoOf(Uint16Buffer).d1 = get_size;
initMetadataForClass(Uint16Buffer, 'Uint16Buffer', VOID, VOID, [TypedBuffer]);
initMetadataForClass(SimpleBytesDeque, 'SimpleBytesDeque', SimpleBytesDeque);
initMetadataForClass(SimpleChunkedByteDeque, 'SimpleChunkedByteDeque', SimpleChunkedByteDeque);
initMetadataForClass(SimpleRingBuffer, 'SimpleRingBuffer');
initMetadataForCompanion(Companion_92);
initMetadataForCompanion(Companion_93);
initMetadataForClass(Buffer, 'Buffer', VOID, VOID, [AutoCloseable]);
initMetadataForInterface(CloseableCancellable, 'CloseableCancellable', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_94);
initMetadataForClass(CancellableGroup, 'CancellableGroup', CancellableGroup, VOID, [CloseableCancellable]);
initMetadataForClass(sam$korlibs_io_lang_Cancellable$0, 'sam$korlibs_io_lang_Cancellable$0');
initMetadataForCompanion(Companion_95);
initMetadataForClass(MalformedInputException, 'MalformedInputException');
initMetadataForClass(InvalidOperationException, 'InvalidOperationException', InvalidOperationException.h3m);
initMetadataForClass(UnreachableException, 'UnreachableException', UnreachableException.k3m);
initMetadataForClass(OutOfBoundsException, 'OutOfBoundsException', OutOfBoundsException.w2n);
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', ByteArrayBuilder.s1d);
initMetadataForCompanion(Companion_96);
initMetadataForClass(Arch, 'Arch');
initMetadataForCompanion(Companion_97);
initMetadataForClass(Endian, 'Endian');
initMetadataForCompanion(Companion_98);
initMetadataForClass(Os, 'Os');
initMetadataForInterface(Platform, 'Platform');
protoOf(Companion_99).i1s = get_isWindows;
protoOf(Companion_99).r3m = get_isLinux;
protoOf(Companion_99).j1s = get_isMac;
protoOf(Companion_99).v3m = get_isNative;
protoOf(Companion_99).q2j = get_isJsNodeJs;
protoOf(Companion_99).g2l = get_isJsDenoJs;
protoOf(Companion_99).c1a = get_isJsBrowser;
initMetadataForCompanion(Companion_99, VOID, [Platform]);
initMetadataForCompanion(Companion_100);
initMetadataForClass(Runtime, 'Runtime');
initMetadataForClass(EOFException, 'EOFException');
initMetadataForClass(FileNotFoundException, 'FileNotFoundException');
initMetadataForCompanion(Companion_101);
initMetadataForClass(DenoPointer, 'DenoPointer');
initMetadataForClass(Json, 'Json', Json);
initMetadataForCompanion(Companion_102);
protoOf(MiniNumberArrayList).y1h = getAt;
protoOf(MiniNumberArrayList).r2 = listIterator;
protoOf(MiniNumberArrayList).s2 = listIterator_0;
protoOf(MiniNumberArrayList).t2 = subList;
protoOf(MiniNumberArrayList).z1h = containsAll;
protoOf(MiniNumberArrayList).g1 = isEmpty;
protoOf(MiniNumberArrayList).a1 = iterator_0;
initMetadataForClass(MiniNumberArrayList, 'MiniNumberArrayList', MiniNumberArrayList, VOID, [DoubleList]);
initMetadataForClass(Charset, 'Charset');
initMetadataForClass(BaseSingleByteCharset, 'BaseSingleByteCharset');
initMetadataForClass(SingleByteCharset, 'SingleByteCharset');
initMetadataForObject(ASCII, 'ASCII');
initMetadataForCompanion(Companion_103);
initMetadataForClass(UTF16Charset, 'UTF16Charset');
initMetadataForClass(UTC8CharsetBase, 'UTC8CharsetBase');
initMetadataForObject(ISO_8859_1, 'ISO_8859_1');
initMetadataForObject(Charsets, 'Charsets');
initMetadataForObject(INDENTS_0, 'INDENTS');
initMetadataForClass(Impl, 'Impl');
initMetadataForCompanion(Companion_104);
initMetadataForCompanion(Companion_105);
initMetadataForClass(DateTime, 'DateTime', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_106);
initMetadataForClass(FastDuration, 'FastDuration', VOID, VOID, [Comparable]);
initMetadataForInterface(TimeProvider, 'TimeProvider');
initMetadataForCompanion(Companion_107, VOID, [TimeProvider]);
initMetadataForInterface(ICoreTime, 'ICoreTime');
protoOf(CoreTime$1).m3o = performanceMillis;
initMetadataForClass(CoreTime$1, VOID, VOID, VOID, [ICoreTime]);
initMetadataForObject(PerformanceCounter, 'PerformanceCounter');
initMetadataForClass(Stopwatch, 'Stopwatch', Stopwatch);
initMetadataForClass(IntTimedCache, 'IntTimedCache');
//endregion
//region block: init
Companion_instance_0 = new Companion();
DEFAULT_MAX_SAMPLES = 39690000;
Adler32_instance = new Adler32();
Companion_instance_5 = new Companion_4();
Companion_instance_6 = new Companion_5();
Companion_instance_10 = new Companion_9();
Companion_instance_11 = new Companion_10();
Companion_instance_14 = new Companion_13();
Companion_instance_15 = new Companion_14();
Companion_instance_16 = new Companion_15();
Companion_instance_17 = new Companion_16();
Companion_instance_18 = new Companion_17();
Companion_instance_19 = new Companion_18();
Companion_instance_20 = new Companion_19();
Companion_instance_21 = new Companion_20();
Memory_instance = new Memory();
Companion_instance_22 = new Companion_21();
DynamicInternal_instance = new DynamicInternal();
Hex_instance = new Hex();
Companion_instance_28 = new Companion_27();
Bitmaps_instance = new Bitmaps();
Companion_instance_31 = new Companion_30();
Companion_instance_33 = new Companion_32();
Companion_instance_34 = new Companion_33();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
Companion_instance_36 = new Companion_35();
Companion_instance_38 = new Companion_37();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
Companion_instance_41 = new Companion_40();
Companion_instance_42 = new Companion_41();
NullSyncSystemFS_instance = new NullSyncSystemFS();
Companion_instance_45 = new Companion_44();
Companion_instance_46 = new Companion_45();
Companion_instance_47 = new Companion_46();
Companion_instance_48 = new Companion_47();
resourcesVfsDebug = false;
Companion_instance_51 = new Companion_50();
Companion_instance_52 = new Companion_51();
Companion_instance_53 = new Companion_52();
EmptyLineOnce_instance = new EmptyLineOnce();
Indent_instance = new Indent();
Unindent_instance = new Unindent();
INDENTS_instance = new INDENTS();
Companion_instance_57 = new Companion_56();
Companion_instance_58 = new Companion_57();
StandardPaths_instance = new StandardPaths();
Companion_instance_62 = new Companion_61();
baseConsoleHook = null;
_miniEnvironmentVariablesUC = null;
ConsoleLogOutput_instance = new ConsoleLogOutput();
DefaultLogOutput_instance = new DefaultLogOutput();
Companion_instance_75 = new Companion_74();
Companion_instance_77 = new Companion_76();
Arc_instance = new Arc();
Companion_instance_85 = new Companion_84();
Companion_instance_88 = new Companion_87();
Companion_instance_89 = new Companion_88();
Companion_instance_90 = new Companion_89();
Companion_instance_92 = new Companion_91();
Companion_instance_94 = new Companion_93();
Companion_instance_95 = new Companion_94();
customEnvironments = null;
Companion_instance_96 = new Companion_95();
Companion_instance_97 = new Companion_96();
Companion_instance_101 = new Companion_100();
Companion_instance_102 = new Companion_101();
Companion_instance_104 = new Companion_103();
Charsets_instance = new Charsets();
Companion_instance_105 = new Companion_104();
Companion_instance_107 = new Companion_106();
Companion_instance_108 = new Companion_107();
KlockLocale_default = null;
ExtendedTimezoneNamesOrNull = null;
//endregion
//region block: exports
export {
  DemoWorkerTask as DemoWorkerTask,
};
export {
  Level_DEBUG_getInstance as Level_DEBUG_getInstance2cjwrm9110zsz,
  Level_ERROR_getInstance as Level_ERROR_getInstance3sgixyayx9gy9,
  Level_INFO_getInstance as Level_INFO_getInstance2ziz2o3m3loni,
  Level_TRACE_getInstance as Level_TRACE_getInstance3v3hjwgnnbwb6,
  Level_WARN_getInstance as Level_WARN_getInstancejrnwzyc079xb,
  Os_UNKNOWN_getInstance as Os_UNKNOWN_getInstance1flk2wnh3ycyv,
  readBitmapSlice as readBitmapSlice1mxfjm5uys58e,
  readBitmap_0 as readBitmap1xlsnvr8f9icc,
  readBitmap as readBitmap1dn2o52mvbpv4,
  injector as injector13ltfovoybm52,
  launchUnscopedAndWait as launchUnscopedAndWait6v8yfjb8olf5,
  delay_1 as delay37k8qmbtkbicq,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3iv1uv3wd82oh,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg3ni93gubw9yz3,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1u2gy3h5k9nkx,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf63jsbsnnrny7w3,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmzp2nzhttcejz,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k3pk03bu2ddet,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqt1opkd4mw5vm2z,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2cnrrhh9rakoc,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8v1fb2bqjo5n70o,
  Dyn__set_impl_2ozvx8 as Dyn__set_impl_2ozvx82r2n5zj0vrm3z,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv3gpdj6wpeuir3,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw1zqnfrqkp8did,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y213uoamn5n3x7j,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx3cti8ahdxq1b5,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7x3pz0lxdivao0o,
  _Ratio___init__impl__9mwvn2_0 as _Ratio___init__impl__9mwvn21qo8ztog8o9ep,
  Ratio__compareTo_impl_z2ienc as Ratio__compareTo_impl_z2ienc1iwi3w3dhe1b7,
  Ratio__toFloat_impl_1ftup5 as Ratio__toFloat_impl_1ftup5294anfb3s41c1,
  Ratio__toString_impl_mfgt3e as Ratio__toString_impl_mfgt3e2hpoo0nu4cwhr,
  ByteUnits__toString_impl_ox2ku2 as ByteUnits__toString_impl_ox2ku23u8mrfdqfevi9,
  Float32Buffer__get_impl_659lhu as Float32Buffer__get_impl_659lhu25y6ts3w0gs8j,
  Float32Buffer__set_impl_34szne as Float32Buffer__set_impl_34sznevuviq8wx4pjc,
  _Int8Buffer___init__impl__e20lvc_0 as _Int8Buffer___init__impl__e20lvc25rd50uuh5h3r,
  _Int8Buffer___get_buffer__impl__q0gulb as _Int8Buffer___get_buffer__impl__q0gulb1rowdgq1svh9p,
  Uint16Buffer__set_impl_g0kliu as Uint16Buffer__set_impl_g0kliu1yamftxrkicc6,
  DateTime__hashCode_impl_yf0bc9 as DateTime__hashCode_impl_yf0bc92p1oa6fp4l38p,
  DateTime__minus_impl_10njw8 as DateTime__minus_impl_10njw81nqbgaa48pgq4,
  FastDuration__compareTo_impl_4fhnj7 as FastDuration__compareTo_impl_4fhnj71uadlvoozsr50,
  FastDuration__compareTo_impl_4fhnj7_1 as FastDuration__compareTo_impl_4fhnj71anf17lkhs1by,
  FastDuration__div_impl_rlslck as FastDuration__div_impl_rlslck1plvf7n5rb7aa,
  FastDuration__div_impl_rlslck_0 as FastDuration__div_impl_rlslck15f8mt5g6dyds,
  _FastDuration___get_fastMicroseconds__impl__e641g1 as _FastDuration___get_fastMicroseconds__impl__e641g13hz45luccu2o2,
  _FastDuration___get_fastMilliseconds__impl__pe68va as _FastDuration___get_fastMilliseconds__impl__pe68va279q35r54j5bc,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr as _FastDuration___get_fastNanoseconds__impl__9kjwbr1r08ed2cb76hy,
  FastDuration__hashCode_impl_y13la6 as FastDuration__hashCode_impl_y13la61yn3ntf9nmd1o,
  FastDuration__minus_impl_evs237_0 as FastDuration__minus_impl_evs2371ieewiyvo7cp9,
  FastDuration__minus_impl_evs237 as FastDuration__minus_impl_evs2371fjveki3j5gyc,
  _FastDuration___get_nanoseconds__impl__pxizcb as _FastDuration___get_nanoseconds__impl__pxizcb3qjtomx85900t,
  FastDuration__plus_impl_q1enab as FastDuration__plus_impl_q1enab3lvjsvnxno7fk,
  FastDuration__plus_impl_q1enab_0 as FastDuration__plus_impl_q1enab14z0pv6jz22jd,
  FastDuration__times_impl_h6amcp as FastDuration__times_impl_h6amcp25vm4d6obfh9l,
  FastDuration__toString_impl_c9xohb as FastDuration__toString_impl_c9xohb3cvph1y7s95v4,
  _Frequency___get_hertz__impl__9m7k6x as _Frequency___get_hertz__impl__9m7k6x37zmlsrxcrsca,
  Companion_instance_20 as Companion_instance3aqdk7kknb8d1,
  Companion_getInstance_25 as Companion_getInstance35l79l8djunj4,
  Bitmaps_instance as Bitmaps_instancebct336c8d0m7,
  Colors_getInstance as Colors_getInstance1qvds1isfbag2,
  Companion_instance_34 as Companion_instancevwyx2uq9kvqe,
  Companion_instance_33 as Companion_instance307r99gfwddav,
  Companion_getInstance_13 as Companion_getInstance15h5aaybcsdep,
  Companion_instance_22 as Companion_instance3c5rz779n238s,
  StandardPaths_instance as StandardPaths_instance3ckwvxznkwud8,
  Companion_instance_96 as Companion_instance21jklwk36y3dn,
  Companion_getInstance_57 as Companion_getInstance3mi66xu3smuhs,
  Companion_instance_58 as Companion_instance1fqld9q4wfq20,
  Console_getInstance as Console_getInstance25u15nzhjnxu2,
  Companion_getInstance_65 as Companion_getInstance1lqql7kjbk545,
  Companion_getInstance_85 as Companion_getInstance2yrgpxwoeu923,
  Companion_instance_88 as Companion_instance104pvig6e11lu,
  Companion_getInstance_68 as Companion_getInstance21plr7f541fx9,
  Companion_getInstance_69 as Companion_getInstance1ygiwm9bgjia3,
  Companion_getInstance_70 as Companion_getInstance3om7tc9mg7edv,
  Companion_getInstance_72 as Companion_getInstance9hqru60m2833,
  Companion_getInstance_73 as Companion_getInstance3jdtpl42k8kus,
  Companion_getInstance_75 as Companion_getInstance2npyq9n96lvll,
  Companion_getInstance_77 as Companion_getInstancewvzae8n0fprj,
  Companion_instance_77 as Companion_instance3cau272s9vxbi,
  Companion_getInstance_80 as Companion_getInstance19z3k1g06rka6,
  Companion_getInstance_81 as Companion_getInstancew949xxob44bw,
  Companion_getInstance_82 as Companion_getInstanceuv1p1c5gwy11,
  Companion_getInstance_66 as Companion_getInstancech3bi94cc2ym,
  Companion_getInstance_67 as Companion_getInstance1kb6pmvl5oz92,
  Companion_getInstance_94 as Companion_getInstancehxhdjetxjiew,
  Companion_instance_94 as Companion_instanceimfvy8b5dxd9,
  Companion_getInstance_100 as Companion_getInstance1x6v9sy9zfof9,
  Companion_getInstance_101 as Companion_getInstance4j5fpzk5rb8p,
  Companion_getInstance_107 as Companion_getInstance3moaeo8p2fvjj,
  Companion_instance_107 as Companion_instance2mxqoacslm62w,
  PerformanceCounter_getInstance as PerformanceCounter_getInstance23wo5gavc7ilf,
  Companion_instance_108 as Companion_instance2bvf2vakw640b,
  get_nativeSoundProvider as get_nativeSoundProvider1b6rsunmfcp5k,
  Lock as Lock5n7hh3dgcidl,
  NonRecursiveLock as NonRecursiveLock2vf7fkhp857q,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  Mixin as Mixin3lmkm5hum2vdj,
  PropertyThis as PropertyThis2r0hbk1cs09wj,
  Property as Property1m5vulkepgwzd,
  FastArrayList as FastArrayListw5fr1wlp4slq,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntMap as IntMap2d9g6f5pyaoc2,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  clear as clear3idbm40uzyume,
  contains_2 as containsrsn76oa0puwr,
  fastArrayListOf as fastArrayListOf1rdodhrpn0q8y,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getExtraTyped as getExtraTyped8zexqxz5xxli,
  getExtra as getExtra307y0o9pd6mp3,
  get_4 as get2pw1zlgv5zypd,
  hasExtra as hasExtra1969mplo13qgb,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  setExtra as setExtra314k0z6q35eku,
  set_0 as set2vuztm9k7ubgo,
  get_size_0 as get_size2tttv7g2u748n,
  toFastList_0 as toFastList1btvvxvv57pw,
  toFastList as toFastListzo2jtkrx0z5y,
  toIntMap as toIntMapp1jij98esrcm,
  toRef as toRef3av6zm8yavumw,
  fromBase64 as fromBase6434uveajlhn2ar,
  get_hex as get_hex32p4ssq0y1xxx,
  CreateFFIMemory as CreateFFIMemoryv82e6jbfcdze,
  CreateFFIMemory_0 as CreateFFIMemory2iekizxdvtyvt,
  CreateFFIPointer as CreateFFIPointernsr7ilwulbub,
  FuncInfo as FuncInfocud0a7bce10z,
  FFILib as FFILiby83bova0zjfy,
  getS32 as getS32284qh8a5ldxzn,
  get_pointer as get_pointer2afz2rc14joly,
  set32 as set3216gyp8r69gas8,
  setFFIPointer as setFFIPointerjzarmbova4sm,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  get_isLow as get_isLow1k7uocm2ojjr8,
  InjectorContext as InjectorContextps0ngmjb9onz,
  InjectorDependency as InjectorDependency2f8dsqe1kn3nn,
  Injector as Injectorxjyp19tp5mfu,
  AsyncSignal as AsyncSignal3p186s2w7f15b,
  Signal as Signal3nnez3346azzf,
  invoke_1 as invoke2sf88d1xeuyqh,
  launchImmediately as launchImmediatelylnv8lnistpdy,
  launchImmediately_0 as launchImmediately11za8mkid9pxu,
  launchUnscoped as launchUnscopedpyoa01nqmf1z,
  launchUnscoped_0 as launchUnscoped2lqe6wwpvfo83,
  MountableVfs as MountableVfs3mmbka3zq5l6i,
  get_localCurrentDirVfs as get_localCurrentDirVfs2lka1gsv26an5,
  get_resourcesVfs as get_resourcesVfs3qrvup7jpy9uc,
  toVfs as toVfsr7ir4p66g1my,
  CancellableGroup as CancellableGroup3e8z70ga3djg,
  cancel as cancel1amaozv14ic7s,
  CloseableCancellable as CloseableCancellable3mxnqaxyfppmn,
  cancel_0 as cancel1n0qjc93h2v6w,
  get_invalidOp as get_invalidOp31x7cztl0dv9m,
  invalidOp as invalidOp1stebxh2m3n07,
  get_portableSimpleName as get_portableSimpleName6o7s8nc63i85,
  get_unreachable as get_unreachable2fi7msfg0vgzd,
  unsupported_0 as unsupported198cz39rr1ztw,
  Resourceable as Resourceable38whwgli3ts8g,
  Resources as Resources1ysf2j4wd5yk7,
  openAsync as openAsync37anb1e84urmo,
  Indenter as Indenterdf10c5coibyi,
  toStringDecimal as toStringDecimalw23mr08es1e2,
  get_DEBUG_WORKER as get_DEBUG_WORKER2r7zp31jch3ip,
  get_workerImpl as get_workerImpl14jb6v5ie8q11,
  DenoPointer as DenoPointerpb0vypijx63v,
  get_pointer_0 as get_pointerlkbwhoqlhapz,
  valueOf as valueOf3aj0dpb8xpu5n,
  RectSlice as RectSlicec5msorw5q4el,
  VectorPath as VectorPath1chx1oqdw6sb9,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle as Angle2itorpob18n08,
  MMatrix as MMatrix1y71lv7vv6y8t,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  get_degrees as get_degrees3czcd4ojw4i,
  get_immutable as get_immutablepxpdoj6e54ll,
  interpolateAngleNormalized as interpolateAngleNormalized3h8mzdshuvgea,
  ortho as orthow9c0o91bw54n,
  get_scale as get_scale17gmsnxnqj6j9,
  toFloat as toFloat3b315y36g90cd,
  toInt_1 as toIntp2twe4onfbic,
  toMatrix4 as toMatrix42ci5k1es0x1v1,
  get_EASE_IN_OUT as get_EASE_IN_OUT1plt1ext4tf71,
  get_EASE_IN_OUT_QUAD as get_EASE_IN_OUT_QUAD21w3u6e1aoexb,
  Ratio as Ratio136tf4z2t0p2d,
  interpolate_1 as interpolatewhd2sgxffql5,
  interpolate_0 as interpolate2g7wzskc23f1q,
  toRatio_0 as toRatio1hooqit5gulhr,
  clamp_1 as clampdicp8njiht45,
  clamp as clamp31lhm66c28ic8,
  clamp_0 as clamp1qclpmpfxm7xb,
  convertRange as convertRange1a6ancvyn151r,
  convertRange_0 as convertRange24n2xnngpze54,
  ilog2_0 as ilog23dbvpk38jf7rc,
  get_isPowerOfTwo as get_isPowerOfTwoeb2yxu9ww0f7,
  nextAlignedTo as nextAlignedTo2788hp7lcoqp,
  nextMultipleOf as nextMultipleOf14oge7vxqp9sy,
  roundDecimalPlaces_1 as roundDecimalPlacespck2j5mpzhqn,
  toIntCeil as toIntCeil3h286vm49zgwd,
  toIntRound as toIntRoundjnzmk86x1qp5,
  toIntRound_0 as toIntRound1mv0y8x9hh1p4,
  toLongRound as toLongRound7crzegvo2qbo,
  toShortClamped as toShortClampedqjuvod9w2qhj,
  Buffer as Buffer25z94vsj0kb1s,
  allocDirect as allocDirecttfrgytwudkpf,
  allocNoDirect as allocNoDirect3dykranmovqsj,
  get_arrayFloat as get_arrayFloat1r0vk858s9phl,
  get_arrayInt as get_arrayInt3v8kuk47rixtz,
  get_arrayUByte as get_arrayUByte9swx7ogt2hf2,
  arrayadd as arrayadd3erpr00t9k8j,
  arraycopy_0 as arraycopy52dxe7vhzf14,
  arraycopy_8 as arraycopyphzg5lpa6gvz,
  arraycopy_4 as arraycopyqmyo4vjwforw,
  arraycopy_10 as arraycopy1hsh296f5d0xg,
  arraycopy_9 as arraycopy3fi6tr79d693r,
  arraycopy_3 as arraycopy3uxsqjlixmnz3,
  arraycopy_5 as arraycopy28e1us87mwypg,
  arraycopy_7 as arraycopy9a0yzbjqwnvw,
  arrayequal as arrayequal25g4om83vd8w1,
  arrayfill_0 as arrayfill1njpugsfcm512,
  arrayfill as arrayfill2iqmyqqqfwuaf,
  asUShortArrayInt as asUShortArrayInt2gfk0h9rafip5,
  clone as clonelcrqoxe4ne5i,
  copyOf_3 as copyOfnqvdm0sc8lk,
  extractScaledf01 as extractScaledf013fj6eqsu4szwo,
  extract_0 as extract2vhru1ihy4ogl,
  get_f32 as get_f3218rglfhpgbhzp,
  getInt32 as getInt32gmg3zyw00v1v,
  get_high as get_high3vl4k4kkorqlu,
  get_i32 as get_i323p4hlz6j3xys8,
  get_i8 as get_i83qhdj74rhdyeg,
  insert14 as insert141hi307uxchfzk,
  insert2 as insert22yqrzxcpmo55e,
  insert3 as insert32d422lnha9g5r,
  insert4 as insert42sy0xc4ax89g9,
  insert5 as insert52qor1kqho1lpj,
  insert8 as insert8f3zk23r8x9da,
  insertScaledf01 as insertScaledf01oj6k04gavkch,
  insert as insertm9bp9ll4cml3,
  insert_0 as insert2fz5125p2hdyd,
  get_low as get_low2kdkn3173rx8r,
  setArrayLE_0 as setArrayLEwil75hzlfusu,
  setBits as setBitsqsmqq5kc486j,
  setFloat32 as setFloat323e0ukqyly1ufv,
  setInt32 as setInt32178h074gei71f,
  get_size_1 as get_size13scmefs6mbfn,
  sliceBuffer as sliceBufferpiate0wictoq,
  sliceWithSize_2 as sliceWithSize2i7i6olf26byj,
  get_u16 as get_u163bxpdbbave1v5,
  get_niceStr as get_niceStr3crhxydmlnaoj,
  get_niceStr_0 as get_niceStr1tlwtz2l2j4my,
  niceStr_0 as niceStr1ftz2qvn4gdyq,
  get_jsGlobalThis as get_jsGlobalThis3odmbn60utci,
  get_DURATION_NIL as get_DURATION_NIL2lkiawowwp1us,
  DateTime as DateTime2gld4ho36azq9,
  FastDuration as FastDuration3d3pupg2e5ora,
  IntTimedCache as IntTimedCache39ymx9abjz88x,
  Stopwatch as Stopwatch1guqi4xl0rpfb,
  TimeProvider as TimeProvider2j6wl2le6n0p3,
  div as div1s6t4x2ts64sh,
  get_fast as get_fast37cu8s8qwnuyi,
  get_fastMicroseconds_0 as get_fastMicroseconds16wth98xujxdo,
  get_fastMicroseconds as get_fastMicroseconds3xewe49ldi5s,
  get_fastMilliseconds_0 as get_fastMilliseconds2pmoifl74b2oz,
  get_fastMilliseconds as get_fastMillisecondsfxaeyfzoedsj,
  get_fastNanoseconds_0 as get_fastNanoseconds1laeiegsk8vcx,
  get_fastNanoseconds as get_fastNanosecondsibv7lnrlu50o,
  get_fastSeconds as get_fastSecondsxsf72e0ltu4j,
  max as max1q2oylvn6uire,
  minus_0 as minus2npwq73u0d9yx,
  roundMilliseconds as roundMilliseconds3bd2pntxev66o,
  get_slow as get_slowaqovrrnrezzv,
  toDuration_2 as toDuration15w5sljvx2ut2,
  toFrequency as toFrequency3flbtmp5xney7,
};
//endregion
